(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["anx"] = factory(require("vue"));
	else
		root["anx"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "01ec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};

/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "0429":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxToast/AnxToast.vue?vue&type=template&id=0f850245&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibility || _vm.fadeIn)?_c('div',{class:("anx-toast-container anx-toast-" + _vm.horizontalAlign)},[_c('div',{class:[
      {
        'anx-toast': true,
        show: _vm.visibility,
        'fade-in': _vm.fadeIn,
        'fade-out': _vm.fadeOut
      },
      ("anx-toast-" + _vm.type)
    ],style:(_vm.cssProps),on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxToast/AnxToast.vue?vue&type=template&id=0f850245&scoped=true&


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");
var isObject = __webpack_require__("861d");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "06e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("faa5");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "08ed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFormContainer_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ded4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFormContainer_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFormContainer_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "09ac":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "09f6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxContent_vue_vue_type_template_id_2eb4993f_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f7f3");
/* harmony import */ var _AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("f535");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxContent_vue_vue_type_style_index_0_id_2eb4993f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("41cb");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxContent_vue_vue_type_template_id_2eb4993f_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxContent_vue_vue_type_template_id_2eb4993f_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "2eb4993f",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "0a11":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0a19":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * The *anx-toast* is used to create push notifications for your users
 */


var AnxToast = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxToast, _vue_property_decorat);

  var _super = _createSuper(AnxToast);

  function AnxToast() {
    var _this;

    _classCallCheck(this, AnxToast);

    _this = _super.apply(this, arguments);
    /** Helper variables */

    _this.fadeIn = false;
    _this.fadeOut = false;
    _this.visibility = false;
    /** This are the ids of the defined timeouts */

    _this.timeouts = {
      showAnimation: null,
      hideAnimation: null,
      autoClose: null
    };
    return _this;
  }
  /** Check for value changes and adapt the visibility of the toast */


  _createClass(AnxToast, [{
    key: "onValueChanged",
    value: function onValueChanged() {
      // If the toast is closed, the auto close timeout has to be canceled
      if (!this.value) {
        this.cancelTimeout(this.timeouts.autoClose);
        this.timeouts.autoClose = null;
      } // Update the visibility


      this.updateVisibility();
    }
    /**
     * Emitts the input event
     *
     * @prop val: the new value
     * @prop byUser: value changed by user or automatically
     * @event input
     */

  }, {
    key: "input",
    value: function input(val, byUser) {
      if (!val) this.dismiss(byUser ? byUser : false);
      return val;
    }
    /**
     * Emit the dismiss event
     *
     * @prop byUser: states if the user closed the toast or it has been automatically closed
     * @event dismiss
     */

  }, {
    key: "dismiss",
    value: function dismiss(byUser) {
      return byUser;
    }
    /**
     * Emit the destroy event.
     * This indicates that the toast can be removed from the DOM
     *
     * @event destroy
     */

  }, {
    key: "destroy",
    value: function destroy() {
      return true;
    }
    /** Update visibility on creat */

  }, {
    key: "created",
    value: function created() {
      this.updateVisibility();
      this.visibility = this.value === null ? false : this.value;
    }
    /** Checks if the toast should be shown or not depending on the value */

  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      if (this.value) {
        this.showAction();
      } else {
        this.hideAction();
      }
    }
    /** Show the toast */

  }, {
    key: "showAction",
    value: function showAction() {
      var _this2 = this;

      if (this.animations) {
        this.fadeIn = true;

        if (typeof window !== "undefined") {
          this.timeouts.showAnimation = window.setTimeout(function () {
            _this2.fadeIn = false;
            _this2.visibility = true;
          }, 500);
        }
      } else {
        this.visibility = true;
      }
      /** Check if the alert should be auto closed and set a timeout */


      if (this.autoClose) {
        if (typeof window !== "undefined") {
          this.timeouts.autoClose = window.setTimeout(function () {
            _this2.input(false, false);
          }, this.autoCloseTimeout);
        }
      }
    }
    /** Hide the toast */

  }, {
    key: "hideAction",
    value: function hideAction() {
      var _this3 = this;

      if (this.animations) {
        this.fadeOut = true;
        this.timeouts.hideAnimation = window.setTimeout(function () {
          _this3.fadeOut = false;
          _this3.visibility = false;

          _this3.destroy();
        }, 480);
      } else {
        this.visibility = false;
        this.destroy();
      }
    }
    /** Cancel all timeouts for the toast */

  }, {
    key: "cancelTimeout",
    value: function cancelTimeout(timeout) {
      if (typeof window !== "undefined" && timeout !== null) {
        window.clearTimeout(timeout);
      }
    }
    /** Handle the user click and check if the toast should be closed */

  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.disableCloseOnClick === null) {
        this.input(false, true);
      }
    }
    /** This are some style that are directly injected as css into the component */

  }, {
    key: "cssProps",
    get: function get() {
      var style = {};

      if (this.backgroundColor !== null) {
        style["background-color"] = this.backgroundColor + " !important";
      }

      if (this.color !== null) {
        style["color"] = this.color + " !important";
      }

      return style;
    }
  }]);

  return AnxToast;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxToast.prototype, "animations", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxToast.prototype, "autoClose", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: 2500
})], AnxToast.prototype, "autoCloseTimeout", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxToast.prototype, "message", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "right"
})], AnxToast.prototype, "horizontalAlign", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "success"
})], AnxToast.prototype, "type", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxToast.prototype, "value", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxToast.prototype, "disableCloseOnClick", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxToast.prototype, "backgroundColor", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxToast.prototype, "color", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("value")], AnxToast.prototype, "onValueChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Emit("input")], AnxToast.prototype, "input", null);

tslib_1.__decorate([vue_property_decorator_1.Emit("dismiss")], AnxToast.prototype, "dismiss", null);

tslib_1.__decorate([vue_property_decorator_1.Emit("destroy")], AnxToast.prototype, "destroy", null);

AnxToast = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxToast);
exports.default = AnxToast;

/***/ }),

/***/ "0ac0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_style_index_0_id_33abed87_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e0f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_style_index_0_id_33abed87_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_style_index_0_id_33abed87_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0b33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxCard_vue_vue_type_template_id_58212e84___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0bb0");
/* harmony import */ var _AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ca4b");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1505");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxCard_vue_vue_type_template_id_58212e84___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxCard_vue_vue_type_template_id_58212e84___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "0bb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxCard/AnxCard.vue?vue&type=template&id=58212e84&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-card"},[_c('div',{staticClass:"anx-card-content d-flex"},[(_vm.icon != null)?_c('anx-icon',{staticClass:"anx-card-icon",attrs:{"icon":_vm.icon}}):(_vm.image != null)?_c('img',{staticClass:"anx-card-icon",attrs:{"src":_vm.image,"alt":"Card icon"}}):_vm._e(),_c('anx-paragraph',{attrs:{"title":_vm.title,"size":"h3"}},[_vm._t("default"),(_vm.linkText)?_c('br'):_vm._e(),(_vm.linkText)?_c('anx-link',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.linkText))]):_vm._e()],2)],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxCard/AnxCard.vue?vue&type=template&id=58212e84&


/***/ }),

/***/ "0c18":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * This component is like a simple *\<hr\>* html tag with some features and predefined layout.
 */


var AnxHrLine = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxHrLine, _vue_property_decorat);

  var _super = _createSuper(AnxHrLine);

  function AnxHrLine() {
    _classCallCheck(this, AnxHrLine);

    return _super.apply(this, arguments);
  }

  _createClass(AnxHrLine, [{
    key: "cssProps",
    get: function get() {
      return {
        "--marginTop": this.marginTop !== null ? this.marginTop : this.margin,
        "--marginBottom": this.marginBottom !== null ? this.marginBottom : this.margin
      };
    }
  }]);

  return AnxHrLine;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "grey"
})], AnxHrLine.prototype, "color", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "40px"
})], AnxHrLine.prototype, "margin", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxHrLine.prototype, "marginTop", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxHrLine.prototype, "marginBottom", void 0);

AnxHrLine = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxHrLine);
exports.default = AnxHrLine;

/***/ }),

/***/ "0c29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnxIconsNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnxIconsPlugin; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4978");
// --- BEGIN AUTO-GENERATED FILE ---
//
// This file is auto generated on each build. Do not edit this file!
// Run the necessary scripts defined in package.json to generate this file.


var AnxIconsNames = ["AnxIcon24h", "AnxIcon3d", "AnxIconLKWTransport", "AnxIconAiKuenstlicheintelligenz", "AnxIconAlexa", "AnxIconAnderesWeiteresTeil", "AnxIconAndroid", "AnxIconAnexiaStamp", "AnxIconAnexia", "AnxIconApp", "AnxIconApple", "AnxIconArbeitBuero", "AnxIconArrowGreenBottom", "AnxIconArrowRedBottom", "AnxIconAtSign", "AnxIconAuszeichnung", "AnxIconBarcode", "AnxIconBildFoto", "AnxIconBlockchain", "AnxIconCardboardVrBrilleSmartphone", "AnxIconCardboardVrBrille", "AnxIconCheckGreen", "AnxIconCheckWhite", "AnxIconCheck", "AnxIconCloudStorage", "AnxIconCloud", "AnxIconCloudservicesHosting", "AnxIconConnections", "AnxIconController", "AnxIconCopy", "AnxIconDashboardEchtzeitMonitor", "AnxIconDatenbank", "AnxIconDevices", "AnxIconDns", "AnxIconDokument", "AnxIconDollar", "AnxIconDownload", "AnxIconDsl", "AnxIconESim", "AnxIconEingabe", "AnxIconEins", "AnxIconEinstellungenVerwaltung", "AnxIconError", "AnxIconEuro", "AnxIconExperimentierfreudig", "AnxIconFabrik", "AnxIconFirmenautoAuto", "AnxIconFlexibilitaet", "AnxIconFlexibleArbeitszeitenTiming", "AnxIconFolder", "AnxIconForschungEntwicklung", "AnxIconFotoapparat", "AnxIconFramework", "AnxIconGabelstapler", "AnxIconGefahrenWarnung", "AnxIconGenericautomation", "AnxIconHerz", "AnxIconHomeoffice", "AnxIconIdee", "AnxIconInformation", "AnxIconInstallation", "AnxIconInterdisziplinaer", "AnxIconIp", "AnxIconKalender", "AnxIconKontaktTelefonTelekommunikation", "AnxIconKonzept", "AnxIconKunde", "AnxIconKunden", "AnxIconLaden", "AnxIconLastverteilung", "AnxIconLike", "AnxIconLoeschen", "AnxIconMailKontakt", "AnxIconMassgeschneiderteIndividuelleLoesungen", "AnxIconMbaas", "AnxIconMicrocontroller", "AnxIconMitarbeiterevents", "AnxIconMobileEntwicklung", "AnxIconMonitoring", "AnxIconMusik", "AnxIconNetzwerk", "AnxIconOeffentlicherNahverkehr", "AnxIconOffline", "AnxIconOnlineshopWarenkorb", "AnxIconPaket", "AnxIconParkplatz", "AnxIconPartyProjektabschluss", "AnxIconPdf", "AnxIconPfeilLinksKlein", "AnxIconPfeilLinks", "AnxIconPfeilOben", "AnxIconPfeilRechtsKlein", "AnxIconPfeilRechts", "AnxIconPfeilRunter", "AnxIconPflichtenheft", "AnxIconPlatform", "AnxIconPraesentation", "AnxIconProjektablauf", "AnxIconProjektmanagementCheckliste", "AnxIconRedundant", "AnxIconSatellit", "AnxIconSchluessel", "AnxIconScrum", "AnxIconSeoSemCrawler", "AnxIconServerVeerbunden", "AnxIconServiceprovider", "AnxIconSharing", "AnxIconShop", "AnxIconSicherheitFirewall", "AnxIconSignal", "AnxIconSkalierbar", "AnxIconSmartTv", "AnxIconSmartWatch", "AnxIconSmarthome", "AnxIconSoftwareentwicklungCode", "AnxIconSpieleUndSpass", "AnxIconSprechblasen", "AnxIconStandortUnternehmenssitz", "AnxIconStartUp", "AnxIconStatistikAnalysen", "AnxIconStern", "AnxIconStorageBackup", "AnxIconStromEnergie", "AnxIconSuchen", "AnxIconSupportMitarbeiter", "AnxIconTasse", "AnxIconTeam", "AnxIconTechnischerSupport", "AnxIconTextdokument", "AnxIconTextdokumentFragezeichen", "AnxIconTextdokumentRufzeichen", "AnxIconUpload", "AnxIconUserProfil", "AnxIconVerbundeneServerBlade", "AnxIconVerlautbarungWichtigeNewsPressemitteilung", "AnxIconVerpflegungMittagspauseEssen", "AnxIconVerschluesselung", "AnxIconVideo", "AnxIconVierenBugs", "AnxIconVirtualisierung", "AnxIconVollbildVerschieben", "AnxIconVr", "AnxIconWachstumUmsatz", "AnxIconWarningSmall", "AnxIconWarning", "AnxIconWebdesign", "AnxIconWebentwicklung", "AnxIconWeiterbildung", "AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc", "AnxIconWhiteLabel", "AnxIconWidgets", "AnxIconWindows", "AnxIconWlan", "AnxIconX", "AnxIconZeitungMedienNews", "AnxIconZertifikat", "AnxIconZielMarkierung"];
var AnxIconsPlugin = {
  install: function install() {
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIcon24h", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIcon24h */ "a"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIcon3d", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIcon3d */ "b"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconLKWTransport", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconLKWTransport */ "pb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAiKuenstlicheintelligenz", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAiKuenstlicheintelligenz */ "c"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAlexa", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAlexa */ "d"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAnderesWeiteresTeil", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAnderesWeiteresTeil */ "e"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAndroid", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAndroid */ "f"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAnexiaStamp", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAnexiaStamp */ "h"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAnexia", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAnexia */ "g"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconApp", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconApp */ "i"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconApple", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconApple */ "j"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconArbeitBuero", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconArbeitBuero */ "k"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconArrowGreenBottom", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconArrowGreenBottom */ "l"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconArrowRedBottom", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconArrowRedBottom */ "m"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAtSign", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAtSign */ "n"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconAuszeichnung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconAuszeichnung */ "o"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconBarcode", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconBarcode */ "p"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconBildFoto", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconBildFoto */ "q"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconBlockchain", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconBlockchain */ "r"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCardboardVrBrilleSmartphone", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCardboardVrBrilleSmartphone */ "t"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCardboardVrBrille", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCardboardVrBrille */ "s"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCheckGreen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCheckGreen */ "v"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCheckWhite", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCheckWhite */ "w"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCheck", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCheck */ "u"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCloudStorage", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCloudStorage */ "y"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCloud", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCloud */ "x"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCloudservicesHosting", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCloudservicesHosting */ "z"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconConnections", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconConnections */ "A"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconController", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconController */ "B"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconCopy", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconCopy */ "C"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDashboardEchtzeitMonitor", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDashboardEchtzeitMonitor */ "D"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDatenbank", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDatenbank */ "E"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDevices", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDevices */ "F"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDns", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDns */ "G"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDokument", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDokument */ "H"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDollar", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDollar */ "I"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDownload", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDownload */ "J"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconDsl", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconDsl */ "K"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconESim", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconESim */ "L"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconEingabe", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconEingabe */ "M"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconEins", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconEins */ "N"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconEinstellungenVerwaltung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconEinstellungenVerwaltung */ "O"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconError", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconError */ "P"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconEuro", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconEuro */ "Q"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconExperimentierfreudig", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconExperimentierfreudig */ "R"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFabrik", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFabrik */ "S"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFirmenautoAuto", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFirmenautoAuto */ "T"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFlexibilitaet", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFlexibilitaet */ "U"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFlexibleArbeitszeitenTiming", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFlexibleArbeitszeitenTiming */ "V"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFolder", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFolder */ "W"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconForschungEntwicklung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconForschungEntwicklung */ "X"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFotoapparat", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFotoapparat */ "Y"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconFramework", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconFramework */ "Z"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconGabelstapler", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconGabelstapler */ "ab"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconGefahrenWarnung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconGefahrenWarnung */ "bb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconGenericautomation", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconGenericautomation */ "cb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconHerz", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconHerz */ "db"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconHomeoffice", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconHomeoffice */ "eb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconIdee", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconIdee */ "fb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconInformation", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconInformation */ "gb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconInstallation", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconInstallation */ "hb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconInterdisziplinaer", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconInterdisziplinaer */ "ib"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconIp", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconIp */ "jb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconKalender", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconKalender */ "kb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconKontaktTelefonTelekommunikation", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconKontaktTelefonTelekommunikation */ "lb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconKonzept", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconKonzept */ "mb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconKunde", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconKunde */ "nb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconKunden", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconKunden */ "ob"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconLaden", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconLaden */ "qb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconLastverteilung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconLastverteilung */ "rb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconLike", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconLike */ "sb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconLoeschen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconLoeschen */ "tb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMailKontakt", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMailKontakt */ "ub"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMassgeschneiderteIndividuelleLoesungen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMassgeschneiderteIndividuelleLoesungen */ "vb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMbaas", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMbaas */ "wb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMicrocontroller", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMicrocontroller */ "xb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMitarbeiterevents", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMitarbeiterevents */ "yb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMobileEntwicklung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMobileEntwicklung */ "zb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMonitoring", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMonitoring */ "Ab"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconMusik", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconMusik */ "Bb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconNetzwerk", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconNetzwerk */ "Cb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconOeffentlicherNahverkehr", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconOeffentlicherNahverkehr */ "Db"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconOffline", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconOffline */ "Eb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconOnlineshopWarenkorb", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconOnlineshopWarenkorb */ "Fb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPaket", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPaket */ "Gb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconParkplatz", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconParkplatz */ "Hb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPartyProjektabschluss", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPartyProjektabschluss */ "Ib"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPdf", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPdf */ "Jb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPfeilLinksKlein", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPfeilLinksKlein */ "Lb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPfeilLinks", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPfeilLinks */ "Kb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPfeilOben", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPfeilOben */ "Mb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPfeilRechtsKlein", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPfeilRechtsKlein */ "Ob"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPfeilRechts", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPfeilRechts */ "Nb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPfeilRunter", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPfeilRunter */ "Pb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPflichtenheft", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPflichtenheft */ "Qb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPlatform", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPlatform */ "Rb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconPraesentation", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconPraesentation */ "Sb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconProjektablauf", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconProjektablauf */ "Tb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconProjektmanagementCheckliste", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconProjektmanagementCheckliste */ "Ub"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconRedundant", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconRedundant */ "Vb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSatellit", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSatellit */ "Wb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSchluessel", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSchluessel */ "Xb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconScrum", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconScrum */ "Yb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSeoSemCrawler", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSeoSemCrawler */ "Zb"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconServerVeerbunden", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconServerVeerbunden */ "ac"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconServiceprovider", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconServiceprovider */ "bc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSharing", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSharing */ "cc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconShop", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconShop */ "dc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSicherheitFirewall", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSicherheitFirewall */ "ec"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSignal", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSignal */ "fc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSkalierbar", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSkalierbar */ "gc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSmartTv", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSmartTv */ "hc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSmartWatch", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSmartWatch */ "ic"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSmarthome", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSmarthome */ "jc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSoftwareentwicklungCode", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSoftwareentwicklungCode */ "kc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSpieleUndSpass", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSpieleUndSpass */ "lc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSprechblasen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSprechblasen */ "mc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconStandortUnternehmenssitz", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconStandortUnternehmenssitz */ "nc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconStartUp", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconStartUp */ "oc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconStatistikAnalysen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconStatistikAnalysen */ "pc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconStern", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconStern */ "qc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconStorageBackup", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconStorageBackup */ "rc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconStromEnergie", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconStromEnergie */ "sc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSuchen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSuchen */ "tc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconSupportMitarbeiter", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconSupportMitarbeiter */ "uc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconTasse", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconTasse */ "vc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconTeam", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconTeam */ "wc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconTechnischerSupport", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconTechnischerSupport */ "xc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconTextdokument", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconTextdokument */ "yc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconTextdokumentFragezeichen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconTextdokumentFragezeichen */ "zc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconTextdokumentRufzeichen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconTextdokumentRufzeichen */ "Ac"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconUpload", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconUpload */ "Bc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconUserProfil", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconUserProfil */ "Cc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVerbundeneServerBlade", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVerbundeneServerBlade */ "Dc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVerlautbarungWichtigeNewsPressemitteilung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVerlautbarungWichtigeNewsPressemitteilung */ "Ec"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVerpflegungMittagspauseEssen", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVerpflegungMittagspauseEssen */ "Fc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVerschluesselung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVerschluesselung */ "Gc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVideo", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVideo */ "Hc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVierenBugs", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVierenBugs */ "Ic"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVirtualisierung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVirtualisierung */ "Jc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVollbildVerschieben", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVollbildVerschieben */ "Kc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconVr", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconVr */ "Lc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWachstumUmsatz", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWachstumUmsatz */ "Mc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWarningSmall", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWarningSmall */ "Oc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWarning", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWarning */ "Nc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWebdesign", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWebdesign */ "Pc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWebentwicklung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWebentwicklung */ "Qc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWeiterbildung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWeiterbildung */ "Rc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc */ "Sc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWhiteLabel", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWhiteLabel */ "Tc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWidgets", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWidgets */ "Uc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWindows", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWindows */ "Vc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconWlan", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconWlan */ "Wc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconX", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconX */ "Xc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconZeitungMedienNews", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconZeitungMedienNews */ "Yc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconZertifikat", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconZertifikat */ "Zc"]);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.component("AnxIconZielMarkierung", _icons__WEBPACK_IMPORTED_MODULE_1__[/* AnxIconZielMarkierung */ "ad"]);
  }
}; // --- END AUTO-GENERATED FILE ---

/***/ }),

/***/ "0c7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1f23");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0df1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a322");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0e0b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};

/***/ }),

/***/ "0e0f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "102a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e0bb");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1129":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxList/AnxList.vue?vue&type=template&id=67e37bb0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:{
    'anx-list': true,
    'no-padding': _vm.noPadding !== null,
    'with-icon': _vm.icon !== null,
    'no-spacing': _vm.noSpacing !== null
  },style:({ listStyleType: _vm.listStyleType, marginBottom: _vm.marginBottom, marginTop: _vm.marginTop })},_vm._l((_vm.items),function(item,i){return _c('li',{key:(i + "-" + item)},[_vm._t(("icon" + i),function(){return [(_vm.icon)?_c('anx-icon',{staticClass:"anx-icon-list",attrs:{"icon":_vm.icon}}):_vm._e()]}),_vm._t(("item" + i),function(){return [_c('span',[_vm._v(" "+_vm._s(item)+" ")])]})],2)}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxList/AnxList.vue?vue&type=template&id=67e37bb0&scoped=true&


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var stickyHelpers = __webpack_require__("9f7f");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, UNSUPPORTED_Y);


/***/ }),

/***/ "140e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1505":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("70d7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "1816":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__("440d")
  , qs = __webpack_require__("9c59")
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:[\\/]+/
  , protocolre = /^([a-z][a-z0-9.+-]*:)?([\\/]{1,})?([\S\s]*)/i
  , whitespace = '[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]'
  , left = new RegExp('^'+ whitespace +'+');

/**
 * Trim a given string.
 *
 * @param {String} str String to trim.
 * @public
 */
function trimLeft(str) {
  return (str ? str : '').toString().replace(left, '');
}

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address) {          // Sanitize what is left of the address
    return address.replace('\\', '/');
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof global !== 'undefined') globalVar = global;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  address = trimLeft(address);

  var match = protocolre.exec(address)
    , protocol = match[1] ? match[1].toLowerCase() : ''
    , slashes = !!(match[2] && match[2].length >= 2)
    , rest =  match[2] && match[2].length === 1 ? '/' + match[3] : match[3];

  return {
    protocol: protocol,
    slashes: slashes,
    rest: rest
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  if (relative === '') return base;

  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  address = trimLeft(address);

  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // Default to a / for pathname if none exists. This normalizes the URL
  // to always have a /
  //
  if (url.pathname.charAt(0) !== '/' && url.hostname) {
    url.pathname = '/' + url.pathname;
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;

module.exports = Url;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dc4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxLanguageSwitcher_vue_vue_type_template_id_7657fe93_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f33f");
/* harmony import */ var _AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0c7a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxLanguageSwitcher_vue_vue_type_style_index_0_id_7657fe93_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8659");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxLanguageSwitcher_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxLanguageSwitcher_vue_vue_type_template_id_7657fe93_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxLanguageSwitcher_vue_vue_type_template_id_7657fe93_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "7657fe93",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1e24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e5cc");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1eb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* unused harmony default export */ var _unused_webpack_default_export = (null);


/***/ }),

/***/ "1f23":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxLink_vue_1 = tslib_1.__importDefault(__webpack_require__("a059"));
/**
 * This component is a simple implementation of a language switcher in combination with Vue-I18n
 */


var I18nLangSwitcher = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(I18nLangSwitcher, _vue_property_decorat);

  var _super = _createSuper(I18nLangSwitcher);

  function I18nLangSwitcher() {
    var _this;

    _classCallCheck(this, I18nLangSwitcher);

    _this = _super.apply(this, arguments);
    /** The current locale */

    _this.locale = "";
    return _this;
  }
  /** Emit the changes languages as @localeChange event */


  _createClass(I18nLangSwitcher, [{
    key: "setLocale",
    value: function setLocale(locale) {
      /** Set the locale in the property */
      this.locale = locale;
      /** Set the locale for the i18n instance if provided */

      if (this.i18n !== null) {
        this.i18n.locale = locale;
      }

      return locale;
    }
    /** Sync the current locale with the i18n locale on mount */

  }, {
    key: "mounted",
    value: function mounted() {
      if (this.i18n) {
        this.locale = this.i18n.locale;
      }
    }
  }]);

  return I18nLangSwitcher;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  required: true
})], I18nLangSwitcher.prototype, "i18n", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return [{
      code: "de",
      link: null,
      text: "DE"
    }, {
      code: "en",
      link: null,
      text: "EN"
    }];
  }
})], I18nLangSwitcher.prototype, "languages", void 0);

tslib_1.__decorate([vue_property_decorator_1.Emit("localeChange")], I18nLangSwitcher.prototype, "setLocale", null);

I18nLangSwitcher = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxLink: AnxLink_vue_1.default
  }
})], I18nLangSwitcher);
exports.default = I18nLangSwitcher;

/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("90d7");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "25ec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2739":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f598");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2769":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxIcon_vue_vue_type_template_id_a1b355ac_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c2b8");
/* harmony import */ var _AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7a3a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxIcon_vue_vue_type_style_index_0_id_a1b355ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fa08");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxIcon_vue_vue_type_template_id_a1b355ac_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxIcon_vue_vue_type_template_id_a1b355ac_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "a1b355ac",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "28ab":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "28c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxModal/AnxModal.vue?vue&type=template&id=3d074454&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"anxModalOutsideContainer",class:("modal anx-modal anx-modal-size-" + _vm.size),attrs:{"id":_vm._id},on:{"click":_vm.checkForClosing}},[_c('div',{class:'modal-dialog modal-dialog-scrollable',attrs:{"id":(_vm._id + "-dialog")}},[_c('div',{staticClass:"modal-content anx-modal-content"},[_c('div',{staticClass:"modal-header  anx-modal-header"},[_c('button',{staticClass:"close close-button-x",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"close-symbol"})]),_c('div',{staticClass:"h2 modal-title heading",domProps:{"textContent":_vm._s(_vm.title)}}),_c('div',{staticClass:"small-line h2"},[_vm._v(" — ")])]),_c('div',{staticClass:"modal-body  anx-modal-body"},[_vm._t("default")],2),(_vm.confirm !== null)?_c('div',{class:("modal-footer anx-modal-footer footer-content-" + _vm.closeButtonAlign)},[_c('anx-button',{staticClass:"close-button",attrs:{"text":_vm.closeButtonText,"outline":""},on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{staticClass:"space"}),_c('anx-button',{staticClass:"confirm-button",attrs:{"text":_vm.confirmButtonText},on:{"click":function($event){return _vm.$emit('confirm')}}}),_vm._t("modal-footer")],2):_c('div',{class:("modal-footer anx-modal-footer footer-content-" + _vm.closeButtonAlign)},[(_vm.hasCloseButton !== null)?_c('anx-button',{staticClass:"close-button",attrs:{"text":_vm.closeButtonText},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e(),_vm._t("modal-footer")],2)])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxModal/AnxModal.vue?vue&type=template&id=3d074454&scoped=true&


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "2b0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2ebd");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2bc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_style_index_0_id_35d78eab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("09ac");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_style_index_0_id_35d78eab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableContainer_vue_vue_type_style_index_0_id_35d78eab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2be7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * A table colum for the *anx-table*
 */


var AnxTableCol = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxTableCol, _vue_property_decorat);

  var _super = _createSuper(AnxTableCol);

  function AnxTableCol() {
    _classCallCheck(this, AnxTableCol);

    return _super.apply(this, arguments);
  }

  return AnxTableCol;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxTableCol.prototype, "content", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "left"
})], AnxTableCol.prototype, "align", void 0);

AnxTableCol = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxTableCol);
exports.default = AnxTableCol;

/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var bind = __webpack_require__("0366");
var html = __webpack_require__("1be4");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "2d0d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ae1");

var getPrototypeOf = __webpack_require__("36c6");

var isNativeReflectConstruct = __webpack_require__("6f8f");

var possibleConstructorReturn = __webpack_require__("6b58");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return possibleConstructorReturn(this, result);
  };
}

module.exports = _createSuper;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "2de1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxTableCol_vue_vue_type_template_id_28ec5454_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6dc8");
/* harmony import */ var _AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("94b7");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxTableCol_vue_vue_type_style_index_0_id_28ec5454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a26f");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxTableCol_vue_vue_type_template_id_28ec5454_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxTableCol_vue_vue_type_template_id_28ec5454_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "28ec5454",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "2ebd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("b0c0");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * A simple link with VueRouter integrated
 */


var AnxLink = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxLink, _vue_property_decorat);

  var _super = _createSuper(AnxLink);

  function AnxLink() {
    var _this;

    _classCallCheck(this, AnxLink);

    _this = _super.apply(this, arguments);
    /** Require the url module (import can't be used because it does not have @types) */

    _this.Url = __webpack_require__("1816");
    return _this;
  }
  /** Emit the click event */


  _createClass(AnxLink, [{
    key: "click",
    value: function click(event) {
      /** Check if the vue router can/should be used */
      if (this.useVueRouter) {
        /** Prevent the default event for link */
        event.preventDefault();
        /** If a route name is defined, use it instead of the href */

        if (this.routeName && this.$route) {
          /** If the window should be opened in a new tab, this is done independent from the route name */
          if (this.newTab !== null) {
            /** Logic to open link in new tab by route name */
            var url = new this.Url(this.$router.resolve({
              name: this.routeName
            }).href);
            window.open(url.href);
            /** If the window should be opened in the same window, this is only done if the current route name and the provided route name differ */
          } else {
            if (this.$route.name !== this.routeName && this.newTab === null) {
              this.$router.push({
                name: this.routeName
              });
            }
          }
        } else {
          /** Only push to the new route if the link is different from the current location */

          /** Check if the url should be opened in a new tab */
          if (this.newTab !== null) {
            /** If the url is internal, the href has to be parsed first to get the pathname that is then parsed with the vue router */
            var pathname = new this.Url(this.href).pathname;

            var _url = new this.Url(this.$router.resolve(pathname).href);

            window.open(_url.href);
          } else {
            if (this.isDifferentUrl) {
              /** Parse the url first to get the path name (in case a full href with hostname is provided) */
              var _url2 = new this.Url(this.href);

              this.$router.push(_url2.pathname + _url2.hash);
            }
          }
        }
      }

      return;
    }
    /**
     * Checks if the vue router can/should be used
     * - Router has to be defined (!= null)
     * - The url has to be internal
     * - The external property mustn't be set
     */

  }, {
    key: "useVueRouter",
    get: function get() {
      return this.$router && this.isInternalUrl && this.external === null;
    }
    /** Checks if the provided url is internal */

  }, {
    key: "isInternalUrl",
    get: function get() {
      var url = new this.Url(this.href);
      var currentUrl = new this.Url(window.location.href);
      return url.host == currentUrl.host;
    }
    /** Check if the provided url differs from the current url (window location) */

  }, {
    key: "isDifferentUrl",
    get: function get() {
      var url = new this.Url(this.href);
      var currentUrl = new this.Url(window.location.href);
      return url.href !== currentUrl.href;
    }
  }]);

  return AnxLink;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLink.prototype, "disabled", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "default"
})], AnxLink.prototype, "disabledStyle", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxLink.prototype, "href", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLink.prototype, "routeName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLink.prototype, "external", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLink.prototype, "newTab", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLink.prototype, "noStyle", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxLink.prototype, "text", void 0);

tslib_1.__decorate([vue_property_decorator_1.Emit("click")], AnxLink.prototype, "click", null);

AnxLink = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxLink);
exports.default = AnxLink;

/***/ }),

/***/ "2fce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ AnxAlertPlugin; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./src/components/AnxAlert/AnxAlert.vue
var AnxAlert = __webpack_require__("3321");

// CONCATENATED MODULE: ./src/plugins/alert/api.js



var api_Api = function Api(Vue) {
  var globalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // This is alert stuff
  var alert = {
    text: null,
    target: null
  };

  function getAlert(propsData, target) {
    var componentClass = Vue.extend(AnxAlert["default"]);
    var instance = new componentClass({
      propsData: propsData
    });
    instance.$mount();

    if (alert[instance]) {
      return alert[instance];
    } else {
      if (target !== undefined) {
        document.querySelector(target).appendChild(instance.$el);
      } else {
        document.body.appendChild(instance.$el);
      }
    } // Remove instance


    instance.$on("destroy", function () {
      alert[instance] = null;

      try {
        document.body.removeChild(instance.$el);
      } catch (ex) {// Dont't handle this exception
      }
    });
    alert[instance] = instance;
    return instance;
  }

  return {
    show: function show(text, target) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var localOptions = Object(objectSpread2["a" /* default */])({
        text: text,
        target: target
      }, options);

      var propsData = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, globalOptions), localOptions);

      var alert = getAlert(propsData, target);
      alert.showAction({
        propsData: propsData
      });
      return alert;
    }
  };
};

/* harmony default export */ var api = (api_Api);
// CONCATENATED MODULE: ./src/plugins/alert/plugin.js

var AnxAlertPlugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var methods = api(Vue, options);
    Vue.prototype.$anxAlert = methods;
    Vue.$anxAlert = methods;
  }
};
// CONCATENATED MODULE: ./src/plugins/alert/index.js


/***/ }),

/***/ "3097":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxButton_vue_vue_type_template_id_4d673718_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e24a");
/* harmony import */ var _AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("f03a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxButton_vue_vue_type_style_index_0_id_4d673718_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("65cb");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxButton_vue_vue_type_template_id_4d673718_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxButton_vue_vue_type_template_id_4d673718_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "4d673718",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "3288":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3321":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxAlert_vue_vue_type_template_id_33abed87_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a8f3");
/* harmony import */ var _AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("bac9");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxAlert_vue_vue_type_style_index_0_id_33abed87_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0ac0");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxAlert_vue_vue_type_template_id_33abed87_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxAlert_vue_vue_type_template_id_33abed87_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "33abed87",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "345b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxHrLine/AnxHrLine.vue?vue&type=template&id=736bfe57&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{class:("anx-hr-line " + _vm.color),style:(_vm.cssProps)})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxHrLine/AnxHrLine.vue?vue&type=template&id=736bfe57&scoped=true&


/***/ }),

/***/ "3473":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxForm_vue_vue_type_template_id_7db652f3_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6e7f");
/* harmony import */ var _AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("24a8");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxForm_vue_vue_type_style_index_0_id_7db652f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b332");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxForm_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxForm_vue_vue_type_template_id_7db652f3_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxForm_vue_vue_type_template_id_7db652f3_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "7db652f3",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "34d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0c18");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "34f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e0b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3535":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_style_index_0_id_3ccffd92_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("884c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_style_index_0_id_3ccffd92_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableRow_vue_vue_type_style_index_0_id_3ccffd92_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3617":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnxToaster = exports.AnxToast = exports.AnxTitle = exports.AnxTextarea = exports.AnxTableRow = exports.AnxTableContainer = exports.AnxTableCol = exports.AnxTable = exports.AnxSelect = exports.AnxReadonly = exports.AnxParagraph = exports.AnxModal = exports.AnxLogin = exports.AnxList = exports.AnxLink = exports.AnxLanguageSwitcher = exports.AnxInput = exports.AnxIcon = exports.AnxHrLine = exports.AnxHeader = exports.AnxGlobal = exports.AnxFormContainer = exports.AnxForm = exports.AnxFooter = exports.AnxCrudTable = exports.AnxContent = exports.AnxContainer = exports.AnxContact = exports.AnxCheckbox = exports.AnxCard = exports.AnxButton = exports.AnxAlert = void 0;

var tslib_1 = __webpack_require__("9ab4");

var AnxAlert_vue_1 = tslib_1.__importDefault(__webpack_require__("3321"));

exports.AnxAlert = AnxAlert_vue_1.default;

var AnxButton_vue_1 = tslib_1.__importDefault(__webpack_require__("3097"));

exports.AnxButton = AnxButton_vue_1.default;

var AnxCard_vue_1 = tslib_1.__importDefault(__webpack_require__("0b33"));

exports.AnxCard = AnxCard_vue_1.default;

var AnxCheckbox_vue_1 = tslib_1.__importDefault(__webpack_require__("7f56"));

exports.AnxCheckbox = AnxCheckbox_vue_1.default;

var AnxContact_vue_1 = tslib_1.__importDefault(__webpack_require__("628e"));

exports.AnxContact = AnxContact_vue_1.default;

var AnxContainer_vue_1 = tslib_1.__importDefault(__webpack_require__("d919"));

exports.AnxContainer = AnxContainer_vue_1.default;

var AnxContent_vue_1 = tslib_1.__importDefault(__webpack_require__("09f6"));

exports.AnxContent = AnxContent_vue_1.default;

var AnxCrudTable_vue_1 = tslib_1.__importDefault(__webpack_require__("97e8"));

exports.AnxCrudTable = AnxCrudTable_vue_1.default;

var AnxFooter_vue_1 = tslib_1.__importDefault(__webpack_require__("3822"));

exports.AnxFooter = AnxFooter_vue_1.default;

var AnxForm_vue_1 = tslib_1.__importDefault(__webpack_require__("3473"));

exports.AnxForm = AnxForm_vue_1.default;

var AnxFormContainer_vue_1 = tslib_1.__importDefault(__webpack_require__("6755"));

exports.AnxFormContainer = AnxFormContainer_vue_1.default;

var AnxGlobal_vue_1 = tslib_1.__importDefault(__webpack_require__("d746"));

exports.AnxGlobal = AnxGlobal_vue_1.default;

var AnxHeader_vue_1 = tslib_1.__importDefault(__webpack_require__("518b"));

exports.AnxHeader = AnxHeader_vue_1.default;

var AnxHrLine_vue_1 = tslib_1.__importDefault(__webpack_require__("825a1"));

exports.AnxHrLine = AnxHrLine_vue_1.default;

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));

exports.AnxIcon = AnxIcon_vue_1.default;

var AnxInput_vue_1 = tslib_1.__importDefault(__webpack_require__("6911"));

exports.AnxInput = AnxInput_vue_1.default;

var AnxLink_vue_1 = tslib_1.__importDefault(__webpack_require__("a059"));

exports.AnxLink = AnxLink_vue_1.default;

var AnxList_vue_1 = tslib_1.__importDefault(__webpack_require__("4c67"));

exports.AnxList = AnxList_vue_1.default;

var AnxLogin_vue_1 = tslib_1.__importDefault(__webpack_require__("9213"));

exports.AnxLogin = AnxLogin_vue_1.default;

var AnxLanguageSwitcher_vue_1 = tslib_1.__importDefault(__webpack_require__("1dc4"));

exports.AnxLanguageSwitcher = AnxLanguageSwitcher_vue_1.default;

var AnxModal_vue_1 = tslib_1.__importDefault(__webpack_require__("b4c7"));

exports.AnxModal = AnxModal_vue_1.default;

var AnxParagraph_vue_1 = tslib_1.__importDefault(__webpack_require__("78a2"));

exports.AnxParagraph = AnxParagraph_vue_1.default;

var AnxReadonly_vue_1 = tslib_1.__importDefault(__webpack_require__("a430"));

exports.AnxReadonly = AnxReadonly_vue_1.default;

var AnxSelect_vue_1 = tslib_1.__importDefault(__webpack_require__("6bb2"));

exports.AnxSelect = AnxSelect_vue_1.default;

var AnxTable_vue_1 = tslib_1.__importDefault(__webpack_require__("ac31"));

exports.AnxTable = AnxTable_vue_1.default;

var AnxTableCol_vue_1 = tslib_1.__importDefault(__webpack_require__("2de1"));

exports.AnxTableCol = AnxTableCol_vue_1.default;

var AnxTableContainer_vue_1 = tslib_1.__importDefault(__webpack_require__("e7fc"));

exports.AnxTableContainer = AnxTableContainer_vue_1.default;

var AnxTableRow_vue_1 = tslib_1.__importDefault(__webpack_require__("d25a"));

exports.AnxTableRow = AnxTableRow_vue_1.default;

var AnxTextarea_vue_1 = tslib_1.__importDefault(__webpack_require__("f682"));

exports.AnxTextarea = AnxTextarea_vue_1.default;

var AnxTitle_vue_1 = tslib_1.__importDefault(__webpack_require__("d602"));

exports.AnxTitle = AnxTitle_vue_1.default;

var AnxToast_vue_1 = tslib_1.__importDefault(__webpack_require__("84c8"));

exports.AnxToast = AnxToast_vue_1.default;

var AnxToaster_vue_1 = tslib_1.__importDefault(__webpack_require__("9c0c"));

exports.AnxToaster = AnxToaster_vue_1.default; // Default export

exports.default = {
  AnxAlert: AnxAlert_vue_1.default,
  AnxButton: AnxButton_vue_1.default,
  AnxCard: AnxCard_vue_1.default,
  AnxCheckbox: AnxCheckbox_vue_1.default,
  AnxContact: AnxContact_vue_1.default,
  AnxContainer: AnxContainer_vue_1.default,
  AnxContent: AnxContent_vue_1.default,
  AnxCrudTable: AnxCrudTable_vue_1.default,
  AnxFooter: AnxFooter_vue_1.default,
  AnxForm: AnxForm_vue_1.default,
  AnxFormContainer: AnxFormContainer_vue_1.default,
  AnxGlobal: AnxGlobal_vue_1.default,
  AnxHeader: AnxHeader_vue_1.default,
  AnxHrLine: AnxHrLine_vue_1.default,
  AnxIcon: AnxIcon_vue_1.default,
  AnxInput: AnxInput_vue_1.default,
  AnxLanguageSwitcher: AnxLanguageSwitcher_vue_1.default,
  AnxLink: AnxLink_vue_1.default,
  AnxList: AnxList_vue_1.default,
  AnxLogin: AnxLogin_vue_1.default,
  AnxModal: AnxModal_vue_1.default,
  AnxParagraph: AnxParagraph_vue_1.default,
  AnxReadonly: AnxReadonly_vue_1.default,
  AnxSelect: AnxSelect_vue_1.default,
  AnxTable: AnxTable_vue_1.default,
  AnxTableCol: AnxTableCol_vue_1.default,
  AnxTableContainer: AnxTableContainer_vue_1.default,
  AnxTableRow: AnxTableRow_vue_1.default,
  AnxTextarea: AnxTextarea_vue_1.default,
  AnxTitle: AnxTitle_vue_1.default,
  AnxToast: AnxToast_vue_1.default
};

/***/ }),

/***/ "3637":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9982");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "36c6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3410");

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3812":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var vee_validate_1 = __webpack_require__("7bb1");

var AttributesHelper_1 = __webpack_require__("4bc1");
/**
 * The *anx-checkbox* renders a simple checkbox.
 * It works like a default HTML checkbox, but has some features implemented.
 * The layout of the checkbox also differs from a default checkbox.
 */


var AnxCheckbox = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxCheckbox, _vue_property_decorat);

  var _super = _createSuper(AnxCheckbox);

  function AnxCheckbox() {
    var _this;

    _classCallCheck(this, AnxCheckbox);

    _this = _super.apply(this, arguments);
    /** The id that is actually used */

    _this.inputId = "";
    /** Use a seperate variable for v-model in the AnxCheckbox component to avoid mutating the parent property directly */

    _this.valueModel = false;
    return _this;
  }
  /** Watch, if the value in the parent changes */


  _createClass(AnxCheckbox, [{
    key: "onValueChanged",
    value: function onValueChanged(newVal) {
      this.valueModel = newVal;
    }
    /**
     * Set the id for the component when created
     */

  }, {
    key: "created",
    value: function created() {
      this.inputId = AttributesHelper_1.AttributesHelper.attributes(this, {
        uniqueId: true,
        uniqueIdPrefix: "anx-input-"
      }).id;
    }
    /** Assign the value to the variable we use for v-model */

  }, {
    key: "beforeMount",
    value: function beforeMount() {
      this.valueModel = this.value;
    }
  }]);

  return AnxCheckbox;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxCheckbox.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxCheckbox.prototype, "name", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxCheckbox.prototype, "validation", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({})], AnxCheckbox.prototype, "value", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("value")], AnxCheckbox.prototype, "onValueChanged", null);

AnxCheckbox = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    ValidationProvider: vee_validate_1.ValidationProvider
  }
})], AnxCheckbox);
exports.default = AnxCheckbox;

/***/ }),

/***/ "3822":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxFooter_vue_vue_type_template_id_3716aafa_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4a5e");
/* harmony import */ var _AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d38a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxFooter_vue_vue_type_style_index_0_id_3716aafa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("bc7c");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxFooter_vue_vue_type_template_id_3716aafa_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxFooter_vue_vue_type_template_id_3716aafa_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "3716aafa",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "3a9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxInput/AnxInput.vue?vue&type=template&id=526a1d8a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"observer",class:{
    'anx-input': true,
    active: _vm.active,
    filled: _vm.filled,
    inline: _vm.inline !== null ? true : false,
    'is-disabled': _vm.disabled !== null ? true : false
  },style:(_vm.cssProps),attrs:{"name":_vm.dataVvAs === null ? _vm.name : _vm.dataVvAs,"rules":_vm.rules,"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
  var valid = ref.valid;
return [((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],class:{
      'is-invalid': errors && errors.length > 0,
      'with-margin': (typeof valid !== 'boolean' || valid) && !_vm.assistiveText
    },attrs:{"id":_vm.inputId,"name":_vm.name,"hide-details":"true","autocomplete":_vm.autocomplete,"readonly":_vm.readonly !== null ? true : false,"disabled":_vm.disabled !== null,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.localValue)?_vm._i(_vm.localValue,null)>-1:(_vm.localValue)},on:{"blur":_vm.inputBlur,"click":function($event){return _vm.clickInputField()},"input":function($event){return _vm.$emit('input', _vm.localValue)},"change":function($event){var $$a=_vm.localValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.localValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.localValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.localValue=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],class:{
      'is-invalid': errors && errors.length > 0,
      'with-margin': (typeof valid !== 'boolean' || valid) && !_vm.assistiveText
    },attrs:{"id":_vm.inputId,"name":_vm.name,"hide-details":"true","autocomplete":_vm.autocomplete,"readonly":_vm.readonly !== null ? true : false,"disabled":_vm.disabled !== null,"type":"radio"},domProps:{"checked":_vm._q(_vm.localValue,null)},on:{"blur":_vm.inputBlur,"click":function($event){return _vm.clickInputField()},"input":function($event){return _vm.$emit('input', _vm.localValue)},"change":function($event){_vm.localValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],class:{
      'is-invalid': errors && errors.length > 0,
      'with-margin': (typeof valid !== 'boolean' || valid) && !_vm.assistiveText
    },attrs:{"id":_vm.inputId,"name":_vm.name,"hide-details":"true","autocomplete":_vm.autocomplete,"readonly":_vm.readonly !== null ? true : false,"disabled":_vm.disabled !== null,"type":_vm.type},domProps:{"value":(_vm.localValue)},on:{"blur":_vm.inputBlur,"click":function($event){return _vm.clickInputField()},"input":[function($event){if($event.target.composing){ return; }_vm.localValue=$event.target.value},function($event){return _vm.$emit('input', _vm.localValue)}]}}),_c('label',{class:errors && errors.length > 0 ? 'error' : '',attrs:{"for":_vm.inputId},domProps:{"textContent":_vm._s(_vm.label)}}),(
      (errors && errors.length > 0) ||
        (_vm.assistiveText && _vm.assistiveText.length > 0)
    )?_c('div',{class:{
      'anx-input-hint': true,
      inline: _vm.inline !== null ? true : false
    }},[(errors && errors.length > 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(errors[0]))]):(_vm.assistiveText && _vm.assistiveText.length > 0)?_c('span',{staticClass:"assistiv"},[_vm._v(_vm._s(_vm.assistiveText))]):_vm._e()]):_vm._e(),(_vm.inline !== null)?_c('div',{staticClass:"inline-content-right"},[_vm._t("default")],2):_vm._e()]}}],null,true)})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxInput/AnxInput.vue?vue&type=template&id=526a1d8a&scoped=true&


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3bd6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3c96":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "41cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_style_index_0_id_2eb4993f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d27c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_style_index_0_id_2eb4993f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_style_index_0_id_2eb4993f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "440d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "47fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("86ec");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "4978":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AnxIcon24h; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ AnxIcon3d; });
__webpack_require__.d(__webpack_exports__, "pb", function() { return /* binding */ AnxIconLKWTransport; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ AnxIconAiKuenstlicheintelligenz; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ AnxIconAlexa; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ AnxIconAnderesWeiteresTeil; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ AnxIconAndroid; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ AnxIconAnexiaStamp; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ AnxIconAnexia; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ AnxIconApp; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ AnxIconApple; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ AnxIconArbeitBuero; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ AnxIconArrowGreenBottom; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ AnxIconArrowRedBottom; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ AnxIconAtSign; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ AnxIconAuszeichnung; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ AnxIconBarcode; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ AnxIconBildFoto; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ AnxIconBlockchain; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ AnxIconCardboardVrBrilleSmartphone; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ AnxIconCardboardVrBrille; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ AnxIconCheckGreen; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ AnxIconCheckWhite; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ AnxIconCheck; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* binding */ AnxIconCloudStorage; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* binding */ AnxIconCloud; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* binding */ AnxIconCloudservicesHosting; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* binding */ AnxIconConnections; });
__webpack_require__.d(__webpack_exports__, "B", function() { return /* binding */ AnxIconController; });
__webpack_require__.d(__webpack_exports__, "C", function() { return /* binding */ AnxIconCopy; });
__webpack_require__.d(__webpack_exports__, "D", function() { return /* binding */ AnxIconDashboardEchtzeitMonitor; });
__webpack_require__.d(__webpack_exports__, "E", function() { return /* binding */ AnxIconDatenbank; });
__webpack_require__.d(__webpack_exports__, "F", function() { return /* binding */ AnxIconDevices; });
__webpack_require__.d(__webpack_exports__, "G", function() { return /* binding */ AnxIconDns; });
__webpack_require__.d(__webpack_exports__, "H", function() { return /* binding */ AnxIconDokument; });
__webpack_require__.d(__webpack_exports__, "I", function() { return /* binding */ AnxIconDollar; });
__webpack_require__.d(__webpack_exports__, "J", function() { return /* binding */ AnxIconDownload; });
__webpack_require__.d(__webpack_exports__, "K", function() { return /* binding */ AnxIconDsl; });
__webpack_require__.d(__webpack_exports__, "L", function() { return /* binding */ AnxIconESim; });
__webpack_require__.d(__webpack_exports__, "M", function() { return /* binding */ AnxIconEingabe; });
__webpack_require__.d(__webpack_exports__, "N", function() { return /* binding */ AnxIconEins; });
__webpack_require__.d(__webpack_exports__, "O", function() { return /* binding */ AnxIconEinstellungenVerwaltung; });
__webpack_require__.d(__webpack_exports__, "P", function() { return /* binding */ AnxIconError; });
__webpack_require__.d(__webpack_exports__, "Q", function() { return /* binding */ AnxIconEuro; });
__webpack_require__.d(__webpack_exports__, "R", function() { return /* binding */ AnxIconExperimentierfreudig; });
__webpack_require__.d(__webpack_exports__, "S", function() { return /* binding */ AnxIconFabrik; });
__webpack_require__.d(__webpack_exports__, "T", function() { return /* binding */ AnxIconFirmenautoAuto; });
__webpack_require__.d(__webpack_exports__, "U", function() { return /* binding */ AnxIconFlexibilitaet; });
__webpack_require__.d(__webpack_exports__, "V", function() { return /* binding */ AnxIconFlexibleArbeitszeitenTiming; });
__webpack_require__.d(__webpack_exports__, "W", function() { return /* binding */ AnxIconFolder; });
__webpack_require__.d(__webpack_exports__, "X", function() { return /* binding */ AnxIconForschungEntwicklung; });
__webpack_require__.d(__webpack_exports__, "Y", function() { return /* binding */ AnxIconFotoapparat; });
__webpack_require__.d(__webpack_exports__, "Z", function() { return /* binding */ AnxIconFramework; });
__webpack_require__.d(__webpack_exports__, "ab", function() { return /* binding */ AnxIconGabelstapler; });
__webpack_require__.d(__webpack_exports__, "bb", function() { return /* binding */ AnxIconGefahrenWarnung; });
__webpack_require__.d(__webpack_exports__, "cb", function() { return /* binding */ AnxIconGenericautomation; });
__webpack_require__.d(__webpack_exports__, "db", function() { return /* binding */ AnxIconHerz; });
__webpack_require__.d(__webpack_exports__, "eb", function() { return /* binding */ AnxIconHomeoffice; });
__webpack_require__.d(__webpack_exports__, "fb", function() { return /* binding */ AnxIconIdee; });
__webpack_require__.d(__webpack_exports__, "gb", function() { return /* binding */ AnxIconInformation; });
__webpack_require__.d(__webpack_exports__, "hb", function() { return /* binding */ AnxIconInstallation; });
__webpack_require__.d(__webpack_exports__, "ib", function() { return /* binding */ AnxIconInterdisziplinaer; });
__webpack_require__.d(__webpack_exports__, "jb", function() { return /* binding */ AnxIconIp; });
__webpack_require__.d(__webpack_exports__, "kb", function() { return /* binding */ AnxIconKalender; });
__webpack_require__.d(__webpack_exports__, "lb", function() { return /* binding */ AnxIconKontaktTelefonTelekommunikation; });
__webpack_require__.d(__webpack_exports__, "mb", function() { return /* binding */ AnxIconKonzept; });
__webpack_require__.d(__webpack_exports__, "nb", function() { return /* binding */ AnxIconKunde; });
__webpack_require__.d(__webpack_exports__, "ob", function() { return /* binding */ AnxIconKunden; });
__webpack_require__.d(__webpack_exports__, "qb", function() { return /* binding */ AnxIconLaden; });
__webpack_require__.d(__webpack_exports__, "rb", function() { return /* binding */ AnxIconLastverteilung; });
__webpack_require__.d(__webpack_exports__, "sb", function() { return /* binding */ AnxIconLike; });
__webpack_require__.d(__webpack_exports__, "tb", function() { return /* binding */ AnxIconLoeschen; });
__webpack_require__.d(__webpack_exports__, "ub", function() { return /* binding */ AnxIconMailKontakt; });
__webpack_require__.d(__webpack_exports__, "vb", function() { return /* binding */ AnxIconMassgeschneiderteIndividuelleLoesungen; });
__webpack_require__.d(__webpack_exports__, "wb", function() { return /* binding */ AnxIconMbaas; });
__webpack_require__.d(__webpack_exports__, "xb", function() { return /* binding */ AnxIconMicrocontroller; });
__webpack_require__.d(__webpack_exports__, "yb", function() { return /* binding */ AnxIconMitarbeiterevents; });
__webpack_require__.d(__webpack_exports__, "zb", function() { return /* binding */ AnxIconMobileEntwicklung; });
__webpack_require__.d(__webpack_exports__, "Ab", function() { return /* binding */ AnxIconMonitoring; });
__webpack_require__.d(__webpack_exports__, "Bb", function() { return /* binding */ AnxIconMusik; });
__webpack_require__.d(__webpack_exports__, "Cb", function() { return /* binding */ AnxIconNetzwerk; });
__webpack_require__.d(__webpack_exports__, "Db", function() { return /* binding */ AnxIconOeffentlicherNahverkehr; });
__webpack_require__.d(__webpack_exports__, "Eb", function() { return /* binding */ AnxIconOffline; });
__webpack_require__.d(__webpack_exports__, "Fb", function() { return /* binding */ AnxIconOnlineshopWarenkorb; });
__webpack_require__.d(__webpack_exports__, "Gb", function() { return /* binding */ AnxIconPaket; });
__webpack_require__.d(__webpack_exports__, "Hb", function() { return /* binding */ AnxIconParkplatz; });
__webpack_require__.d(__webpack_exports__, "Ib", function() { return /* binding */ AnxIconPartyProjektabschluss; });
__webpack_require__.d(__webpack_exports__, "Jb", function() { return /* binding */ AnxIconPdf; });
__webpack_require__.d(__webpack_exports__, "Lb", function() { return /* binding */ AnxIconPfeilLinksKlein; });
__webpack_require__.d(__webpack_exports__, "Kb", function() { return /* binding */ AnxIconPfeilLinks; });
__webpack_require__.d(__webpack_exports__, "Mb", function() { return /* binding */ AnxIconPfeilOben; });
__webpack_require__.d(__webpack_exports__, "Ob", function() { return /* binding */ AnxIconPfeilRechtsKlein; });
__webpack_require__.d(__webpack_exports__, "Nb", function() { return /* binding */ AnxIconPfeilRechts; });
__webpack_require__.d(__webpack_exports__, "Pb", function() { return /* binding */ AnxIconPfeilRunter; });
__webpack_require__.d(__webpack_exports__, "Qb", function() { return /* binding */ AnxIconPflichtenheft; });
__webpack_require__.d(__webpack_exports__, "Rb", function() { return /* binding */ AnxIconPlatform; });
__webpack_require__.d(__webpack_exports__, "Sb", function() { return /* binding */ AnxIconPraesentation; });
__webpack_require__.d(__webpack_exports__, "Tb", function() { return /* binding */ AnxIconProjektablauf; });
__webpack_require__.d(__webpack_exports__, "Ub", function() { return /* binding */ AnxIconProjektmanagementCheckliste; });
__webpack_require__.d(__webpack_exports__, "Vb", function() { return /* binding */ AnxIconRedundant; });
__webpack_require__.d(__webpack_exports__, "Wb", function() { return /* binding */ AnxIconSatellit; });
__webpack_require__.d(__webpack_exports__, "Xb", function() { return /* binding */ AnxIconSchluessel; });
__webpack_require__.d(__webpack_exports__, "Yb", function() { return /* binding */ AnxIconScrum; });
__webpack_require__.d(__webpack_exports__, "Zb", function() { return /* binding */ AnxIconSeoSemCrawler; });
__webpack_require__.d(__webpack_exports__, "ac", function() { return /* binding */ AnxIconServerVeerbunden; });
__webpack_require__.d(__webpack_exports__, "bc", function() { return /* binding */ AnxIconServiceprovider; });
__webpack_require__.d(__webpack_exports__, "cc", function() { return /* binding */ AnxIconSharing; });
__webpack_require__.d(__webpack_exports__, "dc", function() { return /* binding */ AnxIconShop; });
__webpack_require__.d(__webpack_exports__, "ec", function() { return /* binding */ AnxIconSicherheitFirewall; });
__webpack_require__.d(__webpack_exports__, "fc", function() { return /* binding */ AnxIconSignal; });
__webpack_require__.d(__webpack_exports__, "gc", function() { return /* binding */ AnxIconSkalierbar; });
__webpack_require__.d(__webpack_exports__, "hc", function() { return /* binding */ AnxIconSmartTv; });
__webpack_require__.d(__webpack_exports__, "ic", function() { return /* binding */ AnxIconSmartWatch; });
__webpack_require__.d(__webpack_exports__, "jc", function() { return /* binding */ AnxIconSmarthome; });
__webpack_require__.d(__webpack_exports__, "kc", function() { return /* binding */ AnxIconSoftwareentwicklungCode; });
__webpack_require__.d(__webpack_exports__, "lc", function() { return /* binding */ AnxIconSpieleUndSpass; });
__webpack_require__.d(__webpack_exports__, "mc", function() { return /* binding */ AnxIconSprechblasen; });
__webpack_require__.d(__webpack_exports__, "nc", function() { return /* binding */ AnxIconStandortUnternehmenssitz; });
__webpack_require__.d(__webpack_exports__, "oc", function() { return /* binding */ AnxIconStartUp; });
__webpack_require__.d(__webpack_exports__, "pc", function() { return /* binding */ AnxIconStatistikAnalysen; });
__webpack_require__.d(__webpack_exports__, "qc", function() { return /* binding */ AnxIconStern; });
__webpack_require__.d(__webpack_exports__, "rc", function() { return /* binding */ AnxIconStorageBackup; });
__webpack_require__.d(__webpack_exports__, "sc", function() { return /* binding */ AnxIconStromEnergie; });
__webpack_require__.d(__webpack_exports__, "tc", function() { return /* binding */ AnxIconSuchen; });
__webpack_require__.d(__webpack_exports__, "uc", function() { return /* binding */ AnxIconSupportMitarbeiter; });
__webpack_require__.d(__webpack_exports__, "vc", function() { return /* binding */ AnxIconTasse; });
__webpack_require__.d(__webpack_exports__, "wc", function() { return /* binding */ AnxIconTeam; });
__webpack_require__.d(__webpack_exports__, "xc", function() { return /* binding */ AnxIconTechnischerSupport; });
__webpack_require__.d(__webpack_exports__, "yc", function() { return /* binding */ AnxIconTextdokument; });
__webpack_require__.d(__webpack_exports__, "zc", function() { return /* binding */ AnxIconTextdokumentFragezeichen; });
__webpack_require__.d(__webpack_exports__, "Ac", function() { return /* binding */ AnxIconTextdokumentRufzeichen; });
__webpack_require__.d(__webpack_exports__, "Bc", function() { return /* binding */ AnxIconUpload; });
__webpack_require__.d(__webpack_exports__, "Cc", function() { return /* binding */ AnxIconUserProfil; });
__webpack_require__.d(__webpack_exports__, "Dc", function() { return /* binding */ AnxIconVerbundeneServerBlade; });
__webpack_require__.d(__webpack_exports__, "Ec", function() { return /* binding */ AnxIconVerlautbarungWichtigeNewsPressemitteilung; });
__webpack_require__.d(__webpack_exports__, "Fc", function() { return /* binding */ AnxIconVerpflegungMittagspauseEssen; });
__webpack_require__.d(__webpack_exports__, "Gc", function() { return /* binding */ AnxIconVerschluesselung; });
__webpack_require__.d(__webpack_exports__, "Hc", function() { return /* binding */ AnxIconVideo; });
__webpack_require__.d(__webpack_exports__, "Ic", function() { return /* binding */ AnxIconVierenBugs; });
__webpack_require__.d(__webpack_exports__, "Jc", function() { return /* binding */ AnxIconVirtualisierung; });
__webpack_require__.d(__webpack_exports__, "Kc", function() { return /* binding */ AnxIconVollbildVerschieben; });
__webpack_require__.d(__webpack_exports__, "Lc", function() { return /* binding */ AnxIconVr; });
__webpack_require__.d(__webpack_exports__, "Mc", function() { return /* binding */ AnxIconWachstumUmsatz; });
__webpack_require__.d(__webpack_exports__, "Oc", function() { return /* binding */ AnxIconWarningSmall; });
__webpack_require__.d(__webpack_exports__, "Nc", function() { return /* binding */ AnxIconWarning; });
__webpack_require__.d(__webpack_exports__, "Pc", function() { return /* binding */ AnxIconWebdesign; });
__webpack_require__.d(__webpack_exports__, "Qc", function() { return /* binding */ AnxIconWebentwicklung; });
__webpack_require__.d(__webpack_exports__, "Rc", function() { return /* binding */ AnxIconWeiterbildung; });
__webpack_require__.d(__webpack_exports__, "Sc", function() { return /* binding */ AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc; });
__webpack_require__.d(__webpack_exports__, "Tc", function() { return /* binding */ AnxIconWhiteLabel; });
__webpack_require__.d(__webpack_exports__, "Uc", function() { return /* binding */ AnxIconWidgets; });
__webpack_require__.d(__webpack_exports__, "Vc", function() { return /* binding */ AnxIconWindows; });
__webpack_require__.d(__webpack_exports__, "Wc", function() { return /* binding */ AnxIconWlan; });
__webpack_require__.d(__webpack_exports__, "Xc", function() { return /* binding */ AnxIconX; });
__webpack_require__.d(__webpack_exports__, "Yc", function() { return /* binding */ AnxIconZeitungMedienNews; });
__webpack_require__.d(__webpack_exports__, "Zc", function() { return /* binding */ AnxIconZertifikat; });
__webpack_require__.d(__webpack_exports__, "ad", function() { return /* binding */ AnxIconZielMarkierung; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vue-functional-data-merge/dist/lib.esm.js
var e=function(){return(e=Object.assign||function(e){for(var t,r=1,s=arguments.length;r<s;r++)for(var a in t=arguments[r])Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e}).apply(this,arguments)},t={kebab:/-(\w)/g,styleProp:/:(.*)/,styleList:/;(?![^(]*\))/g};function lib_esm_r(e,t){return t?t.toUpperCase():""}function s(e){for(var s,a={},c=0,o=e.split(t.styleList);c<o.length;c++){var n=o[c].split(t.styleProp),i=n[0],l=n[1];(i=i.trim())&&("string"==typeof l&&(l=l.trim()),a[(s=i,s.replace(t.kebab,lib_esm_r))]=l)}return a}function a(){for(var t,r,a={},c=arguments.length;c--;)for(var o=0,n=Object.keys(arguments[c]);o<n.length;o++)switch(t=n[o]){case"class":case"style":case"directives":if(Array.isArray(a[t])||(a[t]=[]),"style"===t){var i=void 0;i=Array.isArray(arguments[c].style)?arguments[c].style:[arguments[c].style];for(var l=0;l<i.length;l++){var y=i[l];"string"==typeof y&&(i[l]=s(y))}arguments[c].style=i}a[t]=a[t].concat(arguments[c][t]);break;case"staticClass":if(!arguments[c][t])break;void 0===a[t]&&(a[t]=""),a[t]&&(a[t]+=" "),a[t]+=arguments[c][t].trim();break;case"on":case"nativeOn":a[t]||(a[t]={});for(var p=0,f=Object.keys(arguments[c][t]||{});p<f.length;p++)r=f[p],a[t][r]?a[t][r]=[].concat(a[t][r],arguments[c][t][r]):a[t][r]=arguments[c][t][r];break;case"attrs":case"props":case"domProps":case"scopedSlots":case"staticStyle":case"hook":case"transition":a[t]||(a[t]={}),a[t]=e({},arguments[c][t],a[t]);break;case"slot":case"key":case"ref":case"tag":case"show":case"keepAlive":default:a[t]||(a[t]=arguments[c][t])}return a}
//# sourceMappingURL=lib.esm.js.map

// EXTERNAL MODULE: ./src/plugins/icons/helpers/string-utils.js
var string_utils = __webpack_require__("500a");

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/nodes/node.js
/**
 * Node Class as base class for TextNode and HTMLElement.
 */
class Node {
    constructor() {
        this.childNodes = [];
    }
    get innerText() {
        return this.rawText;
    }
    get textContent() {
        return this.rawText;
    }
    set textContent(val) {
        this.rawText = val;
    }
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/nodes/type.js
var NodeType;
(function (NodeType) {
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
})(NodeType || (NodeType = {}));
/* harmony default export */ var type = (NodeType);

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/nodes/comment.js


class comment_CommentNode extends Node {
    constructor(rawText) {
        super();
        this.rawText = rawText;
        /**
         * Node Type declaration.
         * @type {Number}
         */
        this.nodeType = type.COMMENT_NODE;
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */
    get text() {
        return this.rawText;
    }
    toString() {
        return `<!--${this.rawText}-->`;
    }
}

// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__("92d7");
var he_default = /*#__PURE__*/__webpack_require__.n(he);

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/nodes/text.js


/**
 * TextNode to contain a text element in DOM tree.
 * @param {string} value [description]
 */
class text_TextNode extends Node {
    constructor(rawText) {
        super();
        this.rawText = rawText;
        /**
         * Node Type declaration.
         * @type {Number}
         */
        this.nodeType = type.TEXT_NODE;
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */
    get text() {
        return this.rawText;
    }
    /**
     * Detect if the node contains only white space.
     * @return {bool}
     */
    get isWhitespace() {
        return /^(\s|&nbsp;)*$/.test(this.rawText);
    }
    toString() {
        return this.text;
    }
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/matcher.js
/**
 * Cache to store generated match functions
 * @type {Object}
 */
let pMatchFunctionCache = {};
function compare_tagname(tag1, tag2) {
    if (!tag1) {
        return !tag2;
    }
    if (!tag2) {
        return !tag1;
    }
    return tag1.toLowerCase() === tag2.toLowerCase();
}
/**
 * Function cache
 */
const functionCache = {
    f145(el, tagName, classes) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        if (el.id !== tagName.substr(1)) {
            return false;
        }
        for (let cls = classes, i = 0; i < cls.length; i++) {
            if (el.classNames.indexOf(cls[i]) === -1) {
                return false;
            }
        }
        return true;
    },
    f45(el, tagName, classes) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        for (let cls = classes, i = 0; i < cls.length; i++) {
            if (el.classNames.indexOf(cls[i]) === -1) {
                return false;
            }
        }
        return true;
    },
    f15(el, tagName) {
        'use strict';
        tagName = tagName || '';
        if (el.id !== tagName.substr(1)) {
            return false;
        }
        return true;
    },
    f1(el, tagName) {
        'use strict';
        tagName = tagName || '';
        if (el.id !== tagName.substr(1)) {
            return false;
        }
    },
    f5() {
        'use strict';
        return true;
    },
    f55(el, tagName, classes, attr_key) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        attr_key = attr_key || '';
        const attrs = el.attributes;
        return attrs.hasOwnProperty(attr_key);
    },
    f245(el, tagName, classes, attr_key, value) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        attr_key = (attr_key || '').toLowerCase();
        value = value || '';
        const attrs = el.attributes;
        return Object.keys(attrs).some((key) => {
            const val = attrs[key];
            return key.toLowerCase() === attr_key && val === value;
        });
        // for (let cls = classes, i = 0; i < cls.length; i++) {if (el.classNames.indexOf(cls[i]) === -1){ return false;}}
        // return true;
    },
    f25(el, tagName, classes, attr_key, value) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        attr_key = (attr_key || '').toLowerCase();
        value = value || '';
        const attrs = el.attributes;
        return Object.keys(attrs).some((key) => {
            const val = attrs[key];
            return key.toLowerCase() === attr_key && val === value;
        });
        // return true;
    },
    f2(el, tagName, classes, attr_key, value) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        attr_key = (attr_key || '').toLowerCase();
        value = value || '';
        const attrs = el.attributes;
        return Object.keys(attrs).some((key) => {
            const val = attrs[key];
            return key.toLowerCase() === attr_key && val === value;
        });
    },
    f345(el, tagName, classes) {
        'use strict';
        tagName = tagName || '';
        classes = classes || [];
        if (!compare_tagname(el.tagName, tagName)) {
            return false;
        }
        for (let cls = classes, i = 0; i < cls.length; i++) {
            if (el.classNames.indexOf(cls[i]) === -1) {
                return false;
            }
        }
        return true;
    },
    f35(el, tagName) {
        'use strict';
        tagName = tagName || '';
        return compare_tagname(el.tagName, tagName);
    },
    f3(el, tagName) {
        'use strict';
        tagName = tagName || '';
        // if (el.tagName !== tagName) {
        // 	return false;
        // }
        return compare_tagname(el.tagName, tagName);
    }
};
/**
 * Matcher class to make CSS match
 *
 * @class Matcher
 */
class Matcher {
    /**
     * Creates an instance of Matcher.
     * @param {string} selector
     *
     * @memberof Matcher
     */
    constructor(selector) {
        this.nextMatch = 0;
        this.matchers = selector.split(' ').map((matcher) => {
            if (pMatchFunctionCache[matcher]) {
                return pMatchFunctionCache[matcher];
            }
            const parts = matcher.split('.');
            const tagName = parts[0];
            const classes = parts.slice(1).sort();
            // let source = '"use strict";';
            let function_name = 'f';
            let attr_key = '';
            let value = '';
            if (tagName && tagName !== '*') {
                if (tagName.startsWith('#')) {
                    // source += 'if (el.id != ' + JSON.stringify(tagName.substr(1)) + ') return false;';// 1
                    function_name += '1';
                }
                else {
                    // https://github.com/taoqf/node-html-parser/issues/86
                    // const reg = /\[\s*([\w-]+)(\s*=\s*(((?<quote>'|")\s*(.*)(\k<quote>))|(\S*)))?\s*\]/.exec(tagName);
                    // `[a-b]`,`[ a-b ]`,`[a-b=c]`, `[a-b=c'd]`,`[a-b='c\' d"e ']`,`[ a-b = 'c\' d"e ' ]`,`[a-b="c' d\"e " ]`,`[ a-b = "c' d\"e " ]`
                    const reg = /\[\s*([\w-]+)(\s*=\s*(('\s*(.*)'|"\s*(.*)")|(\S*)))?\s*\]/.exec(tagName);
                    if (reg) {
                        attr_key = reg[1];
                        value = reg[5] || reg[6] || reg[7];
                        // source += `let attrs = el.attributes;for (let key in attrs){const val = attrs[key]; if (key == "${attr_key}" && val == "${value}"){return true;}} return false;`;// 2
                        function_name += '2';
                    }
                    else {
                        // source += 'if (el.tagName != ' + JSON.stringify(tagName) + ') return false;';// 3
                        function_name += '3';
                    }
                }
            }
            if (classes.length > 0) {
                // source += 'for (let cls = ' + JSON.stringify(classes) + ', i = 0; i < cls.length; i++) if (el.classNames.indexOf(cls[i]) === -1) return false;';// 4
                function_name += '4';
            }
            // source += 'return true;';// 5
            function_name += '5';
            const obj = {
                func: functionCache[function_name],
                tagName: tagName || '',
                classes: classes || '',
                attr_key: attr_key || '',
                value: value || ''
            };
            // source = source || '';
            return (pMatchFunctionCache[matcher] = obj);
        });
    }
    /**
     * Trying to advance match pointer
     * @param  {HTMLElement} el element to make the match
     * @return {bool}           true when pointer advanced.
     */
    advance(el) {
        if (this.nextMatch < this.matchers.length &&
            this.matchers[this.nextMatch].func(el, this.matchers[this.nextMatch].tagName, this.matchers[this.nextMatch].classes, this.matchers[this.nextMatch].attr_key, this.matchers[this.nextMatch].value)) {
            this.nextMatch++;
            return true;
        }
        return false;
    }
    /**
     * Rewind the match pointer
     */
    rewind() {
        this.nextMatch--;
    }
    /**
     * Trying to determine if match made.
     * @return {bool} true when the match is made
     */
    get matched() {
        return this.nextMatch === this.matchers.length;
    }
    /**
     * Rest match pointer.
     * @return {[type]} [description]
     */
    reset() {
        this.nextMatch = 0;
    }
    /**
     * flush cache to free memory
     */
    flushCache() {
        pMatchFunctionCache = {};
    }
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/back.js
function arr_back(arr) {
    return arr[arr.length - 1];
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/parse.js


/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */
function parse(data, options = { lowerCaseTagName: false, comment: false }) {
    const stack = base_parse(data, options);
    const [root] = stack;
    while (stack.length > 1) {
        // Handle each error elements.
        const last = stack.pop();
        const oneBefore = arr_back(stack);
        if (last.parentNode && last.parentNode.parentNode) {
            if (last.parentNode === oneBefore && last.tagName === oneBefore.tagName) {
                // Pair error case <h3> <h3> handle : Fixes to <h3> </h3>
                oneBefore.removeChild(last);
                last.childNodes.forEach((child) => {
                    oneBefore.parentNode.appendChild(child);
                });
                stack.pop();
            }
            else {
                // Single error  <div> <h3> </div> handle: Just removes <h3>
                oneBefore.removeChild(last);
                last.childNodes.forEach((child) => {
                    oneBefore.appendChild(child);
                });
            }
        }
        else {
            // If it's final element just skip.
        }
    }
    // response.childNodes.forEach((node) => {
    // 	if (node instanceof HTMLElement) {
    // 		node.parentNode = null;
    // 	}
    // });
    return root;
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/nodes/html.js








const { decode } = he_default.a;
const kBlockElements = new Map();
kBlockElements.set('DIV', true);
kBlockElements.set('div', true);
kBlockElements.set('P', true);
kBlockElements.set('p', true);
// ul: true,
// ol: true,
kBlockElements.set('LI', true);
kBlockElements.set('li', true);
// table: true,
// tr: true,
kBlockElements.set('TD', true);
kBlockElements.set('td', true);
kBlockElements.set('SECTION', true);
kBlockElements.set('section', true);
kBlockElements.set('BR', true);
kBlockElements.set('br', true);
/**
 * HTMLElement, which contains a set of children.
 *
 * Note: this is a minimalist implementation, no complete tree
 *   structure provided (no parentNode, nextSibling,
 *   previousSibling etc).
 * @class HTMLElement
 * @extends {Node}
 */
class html_HTMLElement extends Node {
    /**
     * Creates an instance of HTMLElement.
     * @param keyAttrs	id and class attribute
     * @param [rawAttrs]	attributes in string
     *
     * @memberof HTMLElement
     */
    constructor(tagName, keyAttrs, rawAttrs = '', parentNode = null) {
        super();
        this.rawAttrs = rawAttrs;
        this.parentNode = parentNode;
        this.classNames = [];
        /**
         * Node Type declaration.
         */
        this.nodeType = type.ELEMENT_NODE;
        this.rawTagName = tagName;
        this.rawAttrs = rawAttrs || '';
        this.childNodes = [];
        if (keyAttrs.id) {
            this.id = keyAttrs.id;
            if (!rawAttrs) {
                this.rawAttrs = `id="${keyAttrs.id}"`;
            }
        }
        if (keyAttrs.class) {
            this.classNames = keyAttrs.class.split(/\s+/);
            if (!rawAttrs) {
                const cls = `class="${this.classNames.join(' ')}"`;
                if (this.rawAttrs) {
                    this.rawAttrs += ` ${cls}`;
                }
                else {
                    this.rawAttrs = cls;
                }
            }
        }
    }
    /**
     * Remove current element
     */
    remove() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            this.parentNode.childNodes = children.filter((child) => {
                return this !== child;
            });
        }
    }
    /**
     * Remove Child element from childNodes array
     * @param {HTMLElement} node     node to remove
     */
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child) => {
            return (child !== node);
        });
    }
    /**
     * Exchanges given child with new child
     * @param {HTMLElement} oldNode     node to exchange
     * @param {HTMLElement} newNode     new node
     */
    exchangeChild(oldNode, newNode) {
        const children = this.childNodes;
        this.childNodes = children.map((child) => {
            if (child === oldNode) {
                return newNode;
            }
            return child;
        });
    }
    get tagName() {
        return this.rawTagName ? this.rawTagName.toUpperCase() : this.rawTagName;
    }
    /**
     * Get escpaed (as-it) text value of current node and its children.
     * @return {string} text content
     */
    get rawText() {
        return this.childNodes.reduce((pre, cur) => {
            return (pre += cur.rawText);
        }, '');
    }
    get textContent() {
        return this.rawText;
    }
    set textContent(val) {
        const content = [new text_TextNode(val)];
        this.childNodes = content;
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */
    get text() {
        return decode(this.rawText);
    }
    /**
     * Get structured Text (with '\n' etc.)
     * @return {string} structured text
     */
    get structuredText() {
        let currentBlock = [];
        const blocks = [currentBlock];
        function dfs(node) {
            if (node.nodeType === type.ELEMENT_NODE) {
                if (kBlockElements.get(node.rawTagName)) {
                    if (currentBlock.length > 0) {
                        blocks.push(currentBlock = []);
                    }
                    node.childNodes.forEach(dfs);
                    if (currentBlock.length > 0) {
                        blocks.push(currentBlock = []);
                    }
                }
                else {
                    node.childNodes.forEach(dfs);
                }
            }
            else if (node.nodeType === type.TEXT_NODE) {
                if (node.isWhitespace) {
                    // Whitespace node, postponed output
                    currentBlock.prependWhitespace = true;
                }
                else {
                    let text = node.text;
                    if (currentBlock.prependWhitespace) {
                        text = ` ${text}`;
                        currentBlock.prependWhitespace = false;
                    }
                    currentBlock.push(text);
                }
            }
        }
        dfs(this);
        return blocks.map((block) => {
            // Normalize each line's whitespace
            return block.join('').trim().replace(/\s{2,}/g, ' ');
        })
            .join('\n').replace(/\s+$/, ''); // trimRight;
    }
    toString() {
        const tag = this.rawTagName;
        if (tag) {
            const is_void = /^(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/i.test(tag);
            const attrs = this.rawAttrs ? ` ${this.rawAttrs}` : '';
            if (is_void) {
                return `<${tag}${attrs}>`;
            }
            return `<${tag}${attrs}>${this.innerHTML}</${tag}>`;
        }
        return this.innerHTML;
    }
    get innerHTML() {
        return this.childNodes.map((child) => {
            return child.toString();
        }).join('');
    }
    set_content(content, options = {}) {
        if (content instanceof Node) {
            content = [content];
        }
        else if (typeof content == 'string') {
            const r = parse(content, options);
            content = r.childNodes.length ? r.childNodes : [new text_TextNode(content)];
        }
        this.childNodes = content;
    }
    get outerHTML() {
        return this.toString();
    }
    /**
     * Trim element from right (in block) after seeing pattern in a TextNode.
     * @param  {RegExp} pattern pattern to find
     * @return {HTMLElement}    reference to current node
     */
    trimRight(pattern) {
        for (let i = 0; i < this.childNodes.length; i++) {
            const childNode = this.childNodes[i];
            if (childNode.nodeType === type.ELEMENT_NODE) {
                childNode.trimRight(pattern);
            }
            else {
                const index = childNode.rawText.search(pattern);
                if (index > -1) {
                    childNode.rawText = childNode.rawText.substr(0, index);
                    // trim all following nodes.
                    this.childNodes.length = i + 1;
                }
            }
        }
        return this;
    }
    /**
     * Get DOM structure
     * @return {string} strucutre
     */
    get structure() {
        const res = [];
        let indention = 0;
        function write(str) {
            res.push('  '.repeat(indention) + str);
        }
        function dfs(node) {
            const idStr = node.id ? (`#${node.id}`) : '';
            const classStr = node.classNames.length ? (`.${node.classNames.join('.')}`) : '';
            write(`${node.rawTagName}${idStr}${classStr}`);
            indention++;
            node.childNodes.forEach((childNode) => {
                if (childNode.nodeType === type.ELEMENT_NODE) {
                    dfs(childNode);
                }
                else if (childNode.nodeType === type.TEXT_NODE) {
                    if (!childNode.isWhitespace) {
                        write('#text');
                    }
                }
            });
            indention--;
        }
        dfs(this);
        return res.join('\n');
    }
    /**
     * Remove whitespaces in this sub tree.
     * @return {HTMLElement} pointer to this
     */
    removeWhitespace() {
        let o = 0;
        this.childNodes.forEach((node) => {
            if (node.nodeType === type.TEXT_NODE) {
                if (node.isWhitespace) {
                    return;
                }
                node.rawText = node.rawText.trim();
            }
            else if (node.nodeType === type.ELEMENT_NODE) {
                node.removeWhitespace();
            }
            this.childNodes[o++] = node;
        });
        this.childNodes.length = o;
        return this;
    }
    /**
     * Query CSS selector to find matching nodes.
     * @param  {string}         selector Simplified CSS selector
     * @param  {Matcher}        selector A Matcher instance
     * @return {HTMLElement[]}  matching elements
     */
    querySelectorAll(selector) {
        let matcher;
        if (selector instanceof Matcher) {
            matcher = selector;
            matcher.reset();
        }
        else {
            if (selector.includes(',')) {
                const selectors = selector.split(',');
                return Array.from(selectors.reduce((pre, cur) => {
                    const result = this.querySelectorAll(cur.trim());
                    return result.reduce((p, c) => {
                        return p.add(c);
                    }, pre);
                }, new Set()));
            }
            matcher = new Matcher(selector);
        }
        const stack = [];
        return this.childNodes.reduce((res, cur) => {
            stack.push([cur, 0, false]);
            while (stack.length) {
                const state = arr_back(stack); // get last element
                const el = state[0];
                if (state[1] === 0) {
                    // Seen for first time.
                    if (el.nodeType !== type.ELEMENT_NODE) {
                        stack.pop();
                        continue;
                    }
                    const html_el = el;
                    state[2] = matcher.advance(html_el);
                    if (state[2]) {
                        if (matcher.matched) {
                            res.push(html_el);
                            res.push(...(html_el.querySelectorAll(selector)));
                            // no need to go further.
                            matcher.rewind();
                            stack.pop();
                            continue;
                        }
                    }
                }
                if (state[1] < el.childNodes.length) {
                    stack.push([el.childNodes[state[1]++], 0, false]);
                }
                else {
                    if (state[2]) {
                        matcher.rewind();
                    }
                    stack.pop();
                }
            }
            return res;
        }, []);
    }
    /**
     * Query CSS Selector to find matching node.
     * @param  {string}         selector Simplified CSS selector
     * @param  {Matcher}        selector A Matcher instance
     * @return {HTMLElement}    matching node
     */
    querySelector(selector) {
        let matcher;
        if (selector instanceof Matcher) {
            matcher = selector;
            matcher.reset();
        }
        else {
            matcher = new Matcher(selector);
        }
        const stack = [];
        for (const node of this.childNodes) {
            stack.push([node, 0, false]);
            while (stack.length) {
                const state = arr_back(stack);
                const el = state[0];
                if (state[1] === 0) {
                    // Seen for first time.
                    if (el.nodeType !== type.ELEMENT_NODE) {
                        stack.pop();
                        continue;
                    }
                    state[2] = matcher.advance(el);
                    if (state[2]) {
                        if (matcher.matched) {
                            return el;
                        }
                    }
                }
                if (state[1] < el.childNodes.length) {
                    stack.push([el.childNodes[state[1]++], 0, false]);
                }
                else {
                    if (state[2]) {
                        matcher.rewind();
                    }
                    stack.pop();
                }
            }
        }
        return null;
    }
    /**
     * Append a child node to childNodes
     * @param  {Node} node node to append
     * @return {Node}      node appended
     */
    appendChild(node) {
        // node.parentNode = this;
        this.childNodes.push(node);
        if (node instanceof html_HTMLElement) {
            node.parentNode = this;
        }
        return node;
    }
    /**
     * Get first child node
     * @return {Node} first child node
     */
    get firstChild() {
        return this.childNodes[0];
    }
    /**
     * Get last child node
     * @return {Node} last child node
     */
    get lastChild() {
        return arr_back(this.childNodes);
    }
    /**
     * Get attributes
     * @access private
     * @return {Object} parsed and unescaped attributes
     */
    get attrs() {
        if (this._attrs) {
            return this._attrs;
        }
        this._attrs = {};
        const attrs = this.rawAttributes;
        for (const key in attrs) {
            const val = attrs[key] || '';
            this._attrs[key.toLowerCase()] = decode(val);
        }
        return this._attrs;
    }
    get attributes() {
        const ret_attrs = {};
        const attrs = this.rawAttributes;
        for (const key in attrs) {
            const val = attrs[key] || '';
            ret_attrs[key] = decode(val);
        }
        return ret_attrs;
    }
    /**
     * Get escaped (as-it) attributes
     * @return {Object} parsed attributes
     */
    get rawAttributes() {
        if (this._rawAttrs) {
            return this._rawAttrs;
        }
        const attrs = {};
        if (this.rawAttrs) {
            const re = /\b([a-z][a-z0-9-_]*)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|(\S+)))?/ig;
            let match;
            while ((match = re.exec(this.rawAttrs))) {
                attrs[match[1]] = match[2] || match[3] || match[4] || null;
            }
        }
        this._rawAttrs = attrs;
        return attrs;
    }
    removeAttribute(key) {
        const attrs = this.rawAttributes;
        delete attrs[key];
        // Update this.attribute
        if (this._attrs) {
            delete this._attrs[key];
        }
        // Update rawString
        this.rawAttrs = Object.keys(attrs).map((name) => {
            const val = JSON.stringify(attrs[name]);
            if (val === undefined || val === 'null') {
                return name;
            }
            return `${name}=${val}`;
        }).join(' ');
    }
    hasAttribute(key) {
        return key.toLowerCase() in this.attrs;
    }
    /**
     * Get an attribute
     * @return {string} value of the attribute
     */
    getAttribute(key) {
        return this.attrs[key.toLowerCase()];
    }
    /**
     * Set an attribute value to the HTMLElement
     * @param {string} key The attribute name
     * @param {string} value The value to set, or null / undefined to remove an attribute
     */
    setAttribute(key, value) {
        if (arguments.length < 2) {
            throw new Error('Failed to execute \'setAttribute\' on \'Element\'');
        }
        const k2 = key.toLowerCase();
        const attrs = this.rawAttributes;
        for (const k in attrs) {
            if (k.toLowerCase() === k2) {
                key = k;
                break;
            }
        }
        attrs[key] = String(value);
        // update this.attrs
        if (this._attrs) {
            this._attrs[k2] = decode(attrs[key]);
        }
        // Update rawString
        this.rawAttrs = Object.keys(attrs).map((name) => {
            const val = JSON.stringify(attrs[name]);
            if (val === 'null' || val === '""') {
                return name;
            }
            return `${name}=${val}`;
        }).join(' ');
    }
    /**
     * Replace all the attributes of the HTMLElement by the provided attributes
     * @param {Attributes} attributes the new attribute set
     */
    setAttributes(attributes) {
        // Invalidate current this.attributes
        if (this._attrs) {
            delete this._attrs;
        }
        // Invalidate current this.rawAttributes
        if (this._rawAttrs) {
            delete this._rawAttrs;
        }
        // Update rawString
        this.rawAttrs = Object.keys(attributes).map((name) => {
            const val = attributes[name];
            if (val === 'null' || val === '""') {
                return name;
            }
            return `${name}=${JSON.stringify(String(val))}`;
        }).join(' ');
    }
    insertAdjacentHTML(where, html) {
        if (arguments.length < 2) {
            throw new Error('2 arguments required');
        }
        const p = parse(html);
        if (where === 'afterend') {
            const idx = this.parentNode.childNodes.findIndex((child) => {
                return child === this;
            });
            this.parentNode.childNodes.splice(idx + 1, 0, ...p.childNodes);
            p.childNodes.forEach((n) => {
                if (n instanceof html_HTMLElement) {
                    n.parentNode = this.parentNode;
                }
            });
        }
        else if (where === 'afterbegin') {
            this.childNodes.unshift(...p.childNodes);
        }
        else if (where === 'beforeend') {
            p.childNodes.forEach((n) => {
                this.appendChild(n);
            });
        }
        else if (where === 'beforebegin') {
            const idx = this.parentNode.childNodes.findIndex((child) => {
                return child === this;
            });
            this.parentNode.childNodes.splice(idx, 0, ...p.childNodes);
            p.childNodes.forEach((n) => {
                if (n instanceof html_HTMLElement) {
                    n.parentNode = this.parentNode;
                }
            });
        }
        else {
            throw new Error(`The value provided ('${where}') is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'`);
        }
        // if (!where || html === undefined || html === null) {
        // 	return;
        // }
    }
    get nextSibling() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            let i = 0;
            while (i < children.length) {
                const child = children[i++];
                if (this === child) {
                    return children[i] || null;
                }
            }
            return null;
        }
    }
    get nextElementSibling() {
        if (this.parentNode) {
            const children = this.parentNode.childNodes;
            let i = 0;
            let find = false;
            while (i < children.length) {
                const child = children[i++];
                if (find) {
                    if (child instanceof html_HTMLElement) {
                        return child || null;
                    }
                }
                else if (this === child) {
                    find = true;
                }
            }
            return null;
        }
    }
}
// https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
const kMarkupPattern = /<!--[^]*?(?=-->)-->|<(\/?)([a-z][-.:0-9_a-z]*)\s*([^>]*?)(\/?)>/ig;
// <(?<tag>[^\s]*)(.*)>(.*)</\k<tag>>
// <([a-z][-.:0-9_a-z]*)\s*\/>
// <(area|base|br|col|hr|img|input|link|meta|source)\s*(.*)\/?>
// <(area|base|br|col|hr|img|input|link|meta|source)\s*(.*)\/?>|<(?<tag>[^\s]*)(.*)>(.*)</\k<tag>>
const kAttributePattern = /(^|\s)(id|class)\s*=\s*("([^"]+)"|'([^']+)'|(\S+))/ig;
const kSelfClosingElements = {
    area: true,
    AREA: true,
    base: true,
    BASE: true,
    br: true,
    BR: true,
    col: true,
    COL: true,
    hr: true,
    HR: true,
    img: true,
    IMG: true,
    input: true,
    INPUT: true,
    link: true,
    LINK: true,
    meta: true,
    META: true,
    source: true,
    SOURCE: true,
    embed: true,
    EMBED: true,
    param: true,
    PARAM: true,
    track: true,
    TRACK: true,
    wbr: true,
    WBR: true
};
const kElementsClosedByOpening = {
    li: { li: true, LI: true },
    LI: { li: true, LI: true },
    p: { p: true, div: true, P: true, DIV: true },
    P: { p: true, div: true, P: true, DIV: true },
    b: { div: true, DIV: true },
    B: { div: true, DIV: true },
    td: { td: true, th: true, TD: true, TH: true },
    TD: { td: true, th: true, TD: true, TH: true },
    th: { td: true, th: true, TD: true, TH: true },
    TH: { td: true, th: true, TD: true, TH: true },
    h1: { h1: true, H1: true },
    H1: { h1: true, H1: true },
    h2: { h2: true, H2: true },
    H2: { h2: true, H2: true },
    h3: { h3: true, H3: true },
    H3: { h3: true, H3: true },
    h4: { h4: true, H4: true },
    H4: { h4: true, H4: true },
    h5: { h5: true, H5: true },
    H5: { h5: true, H5: true },
    h6: { h6: true, H6: true },
    H6: { h6: true, H6: true }
};
const kElementsClosedByClosing = {
    li: { ul: true, ol: true, UL: true, OL: true },
    LI: { ul: true, ol: true, UL: true, OL: true },
    a: { div: true, DIV: true },
    A: { div: true, DIV: true },
    b: { div: true, DIV: true },
    B: { div: true, DIV: true },
    i: { div: true, DIV: true },
    I: { div: true, DIV: true },
    p: { div: true, DIV: true },
    P: { div: true, DIV: true },
    td: { tr: true, table: true, TR: true, TABLE: true },
    TD: { tr: true, table: true, TR: true, TABLE: true },
    th: { tr: true, table: true, TR: true, TABLE: true },
    TH: { tr: true, table: true, TR: true, TABLE: true }
};
const frameflag = 'documentfragmentcontainer';
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 * @param  {string} data      html
 * @return {HTMLElement}      root element
 */
function base_parse(data, options = { lowerCaseTagName: false, comment: false }) {
    const elements = options.blockTextElements || {
        script: true,
        noscript: true,
        style: true,
        pre: true
    };
    const element_names = Object.keys(elements);
    const kBlockTextElements = element_names.map((it) => {
        return new RegExp(it, 'i');
    });
    const kIgnoreElements = element_names.filter((it) => {
        return elements[it];
    }).map((it) => {
        return new RegExp(it, 'i');
    });
    function element_should_be_ignore(tag) {
        return kIgnoreElements.some((it) => {
            return it.test(tag);
        });
    }
    function is_block_text_element(tag) {
        return kBlockTextElements.some((it) => {
            return it.test(tag);
        });
    }
    const root = new html_HTMLElement(null, {});
    let currentParent = root;
    const stack = [root];
    let lastTextPos = -1;
    let match;
    // https://github.com/taoqf/node-html-parser/issues/38
    data = `<${frameflag}>${data}</${frameflag}>`;
    while ((match = kMarkupPattern.exec(data))) {
        if (lastTextPos > -1) {
            if (lastTextPos + match[0].length < kMarkupPattern.lastIndex) {
                // if has content
                const text = data.substring(lastTextPos, kMarkupPattern.lastIndex - match[0].length);
                currentParent.appendChild(new text_TextNode(text));
            }
        }
        lastTextPos = kMarkupPattern.lastIndex;
        if (match[2] === frameflag) {
            continue;
        }
        if (match[0][1] === '!') {
            // this is a comment
            if (options.comment) {
                // Only keep what is in between <!-- and -->
                const text = data.substring(lastTextPos - 3, lastTextPos - match[0].length + 4);
                currentParent.appendChild(new comment_CommentNode(text));
            }
            continue;
        }
        if (options.lowerCaseTagName) {
            match[2] = match[2].toLowerCase();
        }
        if (!match[1]) {
            // not </ tags
            const attrs = {};
            for (let attMatch; (attMatch = kAttributePattern.exec(match[3]));) {
                attrs[attMatch[2].toLowerCase()] = attMatch[4] || attMatch[5] || attMatch[6];
            }
            const tagName = currentParent.rawTagName;
            if (!match[4] && kElementsClosedByOpening[tagName]) {
                if (kElementsClosedByOpening[tagName][match[2]]) {
                    stack.pop();
                    currentParent = arr_back(stack);
                }
            }
            // ignore container tag we add above
            // https://github.com/taoqf/node-html-parser/issues/38
            currentParent = currentParent.appendChild(new html_HTMLElement(match[2], attrs, match[3]));
            stack.push(currentParent);
            if (is_block_text_element(match[2])) {
                // a little test to find next </script> or </style> ...
                const closeMarkup = `</${match[2]}>`;
                const index = (() => {
                    if (options.lowerCaseTagName) {
                        return data.toLocaleLowerCase().indexOf(closeMarkup, kMarkupPattern.lastIndex);
                    }
                    return data.indexOf(closeMarkup, kMarkupPattern.lastIndex);
                })();
                if (element_should_be_ignore(match[2])) {
                    let text;
                    if (index === -1) {
                        // there is no matching ending for the text element.
                        text = data.substr(kMarkupPattern.lastIndex);
                    }
                    else {
                        text = data.substring(kMarkupPattern.lastIndex, index);
                    }
                    if (text.length > 0) {
                        currentParent.appendChild(new text_TextNode(text));
                    }
                }
                if (index === -1) {
                    lastTextPos = kMarkupPattern.lastIndex = data.length + 1;
                }
                else {
                    lastTextPos = kMarkupPattern.lastIndex = index + closeMarkup.length;
                    match[1] = 'true';
                }
            }
        }
        if (match[1] || match[4] || kSelfClosingElements[match[2]]) {
            // </ or /> or <br> etc.
            while (true) {
                if (currentParent.rawTagName === match[2]) {
                    stack.pop();
                    currentParent = arr_back(stack);
                    break;
                }
                else {
                    const tagName = currentParent.tagName;
                    // Trying to close current tag, and move on
                    if (kElementsClosedByClosing[tagName]) {
                        if (kElementsClosedByClosing[tagName][match[2]]) {
                            stack.pop();
                            currentParent = arr_back(stack);
                            continue;
                        }
                    }
                    // Use aggressive strategy to handle unmatching markups.
                    break;
                }
            }
        }
    }
    return stack;
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/valid.js

/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */
function valid(data, options = { lowerCaseTagName: false, comment: false }) {
    const stack = base_parse(data, options);
    return Boolean(stack.length === 1);
}

// CONCATENATED MODULE: ./node_modules/node-html-parser/dist/esm/index.js








// CONCATENATED MODULE: ./src/plugins/icons/helpers/make-icon.js






var make_icon_makeIcon = function makeIcon(name, content) {
  var kebabName = Object(string_utils["kebab"])(name);
  var iconName = "AnxIcon".concat(name);
  var iconNameClass = "anx-icon anx-icon-".concat(kebabName);
  /** Parse the raw html and get the parsed <svg> element */

  var svgNodeElement = parse(content);

  while (svgNodeElement.tagName != "SVG") {
    svgNodeElement = svgNodeElement.childNodes[0];
  } // Return the icon component definition


  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    name: iconName,
    functional: true,
    props: {
      height: {
        type: String,
        default: "100%"
      },
      width: {
        type: String,
        default: "100%"
      },
      margin: {
        type: String,
        default: "0px"
      },
      title: {
        type: String,
        default: iconName
      }
    },
    render: function render(h, _ref) {
      var data = _ref.data,
          props = _ref.props;

      /** Render all the child components of the svg elemnt as vue components */
      var svgChildComponents = [];
      svgNodeElement.childNodes.forEach(function (child) {
        svgChildComponents.push(h(child.rawTagName, {
          attrs: child.attributes,
          domProps: {
            innerHTML: child.innerHTML
          }
        }));
      });
      /** Render a component for the title and bind the title property to it */

      svgChildComponents.push(h("title", props.title));
      /**
       * This function renders a <div> with the defined properties as elemnt attributes
       * It also renders a <svg> as child element of the div with all the options of the raw svg elemnt
       * Then it renders all the child components for the svg element
       */

      return h("div", a(data, {
        staticClass: iconNameClass,
        props: Object(objectSpread2["a" /* default */])({}, props),
        attrs: {
          "aria-label": iconName,
          style: (props.width ? "width: ".concat(props.width, ";") : "") + (props.height ? " height: ".concat(props.height, ";") : "") + (props.margin ? "margin: ".concat(props.margin, ";") : "")
        }
      }), [h("svg", {
        attrs: svgNodeElement.attributes
      }, svgChildComponents)]);
    }
  });
};
// CONCATENATED MODULE: ./src/plugins/icons/icons.js
// --- BEGIN AUTO-GENERATED FILE ---
//
// This file is auto generated on each build. Do not edit this file!
// Run the necessary scripts defined in package.json to generate this file.

var AnxIcon24h = make_icon_makeIcon("24h", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon24h-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon24h-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <g>      <g>        <path class='anx-icon24h-cls1' d='M155.37,189.68A66.72,66.72,0,1,1,174.78,81.82c.33.34.66.67,1,1'/>        <polygon class='anx-icon24h-cls2' points='156.46 89.28 190.1 105.61 187.42 68.31 156.46 89.28'/>      </g>      <path class='anx-icon24h-cls1' d='M177.64,173.13a67,67,0,0,1-11.85,10.58'/>      <path class='anx-icon24h-cls1' d='M190.38,151.63a66.78,66.78,0,0,1-5.56,11.7'/>      <path class='anx-icon24h-cls1' d='M194.32,129a66.86,66.86,0,0,1-.94,11.21'/>    </g>    <circle class='anx-icon24h-cls1' cx='129' cy='129' r='125'/>  </g>  <g>    <path class='anx-icon24h-cls2' d='M123.65,149.19H97.79v-4.63a122.05,122.05,0,0,0,10.14-10c6.21-6.84,8.18-11.34,8.18-15,0-4.5-2.79-6.78-6.34-6.78-3.74,0-6.53,2-9.25,4.12L97,112.75c4.63-4.06,9.32-6.15,15-6.15,7.1,0,12.11,5.07,12.11,12,0,4.12-2.35,8.68-6,13-1.71,2.09-4.24,4.56-6.72,7.1-2.21,2.22-4.49,4.56-5.32,5,1.27-.12,3.93-.25,6.15-.25h13Z'/>    <path class='anx-icon24h-cls2' d='M158.88,141.27a17.47,17.47,0,0,1-1.84-.13,12,12,0,0,1,.19,2.41v6.59l-6.65,1.2V143.1c0-.76.06-1.71.06-2-.19,0-1,.13-2.22.13h-16.6v-5l13.43-29.15h7.35l-10.77,23.39c-.89,2-2.34,4.43-2.66,5,.19,0,1-.12,1.77-.12h8.37c.7,0,1.33.06,1.46.06,0-.19-.07-1.14-.07-1.39,0-1.53.13-3.93.32-6.28l.76-9.06,5.45-1.39V134c0,.26-.06,1.27-.06,1.52.25,0,1.2-.12,1.71-.12H162v5.83Z'/>  </g></svg>");
var AnxIcon3d = make_icon_makeIcon("3d", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon3d-cls1, .anx-icon3d-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon3d-cls1 {        stroke-miterlimit: 10;      }      .anx-icon3d-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon3d-cls1' cx='129' cy='129' r='125'/>  <g>    <polygon class='anx-icon3d-cls2' points='129 162.5 98.94 147.46 98.94 80.01 129 95.05 129 162.5'/>    <polygon class='anx-icon3d-cls2' points='129 162.5 159.06 147.46 159.06 80.01 129 95.05 129 162.5'/>    <polyline class='anx-icon3d-cls2' points='159.06 80.01 129 64.13 98.94 80.01'/>    <polyline class='anx-icon3d-cls2' points='80.33 131.16 45.33 149.66 129 193.87 212.67 149.66 177.67 131.16'/>  </g></svg>");
var AnxIconLKWTransport = make_icon_makeIcon("LKWTransport", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-lkwtransport-cls1, .anx-icon-lkwtransport-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-lkwtransport-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-lkwtransport-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-lkwtransport-cls1' cx='129' cy='129' r='125'/>    <g>      <rect class='anx-icon-lkwtransport-cls2' x='49.74' y='71.2' width='111.58' height='82.38'/>      <path class='anx-icon-lkwtransport-cls2' d='M59.68,153.58v23.57H81.85c0-.35,0-.7,0-1.05a13,13,0,1,1,26,0c0,.35,0,.7,0,1.05h58c0-.35-.06-.7-.06-1.05a13,13,0,1,1,26,0c0,.35,0,.7-.06,1.05H211.4V153.58Z'/>      <polygon class='anx-icon-lkwtransport-cls2' points='211.4 153.58 161.45 153.58 161.45 88.84 200.98 88.84 211.4 153.58'/>      <circle class='anx-icon-lkwtransport-cls2' cx='94.79' cy='176.1' r='12.99'/>      <circle class='anx-icon-lkwtransport-cls2' cx='178.64' cy='176.1' r='12.99'/>      <polyline class='anx-icon-lkwtransport-cls2' points='202.73 105 186.42 105 186.42 129.33 207.49 129.33'/>    </g>  </g></svg>");
var AnxIconAiKuenstlicheintelligenz = make_icon_makeIcon("AiKuenstlicheintelligenz", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-ai-kuenstlicheintelligenz-cls1, .anx-icon-ai-kuenstlicheintelligenz-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-ai-kuenstlicheintelligenz-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-ai-kuenstlicheintelligenz-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon-ai-kuenstlicheintelligenz-cls1' cx='129' cy='129' r='125'/>  <g>    <path class='anx-icon-ai-kuenstlicheintelligenz-cls2' d='M125.51,76.7V57.91H112.7a1.5,1.5,0,0,0-1.43,1L106.8,72.7a1.51,1.51,0,0,1-.85.93L92.93,79a1.5,1.5,0,0,1-1.26,0L78.79,72.41a1.5,1.5,0,0,0-1.75.27l-12.1,12.1a1.52,1.52,0,0,0-.28,1.75l6.57,12.88a1.54,1.54,0,0,1,0,1.26l-5.4,13a1.53,1.53,0,0,1-.92.86l-14,4.56a1.07,1.07,0,0,0-.74,1v17.43a1.5,1.5,0,0,0,1,1.43L65,143.45a1.53,1.53,0,0,1,.92.86l5.4,13a1.54,1.54,0,0,1,0,1.26l-6.57,12.88a1.52,1.52,0,0,0,.28,1.75L77,185.32a1.5,1.5,0,0,0,1.75.27L91.67,179a1.5,1.5,0,0,1,1.26-.05l13,5.39a1.51,1.51,0,0,1,.85.93l4.47,13.75a1.5,1.5,0,0,0,1.43,1h12.81V181.3'/>    <path class='anx-icon-ai-kuenstlicheintelligenz-cls2' d='M121.57,152.87h-.08a23.87,23.87,0,0,1,.08-47.74'/>    <g>      <g>        <circle class='anx-icon-ai-kuenstlicheintelligenz-cls1' cx='155.86' cy='182.11' r='11.6'/>        <line class='anx-icon-ai-kuenstlicheintelligenz-cls2' x1='147.66' y1='173.91' x2='140.14' y2='166.39'/>      </g>      <g>        <circle class='anx-icon-ai-kuenstlicheintelligenz-cls1' cx='189.97' cy='167.23' r='11.6'/>        <polyline class='anx-icon-ai-kuenstlicheintelligenz-cls2' points='181.77 159.03 171.33 148.18 140.14 148.18'/>      </g>      <circle class='anx-icon-ai-kuenstlicheintelligenz-cls1' cx='204.74' cy='128.6' r='11.6'/>      <line class='anx-icon-ai-kuenstlicheintelligenz-cls2' x1='193.14' y1='128.6' x2='140.14' y2='128.6'/>      <g>        <circle class='anx-icon-ai-kuenstlicheintelligenz-cls1' cx='155.86' cy='75.18' r='11.6'/>        <line class='anx-icon-ai-kuenstlicheintelligenz-cls2' x1='147.66' y1='83.38' x2='140.14' y2='90.9'/>      </g>      <g>        <circle class='anx-icon-ai-kuenstlicheintelligenz-cls1' cx='189.97' cy='90.06' r='11.6'/>        <polyline class='anx-icon-ai-kuenstlicheintelligenz-cls2' points='181.77 98.27 171.33 109.11 140.14 109.11'/>      </g>    </g>  </g></svg>");
var AnxIconAlexa = make_icon_makeIcon("Alexa", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-alexa-cls1, .anx-icon-alexa-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-alexa-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-alexa-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-alexa-cls3 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-alexa-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-alexa-cls2' d='M158.4,81c0,6.59-13.17,11.94-29.4,11.94S99.6,87.56,99.6,81'/>      <ellipse class='anx-icon-alexa-cls2' cx='129' cy='63.07' rx='29.4' ry='11.94'/>      <ellipse class='anx-icon-alexa-cls3' cx='118.96' cy='62.49' rx='6.61' ry='3.39'/>      <ellipse class='anx-icon-alexa-cls3' cx='139.04' cy='62.49' rx='6.61' ry='3.39'/>      <path class='anx-icon-alexa-cls2' d='M99.6,63.87V192.1c0,6.59,13.17,11.94,29.4,11.94s29.4-5.35,29.4-11.94V63.87'/>      <g>        <path class='anx-icon-alexa-cls1' d='M169.93,137.41a14.33,14.33,0,0,1,1.45,25.05'/>        <path class='anx-icon-alexa-cls1' d='M176.08,176.06a28.55,28.55,0,0,0,0-51.44'/>      </g>      <g>        <path class='anx-icon-alexa-cls1' d='M88.07,163.27a14.34,14.34,0,0,1-1.45-25.06'/>        <path class='anx-icon-alexa-cls1' d='M81.92,124.62a28.55,28.55,0,0,0,0,51.44'/>      </g>    </g>  </g></svg>");
var AnxIconAnderesWeiteresTeil = make_icon_makeIcon("AnderesWeiteresTeil", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-anderes-weiteres-teil-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-anderes-weiteres-teil-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-anderes-weiteres-teil-cls1' d='M110,76.43s2.85-17.77,19-17.77,17.58,18.27,17.58,18.27L172,77l0,34.1s23.29-1.86,23.29,17.89-23.7,15.09-23.7,15.09v36.52H143.33s1.37-19.76-16.76-19.76-19.4,19.76-19.4,19.76H75.78V76.43Z'/>  </g></svg>");
var AnxIconAndroid = make_icon_makeIcon("Android", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-android-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-android-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-android-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-android-cls1' d='M152.18,57.64l7.33-13.39A1.46,1.46,0,1,0,157,42.84l-7.4,13.53a51.19,51.19,0,0,0-41.12,0L101,42.86a1.44,1.44,0,0,0-2-.58,1.43,1.43,0,0,0-.58,2l7.34,13.38C91.39,65.07,83.65,78.22,83.66,94.47h90.63C174.29,78.21,166.57,65.09,152.18,57.64Z'/>    <path class='anx-icon-android-cls1' d='M195.3,116a10.51,10.51,0,1,0-21,0v44a10.51,10.51,0,1,0,21,0Z'/>    <path class='anx-icon-android-cls1' d='M83.66,107.54l0,63.46A11.29,11.29,0,0,0,95,182.3h5.69v23.45a10.58,10.58,0,1,0,21.16,0V182.3h14.29v23.45a10.59,10.59,0,0,0,21.17,0V182.29H163A11.29,11.29,0,0,0,174.29,171V107.52Z'/>    <path class='anx-icon-android-cls1' d='M73.15,105.54A10.51,10.51,0,0,0,62.64,116v44a10.51,10.51,0,1,0,21,0V116a10.5,10.5,0,0,0-10.51-10.5'/>    <path class='anx-icon-android-cls2' d='M148.54,80.85a5,5,0,1,1,5-5,5,5,0,0,1-5,5'/>    <path class='anx-icon-android-cls2' d='M109.45,80.86a5,5,0,1,1,5-5,5,5,0,0,1-5,5'/>  </g></svg>");
var AnxIconAnexiaStamp = make_icon_makeIcon("AnexiaStamp", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500'><rect x='141.76' y='74.05' width='7.84' height='37.36' transform='translate(-26.97 96.36) rotate(-33.68)' style='fill:var(--anx-icons-color)'/><polygon points='173.89 64.15 165.87 68.06 179.45 96.05 172.59 99.39 159 71.39 150.78 75.37 148.05 69.77 172.28 58 173.89 64.15' style='fill:var(--anx-icons-color)'/><path d='M230.8,69.5a12.08,12.08,0,0,1-.14,5.27,11.46,11.46,0,0,1-2.35,4.47,13.81,13.81,0,0,1-4.31,3.4,21.49,21.49,0,0,1-6.09,2,26.53,26.53,0,0,1-13.13-1l1.68-6.27a35.78,35.78,0,0,0,5.34,1.26,16.17,16.17,0,0,0,5.3-.17c4.29-.79,6.14-2.87,5.52-6.21-.43-2.29-2.33-3.57-5.69-3.87L212.65,68a16.58,16.58,0,0,1-4.83-1,8.53,8.53,0,0,1-3.27-2.29A10.49,10.49,0,0,1,202,59.42a11,11,0,0,1,.09-4.81,10.71,10.71,0,0,1,2-4.1,12.69,12.69,0,0,1,3.76-3.09A17.23,17.23,0,0,1,213,45.61a23.08,23.08,0,0,1,6.79-.24A19.62,19.62,0,0,1,226,47L223.47,53a22.82,22.82,0,0,0-4.92-1.34,13.81,13.81,0,0,0-4.16.11,5.69,5.69,0,0,0-3.48,1.89,3.87,3.87,0,0,0-.86,3.29A3,3,0,0,0,211.33,59a8.09,8.09,0,0,0,3.48.86l4.66.39A13.49,13.49,0,0,1,227.13,63a10.58,10.58,0,0,1,3.67,6.49' style='fill:var(--anx-icons-color)'/><polygon points='239.66 81.05 239.05 43.69 260.34 43.35 259.47 49.5 246.79 49.7 246.93 58.36 257.52 58.18 257.61 64.31 247.03 64.48 247.19 74.48 261.32 74.25 261.44 80.7 239.66 81.05' style='fill:var(--anx-icons-color)'/><path d='M290,57.61q.64-3.54-1.84-5a6.31,6.31,0,0,0-1.64-.7,19.28,19.28,0,0,0-2.43-.59l-2.65-.48-1.8,9.94,2.48.46a18.21,18.21,0,0,0,3.64.38,4.14,4.14,0,0,0,2.15-.59A4.92,4.92,0,0,0,290,57.61m-3.48,26c-.25-.66-.46-1.24-.64-1.75s-.36-1-.54-1.49-.37-1-.55-1.55-.37-1.16-.6-1.86c-.63-1.82-1.15-3.34-1.56-4.54s-.79-2.18-1.13-2.94a11.54,11.54,0,0,0-.92-1.72,3.37,3.37,0,0,0-.85-.9,3.84,3.84,0,0,0-1.1-.53L275.83,81.7l-7.24-1.31,6.69-36.76L289,46.12a12.27,12.27,0,0,1,4.27,1.57,9.78,9.78,0,0,1,3,2.81,9.89,9.89,0,0,1,1.58,3.82,12.24,12.24,0,0,1,0,4.55,12.05,12.05,0,0,1-1.34,3.78,10.19,10.19,0,0,1-2.34,2.87,8.75,8.75,0,0,1-3,1.73,7.43,7.43,0,0,1-3.34.29,7.24,7.24,0,0,1,.73.89c.15.25.32.55.5.92a18.66,18.66,0,0,1,.92,1.94c.35.85.74,1.78,1.15,2.83l1.27,3.24c.43,1.11.83,2.19,1.21,3.22s.71,2,1,2.78.53,1.45.68,1.88Z' style='fill:var(--anx-icons-color)'/><path d='M315.28,93.85l-6.35-2.5,1.94-39.66,7.65,3-1.35,20.36c0,.88-.12,1.87-.25,3s-.29,2.35-.52,3.72a17.14,17.14,0,0,1,1.08-1.57c.4-.56.82-1.1,1.24-1.64s.85-1.09,1.26-1.59.79-1,1.13-1.38l12.67-14.9,7.36,2.9Z' style='fill:var(--anx-icons-color)'/><polygon points='331.1 100.88 349.72 68.5 356.52 72.4 337.9 104.8 331.1 100.88' style='fill:var(--anx-icons-color)'/><path d='M367.75,123.55a15.58,15.58,0,0,1-5.34-.83,17.41,17.41,0,0,1-5-2.86q-6.06-4.77-6.38-11.62t4.75-13.3A24.57,24.57,0,0,1,365,87.4a16.23,16.23,0,0,1,8.63-1.29,15.56,15.56,0,0,1,8,3.37,17.9,17.9,0,0,1,3.7,3.94,11.67,11.67,0,0,1,1.89,4.24l-5.82,1.91A10,10,0,0,0,378,94.23a7.77,7.77,0,0,0-3.36-1.57,7,7,0,0,0-3.62.16q-3.57,1.14-7.61,6.25a41.21,41.21,0,0,0-3.54,5.05,11.45,11.45,0,0,0-1.45,3.76,7.66,7.66,0,0,0,3.07,7.75,9.08,9.08,0,0,0,2.84,1.56,10.39,10.39,0,0,0,3.68.51Z' style='fill:var(--anx-icons-color)'/><polygon points='371.33 131.16 399.35 106.45 413.43 122.42 408.19 125.74 399.8 116.23 393.31 121.96 400.32 129.9 395.73 133.95 388.71 126.01 381.21 132.63 390.57 143.22 385.74 147.48 371.33 131.16' style='fill:var(--anx-icons-color)'/><path d='M413.18,168.92a11.89,11.89,0,0,1-5,1.71,11.45,11.45,0,0,1-5-.64,14,14,0,0,1-4.7-2.85,21.16,21.16,0,0,1-4-5,25.78,25.78,0,0,1-2.61-6.09,26.21,26.21,0,0,1-1-6.59l6.47-.62a33.46,33.46,0,0,0,.69,5.45,16.46,16.46,0,0,0,2,4.91c2.25,3.76,4.84,4.74,7.76,3,2-1.2,2.54-3.42,1.63-6.68l-1.15-4.13a16.42,16.42,0,0,1-.75-4.89,8.54,8.54,0,0,1,1-3.86,10.78,10.78,0,0,1,4.09-4.26,11.27,11.27,0,0,1,4.54-1.6,10.81,10.81,0,0,1,4.55.47,13,13,0,0,1,4.22,2.43,17.21,17.21,0,0,1,3.5,4.23,23,23,0,0,1,2.59,6.28,19.27,19.27,0,0,1,.58,6.36l-6.42-.29a22.07,22.07,0,0,0-.49-5.07,13,13,0,0,0-1.56-3.86,5.61,5.61,0,0,0-3-2.61,3.85,3.85,0,0,0-3.4.35,3,3,0,0,0-1.5,1.94,7.93,7.93,0,0,0,.4,3.55l1.26,4.51a13.57,13.57,0,0,1,.12,8.14,10.58,10.58,0,0,1-4.8,5.69' style='fill:var(--anx-icons-color)'/><path d='M441,203a3.68,3.68,0,0,0,2.28-1.53,3.11,3.11,0,0,0,.42-2.56,3.3,3.3,0,0,0-1.54-2.2,3.42,3.42,0,0,0-2.67-.31,5.51,5.51,0,0,0-1,.35,3.87,3.87,0,0,0-.88.68,7.79,7.79,0,0,0-.92,1.09c-.31.45-.68,1-1.1,1.73l-.31.51q2.61,3,5.76,2.24m-13.49-2.78a5.47,5.47,0,0,0-5.48-1.64,4.94,4.94,0,0,0-3.46,2.45,6.52,6.52,0,0,0-.28,4.67c.62,2.52,1.66,4.18,3.12,5.05Zm-10.66,18.51,1.65-2.74a8.91,8.91,0,0,1-1.4-1.2,13,13,0,0,1-1.25-1.46,19.69,19.69,0,0,1-2.72-6.58c-1-4.21-1-7.67.17-10.35a8.88,8.88,0,0,1,6.47-5.19c4-1,7.55.45,10.64,4.32a19.77,19.77,0,0,1,1.4-2.67,6.73,6.73,0,0,1,1.47-1.65,8.06,8.06,0,0,1,1.76-1.06,11.33,11.33,0,0,1,2.17-.77,8.39,8.39,0,0,1,3.72-.13,8.28,8.28,0,0,1,3.31,1.46,10.75,10.75,0,0,1,2.6,2.89,13.63,13.63,0,0,1,1.7,4.06,14.69,14.69,0,0,1,.44,4.43,10.58,10.58,0,0,1-.87,3.75,8,8,0,0,1-2.08,2.84,7.33,7.33,0,0,1-3.14,1.6,8.33,8.33,0,0,1-2.88.21,7.21,7.21,0,0,1-2.56-.75,8.72,8.72,0,0,1-2-1.42c-.62-.56-1.41-1.36-2.36-2.38l-.38-.41L428.46,213h1.14a4.54,4.54,0,0,0,1-.12c.35-.05.76-.14,1.24-.24s1.09-.23,1.86-.43l.36-.09,1.44,5.85-.32.08a25,25,0,0,1-10.12.71l-5.8,9.67Z' style='fill:var(--anx-icons-color)'/><path d='M430.68,274.37a11.88,11.88,0,0,1-5.09-1.39,11.68,11.68,0,0,1-3.8-3.34,14.49,14.49,0,0,1-2.27-5,21,21,0,0,1-.51-6.37,24.87,24.87,0,0,1,1.25-6.51,26.32,26.32,0,0,1,2.85-6l5.68,3.13a35.78,35.78,0,0,0-2.48,4.89,16.41,16.41,0,0,0-1.1,5.2q-.37,6.54,4.73,6.83c2.33.13,4-1.41,5.1-4.61l1.36-4.07a16.48,16.48,0,0,1,2.14-4.45,8.49,8.49,0,0,1,3-2.63,10.63,10.63,0,0,1,5.77-1.24A11.36,11.36,0,0,1,452,250a10.64,10.64,0,0,1,3.49,3,12.41,12.41,0,0,1,2.12,4.38,16.89,16.89,0,0,1,.52,5.46,23.32,23.32,0,0,1-1.38,6.66,19.6,19.6,0,0,1-3.08,5.58l-5.17-3.86a22.45,22.45,0,0,0,2.46-4.46,13.24,13.24,0,0,0,.88-4.07,5.76,5.76,0,0,0-1-3.82,3.86,3.86,0,0,0-3-1.62,3,3,0,0,0-2.33.75,7.89,7.89,0,0,0-1.66,3.17l-1.49,4.43a13.63,13.63,0,0,1-4.48,6.8,10.41,10.41,0,0,1-7.17,2' style='fill:var(--anx-icons-color)'/><path d='M430,307.17a43.89,43.89,0,0,0,4.89,1.08,20.46,20.46,0,0,0,3.73.28,8,8,0,0,0,1.65-.27,5.85,5.85,0,0,0,1.81-.85,7,7,0,0,0,1.66-1.54,7.22,7.22,0,0,0,1.22-6,6,6,0,0,0-1.69-2.91q-2.91-2.76-9.35-4.52c-6.25-1.71-10.43-1.71-12.54,0a7.22,7.22,0,0,0-2.43,3.95,6,6,0,0,0,1.56,6.31q2.6,2.52,9.49,4.42m-2.08,8.4a25.38,25.38,0,0,1-9.95-4.93,14,14,0,0,1-5.32-11.43,20.88,20.88,0,0,1,3.76-10.57,12.59,12.59,0,0,1,5.22-3.78c4.31-1.79,9.16-2,14.51-.48a24.15,24.15,0,0,1,9.68,4.93,15.17,15.17,0,0,1,4.94,7.83,14.54,14.54,0,0,1,.35,3.89,17.25,17.25,0,0,1-.64,4.05,16.54,16.54,0,0,1-3,6.11,13.83,13.83,0,0,1-5,3.9,16.92,16.92,0,0,1-6.59,1.5,26.28,26.28,0,0,1-7.92-1' style='fill:var(--anx-icons-color)'/><polygon points='425.32 348.47 430.55 337.81 422.88 334.05 418.69 342.58 413.19 339.88 417.39 331.35 402.47 324.01 405.79 317.25 439.32 333.74 430.38 351.92 425.32 348.47' style='fill:var(--anx-icons-color)'/><polygon points='406.58 376.27 411.74 368.99 386.35 350.99 390.77 344.77 416.15 362.77 421.43 355.31 426.53 358.91 410.96 380.89 406.58 376.27' style='fill:var(--anx-icons-color)'/><path d='M352.89,385.47,359,380l12.6,9.15c.95.7,1.87,1.37,2.75,2.05s1.71,1.32,2.45,1.93,1.38,1.16,1.92,1.63.94.84,1.2,1.08c-.14-.21-.4-.6-.76-1.18s-.82-1.27-1.32-2.07-1.09-1.67-1.69-2.66-1.23-2-1.83-3.06l-7.86-13.51,6.38-5.68,31.73,22.22-5.95,5.28-12.2-8.85c-1.33-1-2.57-1.91-3.68-2.81l-2.93-2.39-2-1.76c-.51-.47-.84-.77-1-.89.24.33.58.83,1,1.49s1,1.47,1.58,2.39,1.23,1.9,1.9,3,1.32,2.18,1.94,3.31l7.55,13.51-6.15,5.46L371,397.41c-.68-.5-1.45-1.08-2.3-1.78s-1.65-1.34-2.42-2l-2-1.68c-.57-.47-.92-.76-1-.84.2.27.55.81,1.1,1.65l1.84,2.82c.67,1.06,1.36,2.14,2.05,3.25s1.26,2.07,1.7,2.88l7.14,12.64-5.9,5.25Z' style='fill:var(--anx-icons-color)'/><path d='M334.94,414.16l.87.84,1.38,1.46,1.63,1.72c.57.59,1.07,1.14,1.5,1.63l4.46,5.11a9.77,9.77,0,0,0-.28-1.13c-.14-.53-.31-1.15-.5-1.85s-.37-1.41-.55-2.16-.37-1.44-.53-2c-.33-1.37-.6-2.57-.83-3.59s-.46-2.16-.71-3.45ZM323.85,403l6.53,6.55,9.65-5.2-1.89-9.06,6.91-3.72,7,38.79-7.16,3.86-28.13-27.39Z' style='fill:var(--anx-icons-color)'/><path d='M303,438c.71,2.3,2,3.48,3.91,3.57a6.58,6.58,0,0,0,1.79-.12,21.88,21.88,0,0,0,2.43-.6l2.57-.8-3-9.66-2.41.74a20,20,0,0,0-3.41,1.34,4.17,4.17,0,0,0-1.62,1.51,4.89,4.89,0,0,0-.28,4m-8.9-24.71c.54.48,1,.9,1.38,1.27s.78.73,1.18,1.08.78.71,1.18,1.11.87.85,1.41,1.38l3.46,3.31c.92.88,1.72,1.58,2.35,2.09a10.56,10.56,0,0,0,1.61,1.1,3,3,0,0,0,1.18.41,3.55,3.55,0,0,0,1.22,0L304.5,410l7-2.16,11,35.72-13.31,4.09a12.07,12.07,0,0,1-4.52.57,9.83,9.83,0,0,1-4-1.1,10.17,10.17,0,0,1-3.16-2.67,12.62,12.62,0,0,1-2.06-4.06,11.86,11.86,0,0,1-.54-4,10.72,10.72,0,0,1,.74-3.63,8.51,8.51,0,0,1,1.89-2.91,7.07,7.07,0,0,1,2.85-1.8,5.73,5.73,0,0,1-1.07-.46c-.25-.14-.54-.34-.89-.58a19.8,19.8,0,0,1-1.69-1.3c-.71-.59-1.49-1.25-2.33-2l-2.62-2.28c-.9-.8-1.75-1.56-2.56-2.31l-2.18-2c-.66-.59-1.14-1-1.47-1.35Z' style='fill:var(--anx-icons-color)'/><polygon points='279.05 417.24 283.35 454.36 262.21 456.81 262.45 450.61 275.06 449.15 274.06 440.55 263.54 441.76 262.84 435.67 273.36 434.46 272.21 424.54 258.16 426.17 257.42 419.74 279.05 417.24' style='fill:var(--anx-icons-color)'/><path d='M215.08,434.27a42.51,42.51,0,0,0-.53,5.91,11.8,11.8,0,0,0,.79,4.73,6.23,6.23,0,0,0,1.88,2.65,7.42,7.42,0,0,0,3.48,1.34l3.39.52,3.9-25-4-.63a5.94,5.94,0,0,0-5.82,2c-1.44,1.72-2.48,4.55-3.1,8.49m-8.45-.62a26.26,26.26,0,0,1,2-6.9,18.47,18.47,0,0,1,3.69-5.32,14.26,14.26,0,0,1,4.61-3.07,11.31,11.31,0,0,1,5.19-.84c.72,0,1.51.11,2.39.2s1.86.24,3,.41l9,1.4-5.75,36.92-7.44-1.16c-1.06-.17-2.21-.37-3.45-.59s-2.21-.44-2.93-.62a13.69,13.69,0,0,1-4.21-1.79,11.52,11.52,0,0,1-3.29-3.14,15.89,15.89,0,0,1-2.85-6.73,26.39,26.39,0,0,1,.07-8.77' style='fill:var(--anx-icons-color)'/><polygon points='202.35 413.29 189.78 448.46 169.73 441.3 172.7 435.85 184.65 440.13 187.56 431.97 177.6 428.42 179.66 422.64 189.63 426.2 192.99 416.79 179.68 412.04 181.85 405.96 202.35 413.29' style='fill:var(--anx-icons-color)'/><path d='M163,395.27l5.9,3.42-7.82,38.93L154,433.51l4.37-19.94c.17-.86.4-1.83.69-2.9s.64-2.28,1.07-3.6c-.38.44-.81.9-1.31,1.39s-1,1-1.47,1.44-1,.94-1.48,1.39-.93.84-1.34,1.18L139.8,425.32l-6.85-4Z' style='fill:var(--anx-icons-color)'/><polygon points='147.19 385.47 123.03 413.96 106.8 400.19 111.49 396.15 121.17 404.36 126.78 397.75 118.7 390.9 122.66 386.23 130.74 393.09 137.21 385.44 126.42 376.31 130.59 371.39 147.19 385.47' style='fill:var(--anx-icons-color)'/><polygon points='113.49 350.81 126.26 365.86 97.76 390.02 92.79 384.16 116.53 364.04 107.87 353.84 113.49 350.81' style='fill:var(--anx-icons-color)'/><path d='M81.46,335.27a47.27,47.27,0,0,0-4.25,2.66,20.54,20.54,0,0,0-2.82,2.42,7.5,7.5,0,0,0-1,1.36,6,6,0,0,0-.7,1.88,7.34,7.34,0,0,0-.08,2.26,6.49,6.49,0,0,0,.86,2.54A6.73,6.73,0,0,0,75.93,351a6,6,0,0,0,3.25.9q4-.11,9.82-3.37c5.65-3.18,8.62-6.1,8.92-8.81a7.48,7.48,0,0,0-1.06-4.52,6,6,0,0,0-5.54-3.4q-3.63,0-9.86,3.52M77,327.84a25.83,25.83,0,0,1,10.55-3.5,14.11,14.11,0,0,1,11.82,4.41,18.52,18.52,0,0,1,2.34,3.34,18.12,18.12,0,0,1,2.4,6.83,12.5,12.5,0,0,1-1.06,6.34q-2.72,6.47-10,10.53a24.21,24.21,0,0,1-10.35,3.31,15.08,15.08,0,0,1-9-2.11,14.56,14.56,0,0,1-3-2.51,18.45,18.45,0,0,1-2.39-3.34,16.58,16.58,0,0,1-2.13-6.49,14.08,14.08,0,0,1,.81-6.28,17.12,17.12,0,0,1,3.65-5.72A26.52,26.52,0,0,1,77,327.84' style='fill:var(--anx-icons-color)'/><path d='M61.81,303.38a6.06,6.06,0,0,0-3.53,2.48,4.75,4.75,0,0,0-.3,4l1.43,4.56L70.29,311l-1.18-3.75c-.22-.72-.44-1.31-.64-1.8a5.49,5.49,0,0,0-.68-1.19,3,3,0,0,0-.86-.75,5.11,5.11,0,0,0-1.15-.45,5,5,0,0,0-1.77-.17,8.94,8.94,0,0,0-2.2.45m-2.6-7.79a12.43,12.43,0,0,1,6.75-.35,10.71,10.71,0,0,1,5.53,3.25,11.53,11.53,0,0,1,.91,1.1c.26.39.54.82.81,1.32a18,18,0,0,1,.81,1.81c.28.7.57,1.54.88,2.54l1.23,3.94,13.14-4.1,2.24,7.17L55.85,323.42,52.92,314c-.46-1.51-.83-2.79-1.09-3.86a19.14,19.14,0,0,1-.5-2.77,9.85,9.85,0,0,1,0-2c0-.59.14-1.18.25-1.79a9.83,9.83,0,0,1,2.58-5,11.51,11.51,0,0,1,5.06-3' style='fill:var(--anx-icons-color)'/><path d='M80.59,251.09,60.8,254c-1.17.16-2.25.31-3.23.43s-2,.23-3,.31c1.08.13,2,.27,2.85.4s1.82.31,3,.57l20.82,4.38.47,6.37-19.17,6.76c-.91.33-2,.67-3.1,1s-2.18.68-3.16.93c1-.07,2.07-.12,3.12-.12s2.23-.08,3.38-.09l19.55-.16.56,7.45-37.52-.71-.71-9.6L63,265.66c.66-.24,1.25-.43,1.76-.59l1.42-.43,1.29-.36c.43-.12.87-.23,1.34-.34-1.89-.18-4-.48-6.16-.9l-18.88-3.66L43,249.85l37-6.1Z' style='fill:var(--anx-icons-color)'/><polygon points='81.22 235.28 44.25 229.99 47.27 208.91 53.19 210.73 51.39 223.29 59.97 224.53 61.46 214.04 67.53 214.91 66.03 225.39 75.92 226.81 77.92 212.81 84.3 213.74 81.22 235.28' style='fill:var(--anx-icons-color)'/><path d='M91.41,189.63,75.82,191c-1.31.13-2.6.24-3.89.34l-3.74.28c-1.18.09-2.27.16-3.22.2s-1.64,0-2.18.05c.67.16,1.41.35,2.23.6l2.63.79c.9.26,1.77.54,2.65.82l2.42.8,15.17,5-2.36,6.87L50.2,194.63l2.71-7.88,16.46-1.9q3.28-.36,6.26-.45c2-.05,3.66-.05,5.07,0-.7-.16-1.49-.36-2.37-.59s-1.79-.47-2.7-.73-1.8-.51-2.65-.76-1.56-.49-2.18-.7l-14.49-4.8,2.33-6.76L94,182.21Z' style='fill:var(--anx-icons-color)'/><polygon points='81.77 139.25 77.33 147 104.32 162.46 100.53 169.09 73.54 153.61 68.99 161.55 63.59 158.44 76.97 135.08 81.77 139.25' style='fill:var(--anx-icons-color)'/><path d='M114.51,112.72a6.6,6.6,0,0,0-2.48.48,5.86,5.86,0,0,0-2,1.37,5.76,5.76,0,0,0-1.31,2,6.86,6.86,0,0,0-.43,2.39,7,7,0,0,0,.51,2.31,5.81,5.81,0,0,0,1.36,2,5.7,5.7,0,0,0,2,1.29,6.12,6.12,0,0,0,2.26.42v3.38l.09-3.38a6.56,6.56,0,0,0,2.35-.5,5.83,5.83,0,0,0,2-1.37,5.48,5.48,0,0,0,1.29-2,6.17,6.17,0,0,0,.42-2.36,6.25,6.25,0,0,0-.49-2.34,5.92,5.92,0,0,0-1.36-2,6,6,0,0,0-2-1.3,6.17,6.17,0,0,0-2.21-.41m0,19a13.09,13.09,0,0,1-4.63-.85,12.9,12.9,0,0,1-7.26-7,13,13,0,0,1-1-4.76,13.35,13.35,0,0,1,.84-4.85,12.85,12.85,0,0,1,7-7.27,12.72,12.72,0,0,1,4.8-1h0a13.17,13.17,0,0,1,4.77.83,12.91,12.91,0,0,1,7.28,7,13,13,0,0,1,.15,9.6,12.47,12.47,0,0,1-2.77,4.35,12.64,12.64,0,0,1-4.25,2.92,13.37,13.37,0,0,1-4.78,1Z' style='fill:var(--anx-icons-color)'/><path d='M442.24,409.83l-11.53-9.61a233,233,0,0,0,43.91-80.93L489,323.71a248.19,248.19,0,0,1-46.72,86.12' style='fill:var(--anx-icons-color)'/><path d='M351.29,478.61l-6.08-13.71a234,234,0,0,0,75.22-53.13l10.87,10.35a249.13,249.13,0,0,1-80,56.49' style='fill:var(--anx-icons-color)'/><path d='M314.72,491.54,310.84,477c6.71-1.78,13.45-3.92,20.07-6.33l5.14,14.08c-7,2.58-14.2,4.85-21.33,6.75' style='fill:var(--anx-icons-color)'/><path d='M15.21,336.05c-2.56-7-4.83-14.17-6.75-21.34L23,310.83c1.79,6.75,3.93,13.49,6.33,20.06Z' style='fill:var(--anx-icons-color)'/><path d='M77.88,431.32a249,249,0,0,1-56.49-80l13.71-6.07a234,234,0,0,0,53.12,75.2Z' style='fill:var(--anx-icons-color)'/><path d='M176.29,489a248.33,248.33,0,0,1-86.12-46.71l9.61-11.54a233.22,233.22,0,0,0,80.93,43.91Z' style='fill:var(--anx-icons-color)'/><path d='M169.1,29.27l-5.17-14.09c7-2.56,14.15-4.83,21.35-6.75l3.87,14.5c-6.76,1.8-13.5,3.94-20.05,6.34' style='fill:var(--anx-icons-color)'/><path d='M79.56,88.19,68.68,77.86a249.18,249.18,0,0,1,80-56.5l6.09,13.71A234.28,234.28,0,0,0,79.56,88.19' style='fill:var(--anx-icons-color)'/><path d='M25.39,180.69l-14.34-4.42A248.26,248.26,0,0,1,57.76,90.15l11.53,9.6a233.33,233.33,0,0,0-43.9,80.94' style='fill:var(--anx-icons-color)'/><path d='M400.23,69.26a233.37,233.37,0,0,0-80.93-43.9L323.72,11a248.14,248.14,0,0,1,86.11,46.71Z' style='fill:var(--anx-icons-color)'/><path d='M464.9,154.76a234.06,234.06,0,0,0-53.12-75.22l10.34-10.88a249.24,249.24,0,0,1,56.49,80Z' style='fill:var(--anx-icons-color)'/><path d='M477,189.14c-1.78-6.71-3.92-13.46-6.33-20.06l14.08-5.16c2.57,7,4.84,14.2,6.75,21.35Z' style='fill:var(--anx-icons-color)'/><path d='M197.69,20.82,194.36,6.18a253.56,253.56,0,0,1,111.28,0l-3.33,14.64a238.14,238.14,0,0,0-104.62,0' style='fill:var(--anx-icons-color)'/><path d='M6.21,305.62a252.32,252.32,0,0,1,0-111.27l14.63,3.33a237.15,237.15,0,0,0,0,104.61Z' style='fill:var(--anx-icons-color)'/><path d='M493.79,305.62l-14.63-3.33a237.15,237.15,0,0,0,0-104.61l14.63-3.33a252.32,252.32,0,0,1,0,111.27' style='fill:var(--anx-icons-color)'/><path d='M250,500a251.86,251.86,0,0,1-55.64-6.21l3.33-14.63a238.74,238.74,0,0,0,104.62,0l3.33,14.63A251.73,251.73,0,0,1,250,500' style='fill:var(--anx-icons-color)'/><path d='M390,265,350,235.9l31.82-37.85-48.9-7.24,10.58-48.32-46.68,16.35-13-47.73L250,147.38l-33.77-36.27L203.2,158.84l-46.63-16.35,10.56,48.32-48.89,7.24,31.81,37.85L110,265l45.82,18.73L134,328.19l49.24-4.77,1.32,49.51,41.34-27.09L250,389.08l24.15-43.24,41.36,27.1,1.27-49.52,49.27,4.77-21.92-44.42Zm-36.61,54.4-43.87-4.26-1.13,44.1-36.84-24.13L250,373.69l-21.51-38.54-36.83,24.14-1.18-44.11-43.84,4.26,19.47-39.57-40.82-16.69,35.65-26-28.34-33.72,43.55-6.46-9.39-43,41.54,14.57,11.61-42.5L250,158.38l30.08-32.3,11.6,42.5L333.28,154l-9.42,43,43.56,6.46-28.36,33.71,35.63,26-40.82,16.69Z' style='fill:var(--anx-icons-color)'/></svg>");
var AnxIconAnexia = make_icon_makeIcon("Anexia", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-anexia-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-anexia-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-anexia-cls1' d='M129,79l16.42-17.63,6.33,23.2,22.71-8-5.14,23.5,23.78,3.53-15.48,18.4,19.45,14.18-22.29,9.11L185.44,167l-23.95-2.32-.62,24.08-20.12-13.18-11.74,21-11.75-21-20.1,13.18-.65-24.08L72.57,167l10.64-21.6-22.29-9.11,19.46-14.18-15.47-18.4,23.78-3.53-5.13-23.5,22.68,8,6.34-23.2Z'/>  </g></svg>");
var AnxIconApp = make_icon_makeIcon("App", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-app-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <circle class='anx-icon-app-cls1' cx='129' cy='129' r='125'/>  <g>    <rect class='anx-icon-app-cls1' x='60.44' y='60.44' width='137.12' height='137.12' rx='17.11'/>    <path class='anx-icon-app-cls1' d='M129,99.35l9.74-10.47,3.76,13.78L156,97.93l-3.06,13.95,14.12,2.1-9.19,10.92,11.55,8.41-13.23,5.41,6.32,12.82-14.22-1.38-.36,14.3L136,156.63l-7,12.49-7-12.49-11.93,7.83-.38-14.3-14.21,1.38,6.31-12.82-13.23-5.41,11.55-8.41L91,114l14.12-2.1-3-13.95,13.46,4.73,3.77-13.78Z'/>  </g></svg>");
var AnxIconApple = make_icon_makeIcon("Apple", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-apple-cls1, .anx-icon-apple-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-apple-cls1 {        stroke-width: 7.5px;      }      .anx-icon-apple-cls2 {        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-apple-cls1' cx='129' cy='129' r='125'/>    <g id='_Gruppe_' data-name='&lt;Gruppe&gt;'>      <path id='_Pfad_' data-name='&lt;Pfad&gt;' class='anx-icon-apple-cls1' d='M129,85.58s-3.79-28,29.64-33.95C158.65,51.63,161.17,80.72,129,85.58Z'/>      <path id='_Pfad_2' data-name='&lt;Pfad&gt;' class='anx-icon-apple-cls2' d='M185.85,106.29s-15.54-23.68-45.28-11.43c0,0-6.71,3.11-10.5,3.11s-12-3.69-12-3.69-10.68-5.83-25.16-.39-20,19-20,19S58.6,135.24,79.3,176.05c0,0,13.85,25.48,27.26,25.48,0,0,4.81,1.05,15.45-4.2s24.78,1.95,24.78,1.95,10.64,4.9,18.51-.63,20.12-20.85,24.64-35.57c0,0-20.41-8.89-20.41-28.86A31.65,31.65,0,0,1,185.85,106.29Z'/>    </g>  </g></svg>");
var AnxIconArbeitBuero = make_icon_makeIcon("ArbeitBuero", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-arbeit-buero-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <rect class='anx-icon-arbeit-buero-cls1' x='59.7' y='88.55' width='138.59' height='95.07' rx='10.6' ry='10.6'/>    <path class='anx-icon-arbeit-buero-cls1' d='M110.85,65.23h36.3a11.38,11.38,0,0,1,11.38,11.38V88.55a0,0,0,0,1,0,0H99.47a0,0,0,0,1,0,0V76.61A11.38,11.38,0,0,1,110.85,65.23Z'/>    <g>      <path class='anx-icon-arbeit-buero-cls1' d='M150,143.9v-7.73a5.66,5.66,0,0,0-5.66-5.66H113.68a5.66,5.66,0,0,0-5.66,5.66v7.72'/>      <path class='anx-icon-arbeit-buero-cls1' d='M150,153.35a5.66,5.66,0,0,1-5.66,5.66H113.68a5.66,5.66,0,0,1-5.66-5.66v-9.46c-19.65-3.12-36.62-10.52-48.32-20.55V175a8.62,8.62,0,0,0,8.62,8.62H189.68A8.62,8.62,0,0,0,198.3,175V123.34c-11.7,10-28.67,17.43-48.32,20.56Z'/>      <path class='anx-icon-arbeit-buero-cls1' d='M108,143.89v9.46a5.66,5.66,0,0,0,5.66,5.66h30.64a5.66,5.66,0,0,0,5.66-5.66V143.9'/>    </g>    <circle class='anx-icon-arbeit-buero-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconArrowGreenBottom = make_icon_makeIcon("ArrowGreenBottom", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 7'><defs><style>.anx-icon-arrow-green-bottom-cls1{fill:none;stroke:var(--anx-icons-color);stroke-miterlimit:10;}</style></defs><polyline class='anx-icon-arrow-green-bottom-cls1' points='0.39 0.95 5.5 6.05 10.61 0.95'/></svg>");
var AnxIconArrowRedBottom = make_icon_makeIcon("ArrowRedBottom", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 7'><defs><style>.anx-icon-arrow-red-bottom-cls1{fill:none;stroke:var(--error-color);stroke-miterlimit:10;}</style></defs><polyline class='anx-icon-arrow-red-bottom-cls1' points='0.39 0.95 5.5 6.05 10.61 0.95'/></svg>");
var AnxIconAtSign = make_icon_makeIcon("AtSign", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-at-sign-cls1, .anx-icon-at-sign-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-at-sign-cls1 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-at-sign-cls1' d='M157.1,129c0,15.89-12.58,28.77-28.1,28.77S100.9,144.89,100.9,129s12.58-28.77,28.1-28.77S157.1,113.11,157.1,129Z'/>    <path class='anx-icon-at-sign-cls1' d='M143,186.77a56.93,56.93,0,0,1-14,1.73c-32.1,0-58.12-26.64-58.12-59.5S96.9,69.5,129,69.5s58.12,26.64,58.12,59.5c0,14.4-4.32,29.23-14.49,37.7-13.76,11.47-14-9.7-14-9.7l-1.09-55.84'/>    <circle class='anx-icon-at-sign-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconAuszeichnung = make_icon_makeIcon("Auszeichnung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-auszeichnung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-auszeichnung-cls1' d='M129,123.82,142.41,151l30,4.36-21.7,21.14,5.12,29.86L129,192.25l-26.81,14.1,5.12-29.86-21.7-21.14,30-4.36Z'/>      <path class='anx-icon-auszeichnung-cls1' d='M101.36,119.07V51.65h55.28v67.42l-10.13-1.47L129,89.84,111.5,117.6Z'/>    </g>    <circle class='anx-icon-auszeichnung-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconBarcode = make_icon_makeIcon("Barcode", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-barcode-cls1, .anx-icon-barcode-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-barcode-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-barcode-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon-barcode-cls1' cx='129' cy='129' r='125'/>  <g>    <g>      <line class='anx-icon-barcode-cls2' x1='60.67' y1='89.43' x2='60.67' y2='146.23'/>      <line class='anx-icon-barcode-cls2' x1='75.85' y1='146.06' x2='75.85' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='91.04' y1='146.06' x2='91.04' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='106.22' y1='146.06' x2='106.22' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='121.41' y1='146.06' x2='121.41' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='136.59' y1='146.06' x2='136.59' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='151.78' y1='146.06' x2='151.78' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='166.96' y1='146.06' x2='166.96' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='182.15' y1='146.06' x2='182.15' y2='148.79'/>      <line class='anx-icon-barcode-cls2' x1='75.85' y1='89.43' x2='75.85' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='91.04' y1='89.43' x2='91.04' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='106.22' y1='89.43' x2='106.22' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='121.41' y1='89.43' x2='121.41' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='136.59' y1='89.43' x2='136.59' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='151.78' y1='89.43' x2='151.78' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='166.96' y1='89.43' x2='166.96' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='182.15' y1='89.43' x2='182.15' y2='133.97'/>      <line class='anx-icon-barcode-cls2' x1='197.33' y1='89.43' x2='197.33' y2='146.23'/>    </g>    <polyline class='anx-icon-barcode-cls2' points='137.93 174.13 45.59 174.13 45.59 74.07 212.41 74.07 212.41 174.13 182.99 174.13'/>    <g>      <circle class='anx-icon-barcode-cls2' cx='160.44' cy='173.05' r='22.54'/>      <line class='anx-icon-barcode-cls2' x1='177.9' y1='187.31' x2='196.02' y2='205.44'/>    </g>  </g></svg>");
var AnxIconBildFoto = make_icon_makeIcon("BildFoto", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-bild-foto-cls1, .anx-icon-bild-foto-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-bild-foto-cls1 {        stroke-width: 7.5px;      }      .anx-icon-bild-foto-cls2 {        stroke-width: 7.5px;      }      .anx-icon-bild-foto-cls3 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <circle class='anx-icon-bild-foto-cls1' cx='129' cy='129' r='125'/>  <g>    <rect class='anx-icon-bild-foto-cls2' x='52.17' y='76.18' width='153.67' height='105.65' rx='7.84' ry='7.84'/>    <polyline class='anx-icon-bild-foto-cls2' points='205.83 135.17 205.83 100.8 145.51 153.37 106.12 122.36 52.17 167.61'/>    <circle class='anx-icon-bild-foto-cls3' cx='75.47' cy='100.8' r='10.71'/>  </g></svg>");
var AnxIconBlockchain = make_icon_makeIcon("Blockchain", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-blockchain-cls1, .anx-icon-blockchain-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-blockchain-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-blockchain-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon-blockchain-cls1' cx='129' cy='129' r='125'/>  <g>    <g>      <polygon class='anx-icon-blockchain-cls2' points='133.17 61.59 102.21 79.47 71.25 61.59 102.21 43.72 133.17 61.59'/>      <polygon class='anx-icon-blockchain-cls2' points='102.21 115.22 71.25 97.34 71.25 61.59 102.21 79.47 102.21 115.22'/>      <polygon class='anx-icon-blockchain-cls2' points='133.17 97.34 102.21 115.22 102.21 79.47 133.17 61.59 133.17 97.34'/>    </g>    <g>      <polygon class='anx-icon-blockchain-cls2' points='200.92 111.13 169.96 129 139 111.13 169.96 93.25 200.92 111.13'/>      <polygon class='anx-icon-blockchain-cls2' points='169.96 164.75 139 146.87 139 111.13 169.96 129 169.96 164.75'/>      <polygon class='anx-icon-blockchain-cls2' points='200.92 146.87 169.96 164.75 169.96 129 200.92 111.13 200.92 146.87'/>    </g>    <g>      <polygon class='anx-icon-blockchain-cls2' points='133.17 160.66 102.21 178.53 71.25 160.66 102.21 142.78 133.17 160.66'/>      <polygon class='anx-icon-blockchain-cls2' points='102.21 214.28 71.25 196.41 71.25 160.66 102.21 178.53 102.21 214.28'/>      <polygon class='anx-icon-blockchain-cls2' points='133.17 196.41 102.21 214.28 102.21 178.53 133.17 160.66 133.17 196.41'/>    </g>    <line class='anx-icon-blockchain-cls2' x1='117.69' y1='88.4' x2='148.02' y2='105.92'/>    <line class='anx-icon-blockchain-cls2' x1='154.48' y1='137.94' x2='124.15' y2='155.45'/>  </g></svg>");
var AnxIconCardboardVrBrilleSmartphone = make_icon_makeIcon("CardboardVrBrilleSmartphone", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-cardboard-vr-brille-smartphone-cls1, .anx-icon-cardboard-vr-brille-smartphone-cls2, .anx-icon-cardboard-vr-brille-smartphone-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-cardboard-vr-brille-smartphone-cls1 {        stroke-linecap: round;      }      .anx-icon-cardboard-vr-brille-smartphone-cls1, .anx-icon-cardboard-vr-brille-smartphone-cls2 {        stroke-linejoin: round;      }      .anx-icon-cardboard-vr-brille-smartphone-cls3 {        fill: var(--anx-icons-color);      }      .anx-icon-cardboard-vr-brille-smartphone-cls4 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <g>      <polygon class='anx-icon-cardboard-vr-brille-smartphone-cls1' points='149.44 188.96 194.25 188.96 194.25 112.7 63.75 112.7 63.75 188.96 108.56 188.96 123.3 168.25 134.7 168.25 149.44 188.96'/>      <circle class='anx-icon-cardboard-vr-brille-smartphone-cls1' cx='94.98' cy='143.83' r='14.74'/>      <circle class='anx-icon-cardboard-vr-brille-smartphone-cls1' cx='163.02' cy='143.83' r='14.74'/>    </g>    <g>      <path class='anx-icon-cardboard-vr-brille-smartphone-cls2' d='M73.82,112.7V74.89A5.84,5.84,0,0,1,79.66,69h98.79a5.85,5.85,0,0,1,5.84,5.85V112.7'/>      <line class='anx-icon-cardboard-vr-brille-smartphone-cls2' x1='171.62' y1='69.04' x2='171.62' y2='112.7'/>      <line class='anx-icon-cardboard-vr-brille-smartphone-cls2' x1='97.35' y1='69.04' x2='97.35' y2='112.7'/>      <circle class='anx-icon-cardboard-vr-brille-smartphone-cls3' cx='85.25' cy='96.69' r='4.62' transform='translate(-37.72 58.02) rotate(-31.14)'/>    </g>  </g>  <circle class='anx-icon-cardboard-vr-brille-smartphone-cls4' cx='129' cy='129' r='125'/></svg>");
var AnxIconCardboardVrBrille = make_icon_makeIcon("CardboardVrBrille", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-cardboard-vr-brille-cls1, .anx-icon-cardboard-vr-brille-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-cardboard-vr-brille-cls1 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-cardboard-vr-brille-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-cardboard-vr-brille-cls1' points='149.44 170.18 195.67 170.18 195.67 87.82 62.33 87.82 62.33 170.18 108.56 170.18 123.3 149.47 134.7 149.47 149.44 170.18'/>    <circle class='anx-icon-cardboard-vr-brille-cls1' cx='94.98' cy='125.06' r='14.74'/>    <circle class='anx-icon-cardboard-vr-brille-cls1' cx='163.02' cy='125.06' r='14.74'/>  </g>  <circle class='anx-icon-cardboard-vr-brille-cls2' cx='129' cy='129' r='125'/></svg>");
var AnxIconCheckGreen = make_icon_makeIcon("CheckGreen", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 13'><defs><style>.anx-icon-check-green-cls1{fill:none;stroke:var(--anx-icons-color);stroke-miterlimit:10;stroke-width:1.8px;}</style></defs><polyline class='anx-icon-check-green-cls1' points='0.68 5.73 5.92 11.12 16.32 0.99'/></svg>");
var AnxIconCheckWhite = make_icon_makeIcon("CheckWhite", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 13'><defs><style>.anx-icon-check-white-cls1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.8px;}</style></defs><polyline class='anx-icon-check-white-cls1' points='0.68 5.73 5.92 11.12 16.32 0.99'/></svg>");
var AnxIconCheck = make_icon_makeIcon("Check", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-check-cls1, .anx-icon-check-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-check-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-check-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon-check-cls1' cx='129' cy='129' r='125'/>  <polyline class='anx-icon-check-cls2' points='196.78 84.81 108.38 173.19 61.22 124.33'/></svg>");
var AnxIconCloudStorage = make_icon_makeIcon("CloudStorage", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-cloud-storage-cls1, .anx-icon-cloud-storage-cls2, .anx-icon-cloud-storage-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-cloud-storage-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-cloud-storage-cls2, .anx-icon-cloud-storage-cls4 {        stroke-linejoin: round;      }      .anx-icon-cloud-storage-cls3 {        fill: var(--anx-icons-color);      }      .anx-icon-cloud-storage-cls4 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-cloud-storage-cls1' d='M177.22,133.72a24.29,24.29,0,0,0-17.44-23.3A31.48,31.48,0,0,0,102,96.28a23,23,0,0,0-29.76,15.81A23.06,23.06,0,0,0,75.09,158h8.24'/>    <circle class='anx-icon-cloud-storage-cls1' cx='129' cy='129' r='125'/>    <rect class='anx-icon-cloud-storage-cls2' x='94.47' y='144.11' width='107.64' height='29.44'/>    <circle class='anx-icon-cloud-storage-cls3' cx='189.46' cy='158.83' r='4.58'/>    <line class='anx-icon-cloud-storage-cls4' x1='108.53' y1='163.15' x2='117.16' y2='154.52'/>    <line class='anx-icon-cloud-storage-cls4' x1='127.07' y1='163.15' x2='135.7' y2='154.52'/>    <line class='anx-icon-cloud-storage-cls4' x1='145.73' y1='163.15' x2='154.37' y2='154.52'/>  </g></svg>");
var AnxIconCloud = make_icon_makeIcon("Cloud", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-cloud-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-cloud-cls1' d='M174,173.72a28.52,28.52,0,0,0,8-55.88,37,37,0,0,0-67.88-16.59,27,27,0,0,0-34.94,18.56,27.06,27.06,0,0,0,3.4,53.91Z'/>    <circle class='anx-icon-cloud-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconCloudservicesHosting = make_icon_makeIcon("CloudservicesHosting", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-cloudservices-hosting-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-cloudservices-hosting-cls1' d='M174,154.38a28.52,28.52,0,0,0,8-55.88,37,37,0,0,0-67.88-16.59,27,27,0,0,0-34.94,18.56,27.06,27.06,0,0,0,3.4,53.91Z'/>      <line class='anx-icon-cloudservices-hosting-cls1' x1='67.6' y1='193.06' x2='98.38' y2='193.06'/>      <line class='anx-icon-cloudservices-hosting-cls1' x1='160.42' y1='193.06' x2='191.2' y2='193.06'/>      <line class='anx-icon-cloudservices-hosting-cls1' x1='110.15' y1='193.06' x2='148.66' y2='193.06'/>      <line class='anx-icon-cloudservices-hosting-cls1' x1='129.32' y1='170.01' x2='129.32' y2='193.06'/>    </g>    <circle class='anx-icon-cloudservices-hosting-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconConnections = make_icon_makeIcon("Connections", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-connections-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <circle class='anx-icon-connections-cls1' cx='129' cy='129' r='125'/>  <g>    <circle class='anx-icon-connections-cls1' cx='95.49' cy='192.33' r='11.6' transform='translate(-35.18 21.93) rotate(-11.08)'/>    <circle class='anx-icon-connections-cls1' cx='117.96' cy='139.04' r='11.6' transform='translate(-24.52 25.26) rotate(-11.08)'/>    <circle class='anx-icon-connections-cls1' cx='201.29' cy='121.13' r='11.6' transform='translate(-19.52 40.94) rotate(-11.08)'/>    <circle class='anx-icon-connections-cls1' cx='177.62' cy='179.8' r='11.6' transform='translate(-31.24 37.48) rotate(-11.08)'/>    <circle class='anx-icon-connections-cls1' cx='58.63' cy='104.84' r='11.6' transform='translate(-19.05 13.22) rotate(-11.08)'/>    <circle class='anx-icon-connections-cls1' cx='150.9' cy='61.17' r='11.6' transform='translate(-8.94 30.14) rotate(-11.08)'/>    <line class='anx-icon-connections-cls1' x1='69.13' y1='99.93' x2='140.59' y2='66.47'/>    <line class='anx-icon-connections-cls1' x1='189.91' y1='123.36' x2='129.34' y2='136.81'/>    <line class='anx-icon-connections-cls1' x1='63.11' y1='115.54' x2='90.86' y2='181.7'/>    <line class='anx-icon-connections-cls1' x1='154.25' y1='72.27' x2='193.25' y2='112.77'/>    <line class='anx-icon-connections-cls1' x1='113.25' y1='149.63' x2='99.13' y2='181.32'/>    <line class='anx-icon-connections-cls1' x1='107.92' y1='133.25' x2='68.67' y2='110.63'/>    <line class='anx-icon-connections-cls1' x1='122.48' y1='128.36' x2='146.38' y2='71.85'/>    <line class='anx-icon-connections-cls1' x1='195.83' y1='131.36' x2='176.13' y2='168.3'/>    <line class='anx-icon-connections-cls1' x1='166.24' y1='182.03' x2='106.87' y2='190.1'/>    <line class='anx-icon-connections-cls1' x1='127.54' y1='145.58' x2='168.04' y2='173.26'/>  </g></svg>");
var AnxIconController = make_icon_makeIcon("Controller", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-controller-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-controller-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <circle class='anx-icon-controller-cls1' cx='129' cy='129' r='125'/>  <circle class='anx-icon-controller-cls1' cx='129' cy='129' r='43.69' transform='translate(-53.43 129) rotate(-45)'/>  <polyline class='anx-icon-controller-cls1' points='206.61 129 189.11 129 206.61 129'/>  <polyline class='anx-icon-controller-cls1' points='196.14 167.94 181 159.16 196.14 167.94'/>  <polyline class='anx-icon-controller-cls1' points='167.71 196.27 158.98 181.1 167.71 196.27'/>  <polyline class='anx-icon-controller-cls1' points='129 206.61 129 189.11 129 206.61'/>  <polyline class='anx-icon-controller-cls1' points='90.06 196.14 98.84 181 90.06 196.14'/>  <polyline class='anx-icon-controller-cls1' points='61.73 167.71 76.9 158.98 61.73 167.71'/>  <polyline class='anx-icon-controller-cls1' points='51.39 129 68.89 129 51.39 129'/>  <polyline class='anx-icon-controller-cls1' points='61.86 90.06 77 98.84 61.86 90.06'/>  <polyline class='anx-icon-controller-cls1' points='90.29 61.73 99.02 76.9 90.29 61.73'/>  <polyline class='anx-icon-controller-cls1' points='129 51.39 129 68.89 129 51.39'/>  <polyline class='anx-icon-controller-cls1' points='167.94 61.86 159.16 77 167.94 61.86'/>  <polyline class='anx-icon-controller-cls1' points='196.27 90.29 181.1 99.02 196.27 90.29'/>  <path class='anx-icon-controller-cls2' d='M130.27,111l12.16-8.34a2.13,2.13,0,0,1,3.34,1.93l-1.13,14.7a2.14,2.14,0,0,1-3.2,1.69l-11-6.36A2.14,2.14,0,0,1,130.27,111Z'/></svg>");
var AnxIconCopy = make_icon_makeIcon("Copy", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-copy-cls1, .anx-icon-copy-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-copy-cls1 {        stroke-width: 7.5px;      }      .anx-icon-copy-cls2 {        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-copy-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <polyline class='anx-icon-copy-cls1' points='104.17 49.12 104.17 75.4 73.4 75.4'/>        <polyline class='anx-icon-copy-cls2' points='95.76 149.9 73.4 149.9 73.4 75.4 104.17 49.12 150.71 49.12 150.71 84.57'/>      </g>      <g>        <polyline class='anx-icon-copy-cls1' points='131.12 84.57 131.12 114.76 95.76 114.76'/>        <polygon class='anx-icon-copy-cls2' points='184.6 200.37 95.76 200.37 95.76 114.76 131.12 84.57 184.6 84.57 184.6 200.37'/>      </g>    </g>  </g></svg>");
var AnxIconDashboardEchtzeitMonitor = make_icon_makeIcon("DashboardEchtzeitMonitor", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-dashboard-echtzeit-monitor-cls1, .anx-icon-dashboard-echtzeit-monitor-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-dashboard-echtzeit-monitor-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-dashboard-echtzeit-monitor-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-dashboard-echtzeit-monitor-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-dashboard-echtzeit-monitor-cls1' d='M129,56.72c-39.69,0-71.92,33.53-71.92,75.56v17.2H200.92v-17.2C201,90.25,168.69,56.72,129,56.72Z'/>      <line class='anx-icon-dashboard-echtzeit-monitor-cls1' x1='129.02' y1='56.72' x2='129.02' y2='76.67'/>      <g>        <line class='anx-icon-dashboard-echtzeit-monitor-cls1' x1='57.08' y1='120.43' x2='80.66' y2='120.43'/>        <line class='anx-icon-dashboard-echtzeit-monitor-cls1' x1='177.34' y1='120.43' x2='200.92' y2='120.43'/>      </g>      <g>        <line class='anx-icon-dashboard-echtzeit-monitor-cls1' x1='80.67' y1='77.29' x2='95.39' y2='92.01'/>        <line class='anx-icon-dashboard-echtzeit-monitor-cls1' x1='163.35' y1='91.28' x2='177.34' y2='77.29'/>      </g>      <path class='anx-icon-dashboard-echtzeit-monitor-cls2' d='M128.7,132.65l-20.41-20.4,39.25-17.32Z'/>    </g>  </g></svg>");
var AnxIconDatenbank = make_icon_makeIcon("Datenbank", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-datenbank-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-datenbank-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-datenbank-cls1' d='M134.41,68.27c.85.08,1.7.21,2.55.25,12.3.67,24.42,2.31,36.07,6.51a34,34,0,0,1,9.55,4.83,13.38,13.38,0,0,1,1.71,1.57,4,4,0,0,1,0,5.89,22.58,22.58,0,0,1-7.91,5.07,90.43,90.43,0,0,1-23.18,6.21,175.67,175.67,0,0,1-39.95,1.26c-10.36-.82-20.58-2.41-30.41-5.94a36.59,36.59,0,0,1-10.14-5.1,1.59,1.59,0,0,0-.21-.15c-3.6-2.77-3.62-5.81,0-8.59,3.86-3,8.36-4.64,12.94-6.1,10.86-3.44,22-4.9,33.39-5.47.72,0,1.44-.16,2.16-.24Z'/>    <circle class='anx-icon-datenbank-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-datenbank-cls1' d='M185.66,103.69V109c0,5.7-.09,11.41,0,17.12a6.55,6.55,0,0,1-2.93,5.71c-3.83,2.87-8.22,4.55-12.71,6a122.71,122.71,0,0,1-26.81,5,174.08,174.08,0,0,1-27.59.27c-11.55-.8-22.94-2.45-33.84-6.54-3.81-1.43-7.56-3-10.54-5.93A5.06,5.06,0,0,1,69.67,127q0-11.22,0-22.44c0-.2.06-.4.1-.77,1.12.61,2.11,1.2,3.14,1.71a84.08,84.08,0,0,0,21.62,7,174.09,174.09,0,0,0,44.53,2.75c11.46-.68,22.8-2.21,33.73-5.88,4-1.35,7.84-3.34,11.75-5C184.86,104.14,185.14,104,185.66,103.69Z'/>    <path class='anx-icon-datenbank-cls1' d='M69.78,147.15c2.21,1.08,4.33,2.22,6.54,3.16A100.75,100.75,0,0,0,100,156.69a171.57,171.57,0,0,0,33.73,2c14.47-.5,28.76-2.29,42.47-7.27,2.78-1,5.4-2.48,8.1-3.75.38-.18.74-.39,1.35-.71v3.25c0,6.35-.09,12.71,0,19.06a6.64,6.64,0,0,1-2.86,5.76c-4,3.06-8.68,4.78-13.43,6.26-10.76,3.33-21.84,4.69-33,5.23a177.72,177.72,0,0,1-28-.81c-9.9-1.08-19.65-2.88-28.89-6.79-3-1.28-6-2.69-8.31-5.14a4.89,4.89,0,0,1-1.48-3.48q0-11.36,0-22.7A2.13,2.13,0,0,1,69.78,147.15Z'/>    <circle class='anx-icon-datenbank-cls2' cx='172.88' cy='122.36' r='5.19'/>    <circle class='anx-icon-datenbank-cls2' cx='172.88' cy='166.03' r='5.19'/>  </g></svg>");
var AnxIconDevices = make_icon_makeIcon("Devices", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-devices-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-devices-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-devices-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <rect class='anx-icon-devices-cls1' x='156.03' y='92.28' width='53.45' height='99.2' rx='6.25' ry='6.25'/>        <line class='anx-icon-devices-cls1' x1='156.03' y1='105.52' x2='209.48' y2='105.52'/>        <line class='anx-icon-devices-cls1' x1='156.03' y1='171.44' x2='209.48' y2='171.44'/>        <circle class='anx-icon-devices-cls2' cx='182.75' cy='181.57' r='4.18'/>      </g>      <g>        <path class='anx-icon-devices-cls1' d='M154.12,151.39H49.52V75.79a7.26,7.26,0,0,1,7.27-7.27H188.72A7.27,7.27,0,0,1,196,75.79V92.28'/>        <path class='anx-icon-devices-cls1' d='M156,165.41H53.4a12.88,12.88,0,0,1-12.88-12.88v-1.14H156'/>      </g>    </g>  </g></svg>");
var AnxIconDns = make_icon_makeIcon("Dns", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-dns-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-dns-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <polygon class='anx-icon-dns-cls1' points='129.01 72.34 147.63 52.34 154.82 78.66 180.58 69.64 174.74 96.29 201.71 100.29 184.16 121.17 206.22 137.24 180.94 147.57 193.02 172.07 165.85 169.44 165.15 196.76 142.33 181.81 129.01 205.66 115.69 181.81 92.89 196.76 92.15 169.44 65 172.07 77.06 147.57 51.78 137.24 73.86 121.17 56.31 100.29 83.28 96.29 77.46 69.64 103.18 78.66 110.38 52.34 129.01 72.34'/>    <g>      <path class='anx-icon-dns-cls2' d='M112.65,129.32a22.74,22.74,0,0,1-.83,6.29,16.75,16.75,0,0,1-2.49,5.15,12.71,12.71,0,0,1-3.61,3.3,10.09,10.09,0,0,1-4.42,1.45c-.63.06-1.33.11-2.11.14s-1.65,0-2.63,0h-8v-33h6.64c.95,0,2,0,3.09,0s2,.08,2.65.15a12.27,12.27,0,0,1,3.92,1,10.77,10.77,0,0,1,3.3,2.3,14.24,14.24,0,0,1,3.39,5.48A23.29,23.29,0,0,1,112.65,129.32Zm-7.45.62a38,38,0,0,0-.33-5.25,10.9,10.9,0,0,0-1.33-4,5.48,5.48,0,0,0-2-2.06,6.48,6.48,0,0,0-3.21-.69h-3v22.36h3.56a5.22,5.22,0,0,0,4.81-2.54Q105.2,135.2,105.2,129.94Z'/>      <path class='anx-icon-dns-cls2' d='M134.34,145.7l-5.65-12.63c-.47-1-.94-2.1-1.4-3.16s-.89-2.07-1.3-3-.78-1.85-1.09-2.64-.51-1.36-.67-1.8c.06.6.11,1.28.14,2s.07,1.6.1,2.42,0,1.64.07,2.44,0,1.56,0,2.26l.19,14.1h-6.4v-33h7.35L132,125.9c.82,1.77,1.54,3.48,2.16,5.11s1.09,3,1.44,4.24c-.06-.63-.12-1.35-.19-2.16s-.12-1.63-.16-2.46-.09-1.65-.12-2.42-.05-1.45-.05-2L135,112.71h6.31v33Z'/>      <path class='anx-icon-dns-cls2' d='M171.36,135.3a10.44,10.44,0,0,1-1,4.56,10.29,10.29,0,0,1-2.75,3.51,12.47,12.47,0,0,1-4.3,2.25,18.53,18.53,0,0,1-5.6.79,22.11,22.11,0,0,1-5.79-.79,23,23,0,0,1-5.46-2.2l2.47-5.18a28.68,28.68,0,0,0,4.44,1.95,14.5,14.5,0,0,0,4.63.71q5.79,0,5.79-4.51,0-3.09-4.32-4.27l-3.66-1a14.34,14.34,0,0,1-4-1.66,7.41,7.41,0,0,1-2.47-2.51,9.4,9.4,0,0,1-1.38-5,9.91,9.91,0,0,1,.86-4.15,9.34,9.34,0,0,1,2.42-3.23,11,11,0,0,1,3.75-2.08,14.9,14.9,0,0,1,4.79-.74,20.14,20.14,0,0,1,5.93.88,17.36,17.36,0,0,1,5.08,2.44l-3.13,4.75a19.57,19.57,0,0,0-4.06-2,11.77,11.77,0,0,0-3.63-.57,5,5,0,0,0-3.32,1.07,3.37,3.37,0,0,0-1.28,2.73,2.65,2.65,0,0,0,.78,2,7.07,7.07,0,0,0,2.87,1.3l4,1.09a12,12,0,0,1,6.22,3.61A9.3,9.3,0,0,1,171.36,135.3Z'/>    </g>    <circle class='anx-icon-dns-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconDokument = make_icon_makeIcon("Dokument", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-dokument-cls1, .anx-icon-dokument-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-dokument-cls1 {        stroke-width: 7.5px;      }      .anx-icon-dokument-cls2 {        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-dokument-cls1' cx='129' cy='129' r='125'/>    <g>      <polyline class='anx-icon-dokument-cls1' points='117.98 58.58 117.98 95.3 74.97 95.3'/>      <polygon class='anx-icon-dokument-cls2' points='183.03 199.42 74.97 199.42 74.97 95.3 117.98 58.58 183.03 58.58 183.03 199.42'/>    </g>  </g></svg>");
var AnxIconDollar = make_icon_makeIcon("Dollar", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-dollar-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-dollar-cls1' d='M88.93,156.54c0,15.21,17.94,27.54,40.07,27.54s40.07-12.33,40.07-27.54S151.13,129,129,129s-34.61-12.33-34.61-27.54S106.87,73.92,129,73.92s40.07,12.33,40.07,27.54'/>      <line class='anx-icon-dollar-cls1' x1='121.72' y1='57.71' x2='121.72' y2='200.29'/>      <line class='anx-icon-dollar-cls1' x1='141.23' y1='57.71' x2='141.23' y2='200.29'/>    </g>    <circle class='anx-icon-dollar-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconDownload = make_icon_makeIcon("Download", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-download-cls1, .anx-icon-download-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-download-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-download-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-download-cls1' d='M156.92,149.27h17a28.51,28.51,0,0,0,8-55.87,37,37,0,0,0-67.88-16.59A27,27,0,0,0,79.19,95.37a27.06,27.06,0,0,0,3.4,53.9h17.77'/>      <polygon class='anx-icon-download-cls2' points='141.81 167.44 141.81 126.21 116.19 126.21 116.19 167.44 98.22 167.44 129 213.91 159.78 167.44 141.81 167.44'/>    </g>    <circle class='anx-icon-download-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconDsl = make_icon_makeIcon("Dsl", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-dsl-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-dsl-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-dsl-cls1' d='M129,72.34l18.62-20,7.19,26.32,25.76-9-5.84,26.65,27,4-17.55,20.88,22.06,16.07-25.28,10.33L193,172.08l-27.17-2.64-.7,27.32-22.82-14.95L129,205.66l-13.32-23.85-22.8,14.95-.74-27.32L65,172.08l12.06-24.51L51.78,137.24l22.08-16.07L56.31,100.29l27-4L77.46,69.64l25.72,9,7.2-26.32Z'/>    <circle class='anx-icon-dsl-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-dsl-cls2' d='M115.4,121.65a14.24,14.24,0,0,0-3.39-5.48,11,11,0,0,0-3.3-2.3,12.33,12.33,0,0,0-3.92-1c-.66-.07-1.55-.11-2.66-.15s-2.13,0-3.08,0H92.4v33h8c1,0,1.85,0,2.63,0s1.48-.08,2.11-.15a10,10,0,0,0,4.42-1.44,12.54,12.54,0,0,0,3.6-3.3,16.55,16.55,0,0,0,2.5-5.15,22.74,22.74,0,0,0,.83-6.29A23.55,23.55,0,0,0,115.4,121.65Zm-7.88,16.1a5.24,5.24,0,0,1-4.82,2.54H99.14V117.93h3a6.48,6.48,0,0,1,3.21.69,5.53,5.53,0,0,1,2,2.06,10.54,10.54,0,0,1,1.33,4,38,38,0,0,1,.33,5.25Q109.06,135.2,107.52,137.75Z'/>    <path class='anx-icon-dsl-cls2' d='M145.18,135.3a10.44,10.44,0,0,1-1,4.56,10.17,10.17,0,0,1-2.75,3.51,12.47,12.47,0,0,1-4.3,2.25,18.48,18.48,0,0,1-5.6.79,22.11,22.11,0,0,1-5.79-.79,23,23,0,0,1-5.46-2.2l2.47-5.18a29.67,29.67,0,0,0,4.44,1.95,14.55,14.55,0,0,0,4.63.71q5.79,0,5.79-4.51,0-3.09-4.32-4.27l-3.66-1a14.34,14.34,0,0,1-4-1.66,7.5,7.5,0,0,1-2.47-2.51,9.39,9.39,0,0,1-1.37-5,9.91,9.91,0,0,1,.85-4.15,9.47,9.47,0,0,1,2.42-3.23,11,11,0,0,1,3.75-2.08,14.9,14.9,0,0,1,4.79-.74,20.2,20.2,0,0,1,5.94.88,17.23,17.23,0,0,1,5.08,2.44l-3.14,4.75a19.77,19.77,0,0,0-4-2,11.88,11.88,0,0,0-3.64-.57,5,5,0,0,0-3.32,1.07,3.4,3.4,0,0,0-1.28,2.73,2.65,2.65,0,0,0,.78,2,7.07,7.07,0,0,0,2.87,1.3l4,1.09a12,12,0,0,1,6.22,3.61A9.3,9.3,0,0,1,145.18,135.3Z'/>    <polygon class='anx-icon-dsl-cls2' points='167.83 145.7 150.41 145.7 150.41 112.71 157.19 112.71 157.19 140.19 169.01 140.19 167.83 145.7'/>  </g></svg>");
var AnxIconESim = make_icon_makeIcon("ESim", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-esim-cls1, .anx-icon-esim-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-esim-cls1 {        stroke-width: 7.5px;      }      .anx-icon-esim-cls2 {        stroke-width: 6.75px;      }    </style>  </defs>    <circle class='anx-icon-esim-cls1' cx='129' cy='129' r='125'/>  <g>    <rect class='anx-icon-esim-cls2' x='69.42' y='58' width='119.17' height='141.99'/>    <polygon class='anx-icon-esim-cls2' points='101 86.92 86.98 100.94 86.98 171.08 171.02 171.08 171.02 86.92 101 86.92'/>    <rect class='anx-icon-esim-cls2' x='86.98' y='58' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='111.16' y='58' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='135.33' y='58' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='159.51' y='58' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='86.98' y='186.16' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='111.16' y='186.16' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='135.33' y='186.16' width='11.51' height='13.84'/>    <rect class='anx-icon-esim-cls2' x='159.51' y='186.16' width='11.51' height='13.84'/>  </g></svg>");
var AnxIconEingabe = make_icon_makeIcon("Eingabe", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-eingabe-cls1, .anx-icon-eingabe-cls2, .anx-icon-eingabe-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-eingabe-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-eingabe-cls2, .anx-icon-eingabe-cls4 {        stroke-linejoin: round;      }      .anx-icon-eingabe-cls3 {        fill: var(--anx-icons-color);      }      .anx-icon-eingabe-cls4 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-eingabe-cls1' d='M192.18,149.08H65.82V68.5H192.18Z'/>    <path class='anx-icon-eingabe-cls1' d='M103.09,94.7l19.66,16-19.66,16'/>    <path class='anx-icon-eingabe-cls1' d='M128,125.6h27'/>    <path class='anx-icon-eingabe-cls2' d='M192.18,193.87H65.82v-30H192.18Z'/>    <path class='anx-icon-eingabe-cls3' d='M177.33,173.49a5.38,5.38,0,1,1-5.37,5.38A5.38,5.38,0,0,1,177.33,173.49Z'/>    <path class='anx-icon-eingabe-cls4' d='M81.66,184.8l10.13-10.13'/>    <path class='anx-icon-eingabe-cls4' d='M102.75,184.8l10.13-10.13'/>    <path class='anx-icon-eingabe-cls4' d='M124,184.8l10.14-10.13'/>    <path class='anx-icon-eingabe-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>  </g></svg>");
var AnxIconEins = make_icon_makeIcon("Eins", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-eins-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-eins-cls1' d='M100.4,189.63v-19.5h20.93V97.84q-5,3-11.45,6.17a101.31,101.31,0,0,1-12.35,5.1L91.45,96.23l37-25.94h16.28v99.84h15.57v19.5Z'/>    <circle class='anx-icon-eins-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconEinstellungenVerwaltung = make_icon_makeIcon("EinstellungenVerwaltung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-einstellungen-verwaltung-cls1, .anx-icon-einstellungen-verwaltung-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-einstellungen-verwaltung-cls1 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-einstellungen-verwaltung-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <g id='MsH92u.tif'>      <path class='anx-icon-einstellungen-verwaltung-cls1' d='M129.09,105.69a27.53,27.53,0,1,0,27.44,27.77A27.6,27.6,0,0,0,129.09,105.69Zm10.46-46.43,4.71,14.51a1.55,1.55,0,0,0,.91,1l13.74,5.7a1.61,1.61,0,0,0,1.34,0l13.59-6.93a1.58,1.58,0,0,1,1.85.29l12.78,12.78a1.59,1.59,0,0,1,.29,1.84L181.83,102a1.62,1.62,0,0,0-.06,1.33l5.7,13.75a1.59,1.59,0,0,0,1,.9L203,122.67a1.6,1.6,0,0,1,1.1,1.52v18.07a1.58,1.58,0,0,1-1.1,1.51l-14.51,4.71a1.63,1.63,0,0,0-1,.91l-5.7,13.75a1.63,1.63,0,0,0,.06,1.33l6.93,13.59a1.61,1.61,0,0,1-.29,1.85l-12.78,12.78a1.6,1.6,0,0,1-1.85.29l-13.59-6.93a1.61,1.61,0,0,0-1.34-.05l-13.74,5.69a1.6,1.6,0,0,0-.91,1l-4.71,14.51a1.59,1.59,0,0,1-1.52,1.1H120a1.59,1.59,0,0,1-1.52-1.1l-4.71-14.51a1.6,1.6,0,0,0-.91-1L99.09,186a1.61,1.61,0,0,0-1.34.05L84.16,193a1.6,1.6,0,0,1-1.85-.29L69.54,179.91a1.6,1.6,0,0,1-.3-1.85l6.93-13.59a1.63,1.63,0,0,0,.06-1.33l-5.7-13.75a1.63,1.63,0,0,0-1-.91L55,143.77a1.58,1.58,0,0,1-1.1-1.51V123.85a1.12,1.12,0,0,1,.78-1.07L69.55,118a1.59,1.59,0,0,0,1-.9l5.7-13.75a1.62,1.62,0,0,0-.06-1.33l-6.93-13.6a1.58,1.58,0,0,1,.3-1.84L82.31,73.76a1.58,1.58,0,0,1,1.85-.29L97.75,80.4a1.61,1.61,0,0,0,1.34,0l13.74-5.7a1.55,1.55,0,0,0,.91-1l4.71-14.51a1.6,1.6,0,0,1,1.52-1.1H138A1.6,1.6,0,0,1,139.55,59.26Z'/>    </g>    <circle class='anx-icon-einstellungen-verwaltung-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconError = make_icon_makeIcon("Error", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-error-cls1, .anx-icon-error-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-error-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-error-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon-error-cls1' cx='129' cy='129' r='125'/>  <g>    <line class='anx-icon-error-cls2' x1='185.41' y1='72.59' x2='72.59' y2='185.41'/>    <line class='anx-icon-error-cls2' x1='185.41' y1='185.41' x2='72.59' y2='72.59'/>  </g></svg>");
var AnxIconEuro = make_icon_makeIcon("Euro", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-euro-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-euro-cls1' cx='129' cy='129' r='125'/>    <g>      <line class='anx-icon-euro-cls1' x1='59.62' y1='113.75' x2='143.14' y2='113.75'/>      <line class='anx-icon-euro-cls1' x1='59.62' y1='140.43' x2='143.14' y2='140.43'/>      <path class='anx-icon-euro-cls1' d='M167.44,70.58a63.62,63.62,0,1,0,0,116.86'/>    </g>  </g></svg>");
var AnxIconExperimentierfreudig = make_icon_makeIcon("Experimentierfreudig", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-experimentierfreudig-cls1, .anx-icon-experimentierfreudig-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-experimentierfreudig-cls1 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-experimentierfreudig-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-experimentierfreudig-cls1' d='M186,109.93l-78.63,78.64a24.09,24.09,0,0,1-34,0h0a24.06,24.06,0,0,1,0-34l78.64-78.64'/>      <line class='anx-icon-experimentierfreudig-cls1' x1='152.24' y1='55.53' x2='206.33' y2='109.62'/>      <line class='anx-icon-experimentierfreudig-cls1' x1='136.44' y1='91.39' x2='146.32' y2='101.27'/>      <line class='anx-icon-experimentierfreudig-cls1' x1='120.34' y1='107.5' x2='130.21' y2='117.37'/>      <path class='anx-icon-experimentierfreudig-cls2' d='M97,130.85s15.28,3.78,17.86,17.86,17.61,14.67,17.61,14.67'/>    </g>    <circle class='anx-icon-experimentierfreudig-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconFabrik = make_icon_makeIcon("Fabrik", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-fabrik-cls1, .anx-icon-fabrik-cls2 {        fill: none;        stroke: var(--anx-icons-color);      }      .anx-icon-fabrik-cls1 {        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-fabrik-cls2 {        stroke-linecap: round;        stroke-linejoin: round;        stroke-width: 8.27px;      }    </style>  </defs>    <g>    <circle class='anx-icon-fabrik-cls1' cx='129' cy='129' r='125'/>    <g>      <polygon class='anx-icon-fabrik-cls2' points='163.51 148.78 163.51 123.52 122.87 148.78 122.87 123.52 82.22 148.78 82.22 93.18 56.03 93.18 56.03 148.78 56.03 160.27 56.03 202.52 204.16 202.52 204.16 148.78 204.16 123.52 163.51 148.78'/>      <path class='anx-icon-fabrik-cls2' d='M109.71,77.5H56.89S49.21,64.18,58.2,58.36c7.41-4.8,25.36-3.86,28.05,4.74,4.1-7.7,19.17-5.37,21.5,3.34,6.15-4.7,20-4.41,20,5.18C127.72,78.24,109.71,77.5,109.71,77.5Z'/>      <rect class='anx-icon-fabrik-cls2' x='82.71' y='164.7' width='14.69' height='14.69'/>      <rect class='anx-icon-fabrik-cls2' x='113.03' y='164.7' width='14.69' height='14.69'/>      <rect class='anx-icon-fabrik-cls2' x='143.36' y='164.7' width='14.69' height='14.69'/>      <rect class='anx-icon-fabrik-cls2' x='173.69' y='164.7' width='14.69' height='14.69'/>    </g>  </g></svg>");
var AnxIconFirmenautoAuto = make_icon_makeIcon("FirmenautoAuto", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-firmenauto-auto-cls1, .anx-icon-firmenauto-auto-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-firmenauto-auto-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-firmenauto-auto-cls2 {        stroke-linejoin: bevel;      }    </style>  </defs>    <g>    <path class='anx-icon-firmenauto-auto-cls1' d='M203.5,118.33v44.92H53.26V118.33l1-3.48L84.55,65.34h87.66l30.34,49.51Z'/>    <path class='anx-icon-firmenauto-auto-cls2' d='M62.14,104.94H194.62'/>    <path class='anx-icon-firmenauto-auto-cls1' d='M56.73,163.25h30.1a0,0,0,0,1,0,0V176a5.09,5.09,0,0,1-5.09,5.09h-25A5.09,5.09,0,0,1,51.64,176v-7.63a5.09,5.09,0,0,1,5.09-5.09Z'/>    <path class='anx-icon-firmenauto-auto-cls1' d='M175,163.25h25a5.09,5.09,0,0,1,5.09,5.09v12.72a0,0,0,0,1,0,0H175a5.09,5.09,0,0,1-5.09-5.09v-7.63A5.09,5.09,0,0,1,175,163.25Z' transform='translate(375.05 344.3) rotate(-180)'/>    <path class='anx-icon-firmenauto-auto-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <circle class='anx-icon-firmenauto-auto-cls2' cx='85.21' cy='133.63' r='13.54'/>    <circle class='anx-icon-firmenauto-auto-cls2' cx='171.55' cy='133.63' r='13.54'/>    <path class='anx-icon-firmenauto-auto-cls1' d='M109.28,126.86h38.2'/>    <path class='anx-icon-firmenauto-auto-cls1' d='M109.28,140.4h38.2'/>    <path class='anx-icon-firmenauto-auto-cls1' d='M136.25,102a16.84,16.84,0,1,1,33.68,0'/>  </g></svg>");
var AnxIconFlexibilitaet = make_icon_makeIcon("Flexibilitaet", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-flexibilitaet-cls1, .anx-icon-flexibilitaet-cls2, .anx-icon-flexibilitaet-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-flexibilitaet-cls1, .anx-icon-flexibilitaet-cls2 {        stroke-miterlimit: 10;      }      .anx-icon-flexibilitaet-cls2, .anx-icon-flexibilitaet-cls3 {        stroke-linecap: round;      }      .anx-icon-flexibilitaet-cls3 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-flexibilitaet-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-flexibilitaet-cls2' d='M129,201.05v-26.2c0-27.88,25-48.68,49.62-51.37a202.35,202.35,0,0,1,25-1.17'/>    <polyline class='anx-icon-flexibilitaet-cls3' points='187.55 106.2 203.62 122.27 187.55 138.34'/>    <polyline class='anx-icon-flexibilitaet-cls3' points='111.27 67.23 127.33 51.16 143.4 67.23'/>    <path class='anx-icon-flexibilitaet-cls2' d='M117.12,148A59,59,0,0,0,76,123.48a202.16,202.16,0,0,0-25-1.17'/>    <polyline class='anx-icon-flexibilitaet-cls3' points='67.12 106.2 51.05 122.27 67.12 138.34'/>    <line class='anx-icon-flexibilitaet-cls2' x1='127.33' y1='136.92' x2='127.33' y2='51.16'/>  </g></svg>");
var AnxIconFlexibleArbeitszeitenTiming = make_icon_makeIcon("FlexibleArbeitszeitenTiming", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-flexible-arbeitszeiten-timing-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-flexible-arbeitszeiten-timing-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <g>      <g>        <path class='anx-icon-flexible-arbeitszeiten-timing-cls1' d='M155.37,189.68A66.72,66.72,0,1,1,174.78,81.82c.33.34.66.67,1,1'/>        <polygon class='anx-icon-flexible-arbeitszeiten-timing-cls2' points='156.46 89.28 190.1 105.61 187.42 68.31 156.46 89.28'/>      </g>      <path class='anx-icon-flexible-arbeitszeiten-timing-cls1' d='M177.64,173.13a67,67,0,0,1-11.85,10.58'/>      <path class='anx-icon-flexible-arbeitszeiten-timing-cls1' d='M190.38,151.63a66.78,66.78,0,0,1-5.56,11.7'/>      <path class='anx-icon-flexible-arbeitszeiten-timing-cls1' d='M194.32,129a66.86,66.86,0,0,1-.94,11.21'/>      <polyline class='anx-icon-flexible-arbeitszeiten-timing-cls1' points='98.93 145.42 136.12 145.42 136.12 102.91'/>    </g>    <circle class='anx-icon-flexible-arbeitszeiten-timing-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconFolder = make_icon_makeIcon("Folder", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-folder-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-folder-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-folder-cls1' d='M192.52,103.39v-7.1a9.11,9.11,0,0,0-9.11-9.12H94.47V83.38a9.12,9.12,0,0,0-9.07-9.07H66.09A9.11,9.11,0,0,0,57,83.42h0v91.16a9.11,9.11,0,0,0,9.12,9.11H183.46'/>      <path class='anx-icon-folder-cls1' d='M185.4,183.69H70.12c-5.88,0-11.77,0-10.39-5.51l15-67.58a9.13,9.13,0,0,1,8.83-7H200.45a9.11,9.11,0,0,1,9.08,9.15,9.28,9.28,0,0,1-.25,2.1l-15.05,61.7A9.12,9.12,0,0,1,185.4,183.69Z'/>    </g>  </g></svg>");
var AnxIconForschungEntwicklung = make_icon_makeIcon("ForschungEntwicklung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-forschung-entwicklung-cls1, .anx-icon-forschung-entwicklung-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-forschung-entwicklung-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-forschung-entwicklung-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-forschung-entwicklung-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <path class='anx-icon-forschung-entwicklung-cls2' d='M111.9,77.59V114.5a45.63,45.63,0,0,1-1.61,12l-31.22,52A9.3,9.3,0,0,0,87,192.9h84.13a9.26,9.26,0,0,0,7.72-14.54l-33-51.84a45.63,45.63,0,0,1-1.61-12V77.59'/>        <line class='anx-icon-forschung-entwicklung-cls2' x1='102.65' y1='61.24' x2='155.35' y2='61.24'/>      </g>      <path class='anx-icon-forschung-entwicklung-cls1' d='M91.4,158s20.06-17.54,37.6,0,34-4.47,34-4.47'/>      <line class='anx-icon-forschung-entwicklung-cls2' x1='113.34' y1='92.39' x2='125.03' y2='92.39'/>      <line class='anx-icon-forschung-entwicklung-cls2' x1='111.9' y1='108.5' x2='125.03' y2='108.5'/>    </g>  </g></svg>");
var AnxIconFotoapparat = make_icon_makeIcon("Fotoapparat", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-fotoapparat-cls1, .anx-icon-fotoapparat-cls2, .anx-icon-fotoapparat-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-fotoapparat-cls1, .anx-icon-fotoapparat-cls3 {        stroke-miterlimit: 10;      }      .anx-icon-fotoapparat-cls2, .anx-icon-fotoapparat-cls3 {        stroke-linecap: round;      }      .anx-icon-fotoapparat-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <circle class='anx-icon-fotoapparat-cls1' cx='129' cy='129' r='125'/>  <g>    <g>      <line class='anx-icon-fotoapparat-cls2' x1='205.4' y1='86.67' x2='218.1' y2='75.36'/>      <line class='anx-icon-fotoapparat-cls2' x1='210.75' y1='99.29' x2='220.91' y2='99.29'/>      <line class='anx-icon-fotoapparat-cls2' x1='194.66' y1='79.98' x2='194.66' y2='69.99'/>    </g>    <g>      <g>        <path class='anx-icon-fotoapparat-cls1' d='M151.79,138.41a27,27,0,1,1-27-27A27,27,0,0,1,151.79,138.41Z'/>        <line class='anx-icon-fotoapparat-cls3' x1='105.91' y1='87.9' x2='144.4' y2='87.9'/>        <path class='anx-icon-fotoapparat-cls2' d='M185.65,93.77H167.78c-10.42,0-6.17-22.7-19.79-22.7H100.71c-12.83,0-8.57,22.7-19,22.7H63.84c-7.21,0-13.62,6.19-13.62,13.16v64.78c0,7,6.41,12.38,13.62,12.38H185.65c7.22,0,13.63-5.41,13.63-12.38V106.93C199.28,100,192.87,93.77,185.65,93.77Z'/>      </g>      <path class='anx-icon-fotoapparat-cls1' d='M184,115.61a9.21,9.21,0,1,1-9.21-9.21A9.21,9.21,0,0,1,184,115.61Z'/>    </g>  </g></svg>");
var AnxIconFramework = make_icon_makeIcon("Framework", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-framework-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-framework-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <polyline class='anx-icon-framework-cls1' points='110.71 150.79 95.61 129 110.71 107.21'/>        <line class='anx-icon-framework-cls1' x1='119.54' y1='163.46' x2='138.32' y2='94.54'/>        <polyline class='anx-icon-framework-cls1' points='147.29 150.79 162.39 129 147.29 107.21'/>      </g>      <g>        <polyline class='anx-icon-framework-cls1' points='103.19 196.03 196.03 196.03 196.03 103.19'/>        <polyline class='anx-icon-framework-cls1' points='154.81 61.97 61.97 61.97 61.97 154.81'/>      </g>    </g>  </g></svg>");
var AnxIconGabelstapler = make_icon_makeIcon("Gabelstapler", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-gabelstapler-cls1, .anx-icon-gabelstapler-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-gabelstapler-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-gabelstapler-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-gabelstapler-cls1' cx='129' cy='129' r='125'/>    <g>      <circle class='anx-icon-gabelstapler-cls2' cx='77.51' cy='174.69' r='14.03'/>      <circle class='anx-icon-gabelstapler-cls2' cx='132.44' cy='174.69' r='14.03'/>      <line class='anx-icon-gabelstapler-cls2' x1='91.51' y1='173.86' x2='118.41' y2='173.86'/>      <polyline class='anx-icon-gabelstapler-cls2' points='146.44 173.86 158.16 173.86 158.16 121.82 130.25 121.82 110.68 69.28 68.13 69.28 68.13 121.82 52.91 121.82 52.91 173.86 63.5 173.86'/>      <line class='anx-icon-gabelstapler-cls2' x1='158.16' y1='173.86' x2='202.62' y2='173.86'/>      <rect class='anx-icon-gabelstapler-cls2' x='170.05' y='138.81' width='35.05' height='35.05'/>      <rect class='anx-icon-gabelstapler-cls2' x='170.05' y='104.05' width='35.05' height='35.05'/>      <rect class='anx-icon-gabelstapler-cls2' x='170.05' y='69.28' width='35.05' height='35.05'/>      <polygon class='anx-icon-gabelstapler-cls2' points='82.61 144.26 82.61 83.76 100.63 83.76 115.77 124.43 115.77 144.26 82.61 144.26'/>    </g>  </g></svg>");
var AnxIconGefahrenWarnung = make_icon_makeIcon("GefahrenWarnung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-gefahren-warnung-cls1, .anx-icon-gefahren-warnung-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-gefahren-warnung-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-gefahren-warnung-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-gefahren-warnung-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-gefahren-warnung-cls2' d='M87.06,200.14c9.08-15.54,18.11-31,27.23-46.59a30.92,30.92,0,0,0,14.45,3.36,30.28,30.28,0,0,0,14.58-3.38q13.56,23.26,27.1,46.5C150.58,215.46,112.73,217.91,87.06,200.14Z'/>      <path class='anx-icon-gefahren-warnung-cls2' d='M87.5,57.19l26.73,46.88A30.7,30.7,0,0,0,104.1,114.9a30.21,30.21,0,0,0-4.37,14.32l-53.82.22C42.47,104.54,59.28,70.53,87.5,57.19Z'/>      <path class='anx-icon-gefahren-warnung-cls2' d='M212.44,129.84l-54-.29a30.76,30.76,0,0,0-4.32-14.19,30,30,0,0,0-10.22-10.94L170.66,57.7C194,67.17,215,98.72,212.44,129.84Z'/>      <path class='anx-icon-gefahren-warnung-cls2' d='M141.45,129.55a12.45,12.45,0,0,1-12.36,12.55,12.52,12.52,0,0,1-.06-25A12.43,12.43,0,0,1,141.45,129.55Z'/>    </g>  </g></svg>");
var AnxIconGenericautomation = make_icon_makeIcon("Genericautomation", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-genericautomation-cls1, .anx-icon-genericautomation-cls2, .anx-icon-genericautomation-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-genericautomation-cls1, .anx-icon-genericautomation-cls2 {        stroke-miterlimit: 10;      }      .anx-icon-genericautomation-cls2, .anx-icon-genericautomation-cls3 {        stroke-linecap: round;      }      .anx-icon-genericautomation-cls3 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-genericautomation-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-genericautomation-cls2' d='M57,166.84a81.35,81.35,0,0,0,151.62-21.1'/>      <path class='anx-icon-genericautomation-cls2' d='M201,91.16a81.35,81.35,0,0,0-151.62,21.1'/>      <polyline class='anx-icon-genericautomation-cls3' points='68.23 102.07 49.05 112.15 38.97 92.97'/>      <polyline class='anx-icon-genericautomation-cls3' points='189.77 155.93 208.95 145.85 219.03 165.03'/>    </g>    <g id='MsH92u.tif'>      <path class='anx-icon-genericautomation-cls3' d='M129.06,112.24a16.76,16.76,0,1,0,16.7,16.91A16.79,16.79,0,0,0,129.06,112.24ZM135.42,84l2.87,8.83a1,1,0,0,0,.55.6l8.37,3.47a1,1,0,0,0,.81,0l8.28-4.22a1,1,0,0,1,1.13.18l7.78,7.78a1,1,0,0,1,.18,1.13L161.17,110a1,1,0,0,0,0,.81l3.47,8.37a1,1,0,0,0,.6.55l8.83,2.87a1,1,0,0,1,.67.92v11a1,1,0,0,1-.67.92l-8.83,2.87a1,1,0,0,0-.6.55l-3.47,8.37a1,1,0,0,0,0,.81l4.22,8.28a1,1,0,0,1-.18,1.13l-7.78,7.78a1,1,0,0,1-1.13.18L148,161.17a1,1,0,0,0-.81,0l-8.37,3.47a1,1,0,0,0-.55.6L135.42,174a1,1,0,0,1-.92.67h-11a1,1,0,0,1-.92-.67l-2.87-8.83a1,1,0,0,0-.55-.6l-8.37-3.47a1,1,0,0,0-.81,0l-8.28,4.22a1,1,0,0,1-1.13-.18l-7.78-7.78a1,1,0,0,1-.18-1.13L96.83,148a1,1,0,0,0,0-.81l-3.47-8.37a1,1,0,0,0-.6-.55L84,135.42a1,1,0,0,1-.67-.92V123.29a.69.69,0,0,1,.47-.65l9-2.93a1,1,0,0,0,.6-.55l3.47-8.37a1,1,0,0,0,0-.81l-4.22-8.28a1,1,0,0,1,.18-1.13l7.78-7.78a1,1,0,0,1,1.13-.18L110,96.83a1,1,0,0,0,.81,0l8.37-3.47a1,1,0,0,0,.55-.6L122.58,84a1,1,0,0,1,.92-.67h11A1,1,0,0,1,135.42,84Z'/>    </g>  </g></svg>");
var AnxIconHerz = make_icon_makeIcon("Herz", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-herz-cls1, .anx-icon-herz-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-herz-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-herz-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-herz-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-herz-cls2' d='M94.82,63.54c-20.73,0-37.56,17.8-37.56,39.74,0,44.61,38.62,51.34,71.53,91.18,33.15-39.84,71.53-48,71.53-91.18,0-21.94-16.82-39.74-37.55-39.74-15,0-28,9.4-34,22.91-6-13.51-18.94-22.91-34-22.91Z'/>  </g></svg>");
var AnxIconHomeoffice = make_icon_makeIcon("Homeoffice", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-homeoffice-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-homeoffice-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-homeoffice-cls1' d='M188.21,190.87H69.79V106.41L129,55.73l59.21,50.68Z'/>    <path class='anx-icon-homeoffice-cls1' d='M148.8,190.87H109.2v-49h39.6Z'/>  </g></svg>");
var AnxIconIdee = make_icon_makeIcon("Idee", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-idee-cls1, .anx-icon-idee-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-idee-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-idee-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-idee-cls1' d='M178.06,111.2A49.06,49.06,0,1,0,95.53,147a35.06,35.06,0,0,1,10.75,25.69V197a6.64,6.64,0,0,0,6.64,6.64h32.16c3.67,0,6.64-5.6,6.64-9.27V172.65a36.7,36.7,0,0,1,11.44-26.27A48.87,48.87,0,0,0,178.06,111.2Z'/>      <line class='anx-icon-idee-cls1' x1='106.28' y1='194.33' x2='151.72' y2='184.18'/>      <line class='anx-icon-idee-cls1' x1='106.28' y1='178.59' x2='151.79' y2='168.39'/>      <path class='anx-icon-idee-cls2' d='M120.22,147.39l-12.06-24.47s8.58-11.52,20.1,0,21.58.38,21.58.38l-12.06,24.47'/>    </g>    <circle class='anx-icon-idee-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconInformation = make_icon_makeIcon("Information", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-information-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-information-cls1' cx='129' cy='129' r='125'/>    <g>      <circle class='anx-icon-information-cls1' cx='130.66' cy='68.34' r='17.74' transform='translate(-10.7 26.38) rotate(-11.08)'/>      <polygon class='anx-icon-information-cls1' points='145.06 183.53 145.06 102.92 100.69 102.92 100.69 122.42 121.62 122.42 121.62 183.53 100.69 183.53 100.69 203.04 160.63 203.04 160.63 183.53 145.06 183.53'/>    </g>  </g></svg>");
var AnxIconInstallation = make_icon_makeIcon("Installation", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-installation-cls1, .anx-icon-installation-cls2, .anx-icon-installation-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-installation-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-installation-cls2, .anx-icon-installation-cls3 {        stroke-linejoin: round;      }      .anx-icon-installation-cls3 {        stroke-linecap: round;      }      .anx-icon-installation-cls4 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-installation-cls1' cx='129' cy='129' r='125'/>    <g>      <polyline class='anx-icon-installation-cls2' points='117.02 79.86 85.61 79.86 54.39 134.96 203.61 134.96 172.92 79.86 140.98 79.86'/>      <rect class='anx-icon-installation-cls2' x='54.39' y='134.96' width='149.22' height='35.45'/>      <line class='anx-icon-installation-cls3' x1='73.07' y1='152.68' x2='173.43' y2='152.68'/>      <circle class='anx-icon-installation-cls4' cx='187.49' cy='152.68' r='3.9'/>    </g>  </g>  <g>    <line class='anx-icon-installation-cls1' x1='129' y1='47.21' x2='129' y2='113.95'/>    <polyline class='anx-icon-installation-cls1' points='146.55 96.4 129 113.95 111.45 96.4'/>  </g></svg>");
var AnxIconInterdisziplinaer = make_icon_makeIcon("Interdisziplinaer", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-interdisziplinaer-cls1, .anx-icon-interdisziplinaer-cls2, .anx-icon-interdisziplinaer-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-interdisziplinaer-cls1, .anx-icon-interdisziplinaer-cls3 {        stroke-miterlimit: 10;      }      .anx-icon-interdisziplinaer-cls2, .anx-icon-interdisziplinaer-cls3 {        stroke-linecap: round;      }      .anx-icon-interdisziplinaer-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-interdisziplinaer-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <g>          <path class='anx-icon-interdisziplinaer-cls1' d='M169.73,123.38a40.74,40.74,0,1,0-68.52,29.74,29.13,29.13,0,0,1,8.93,21.34v23.65a5.51,5.51,0,0,0,5.51,5.51h26.8c3,0,5.51-4.65,5.51-7.69l-.1-21.54a30.48,30.48,0,0,1,9.5-21.81A40.52,40.52,0,0,0,169.73,123.38Z'/>          <line class='anx-icon-interdisziplinaer-cls1' x1='110.14' y1='193.58' x2='147.86' y2='185.14'/>          <line class='anx-icon-interdisziplinaer-cls1' x1='110.14' y1='179.32' x2='147.92' y2='170.86'/>          <path class='anx-icon-interdisziplinaer-cls2' d='M121.71,153.42l-10-20.31s7.12-9.57,16.69,0,17.91.31,17.91.31l-10,20.32'/>        </g>        <g>          <path class='anx-icon-interdisziplinaer-cls1' d='M162.69,165.76a19.83,19.83,0,0,1,6.08,14.53V194a3.76,3.76,0,0,0,3.76,3.76h18.19c2.07,0,3.75-3.17,3.75-5.24V180.25a20.77,20.77,0,0,1,6.47-14.86,27.73,27.73,0,0,0-19.32-47.65,28.44,28.44,0,0,0-3.17.17'/>          <line class='anx-icon-interdisziplinaer-cls1' x1='168.77' y1='187.32' x2='194.47' y2='181.57'/>          <path class='anx-icon-interdisziplinaer-cls2' d='M176.65,166,171,153.3s3.67-7.7,10.19-1.18,12.21.21,12.21.21l-6.82,13.84'/>        </g>        <g>          <path class='anx-icon-interdisziplinaer-cls1' d='M76.4,117.74a28.84,28.84,0,0,0-3.2.17,27.74,27.74,0,0,0-15.76,47.85,19.8,19.8,0,0,1,6.09,14.53V194a3.76,3.76,0,0,0,3.75,3.76H85.47c2.08,0,3.76-3.17,3.76-5.24V180.25a20.77,20.77,0,0,1,6.47-14.86'/>          <line class='anx-icon-interdisziplinaer-cls1' x1='63.53' y1='187.32' x2='89.23' y2='181.57'/>          <path class='anx-icon-interdisziplinaer-cls2' d='M71.41,166l-6.82-13.84s4.85-6.52,11.37,0,11,1.39,11,1.39l-5.64,12.66'/>        </g>      </g>      <g>        <line class='anx-icon-interdisziplinaer-cls3' x1='128.94' y1='61.07' x2='128.94' y2='41.67'/>        <line class='anx-icon-interdisziplinaer-cls3' x1='90.15' y1='50.37' x2='100.78' y2='65.98'/>        <line class='anx-icon-interdisziplinaer-cls3' x1='62.92' y1='71.16' x2='81.63' y2='84.75'/>        <line class='anx-icon-interdisziplinaer-cls3' x1='167.75' y1='50.37' x2='157.12' y2='65.99'/>        <line class='anx-icon-interdisziplinaer-cls3' x1='196.4' y1='71.16' x2='179.11' y2='84.77'/>      </g>    </g>  </g></svg>");
var AnxIconIp = make_icon_makeIcon("Ip", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-ip-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-ip-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-ip-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-ip-cls1' d='M129,72.34l18.62-20,7.19,26.32,25.76-9-5.84,26.65,27,4-17.55,20.88,22.06,16.07-25.28,10.33L193,172.08l-27.17-2.64-.7,27.32-22.82-14.95L129,205.66l-13.32-23.85-22.8,14.95-.74-27.32L65,172.08l12.06-24.51L51.78,137.24l22.08-16.07L56.31,100.29l27-4L77.46,69.64l25.72,9,7.2-26.32Z'/>    <rect class='anx-icon-ip-cls2' x='111.87' y='112.71' width='6.93' height='32.99'/>    <path class='anx-icon-ip-cls2' d='M147.3,117.81a8.75,8.75,0,0,0-3.54-3.49c-.47-.25-.95-.48-1.42-.69a9.43,9.43,0,0,0-1.73-.52,18,18,0,0,0-2.47-.31c-1-.06-2.14-.09-3.54-.09h-8.68v33h6.64V133.54h3.66c.91,0,1.71,0,2.37-.07a14.38,14.38,0,0,0,1.73-.21c.49-.1.94-.21,1.33-.33a8.34,8.34,0,0,0,1.16-.48,9.51,9.51,0,0,0,4.21-3.79,11.2,11.2,0,0,0,1.49-5.8A10.31,10.31,0,0,0,147.3,117.81ZM141.06,125a4.62,4.62,0,0,1-.62,1.44,4.18,4.18,0,0,1-.69.86,2.59,2.59,0,0,1-.85.52,4.67,4.67,0,0,1-1.19.26,16.06,16.06,0,0,1-1.68.07h-3.47V118.07h4.23a4.21,4.21,0,0,1,3.3,1.31,5.29,5.29,0,0,1,1.16,3.63A9,9,0,0,1,141.06,125Z'/>  </g></svg>");
var AnxIconKalender = make_icon_makeIcon("Kalender", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-kalender-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-kalender-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-kalender-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-kalender-cls1' d='M179.4,78.87V82a18.49,18.49,0,0,1-37,0V78.87H115.57V82a18.49,18.49,0,0,1-37,0V78.87H65.15V189.78h127.7V78.87Z'/>      <line class='anx-icon-kalender-cls1' x1='65.15' y1='115.84' x2='192.85' y2='115.84'/>      <path class='anx-icon-kalender-cls2' d='M97,90a7.74,7.74,0,0,1-7.73-7.74V68.22a7.74,7.74,0,1,1,15.47,0V82.3A7.74,7.74,0,0,1,97,90Z'/>      <path class='anx-icon-kalender-cls2' d='M160.48,90a7.75,7.75,0,0,1-7.74-7.74V68.22a7.74,7.74,0,0,1,15.48,0V82.3A7.75,7.75,0,0,1,160.48,90Z'/>      <line class='anx-icon-kalender-cls1' x1='77.36' y1='134.33' x2='105.53' y2='134.33'/>      <line class='anx-icon-kalender-cls1' x1='114.92' y1='134.33' x2='143.08' y2='134.33'/>      <line class='anx-icon-kalender-cls1' x1='152.47' y1='134.33' x2='180.64' y2='134.33'/>      <line class='anx-icon-kalender-cls1' x1='77.36' y1='153.1' x2='105.53' y2='153.1'/>      <line class='anx-icon-kalender-cls1' x1='114.92' y1='153.1' x2='143.08' y2='153.1'/>      <line class='anx-icon-kalender-cls1' x1='152.47' y1='153.1' x2='180.64' y2='153.1'/>      <line class='anx-icon-kalender-cls1' x1='77.36' y1='171.88' x2='105.53' y2='171.88'/>      <line class='anx-icon-kalender-cls1' x1='114.92' y1='171.88' x2='143.08' y2='171.88'/>      <line class='anx-icon-kalender-cls1' x1='152.47' y1='171.88' x2='180.63' y2='171.88'/>    </g>  </g></svg>");
var AnxIconKontaktTelefonTelekommunikation = make_icon_makeIcon("KontaktTelefonTelekommunikation", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-kontakt-telefon-telekommunikation-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g id='z40AuA.tif'>      <path class='anx-icon-kontakt-telefon-telekommunikation-cls1' d='M194.31,170.6c-1,4.28-4,7.36-6.71,10.49-2.92,3.3-6.13,6.35-9.25,9.47-3.4,3.42-7.47,4.25-12.18,3.43a67.53,67.53,0,0,1-21-7.73c-10.83-5.95-20.49-13.5-29.64-21.74a254.05,254.05,0,0,1-33.57-36.05c-6.35-8.45-12-17.32-15.45-27.4-1.15-3.39-1.71-7-2.54-10.49l-.24-1.1V86.17a15,15,0,0,1,3.87-6.62c3.18-3.23,6.36-6.48,9.76-9.48,3-2.64,6-5.45,10.1-6.35h2.8c2.93.6,4.69,2.55,6.25,5Q104.12,80.51,112,92.17a8.8,8.8,0,0,1,.74,9.28c-2,4.24-4.39,8.33-6.73,12.42a2.1,2.1,0,0,0,.21,2.76A203.72,203.72,0,0,0,141.7,152a1.62,1.62,0,0,0,2.11.15c4.18-2.34,8.34-4.75,12.64-6.84a8.94,8.94,0,0,1,9.51.76q11.64,7.92,23.48,15.55c2.37,1.54,4.28,3.29,4.87,6.17Z'/>    </g>    <circle class='anx-icon-kontakt-telefon-telekommunikation-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconKonzept = make_icon_makeIcon("Konzept", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-konzept-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <polyline class='anx-icon-konzept-cls1' points='98.64 71.96 98.64 101.7 63.8 101.7'/>    <g>      <rect class='anx-icon-konzept-cls1' x='170.23' y='79.47' width='17.78' height='26.58' transform='translate(-13.13 153.82) rotate(-45)'/>      <polygon class='anx-icon-konzept-cls1' points='155.39 97.7 115.91 137.17 110.47 161.4 134.71 155.97 174.18 116.49 155.39 97.7'/>    </g>    <line class='anx-icon-konzept-cls1' x1='157.54' y1='113.79' x2='127.12' y2='144.21'/>    <polyline class='anx-icon-konzept-cls1' points='151.33 83.63 151.33 71.96 98.64 71.96 63.8 101.7 63.8 186.04 151.33 186.04 151.33 159.2'/>    <circle class='anx-icon-konzept-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconKunde = make_icon_makeIcon("Kunde", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-kunde-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-kunde-cls1' d='M185.14,184.22v-9.59a14.58,14.58,0,0,0-6.27-12,63.55,63.55,0,0,0-21.8-9.54c-18.84-4.43-13.7-12.59-11.16-17,6.36-11,11.75-8.5,13.37-31.39C161.49,73.65,140.15,66,129,66S96.51,73.65,98.72,104.7c1.62,22.89,5.17,20.43,13.37,31.39,3,4.07,7.68,12.56-11.16,17a63.82,63.82,0,0,0-21.6,9.39,15.06,15.06,0,0,0-6.47,12.41v9.34Z'/>    <circle class='anx-icon-kunde-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconKunden = make_icon_makeIcon("Kunden", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-kunden-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-kunden-cls1' d='M112.6,182.59h-63v-9.37a15.05,15.05,0,0,1,6.49-12.43,63.83,63.83,0,0,1,21.65-9.42c18.88-4.44,14.23-13,11.18-17-8.22-11-11.78-8.52-13.4-31.47C73.33,71.74,94.72,64.11,105.9,64.11s32.57,7.63,30.36,38.76c-1.63,22.95-7,20.48-13.41,31.47-2.55,4.41-7.7,12.59,11.19,17'/>    <path class='anx-icon-kunden-cls1' d='M167.69,186.15h40.69v-7a10.58,10.58,0,0,0-4.54-8.7,46,46,0,0,0-15.8-6.91c-13.66-3.22-9.94-9.13-8.09-12.32,4.61-7.94,8.51-6.16,9.69-22.75,1.6-22.51-13.87-28-21.95-28s-23.55,5.52-21.95,28c1.17,16.59,3.74,14.81,9.69,22.75,2.2,3,5.57,9.1-8.09,12.32a46.19,46.19,0,0,0-15.65,6.8,10.9,10.9,0,0,0-4.69,9v6.77Z'/>    <path class='anx-icon-kunden-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>  </g></svg>");
var AnxIconLaden = make_icon_makeIcon("Laden", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-laden-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-laden-cls1' cx='129' cy='129' r='125'/>    <rect class='anx-icon-laden-cls1' x='76.58' y='80.63' width='45.5' height='39.18'/>    <rect class='anx-icon-laden-cls1' x='76.58' y='138.38' width='45.5' height='39.18'/>    <rect class='anx-icon-laden-cls1' x='140.74' y='80.63' width='45.5' height='39.18'/>    <rect class='anx-icon-laden-cls1' x='140.74' y='138.38' width='45.5' height='39.18'/>  </g></svg>");
var AnxIconLastverteilung = make_icon_makeIcon("Lastverteilung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-lastverteilung-cls1, .anx-icon-lastverteilung-cls2, .anx-icon-lastverteilung-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-lastverteilung-cls1, .anx-icon-lastverteilung-cls3 {        stroke-miterlimit: 10;      }      .anx-icon-lastverteilung-cls2, .anx-icon-lastverteilung-cls3 {        stroke-linecap: round;      }      .anx-icon-lastverteilung-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-lastverteilung-cls1' cx='129' cy='129' r='125'/>    <g>      <polyline class='anx-icon-lastverteilung-cls2' points='111.27 67.23 127.33 51.16 143.4 67.23'/>      <line class='anx-icon-lastverteilung-cls3' x1='127.33' y1='201.05' x2='127.33' y2='51.16'/>    </g>    <g>      <polyline class='anx-icon-lastverteilung-cls2' points='160.59 110.07 182.59 104.37 188.29 126.37'/>      <line class='anx-icon-lastverteilung-cls3' x1='127.33' y1='201' x2='182.59' y2='104.37'/>    </g>    <g>      <polyline class='anx-icon-lastverteilung-cls2' points='94.08 110.07 72.08 104.37 66.38 126.37'/>      <line class='anx-icon-lastverteilung-cls3' x1='127.33' y1='201' x2='72.08' y2='104.37'/>    </g>  </g></svg>");
var AnxIconLike = make_icon_makeIcon("Like", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-like-cls1, .anx-icon-like-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-like-cls2 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-like-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-like-cls2' d='M124.44,184.31a22.64,22.64,0,0,1-13.36-4.91,8.1,8.1,0,0,0-1.88-1.26l-3.44-1.56V125.11l6.14-5.25,17.61-32.64.05-.09a11,11,0,0,0,1.26-3,11.2,11.2,0,0,0,.27-3.37l-1.57-20.59a.9.9,0,0,1,.45-.84l1.71-1a12.23,12.23,0,0,1,6-1.61c10.34,0,18.36,14.23,18.36,26.48a30.82,30.82,0,0,1-.37,4.79l-2.4,15.57h34.17a13.56,13.56,0,0,1,9.56,4,12.46,12.46,0,0,1,3.73,8.9,12.71,12.71,0,0,1-4,9.2,12.83,12.83,0,0,1-2.42,22.18,12.81,12.81,0,0,1-7.59,18.95,13.09,13.09,0,0,1,.62,7.41,12.71,12.71,0,0,1-11.73,10.08h-.13l-51,0Z'/>      <rect class='anx-icon-like-cls2' x='63.51' y='115.89' width='42.28' height='72.36' rx='4.17' ry='4.17'/>    </g>  </g></svg>");
var AnxIconLoeschen = make_icon_makeIcon("Loeschen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-loeschen-cls1, .anx-icon-loeschen-cls2, .anx-icon-loeschen-cls3 {        fill: none;        stroke: var(--anx-icons-color);      }      .anx-icon-loeschen-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-loeschen-cls1, .anx-icon-loeschen-cls2 {        stroke-width: 7.5px;      }      .anx-icon-loeschen-cls2, .anx-icon-loeschen-cls3 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-loeschen-cls3 {        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-loeschen-cls1' cx='129' cy='129' r='125'/>    <g>      <polygon class='anx-icon-loeschen-cls2' points='77.74 73.57 180.26 73.57 168.1 204.93 89.89 204.93 77.74 73.57'/>      <rect class='anx-icon-loeschen-cls2' x='103.91' y='53.07' width='50.18' height='20.5'/>      <g>        <line class='anx-icon-loeschen-cls2' x1='129' y1='90.24' x2='129' y2='185.38'/>        <line class='anx-icon-loeschen-cls2' x1='153.3' y1='90.24' x2='147.23' y2='185.38'/>        <line class='anx-icon-loeschen-cls2' x1='104.7' y1='90.24' x2='110.77' y2='185.38'/>      </g>      <line class='anx-icon-loeschen-cls3' x1='64.67' y1='73.57' x2='193.33' y2='73.57'/>    </g>  </g></svg>");
var AnxIconMailKontakt = make_icon_makeIcon("MailKontakt", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-mail-kontakt-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <rect class='anx-icon-mail-kontakt-cls1' x='60.75' y='87.8' width='136.51' height='82.41'/>      <polyline class='anx-icon-mail-kontakt-cls1' points='197.25 87.8 129 147.54 60.75 87.8'/>      <line class='anx-icon-mail-kontakt-cls1' x1='102.27' y1='124.14' x2='60.75' y2='170.2'/>      <line class='anx-icon-mail-kontakt-cls1' x1='155.73' y1='124.14' x2='197.25' y2='170.2'/>    </g>    <circle class='anx-icon-mail-kontakt-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconMassgeschneiderteIndividuelleLoesungen = make_icon_makeIcon("MassgeschneiderteIndividuelleLoesungen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-massgeschneiderte-individuelle-loesungen-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-massgeschneiderte-individuelle-loesungen-cls1' d='M83.61,59.8l64.81,93.67'/>    <path class='anx-icon-massgeschneiderte-individuelle-loesungen-cls1' d='M140.51,154.28c9.49-6.12,23.12-1.88,30.44,9.48s5.56,25.52-3.92,31.64-23.12,1.87-30.44-9.48S131,160.4,140.51,154.28Z'/>    <path class='anx-icon-massgeschneiderte-individuelle-loesungen-cls1' d='M143.2,128.12l16.57.93'/>    <path class='anx-icon-massgeschneiderte-individuelle-loesungen-cls1' d='M159.8,120.74c.58-11.28,12-19.86,25.48-19.16s24,10.39,23.38,21.67-12,19.85-25.48,19.16S159.22,132,159.8,120.74Z'/>    <path class='anx-icon-massgeschneiderte-individuelle-loesungen-cls1' d='M130.18,127.11,49.32,122'/>    <path class='anx-icon-massgeschneiderte-individuelle-loesungen-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>  </g></svg>");
var AnxIconMbaas = make_icon_makeIcon("Mbaas", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-mbaas-cls1, .anx-icon-mbaas-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-mbaas-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-mbaas-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-mbaas-cls3 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <circle class='anx-icon-mbaas-cls1' cx='129' cy='129' r='125'/>  <g>    <g>      <circle class='anx-icon-mbaas-cls1' cx='108.22' cy='129.4' r='11.6'/>      <line class='anx-icon-mbaas-cls2' x1='45.5' y1='129.4' x2='81.8' y2='129.4'/>      <line class='anx-icon-mbaas-cls2' x1='134' y1='129.4' x2='146.73' y2='129.4'/>      <line class='anx-icon-mbaas-cls2' x1='91.11' y1='150.95' x2='51.17' y2='150.95'/>      <polyline class='anx-icon-mbaas-cls2' points='108.39 158.01 108.39 172.9 57.01 172.9'/>      <line class='anx-icon-mbaas-cls2' x1='91.11' y1='107.85' x2='51.17' y2='107.85'/>      <polyline class='anx-icon-mbaas-cls2' points='108.39 100.79 108.39 85.9 57.01 85.9'/>    </g>    <g>      <rect class='anx-icon-mbaas-cls1' x='159.95' y='85.9' width='46.87' height='87' rx='5.48'/>      <line class='anx-icon-mbaas-cls1' x1='159.95' y1='152.49' x2='206.83' y2='152.49'/>      <circle class='anx-icon-mbaas-cls3' cx='183.39' cy='162.54' r='3.67'/>    </g>  </g></svg>");
var AnxIconMicrocontroller = make_icon_makeIcon("Microcontroller", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-microcontroller-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <circle class='anx-icon-microcontroller-cls1' cx='129' cy='129' r='125'/>  <rect class='anx-icon-microcontroller-cls1' x='79.08' y='79.08' width='99.85' height='99.85'/>  <line class='anx-icon-microcontroller-cls1' x1='91.67' y1='79.08' x2='91.67' y2='52.13'/>  <line class='anx-icon-microcontroller-cls1' x1='166.33' y1='79.08' x2='166.33' y2='52.13'/>  <line class='anx-icon-microcontroller-cls1' x1='129' y1='79.08' x2='129' y2='52.13'/>  <line class='anx-icon-microcontroller-cls1' x1='110.34' y1='79.08' x2='110.34' y2='52.13'/>  <line class='anx-icon-microcontroller-cls1' x1='147.66' y1='79.08' x2='147.66' y2='52.13'/>  <line class='anx-icon-microcontroller-cls1' x1='91.67' y1='205.87' x2='91.67' y2='178.92'/>  <line class='anx-icon-microcontroller-cls1' x1='166.33' y1='205.87' x2='166.33' y2='178.92'/>  <line class='anx-icon-microcontroller-cls1' x1='129' y1='205.87' x2='129' y2='178.92'/>  <line class='anx-icon-microcontroller-cls1' x1='110.34' y1='205.87' x2='110.34' y2='178.92'/>  <line class='anx-icon-microcontroller-cls1' x1='147.66' y1='205.87' x2='147.66' y2='178.92'/>  <line class='anx-icon-microcontroller-cls1' x1='178.92' y1='91.67' x2='205.87' y2='91.67'/>  <line class='anx-icon-microcontroller-cls1' x1='178.92' y1='166.33' x2='205.87' y2='166.33'/>  <line class='anx-icon-microcontroller-cls1' x1='178.92' y1='129' x2='205.87' y2='129'/>  <line class='anx-icon-microcontroller-cls1' x1='178.92' y1='110.34' x2='205.87' y2='110.34'/>  <line class='anx-icon-microcontroller-cls1' x1='178.92' y1='147.66' x2='205.87' y2='147.66'/>  <line class='anx-icon-microcontroller-cls1' x1='52.13' y1='91.67' x2='79.08' y2='91.67'/>  <line class='anx-icon-microcontroller-cls1' x1='52.13' y1='166.33' x2='79.08' y2='166.33'/>  <line class='anx-icon-microcontroller-cls1' x1='52.13' y1='129' x2='79.08' y2='129'/>  <line class='anx-icon-microcontroller-cls1' x1='52.13' y1='110.34' x2='79.08' y2='110.34'/>  <line class='anx-icon-microcontroller-cls1' x1='52.13' y1='147.66' x2='79.08' y2='147.66'/></svg>");
var AnxIconMitarbeiterevents = make_icon_makeIcon("Mitarbeiterevents", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-mitarbeiterevents-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-mitarbeiterevents-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-mitarbeiterevents-cls1' d='M188.46,112.15a76.55,76.55,0,0,1-12.6-3.06l-55.35,55.35L94.24,138.17l54.32-54.32a34.73,34.73,0,0,1-1.82-13.42l45.62-4.83Z'/>    <path class='anx-icon-mitarbeiterevents-cls1' d='M97.44,134.18h51.48'/>    <path class='anx-icon-mitarbeiterevents-cls1' d='M121.81,111h51.45'/>    <path class='anx-icon-mitarbeiterevents-cls1' d='M190.2,91.4c-24.32-2.48-25-22.92-25-22.92'/>    <path class='anx-icon-mitarbeiterevents-cls1' d='M101.54,145.48,57.91,189.11'/>    <path class='anx-icon-mitarbeiterevents-cls1' d='M104.82,194.38l-8.48-9.83s-12.4-10.7,1.57-20.54,2.45-18.54,2.45-18.54'/>    <path class='anx-icon-mitarbeiterevents-cls2' d='M123.18,189.87,117.46,199l4.27,9.88-10.44-2.62-8.08,7.11-.73-10.74-9.26-5.48,10-4,2.36-10.5,6.9,8.26Z'/>    <circle class='anx-icon-mitarbeiterevents-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconMobileEntwicklung = make_icon_makeIcon("MobileEntwicklung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-mobile-entwicklung-cls1, .anx-icon-mobile-entwicklung-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-mobile-entwicklung-cls1 {        stroke-width: 7.5px;      }      .anx-icon-mobile-entwicklung-cls2 {        stroke-width: 5.94px;      }      .anx-icon-mobile-entwicklung-cls3 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-mobile-entwicklung-cls1' cx='129' cy='129' r='125'/>    <g>      <rect class='anx-icon-mobile-entwicklung-cls1' x='88.9' y='54.58' width='80.2' height='148.85' rx='15.87' ry='15.87'/>      <line class='anx-icon-mobile-entwicklung-cls1' x1='88.9' y1='74.44' x2='169.1' y2='74.44'/>      <line class='anx-icon-mobile-entwicklung-cls1' x1='88.9' y1='176.35' x2='169.1' y2='176.35'/>      <line class='anx-icon-mobile-entwicklung-cls2' x1='120.15' y1='65.13' x2='137.85' y2='65.13'/>      <circle class='anx-icon-mobile-entwicklung-cls3' cx='129' cy='190.05' r='6.28'/>    </g>  </g></svg>");
var AnxIconMonitoring = make_icon_makeIcon("Monitoring", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-monitoring-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <g>        <rect class='anx-icon-monitoring-cls1' x='74.52' y='136.15' width='16.8' height='19.58'/>        <rect class='anx-icon-monitoring-cls1' x='104.66' y='118.25' width='16.8' height='37.48'/>      </g>      <line class='anx-icon-monitoring-cls1' x1='84.51' y1='191.09' x2='165.88' y2='191.09'/>      <g>        <circle class='anx-icon-monitoring-cls1' cx='173.91' cy='143.62' r='24.71'/>        <line class='anx-icon-monitoring-cls1' x1='193.04' y1='159.26' x2='212.91' y2='179.13'/>      </g>      <polyline class='anx-icon-monitoring-cls1' points='189.84 111.81 189.84 81.91 60.56 81.91 60.56 173.7 150.95 173.7'/>      <rect class='anx-icon-monitoring-cls1' x='107.98' y='173.7' width='34.43' height='17.39'/>      <polyline class='anx-icon-monitoring-cls1' points='135.31 158.53 135.31 101.7 152.76 101.7 152.76 110.31'/>    </g>    <circle class='anx-icon-monitoring-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconMusik = make_icon_makeIcon("Musik", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-musik-cls1, .anx-icon-musik-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-musik-cls1 {        stroke-width: 7.5px;      }      .anx-icon-musik-cls2 {        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-musik-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-musik-cls2' d='M102.59,83c-5.28,1-4.25,4.53-4.25,13.3v55c-15.68-5.27-32.26,5.54-32.22,20.07,0,8.64,10.54,15.82,19.12,16,15.36.36,28.63-9.49,28.8-21.94-.17-20.92,0-41.84,0-62.76,3.82-.6,46.43-7.44,50-8.05l-.14,47.8c-13.48-4.5-30.54,4-33.57,16.42-1.28,6.94,2.19,15.46,9.48,18.4,16.41,6.64,38.31-5.4,37.81-21.49-.22-27.89.18-51.68,0-79.57.05-3.49-1.95-6.87-10.12-5.37Z'/>  </g></svg>");
var AnxIconNetzwerk = make_icon_makeIcon("Netzwerk", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-netzwerk-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <circle class='anx-icon-netzwerk-cls1' cx='129' cy='80.33' r='15.47'/>      <g>        <line class='anx-icon-netzwerk-cls1' x1='129.16' y1='108.37' x2='129.16' y2='127.39'/>        <line class='anx-icon-netzwerk-cls1' x1='129.16' y1='127.39' x2='96.13' y2='160.42'/>        <line class='anx-icon-netzwerk-cls1' x1='129.16' y1='127.39' x2='161.87' y2='160.1'/>      </g>      <g>        <circle class='anx-icon-netzwerk-cls1' cx='78.56' cy='180.89' r='12.25'/>        <circle class='anx-icon-netzwerk-cls1' cx='129.16' cy='180.89' r='12.25'/>        <circle class='anx-icon-netzwerk-cls1' cx='179.44' cy='180.89' r='12.25'/>      </g>    </g>    <circle class='anx-icon-netzwerk-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconOeffentlicherNahverkehr = make_icon_makeIcon("OeffentlicherNahverkehr", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-oeffentlicher-nahverkehr-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-oeffentlicher-nahverkehr-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M184.12,131.3v50.25H73.88V131.3L81.49,83A20.47,20.47,0,0,1,101.71,65.7H156.3A20.46,20.46,0,0,1,176.51,83Z'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M73.88,131.3H184.12'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M112.28,158.08A10.13,10.13,0,1,1,102.16,148,10.13,10.13,0,0,1,112.28,158.08Z'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M80.46,93.63h97.08'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M110.48,79.85h37'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M166,158.08A10.13,10.13,0,1,1,155.84,148,10.13,10.13,0,0,1,166,158.08Z'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M93.2,200.2h0a9,9,0,0,1-9-8.95v-9.7h17.91v9.7A9,9,0,0,1,93.2,200.2Z'/>      <path class='anx-icon-oeffentlicher-nahverkehr-cls1' d='M164.8,200.2h0a9,9,0,0,1-9-8.95v-9.7h17.91v9.7A9,9,0,0,1,164.8,200.2Z'/>    </g>  </g></svg>");
var AnxIconOffline = make_icon_makeIcon("Offline", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-offline-cls1, .anx-icon-offline-cls2 {        fill: none;      }      .anx-icon-offline-cls2 {        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-offline-cls3 {        clip-path: url(#clip-path);      }    </style>    <clipPath id='clip-path'>      <path class='anx-icon-offline-cls1' d='M46.86,42.15V217H211.14V42.17ZM85.71,191.62,72.34,180.5,176.87,52.23l13.55,11.19Z'/>    </clipPath>  </defs>    <circle class='anx-icon-offline-cls2' cx='129' cy='129' r='125'/>  <g>    <line class='anx-icon-offline-cls2' x1='179.34' y1='54.58' x2='74.84' y2='182.52'/>    <g class='anx-icon-offline-cls3'>      <g>        <path class='anx-icon-offline-cls2' d='M52.61,110.51c.88-.7,2-1.51,3-2.45a109.94,109.94,0,0,1,149.73.57'/>        <path class='anx-icon-offline-cls2' d='M76.66,131.16c29.52-30.19,79.68-28.68,107.27.24'/>        <path class='anx-icon-offline-cls2' d='M100.74,152.26c13.6-15.85,43.82-16.95,59.21.18'/>        <path class='anx-icon-offline-cls2' d='M142,174.93a11.75,11.75,0,1,1-11.76-11.73A11.68,11.68,0,0,1,142,174.93Z'/>      </g>    </g>  </g></svg>");
var AnxIconOnlineshopWarenkorb = make_icon_makeIcon("OnlineshopWarenkorb", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-onlineshop-warenkorb-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <polyline class='anx-icon-onlineshop-warenkorb-cls1' points='219.66 89.57 189.98 89.57 161.74 154.67 76.79 154.67 53.81 103.45 151.21 103.45'/>      <circle class='anx-icon-onlineshop-warenkorb-cls1' cx='91.86' cy='183.53' r='11.97'/>      <circle class='anx-icon-onlineshop-warenkorb-cls1' cx='147.38' cy='183.53' r='11.97'/>    </g>    <circle class='anx-icon-onlineshop-warenkorb-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPaket = make_icon_makeIcon("Paket", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-paket-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <path class='anx-icon-paket-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129ZM137.9,77.32l4.33,23.52v34.37h-26V100.84l4.34-23.52M65.39,101.88,90.9,79.05a6.9,6.9,0,0,1,4.56-1.73h67.08a6.88,6.88,0,0,1,4.34,1.73l26,23.13M142,100.84h47.12a6.38,6.38,0,0,1,6.38,6.38V174.3a6.38,6.38,0,0,1-6.38,6.38H68.86a6.38,6.38,0,0,1-6.38-6.38v-67a6.38,6.38,0,0,1,6.29-6.46H116'/></svg>");
var AnxIconParkplatz = make_icon_makeIcon("Parkplatz", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-parkplatz-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-parkplatz-cls1' d='M182,124a32.77,32.77,0,0,1-7.51,13.85Q169,144,159,148.13t-25.69,4.09H123v46.12H89.49V68.7h42.22a103.75,103.75,0,0,1,22,2.14,43.71,43.71,0,0,1,16.46,7,31.33,31.33,0,0,1,10.23,12.46Q184,97.9,184,109.07A60,60,0,0,1,182,124Z'/>    <path class='anx-icon-parkplatz-cls1' d='M144,98.15a16.93,16.93,0,0,0-9.6-2.48H123v30.51h9.6a29.7,29.7,0,0,0,6.74-.67,9.3,9.3,0,0,0,4.7-2.57,11.83,11.83,0,0,0,2.77-5.24,34.16,34.16,0,0,0,.93-8.87C147.71,103.36,146.47,99.81,144,98.15Z'/>    <path class='anx-icon-parkplatz-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>  </g></svg>");
var AnxIconPartyProjektabschluss = make_icon_makeIcon("PartyProjektabschluss", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-party-projektabschluss-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <polygon class='anx-icon-party-projektabschluss-cls1' points='189.78 89.37 129 161 68.22 89.37 189.78 89.37'/>      <line class='anx-icon-party-projektabschluss-cls1' x1='129' y1='161' x2='129' y2='204.52'/>      <line class='anx-icon-party-projektabschluss-cls1' x1='104' y1='204.52' x2='154' y2='204.52'/>      <line class='anx-icon-party-projektabschluss-cls1' x1='178.71' y1='64.09' x2='153.44' y2='89.37'/>      <path class='anx-icon-party-projektabschluss-cls1' d='M94.2,119.73s17.67-8.15,34.91,0,34.9,0,34.9,0'/>    </g>    <circle class='anx-icon-party-projektabschluss-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPdf = make_icon_makeIcon("Pdf", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pdf-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-pdf-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-pdf-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <polyline class='anx-icon-pdf-cls1' points='117.98 58.58 117.98 95.3 74.97 95.3'/>        <polygon class='anx-icon-pdf-cls1' points='183.03 199.42 74.97 199.42 74.97 95.3 117.98 58.58 183.03 58.58 183.03 199.42'/>      </g>      <path class='anx-icon-pdf-cls2' d='M150,149a63.23,63.23,0,0,0-7.12.39,41.83,41.83,0,0,1-4.81-3.2c-3.48-2.87-6.63-7.9-8.84-14.14.06-.16.12-.44.23-.77,1.82-7.35,3.52-16.24-.12-19.88a4.76,4.76,0,0,0-3.37-1.34h-1.33c-2,0-3.86,2.16-4.36,4.26-2,7.34-.84,11.37,1.2,18v.07a92.85,92.85,0,0,1-6,16.17c-1.88,3.7-3.65,7.07-5.31,9.94a32.64,32.64,0,0,0-4.91,2.7c-6.62,4.15-9.78,8.8-10.39,11.72a5,5,0,0,0,.28,3l.18.28L98,178a5,5,0,0,0,2.44.61c4.47,0,9.55-5.25,16.4-17,.38-.16.71-.26,1-.37,5.69-1.82,12.75-3.11,22.25-4.16a40.38,40.38,0,0,0,16.59,4.09c2.43,0,4.07-.59,5-1.64a5.32,5.32,0,0,0,1.53-3.65,4.37,4.37,0,0,0-.66-3C160.94,150.25,156.8,149,150,149ZM99.42,174.71c.27-2.1,2.75-5.74,6.67-9.33a23.11,23.11,0,0,1,2.65-1.71C105.15,170.24,101.9,173.88,99.42,174.71ZM125,114.2a5.68,5.68,0,0,1,.39-.67l.83.28c.94,1.32,1,2.92.5,6.07l-.17.88c-.33,1.22-.49,2.77-.88,4.54l-.28.21C124.15,120.54,124.09,116.51,125,114.2Zm-6.9,43.06-.61.22a32.71,32.71,0,0,1,2.77-5.74,82.89,82.89,0,0,0,5.59-13.24,33.66,33.66,0,0,0,8.44,11.86,18.21,18.21,0,0,0,2.27,1.77A104.44,104.44,0,0,0,118.13,157.26Zm41.27-.32h-.23a5.85,5.85,0,0,1-1.06.11c-2.54,0-6.46-1.05-10.48-2.82a1.42,1.42,0,0,1,1.26-.55c7.73,0,10,1.37,10.51,1.93a2.15,2.15,0,0,1,.49.6C159.84,156.76,159.67,156.83,159.4,156.94Z'/>    </g>  </g></svg>");
var AnxIconPfeilLinksKlein = make_icon_makeIcon("PfeilLinksKlein", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pfeil-links-klein-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <polyline class='anx-icon-pfeil-links-klein-cls1' points='157.88 186.17 87.69 129 157.88 71.83'/>    <circle class='anx-icon-pfeil-links-klein-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPfeilLinks = make_icon_makeIcon("PfeilLinks", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pfeil-links-cls1, .anx-icon-pfeil-links-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-pfeil-links-cls1 {        stroke-linejoin: round;      }      .anx-icon-pfeil-links-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-pfeil-links-cls1' points='134.39 149.66 185.4 149.66 185.4 108.34 134.39 108.34 134.39 79.37 59.45 129 134.39 178.63 134.39 149.66'/>    <circle class='anx-icon-pfeil-links-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPfeilOben = make_icon_makeIcon("PfeilOben", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pfeil-oben-cls1, .anx-icon-pfeil-oben-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-pfeil-oben-cls1 {        stroke-linejoin: round;      }      .anx-icon-pfeil-oben-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-pfeil-oben-cls1' points='108.34 134.39 108.34 185.4 149.66 185.4 149.66 134.39 178.63 134.39 129 59.45 79.37 134.39 108.34 134.39'/>    <circle class='anx-icon-pfeil-oben-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPfeilRechtsKlein = make_icon_makeIcon("PfeilRechtsKlein", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pfeil-rechts-klein-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <polyline class='anx-icon-pfeil-rechts-klein-cls1' points='100.12 71.83 170.31 129 100.12 186.17'/>    <circle class='anx-icon-pfeil-rechts-klein-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPfeilRechts = make_icon_makeIcon("PfeilRechts", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pfeil-rechts-cls1, .anx-icon-pfeil-rechts-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-pfeil-rechts-cls1 {        stroke-linejoin: round;      }      .anx-icon-pfeil-rechts-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-pfeil-rechts-cls1' points='123.61 108.34 72.6 108.34 72.6 149.66 123.61 149.66 123.61 178.63 198.55 129 123.61 79.37 123.61 108.34'/>    <circle class='anx-icon-pfeil-rechts-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPfeilRunter = make_icon_makeIcon("PfeilRunter", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pfeil-runter-cls1, .anx-icon-pfeil-runter-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-pfeil-runter-cls1 {        stroke-linejoin: round;      }      .anx-icon-pfeil-runter-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-pfeil-runter-cls1' points='149.66 123.61 149.66 72.6 108.34 72.6 108.34 123.61 79.37 123.61 129 198.55 178.63 123.61 149.66 123.61'/>    <circle class='anx-icon-pfeil-runter-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPflichtenheft = make_icon_makeIcon("Pflichtenheft", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-pflichtenheft-cls1, .anx-icon-pflichtenheft-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-pflichtenheft-cls1 {        stroke-linejoin: round;      }      .anx-icon-pflichtenheft-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <path class='anx-icon-pflichtenheft-cls1' d='M129,166.54V99.85C102.52,83.16,74.72,92,74.72,92v66.69S103.39,148.71,129,166.54Z'/>    <path class='anx-icon-pflichtenheft-cls1' d='M129.22,166.54V99.85C155.75,83.16,183.54,92,183.54,92v66.69S154.88,148.71,129.22,166.54Z'/>    <path class='anx-icon-pflichtenheft-cls2' d='M193.63,101.38c4.21,1,4.64,1.48,4.64,1.48V175.2s-46.45-15.12-69.27,8.29c-22.82-23.41-69.27-8.29-69.27-8.29V102.86s.15-.44,4.36-1.4'/>    <line class='anx-icon-pflichtenheft-cls2' x1='129.04' y1='168.37' x2='129.04' y2='183.49'/>    <path class='anx-icon-pflichtenheft-cls1' d='M95.31,105.61a65,65,0,0,0-11.68.78'/>    <path class='anx-icon-pflichtenheft-cls1' d='M120.93,111.74a59.8,59.8,0,0,0-20.37-5.81'/>    <path class='anx-icon-pflichtenheft-cls1' d='M90.05,121.83a63.6,63.6,0,0,0-6.42.69'/>    <path class='anx-icon-pflichtenheft-cls1' d='M120.93,127.87a60.77,60.77,0,0,0-25.62-6.13'/>    <path class='anx-icon-pflichtenheft-cls1' d='M120.93,142.24a58,58,0,0,0-10.23-3.89c-1.59-.45-3.16-.81-4.69-1.11a65.37,65.37,0,0,0-22.38-.35'/>    <path class='anx-icon-pflichtenheft-cls1' d='M137.85,111.82c14.78-7.29,29.25-6.56,37.06-5.32'/>    <path class='anx-icon-pflichtenheft-cls1' d='M161,121.85a65.55,65.55,0,0,1,13.94.68'/>    <path class='anx-icon-pflichtenheft-cls1' d='M137.85,127.85a59.47,59.47,0,0,1,20.31-5.78'/>    <path class='anx-icon-pflichtenheft-cls1' d='M152,137.28a64.8,64.8,0,0,1,22.88-.47'/>    <path class='anx-icon-pflichtenheft-cls1' d='M137.85,142.12a59.36,59.36,0,0,1,9.59-3.71'/>    <circle class='anx-icon-pflichtenheft-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconPlatform = make_icon_makeIcon("Platform", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-platform-cls1, .anx-icon-platform-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-platform-cls1 {        stroke-width: 7.5px;      }      .anx-icon-platform-cls2 {        stroke-width: 7px;      }    </style>  </defs>    <circle class='anx-icon-platform-cls1' cx='129' cy='129' r='125'/>  <g>    <line class='anx-icon-platform-cls1' x1='78.14' y1='197.25' x2='179.86' y2='197.25'/>    <rect class='anx-icon-platform-cls1' x='50.42' y='60.75' width='157.16' height='114.75'/>    <rect class='anx-icon-platform-cls1' x='107.48' y='175.5' width='43.04' height='21.74'/>    <rect class='anx-icon-platform-cls2' x='97.3' y='80.28' width='38.8' height='30.43'/>    <rect class='anx-icon-platform-cls2' x='150.52' y='80.28' width='38.8' height='30.43'/>    <line class='anx-icon-platform-cls2' x1='64.3' y1='80.28' x2='83.37' y2='80.28'/>    <line class='anx-icon-platform-cls2' x1='64.3' y1='99.16' x2='83.37' y2='99.16'/>    <line class='anx-icon-platform-cls2' x1='64.3' y1='118.05' x2='83.37' y2='118.05'/>    <line class='anx-icon-platform-cls2' x1='64.3' y1='136.94' x2='83.37' y2='136.94'/>    <line class='anx-icon-platform-cls2' x1='64.3' y1='155.83' x2='83.37' y2='155.83'/>    <rect class='anx-icon-platform-cls2' x='97.3' y='125.4' width='38.8' height='30.43'/>    <rect class='anx-icon-platform-cls2' x='150.52' y='125.4' width='38.8' height='30.43'/>  </g></svg>");
var AnxIconPraesentation = make_icon_makeIcon("Praesentation", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-praesentation-cls1, .anx-icon-praesentation-cls2, .anx-icon-praesentation-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-praesentation-cls1, .anx-icon-praesentation-cls2 {        stroke-linecap: round;      }      .anx-icon-praesentation-cls1 {        stroke-linejoin: round;      }      .anx-icon-praesentation-cls2, .anx-icon-praesentation-cls3 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-praesentation-cls1' points='197.52 167.33 131.06 167.33 64.61 167.33 64.61 72.31 197.52 72.31 197.52 167.33'/>    <line class='anx-icon-praesentation-cls1' x1='155.26' y1='213.62' x2='131.06' y2='167.33'/>    <line class='anx-icon-praesentation-cls1' x1='104.8' y1='213.62' x2='129' y2='167.33'/>    <line class='anx-icon-praesentation-cls1' x1='48.65' y1='72.31' x2='213.47' y2='72.31'/>    <rect class='anx-icon-praesentation-cls2' x='84.94' y='124.34' width='19.6' height='23.8'/>    <rect class='anx-icon-praesentation-cls2' x='121.42' y='109' width='19.6' height='39.14'/>    <rect class='anx-icon-praesentation-cls2' x='159' y='92.88' width='19.6' height='55.27'/>  </g>  <circle class='anx-icon-praesentation-cls3' cx='129' cy='129' r='125'/></svg>");
var AnxIconProjektablauf = make_icon_makeIcon("Projektablauf", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-projektablauf-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-projektablauf-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <g>      <g>        <path class='anx-icon-projektablauf-cls1' d='M99.68,183.5a62,62,0,0,0,78.65-17'/>        <polygon class='anx-icon-projektablauf-cls2' points='92.81 200.8 79.28 165.94 116.24 171.65 92.81 200.8'/>      </g>      <g>        <path class='anx-icon-projektablauf-cls1' d='M95.15,76.53a61.89,61.89,0,0,0-24.38,73.86'/>        <polygon class='anx-icon-projektablauf-cls2' points='83.29 62.24 120.36 67.13 97.6 96.79 83.29 62.24'/>      </g>      <g>        <path class='anx-icon-projektablauf-cls1' d='M191.06,124.41a62.17,62.17,0,0,0-53.42-57.28'/>        <polygon class='anx-icon-projektablauf-cls2' points='209.31 121.02 187 151.02 172.17 116.7 209.31 121.02'/>      </g>    </g>    <circle class='anx-icon-projektablauf-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconProjektmanagementCheckliste = make_icon_makeIcon("ProjektmanagementCheckliste", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-projektmanagement-checkliste-cls1, .anx-icon-projektmanagement-checkliste-cls2, .anx-icon-projektmanagement-checkliste-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-projektmanagement-checkliste-cls1, .anx-icon-projektmanagement-checkliste-cls4 {        stroke-miterlimit: 10;      }      .anx-icon-projektmanagement-checkliste-cls2 {        stroke-linejoin: bevel;      }      .anx-icon-projektmanagement-checkliste-cls3 {        fill: var(--anx-icons-color);      }      .anx-icon-projektmanagement-checkliste-cls4 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-projektmanagement-checkliste-cls1' d='M121.71,59.28,105.85,77.14a9.64,9.64,0,0,0,7.2,16h32.14a9.64,9.64,0,0,0,7.12-16.13L136,59.19A9.64,9.64,0,0,0,121.71,59.28Z'/>    <polyline class='anx-icon-projektmanagement-checkliste-cls2' points='92.52 80.93 71.71 80.93 71.71 193.73 186.29 193.73 186.29 80.93 165.47 80.93'/>    <circle class='anx-icon-projektmanagement-checkliste-cls3' cx='129.04' cy='75.21' r='6.93'/>    <path class='anx-icon-projektmanagement-checkliste-cls4' d='M100.6,143.39l19.58,15.47s26.59-29.49,39.64-37.47'/>    <circle class='anx-icon-projektmanagement-checkliste-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconRedundant = make_icon_makeIcon("Redundant", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-redundant-cls1, .anx-icon-redundant-cls3, .anx-icon-redundant-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-redundant-cls1, .anx-icon-redundant-cls3 {        stroke-linejoin: round;      }      .anx-icon-redundant-cls2 {        fill: var(--anx-icons-color);      }      .anx-icon-redundant-cls3 {        stroke-linecap: round;      }      .anx-icon-redundant-cls4 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <g>      <rect class='anx-icon-redundant-cls1' x='57.15' y='160.89' width='143.69' height='34.14'/>      <circle class='anx-icon-redundant-cls2' cx='183.97' cy='177.96' r='6.11'/>      <line class='anx-icon-redundant-cls3' x1='75.16' y1='184.71' x2='86.68' y2='173.18'/>      <line class='anx-icon-redundant-cls3' x1='99.14' y1='184.71' x2='110.67' y2='173.18'/>      <line class='anx-icon-redundant-cls3' x1='123.3' y1='184.71' x2='134.82' y2='173.18'/>      <rect class='anx-icon-redundant-cls1' x='57.15' y='62.98' width='143.69' height='34.14'/>      <circle class='anx-icon-redundant-cls2' cx='183.97' cy='80.04' r='6.11'/>      <line class='anx-icon-redundant-cls3' x1='75.16' y1='86.8' x2='86.68' y2='75.27'/>      <line class='anx-icon-redundant-cls3' x1='99.14' y1='86.8' x2='110.67' y2='75.27'/>      <line class='anx-icon-redundant-cls3' x1='123.3' y1='86.8' x2='134.82' y2='75.27'/>    </g>    <g>      <g>        <polyline class='anx-icon-redundant-cls3' points='174.49 129.74 161.24 142.99 147.99 129.74'/>        <line class='anx-icon-redundant-cls3' x1='161.24' y1='142.99' x2='161.24' y2='115.01'/>      </g>      <g>        <polyline class='anx-icon-redundant-cls3' points='83.52 128.26 96.76 115.01 110.01 128.26'/>        <line class='anx-icon-redundant-cls3' x1='96.76' y1='115.01' x2='96.76' y2='142.99'/>      </g>    </g>    <circle class='anx-icon-redundant-cls4' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSatellit = make_icon_makeIcon("Satellit", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-satellit-cls1, .anx-icon-satellit-cls2, .anx-icon-satellit-cls3, .anx-icon-satellit-cls5 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-satellit-cls1, .anx-icon-satellit-cls3 {        stroke-width: 7.5px;      }      .anx-icon-satellit-cls2, .anx-icon-satellit-cls3 {        stroke-linecap: round;      }      .anx-icon-satellit-cls2, .anx-icon-satellit-cls5 {        stroke-width: 7.5px;      }      .anx-icon-satellit-cls4 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <circle class='anx-icon-satellit-cls1' cx='129' cy='129' r='125'/>  <g>    <path class='anx-icon-satellit-cls2' d='M123.68,173.31c-10.67-10.67-8.21-30.43,5.49-44.14s33.47-16.16,44.14-5.49Z'/>    <rect class='anx-icon-satellit-cls3' x='113.88' y='63.66' width='58.17' height='31.24' transform='translate(-14.19 124.31) rotate(-45)'/>    <rect class='anx-icon-satellit-cls3' x='50.2' y='127.34' width='58.17' height='31.24' transform='translate(-77.87 97.93) rotate(-45)'/>    <polygon class='anx-icon-satellit-cls3' points='77.35 88.76 88.76 77.35 98.76 84.72 84.72 98.76 77.35 88.76'/>    <path class='anx-icon-satellit-cls4' d='M140.19,156.8c3.94,3.93,11.55,4.11,16.13-.48s4.41-12.19.48-16.13Z'/>    <path class='anx-icon-satellit-cls5' d='M195.74,129c4.58,19-.89,39.06-14.29,52.45S148,200.32,129,195.74'/>    <path class='anx-icon-satellit-cls5' d='M175.07,141.7a27.2,27.2,0,0,1-33.37,33.37'/>    <rect class='anx-icon-satellit-cls3' x='83.99' y='94.52' width='52.94' height='31.88' transform='translate(110.46 -45.75) rotate(45)'/>  </g></svg>");
var AnxIconSchluessel = make_icon_makeIcon("Schluessel", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-schluessel-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-schluessel-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <path class='anx-icon-schluessel-cls1' d='M182.19,90.77a38,38,0,1,0-73.06,14.71L60.21,154.36v20.38H80.59V163H92.31V151.3H104V139.59h11.72l13.34-13.94a38,38,0,0,0,53.11-34.88Z'/>        <circle class='anx-icon-schluessel-cls1' cx='152.88' cy='82.07' r='10.14'/>      </g>      <path class='anx-icon-schluessel-cls1' d='M130.78,126.33c1,1.76,4.72,5.33,5.78,6.33L115,189l7.24,16.24L138.43,198l-4.16-9.33,9.33-4.17-4.16-9.34,9.34-4.16-4.17-9.34,9.34-4.16,5.67-15.85A33.17,33.17,0,0,0,189.55,95a41.71,41.71,0,0,0-7.36-10.55'/>      <path class='anx-icon-schluessel-cls1' d='M161.78,77.2s-3.57,4.08-5.77,1.28,3-19.55,20-22.92c17.66-3.51,27.94,15.53,11.7,35.93'/>    </g>  </g></svg>");
var AnxIconScrum = make_icon_makeIcon("Scrum", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-scrum-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-scrum-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-scrum-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-scrum-cls1' d='M91.82,81.09a24.46,24.46,0,1,0,2.33,28.21'/>      <path class='anx-icon-scrum-cls1' d='M45.44,183h83.07s5.85,0,11.83-.29a76,76,0,0,0,10-1.09,51.59,51.59,0,1,0-54.39-25.59'/>      <line class='anx-icon-scrum-cls1' x1='123.99' y1='183.02' x2='205.7' y2='183.02'/>      <polygon class='anx-icon-scrum-cls2' points='196 194.22 215.4 183.02 196 171.81 196 194.22'/>      <polygon class='anx-icon-scrum-cls2' points='80.9 149.52 98.37 163.53 101.77 141.39 80.9 149.52'/>      <polygon class='anx-icon-scrum-cls2' points='74.97 81.94 97.25 84.22 88.09 63.78 74.97 81.94'/>    </g>  </g></svg>");
var AnxIconSeoSemCrawler = make_icon_makeIcon("SeoSemCrawler", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-seo-sem-crawler-cls1, .anx-icon-seo-sem-crawler-cls2, .anx-icon-seo-sem-crawler-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-seo-sem-crawler-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-seo-sem-crawler-cls2 {        stroke-linejoin: round;      }      .anx-icon-seo-sem-crawler-cls3 {        fill: var(--anx-icons-color);      }      .anx-icon-seo-sem-crawler-cls4 {        stroke-linejoin: bevel;      }    </style>  </defs>    <g>    <path class='anx-icon-seo-sem-crawler-cls1' d='M121.71,59.28,105.85,77.14a9.64,9.64,0,0,0,7.2,16h32.14a9.64,9.64,0,0,0,7.12-16.13L136,59.19A9.64,9.64,0,0,0,121.71,59.28Z'/>    <g>      <polyline class='anx-icon-seo-sem-crawler-cls2' points='186.29 124.79 186.29 80.93 165.47 80.93'/>      <polyline class='anx-icon-seo-sem-crawler-cls2' points='92.52 80.93 71.71 80.93 71.71 186.28 140.63 186.28'/>    </g>    <circle class='anx-icon-seo-sem-crawler-cls3' cx='129.04' cy='75.21' r='6.93'/>    <circle class='anx-icon-seo-sem-crawler-cls1' cx='129' cy='129' r='125'/>    <line class='anx-icon-seo-sem-crawler-cls4' x1='100.35' y1='115.56' x2='159.75' y2='115.56'/>    <line class='anx-icon-seo-sem-crawler-cls4' x1='100.35' y1='130.79' x2='135.97' y2='130.79'/>    <line class='anx-icon-seo-sem-crawler-cls4' x1='100.35' y1='146.02' x2='125.04' y2='146.02'/>    <line class='anx-icon-seo-sem-crawler-cls4' x1='100.35' y1='161.25' x2='131.77' y2='161.25'/>    <g>      <circle class='anx-icon-seo-sem-crawler-cls1' cx='170.59' cy='158.09' r='23.91'/>      <line class='anx-icon-seo-sem-crawler-cls1' x1='189.1' y1='173.22' x2='208.32' y2='192.44'/>    </g>  </g></svg>");
var AnxIconServerVeerbunden = make_icon_makeIcon("ServerVeerbunden", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-server-veerbunden-cls1, .anx-icon-server-veerbunden-cls3, .anx-icon-server-veerbunden-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-server-veerbunden-cls1, .anx-icon-server-veerbunden-cls3 {        stroke-linejoin: round;      }      .anx-icon-server-veerbunden-cls2 {        fill: var(--anx-icons-color);      }      .anx-icon-server-veerbunden-cls3 {        stroke-linecap: round;      }      .anx-icon-server-veerbunden-cls4 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <g>      <rect class='anx-icon-server-veerbunden-cls1' x='65.82' y='161.7' width='126.35' height='30.02'/>      <circle class='anx-icon-server-veerbunden-cls2' cx='177.33' cy='176.71' r='5.38'/>      <line class='anx-icon-server-veerbunden-cls3' x1='81.66' y1='182.65' x2='91.79' y2='172.52'/>      <line class='anx-icon-server-veerbunden-cls3' x1='102.75' y1='182.65' x2='112.88' y2='172.52'/>      <line class='anx-icon-server-veerbunden-cls3' x1='123.98' y1='182.65' x2='134.12' y2='172.52'/>      <rect class='anx-icon-server-veerbunden-cls1' x='65.82' y='115.29' width='126.35' height='30.02'/>      <circle class='anx-icon-server-veerbunden-cls2' cx='177.33' cy='130.3' r='5.38'/>      <line class='anx-icon-server-veerbunden-cls3' x1='81.66' y1='136.24' x2='91.79' y2='126.11'/>      <line class='anx-icon-server-veerbunden-cls3' x1='102.75' y1='136.24' x2='112.88' y2='126.11'/>      <line class='anx-icon-server-veerbunden-cls3' x1='123.98' y1='136.24' x2='134.12' y2='126.11'/>      <polygon class='anx-icon-server-veerbunden-cls3' points='165.1 66.28 92.9 66.28 65.82 115.29 192.18 115.29 165.1 66.28'/>    </g>    <circle class='anx-icon-server-veerbunden-cls4' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconServiceprovider = make_icon_makeIcon("Serviceprovider", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-serviceprovider-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-serviceprovider-cls1' d='M166.92,149.27h7a28.51,28.51,0,0,0,8-55.87,37,37,0,0,0-67.88-16.59A27,27,0,0,0,79.19,95.37a27.06,27.06,0,0,0,3.4,53.9h7.77'/>    <circle class='anx-icon-serviceprovider-cls1' cx='129' cy='129' r='125'/>  </g>  <circle class='anx-icon-serviceprovider-cls1' cx='129' cy='197.98' r='15'/>  <line class='anx-icon-serviceprovider-cls1' x1='129' y1='182.98' x2='129' y2='104.56'/>  <g>    <circle class='anx-icon-serviceprovider-cls1' cx='176.32' cy='182.98' r='10.61'/>    <polyline class='anx-icon-serviceprovider-cls1' points='168.82 175.48 152.57 159.22 152.57 121'/>  </g>  <g>    <circle class='anx-icon-serviceprovider-cls1' cx='81.68' cy='182.98' r='10.61'/>    <polyline class='anx-icon-serviceprovider-cls1' points='89.18 175.48 105.43 159.22 105.43 121'/>  </g></svg>");
var AnxIconSharing = make_icon_makeIcon("Sharing", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-sharing-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-sharing-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <circle class='anx-icon-sharing-cls1' cx='82.13' cy='134.26' r='15.01' transform='translate(-24.27 18.28) rotate(-11.08)'/>        <circle class='anx-icon-sharing-cls1' cx='160.88' cy='88.94' r='15.01' transform='translate(-14.09 32.57) rotate(-11.08)'/>        <line class='anx-icon-sharing-cls1' x1='95.12' y1='126.76' x2='147.9' y2='96.44'/>      </g>      <g>        <circle class='anx-icon-sharing-cls1' cx='160.88' cy='179.59' r='15.01' transform='translate(-46.28 302.97) rotate(-78.92)'/>        <line class='anx-icon-sharing-cls1' x1='147.89' y1='172.09' x2='95.11' y2='141.76'/>      </g>    </g>  </g></svg>");
var AnxIconShop = make_icon_makeIcon("Shop", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-shop-cls1, .anx-icon-shop-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-shop-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-shop-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <circle class='anx-icon-shop-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <rect class='anx-icon-shop-cls2' x='129.3' y='140.44' width='43.09' height='46.86'/>        <rect class='anx-icon-shop-cls2' x='86.21' y='140.44' width='43.09' height='46.86'/>      </g>      <polyline class='anx-icon-shop-cls2' points='192.46 118.29 192.46 187.3 66.13 187.3 66.13 118.29'/>      <path class='anx-icon-shop-cls2' d='M86.71,107.83c1.43,6,7.2,10.46,14,10.46a14.18,14.18,0,0,0,13.87-10.46h.82a14.49,14.49,0,0,0,27.84,0H144a14.47,14.47,0,0,0,27.81,0h.81a14.18,14.18,0,0,0,13.91,10.46c7.9,0,14.31-6.1,14.31-13.63,0-8.62-17.55-36.83-17.55-36.83h-108S57.73,96,57.73,104.66c0,7.53,6.41,13.63,14.31,13.63A14.18,14.18,0,0,0,85.9,107.83Z'/>      <line class='anx-icon-shop-cls2' x1='75.88' y1='93.06' x2='182.71' y2='93.06'/>    </g>  </g></svg>");
var AnxIconSicherheitFirewall = make_icon_makeIcon("SicherheitFirewall", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-sicherheit-firewall-cls1, .anx-icon-sicherheit-firewall-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-sicherheit-firewall-cls2 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-sicherheit-firewall-cls1' d='M129,207.15c74.49-22.79,66-124.84,66-124.84-44.9,0-66-18.36-66-18.36S107.91,82.31,63,82.31C63,82.31,54.51,184.36,129,207.15Z'/>    <line class='anx-icon-sicherheit-firewall-cls1' x1='129' y1='63.95' x2='129' y2='207.15'/>    <line class='anx-icon-sicherheit-firewall-cls2' x1='153.21' y1='90.86' x2='142' y2='102.08'/>    <line class='anx-icon-sicherheit-firewall-cls2' x1='171.58' y1='98.32' x2='142' y2='127.9'/>    <line class='anx-icon-sicherheit-firewall-cls2' x1='176.76' y1='120.43' x2='143.65' y2='153.53'/>    <line class='anx-icon-sicherheit-firewall-cls2' x1='164.98' y1='159.04' x2='143.65' y2='180.37'/>    <circle class='anx-icon-sicherheit-firewall-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSignal = make_icon_makeIcon("Signal", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-signal-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-signal-cls1' d='M173.58,75.4c30.19,29.51,28.69,79.68-.23,107.27'/>    <path class='anx-icon-signal-cls1' d='M152.31,158.69c17.12-15.39,16-45.61.17-59.21'/>    <path class='anx-icon-signal-cls1' d='M141.54,129a11.81,11.81,0,1,0-11.73,11.77A11.75,11.75,0,0,0,141.54,129Z'/>    <path class='anx-icon-signal-cls1' d='M84.65,75.33c-28.92,27.59-30.42,77.76-.23,107.27'/>    <path class='anx-icon-signal-cls1' d='M105.69,99.31c-17.12,15.39-16,45.61-.17,59.21'/>    <circle class='anx-icon-signal-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSkalierbar = make_icon_makeIcon("Skalierbar", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-skalierbar-cls1, .anx-icon-skalierbar-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-skalierbar-cls2 {        stroke-dasharray: 33.72 17.49;      }    </style>  </defs>    <circle class='anx-icon-skalierbar-cls1' cx='129' cy='129' r='125'/>  <g>    <g>      <polyline class='anx-icon-skalierbar-cls1' points='67.65 96 67.65 67.65 94.65 67.65'/>      <line class='anx-icon-skalierbar-cls2' x1='112.14' y1='67.65' x2='154.61' y2='67.65'/>      <polyline class='anx-icon-skalierbar-cls1' points='163.35 67.65 190.35 67.65 190.35 94.65'/>      <line class='anx-icon-skalierbar-cls2' x1='190.35' y1='112.14' x2='190.35' y2='154.61'/>      <polyline class='anx-icon-skalierbar-cls1' points='190.35 163.35 190.35 190.35 162 190.35'/>    </g>    <rect class='anx-icon-skalierbar-cls1' x='67.65' y='116.3' width='74.05' height='74.05'/>  </g></svg>");
var AnxIconSmartTv = make_icon_makeIcon("SmartTv", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-smart-tv-cls1, .anx-icon-smart-tv-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-smart-tv-cls2 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <g>      <rect class='anx-icon-smart-tv-cls1' x='53.44' y='79.73' width='151.12' height='85.5' rx='7.5' ry='7.5'/>      <rect class='anx-icon-smart-tv-cls1' x='119.06' y='165.23' width='19.88' height='13.05' rx='1.06' ry='1.06'/>      <line class='anx-icon-smart-tv-cls2' x1='93.97' y1='178.27' x2='164.03' y2='178.27'/>    </g>    <circle class='anx-icon-smart-tv-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSmartWatch = make_icon_makeIcon("SmartWatch", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-smart-watch-cls1, .anx-icon-smart-watch-cls2, .anx-icon-smart-watch-cls3 {        fill: none;        stroke: var(--anx-icons-color);      }      .anx-icon-smart-watch-cls1, .anx-icon-smart-watch-cls2 {        stroke-miterlimit: 10;      }      .anx-icon-smart-watch-cls1, .anx-icon-smart-watch-cls3 {        stroke-width: 7.5px;      }      .anx-icon-smart-watch-cls2 {        stroke-width: 7.5px;      }      .anx-icon-smart-watch-cls3 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-smart-watch-cls1' d='M78,88.11l-9.66,60.16a8.25,8.25,0,0,0,6.93,9.49L106,161a10.42,10.42,0,0,0,11.88-8.85l9.26-63.33a7.51,7.51,0,0,0-7.39-8.56H87.24A9.38,9.38,0,0,0,78,88.11Z'/>      <path class='anx-icon-smart-watch-cls1' d='M136.86,100.92l.64-4.65s.87-7.3-1.58-10.49c-2-2.57-8.15-7.39-10.65-7.45H90.15a11.83,11.83,0,0,0-8.67,4'/>      <path class='anx-icon-smart-watch-cls1' d='M69.37,153.68s3.32,8.27,11.35,9.26l30.22,3.49,9.2.76s8.51-2.21,10-15.08l5.18-39.31'/>      <ellipse class='anx-icon-smart-watch-cls1' cx='132.84' cy='106.11' rx='5.53' ry='7.51'/>    </g>    <circle class='anx-icon-smart-watch-cls2' cx='129' cy='129' r='125'/>    <path class='anx-icon-smart-watch-cls3' d='M93.43,78.05c4-4,20.74-13.85,33-15.45,14.06-1.85,30.41-1.18,41.42,6.23,14.12,9.5,20.53,22.42,18.95,56.13-1.78,38.3-6.27,45.65-12.42,55.23s-11.19,13.75-21.76,17.61c-11.27,4.11-31.54,2.83-41.31-2.1S84.71,176.42,79.56,159'/>    <path class='anx-icon-smart-watch-cls3' d='M132.74,82.64c.2-5.44,1.55-11.53,11.26-14.23,14.53-4,40.57,23.92,42.92,52.27'/>    <path class='anx-icon-smart-watch-cls3' d='M120.14,167.19c-.14,4.06,2.91,16.61,8.43,20.33,9.77,6.57,22.08,3.72,32.13-3.19C170,178,178.87,173.13,185,147.7'/>    <path class='anx-icon-smart-watch-cls3' d='M135.34,74.92c3.62,1.39,12.56,12.35,15.14,18,3.73,8.23,3.66,16.71,2.63,36.06s-1.72,27.83-8.43,39.91-11.81,14.19-17.49,17.32'/>  </g></svg>");
var AnxIconSmarthome = make_icon_makeIcon("Smarthome", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-smarthome-cls1, .anx-icon-smarthome-cls2, .anx-icon-smarthome-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-smarthome-cls1, .anx-icon-smarthome-cls3 {        stroke-miterlimit: 10;      }      .anx-icon-smarthome-cls2, .anx-icon-smarthome-cls3 {        stroke-linecap: round;      }      .anx-icon-smarthome-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <path class='anx-icon-smarthome-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <g>      <polyline class='anx-icon-smarthome-cls2' points='69.8 114.32 43.31 114.32 129 38.14 214.69 114.32 188.21 114.32'/>      <path class='anx-icon-smarthome-cls1' d='M188.21,197.18H69.79V112.72L129,62l59.21,50.68Z'/>    </g>  </g>  <g>    <path class='anx-icon-smarthome-cls2' d='M115.57,119a27.08,27.08,0,1,0,26.86,0'/>    <line class='anx-icon-smarthome-cls3' x1='129' y1='113.96' x2='129' y2='142'/>  </g></svg>");
var AnxIconSoftwareentwicklungCode = make_icon_makeIcon("SoftwareentwicklungCode", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-softwareentwicklung-code-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-softwareentwicklung-code-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <polyline class='anx-icon-softwareentwicklung-code-cls1' points='96.97 167.15 70.54 129 96.97 90.85'/>    <line class='anx-icon-softwareentwicklung-code-cls1' x1='112.44' y1='189.33' x2='145.31' y2='68.67'/>    <polyline class='anx-icon-softwareentwicklung-code-cls1' points='161.03 167.15 187.46 129 161.03 90.85'/>  </g></svg>");
var AnxIconSpieleUndSpass = make_icon_makeIcon("SpieleUndSpass", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-spiele-und-spass-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-spiele-und-spass-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-spiele-und-spass-cls1' d='M129.08,98.93c12,0,24.1-.17,36.14,0a34.84,34.84,0,0,1,33.59,28,57.33,57.33,0,0,1,.82,10.81c.09,12.26.06,24.52,0,36.77a26,26,0,0,1-2.81,12.17c-3.09,5.88-8,8.33-14.67,7.86-9.51-.67-16.39-5.38-21.33-13.24-2.23-3.56-4.3-7.22-6.39-10.87a1.87,1.87,0,0,0-1.87-1.07q-23.43,0-46.87,0a2.32,2.32,0,0,0-2.23,1.31c-3,4.87-5.71,10-9.2,14.48-5.82,7.49-13.9,10.25-23.21,9.17-4.62-.53-7.61-3.57-9.75-7.48a24.51,24.51,0,0,1-2.88-11.82c-.07-13.78-.2-27.57,0-41.35a34.81,34.81,0,0,1,28.14-34c4.38-.88,9-.76,13.49-.82,9.68-.11,19.36,0,29,0Z'/>    <path class='anx-icon-spiele-und-spass-cls2' d='M164.39,115a6.48,6.48,0,0,1,6.33,6.26,6.34,6.34,0,1,1-12.67,0A6.37,6.37,0,0,1,164.39,115Z'/>    <path class='anx-icon-spiele-und-spass-cls2' d='M151.53,127.87a6.52,6.52,0,0,1,6.3,6.3,6.34,6.34,0,1,1-12.67-.1A6.38,6.38,0,0,1,151.53,127.87Z'/>    <path class='anx-icon-spiele-und-spass-cls2' d='M177.19,140.5a6.52,6.52,0,0,1-6.24-6.35,6.32,6.32,0,0,1,12.64-.06A6.53,6.53,0,0,1,177.19,140.5Z'/>    <path class='anx-icon-spiele-und-spass-cls2' d='M164.54,140.76a6.32,6.32,0,1,1-6.48,6.09A6.49,6.49,0,0,1,164.54,140.76Z'/>    <path class='anx-icon-spiele-und-spass-cls1' d='M129.08,98.89s-2.48-22.45,23.08-22.45,22.32-23.68,22.32-23.68'/>    <line class='anx-icon-spiele-und-spass-cls1' x1='93.68' y1='117.64' x2='93.68' y2='150.74'/>    <line class='anx-icon-spiele-und-spass-cls1' x1='110.24' y1='134.34' x2='77.13' y2='134.34'/>    <circle class='anx-icon-spiele-und-spass-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSprechblasen = make_icon_makeIcon("Sprechblasen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-sprechblasen-cls1, .anx-icon-sprechblasen-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-sprechblasen-cls1 {        stroke-width: 7.5px;      }      .anx-icon-sprechblasen-cls2 {        stroke-width: 6.75px;      }    </style>  </defs>    <g>    <circle class='anx-icon-sprechblasen-cls1' cx='129' cy='129' r='125'/>    <g>      <polygon class='anx-icon-sprechblasen-cls2' points='199.32 56.64 199.32 108.14 181.94 108.14 181.94 124.63 161.22 108.14 105.57 108.14 105.57 56.64 199.32 56.64'/>      <polygon class='anx-icon-sprechblasen-cls2' points='58.68 133.38 58.68 184.87 76.09 184.87 76.09 201.36 96.8 184.87 152.45 184.87 152.45 133.38 58.68 133.38'/>    </g>  </g></svg>");
var AnxIconStandortUnternehmenssitz = make_icon_makeIcon("StandortUnternehmenssitz", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-standort-unternehmenssitz-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-standort-unternehmenssitz-cls1' d='M128.91,148a29.32,29.32,0,1,0-29.33-29.27A29.36,29.36,0,0,0,128.91,148Zm0,52.47s56.52-41.17,56.52-79.94a56.44,56.44,0,1,0-112.88-.16C72.51,159.33,128.87,200.5,128.87,200.5Z'/>    <circle class='anx-icon-standort-unternehmenssitz-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconStartUp = make_icon_makeIcon("StartUp", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-start-up-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-start-up-cls1' d='M192.47,66a124.76,124.76,0,0,1,0,15.59,96.69,96.69,0,0,1-2.88,15.76c-5.58,21.12-14.52,33.21-32.14,45.6l-.24.16L149.43,176l-11.79-19.84A99.07,99.07,0,0,1,126.31,161a2.49,2.49,0,0,1-3.12-.72C115,152,106.67,143.79,98.47,135.46a3.4,3.4,0,0,1-1-2.78,72.12,72.12,0,0,1,4.12-10L82.81,109.35l32.34-7.71c9.15-13.33,17.32-20.31,33.13-27.87a74.93,74.93,0,0,1,27.39-7.59c.58,0,2.26-.16,3-.18C183.5,65.88,187.19,65.72,192.47,66Z'/>    <path class='anx-icon-start-up-cls1' d='M134.76,131.24a7.34,7.34,0,1,0-7.47-7.34A7.36,7.36,0,0,0,134.76,131.24Z'/>    <path class='anx-icon-start-up-cls1' d='M171.19,99.65A12.19,12.19,0,0,0,159.1,87.32a12.21,12.21,0,1,0-.18,24.42A12.09,12.09,0,0,0,171.19,99.65Z'/>    <path class='anx-icon-start-up-cls1' d='M107,165.11c-.06-.05-.17-.05-.38-.11L89,168.79l4.65-16.64-4.26-4.61c-16.8,7.68-26.7,26.41-23.12,43.76.28.07.6.19.92.24,16.94,2.13,30.94-3,41-17.09C112.5,168.45,112.33,170.42,107,165.11Z'/>    <circle class='anx-icon-start-up-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconStatistikAnalysen = make_icon_makeIcon("StatistikAnalysen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-statistik-analysen-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-statistik-analysen-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <g>      <g>        <polyline class='anx-icon-statistik-analysen-cls1' points='96.25 161.48 129.95 127.78 156.99 127.78 178.25 97.74'/>        <polygon class='anx-icon-statistik-analysen-cls2' points='190.35 113 193.79 75.77 159.82 91.4 190.35 113'/>      </g>      <polyline class='anx-icon-statistik-analysen-cls1' points='193.79 182.23 64.31 182.23 64.31 75.77 79.3 75.77'/>      <line class='anx-icon-statistik-analysen-cls1' x1='64.31' y1='99' x2='79.3' y2='99'/>      <line class='anx-icon-statistik-analysen-cls1' x1='64.31' y1='119.75' x2='79.3' y2='119.75'/>      <line class='anx-icon-statistik-analysen-cls1' x1='64.31' y1='161.48' x2='79.3' y2='161.48'/>      <line class='anx-icon-statistik-analysen-cls1' x1='64.21' y1='141.07' x2='79.2' y2='141.07'/>    </g>    <circle class='anx-icon-statistik-analysen-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconStern = make_icon_makeIcon("Stern", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-stern-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-stern-cls1' cx='129' cy='129' r='125'/>    <path class='anx-icon-stern-cls1' d='M132.07,62.35l18.65,37.79A3.41,3.41,0,0,0,153.3,102L195,108.07a3.42,3.42,0,0,1,1.9,5.84l-30.17,29.41a3.41,3.41,0,0,0-1,3l7.13,41.53a3.43,3.43,0,0,1-5,3.61l-37.3-19.61a3.38,3.38,0,0,0-3.18,0l-37.3,19.61a3.43,3.43,0,0,1-5-3.61l7.13-41.53a3.41,3.41,0,0,0-1-3L61.11,113.91a3.42,3.42,0,0,1,1.9-5.84L104.7,102a3.41,3.41,0,0,0,2.58-1.87l18.65-37.79A3.43,3.43,0,0,1,132.07,62.35Z'/>  </g></svg>");
var AnxIconStorageBackup = make_icon_makeIcon("StorageBackup", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-storage-backup-cls1, .anx-icon-storage-backup-cls2, .anx-icon-storage-backup-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-storage-backup-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-storage-backup-cls2, .anx-icon-storage-backup-cls3 {        stroke-linejoin: round;      }      .anx-icon-storage-backup-cls3 {        stroke-linecap: round;      }      .anx-icon-storage-backup-cls4 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-storage-backup-cls1' cx='129' cy='129' r='125'/>    <g>      <polygon class='anx-icon-storage-backup-cls2' points='172.92 79.86 85.61 79.86 54.39 134.96 203.61 134.96 172.92 79.86'/>      <rect class='anx-icon-storage-backup-cls2' x='54.39' y='134.96' width='149.22' height='35.45'/>      <line class='anx-icon-storage-backup-cls3' x1='73.07' y1='152.68' x2='173.43' y2='152.68'/>      <circle class='anx-icon-storage-backup-cls4' cx='187.49' cy='152.68' r='3.9'/>    </g>  </g></svg>");
var AnxIconStromEnergie = make_icon_makeIcon("StromEnergie", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-strom-energie-cls1, .anx-icon-strom-energie-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-strom-energie-cls1 {        stroke-linecap: round;        stroke-linejoin: round;      }      .anx-icon-strom-energie-cls2 {        stroke-miterlimit: 10;      }    </style>  </defs>    <g>    <polygon class='anx-icon-strom-energie-cls1' points='178.99 115.87 129 116.15 129 60.88 79.02 139.8 129 139.52 129 194.79 178.99 115.87'/>    <circle class='anx-icon-strom-energie-cls2' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSuchen = make_icon_makeIcon("Suchen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-suchen-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <circle class='anx-icon-suchen-cls1' cx='116.1' cy='119.26' r='44.61'/>      <line class='anx-icon-suchen-cls1' x1='150.64' y1='147.48' x2='186.51' y2='183.35'/>      <path class='anx-icon-suchen-cls1' d='M91.57,119.26A24.54,24.54,0,0,1,116.1,94.73'/>    </g>    <circle class='anx-icon-suchen-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconSupportMitarbeiter = make_icon_makeIcon("SupportMitarbeiter", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-support-mitarbeiter-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-support-mitarbeiter-cls1' d='M60,193.87V182.39a18.48,18.48,0,0,1,8-15.25,78.29,78.29,0,0,1,26.53-11.53c23.15-5.45,17.45-15.88,13.71-20.88-10.08-13.47-14.43-10.45-16.43-38.57C89.08,58,115.3,48.66,129,48.66s39.92,9.35,37.21,47.5c-2,28.12-8.62,25.1-16.43,38.57-3.13,5.4-9.44,15.43,13.71,20.88a78,78,0,0,1,26.79,11.71,18,18,0,0,1,7.7,14.76v11.79Z'/>    <path class='anx-icon-support-mitarbeiter-cls1' d='M139.91,117.4c20.88,0,26-16.79,26-16.79'/>    <path class='anx-icon-support-mitarbeiter-cls1' d='M135.5,117.4h-8.31'/>    <path class='anx-icon-support-mitarbeiter-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>  </g></svg>");
var AnxIconTasse = make_icon_makeIcon("Tasse", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-tasse-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-tasse-cls1' cx='129' cy='129' r='125'/>    <g>      <path class='anx-icon-tasse-cls1' d='M73,74.33s9.92,101,12,109c1.25,4.81,17.08,8.79,37.79,8.79s36.54-4,37.8-8.79c2.09-8,12-109,12-109'/>      <ellipse class='anx-icon-tasse-cls1' cx='122.84' cy='74.33' rx='49.81' ry='8.44'/>      <g>        <path class='anx-icon-tasse-cls1' d='M171.83,82.62a20.69,20.69,0,0,1,21,2.73c7.4,5.73,9.77,15.85,7.05,30.08-6.79,35.42-35.38,47.53-36.53,48'/>        <path class='anx-icon-tasse-cls1' d='M165.15,146.59c.77-.3,15.65-6.08,20.41-32.29,1.14-6.27,1.4-13.76-3.06-17.43-3.94-3.24-10.89-1-12.35.83'/>      </g>    </g>  </g></svg>");
var AnxIconTeam = make_icon_makeIcon("Team", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-team-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-team-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <g>      <path class='anx-icon-team-cls1' d='M62.09,172.93H33s0-3.7.14-5.81c.26-4.57,3.34-9.35,5.81-11.78s7.16-4.88,13.07-6.27c11.24-2.65,8.18-7.52,6.66-10.14-3.79-6.54-7-5.07-8-18.72C49.4,101.69,62.12,97.15,68.78,97.15s19.37,4.54,18.06,23.06c-1,13.65-4.19,12.18-8,18.72'/>      <path class='anx-icon-team-cls1' d='M185.81,181.67V169.21a14.78,14.78,0,0,0-6.34-12.15,64.26,64.26,0,0,0-22.06-9.65c-19.07-4.48-13.87-12.74-11.29-17.19,6.43-11.1,11.89-8.61,13.53-31.77C161.88,67,140.29,59.32,129,59.32S96.12,67,98.35,98.45c1.64,23.16,5.23,20.67,13.53,31.77,3.08,4.12,7.78,12.71-11.29,17.19a64.76,64.76,0,0,0-21.85,9.5,15.22,15.22,0,0,0-6.55,12.56v12.2Z'/>      <path class='anx-icon-team-cls1' d='M195.91,172.93H225s0-3.7-.14-5.81c-.26-4.57-3.34-9.35-5.81-11.78s-7.16-4.88-13.07-6.27c-11.24-2.65-8.18-7.52-6.66-10.14,3.79-6.54,7-5.07,8-18.72,1.31-18.52-11.41-23.06-18.07-23.06s-19.37,4.54-18.06,23.06c1,13.65,4.19,12.18,8,18.72'/>    </g>  </g></svg>");
var AnxIconTechnischerSupport = make_icon_makeIcon("TechnischerSupport", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-technischer-support-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-technischer-support-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-technischer-support-cls1' d='M134,101.41l25.88-26.17a19.29,19.29,0,1,1,27.65,26.9l0,0-26.21,26.49'/>    <line class='anx-icon-technischer-support-cls1' x1='148.23' y1='114.29' x2='178.96' y2='83.5'/>    <polyline class='anx-icon-technischer-support-cls1' points='106.6 147.03 87.74 165.72 70.27 171.1 67.01 191.34 69.95 194.28 71.19 195.47 74.13 198.41 95.21 194.21 99.75 177.68 118.61 158.99'/>    <path class='anx-icon-technischer-support-cls1' d='M78.48,70.49,96.84,88.85a4.39,4.39,0,0,1,0,6.2l-5.71,5.71a4.39,4.39,0,0,1-6.2,0L66.6,82.43A30,30,0,0,0,71.14,117a29.54,29.54,0,0,0,22.31,9.19,17.72,17.72,0,0,1,13,5.25l63,63a15,15,0,0,0,21.14-21.15l-63-63a17.38,17.38,0,0,1-5.27-12.76,29.65,29.65,0,0,0-43.82-27.1Z'/>    <circle class='anx-icon-technischer-support-cls2' cx='180.88' cy='184.8' r='5.55'/>    <path class='anx-icon-technischer-support-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>  </g></svg>");
var AnxIconTextdokument = make_icon_makeIcon("Textdokument", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-textdokument-cls1, .anx-icon-textdokument-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-textdokument-cls1 {        stroke-width: 7.5px;      }      .anx-icon-textdokument-cls2 {        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-textdokument-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <polyline class='anx-icon-textdokument-cls1' points='117.98 58.58 117.98 95.3 74.97 95.3'/>        <polygon class='anx-icon-textdokument-cls2' points='183.03 199.42 74.97 199.42 74.97 95.3 117.98 58.58 183.03 58.58 183.03 199.42'/>      </g>      <line class='anx-icon-textdokument-cls2' x1='89.73' y1='130.01' x2='168.96' y2='130.01'/>      <line class='anx-icon-textdokument-cls2' x1='89.73' y1='113.53' x2='168.96' y2='113.53'/>      <line class='anx-icon-textdokument-cls2' x1='89.73' y1='146.5' x2='160.84' y2='146.5'/>      <line class='anx-icon-textdokument-cls2' x1='89.73' y1='162.98' x2='168.96' y2='162.98'/>      <line class='anx-icon-textdokument-cls2' x1='89.73' y1='179.47' x2='136.49' y2='179.47'/>    </g>  </g></svg>");
var AnxIconTextdokumentFragezeichen = make_icon_makeIcon("TextdokumentFragezeichen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-textdokument-fragezeichen-cls1, .anx-icon-textdokument-fragezeichen-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-textdokument-fragezeichen-cls1 {        stroke-width: 7.5px;      }      .anx-icon-textdokument-fragezeichen-cls2 {        stroke-width: 7.5px;      }      .anx-icon-textdokument-fragezeichen-cls3 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-textdokument-fragezeichen-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <polyline class='anx-icon-textdokument-fragezeichen-cls1' points='117.98 58.58 117.98 95.3 74.97 95.3'/>        <polyline class='anx-icon-textdokument-fragezeichen-cls2' points='183.03 186.5 183.03 199.42 74.97 199.42 74.97 95.3 117.98 58.58 183.03 58.58 183.03 118.16'/>      </g>      <line class='anx-icon-textdokument-fragezeichen-cls2' x1='89.73' y1='130.01' x2='147.54' y2='130.01'/>      <line class='anx-icon-textdokument-fragezeichen-cls2' x1='89.73' y1='113.53' x2='154.9' y2='113.53'/>      <line class='anx-icon-textdokument-fragezeichen-cls2' x1='89.73' y1='146.5' x2='140.72' y2='146.5'/>      <line class='anx-icon-textdokument-fragezeichen-cls2' x1='89.73' y1='162.98' x2='142.93' y2='162.98'/>      <line class='anx-icon-textdokument-fragezeichen-cls2' x1='89.73' y1='179.47' x2='136.49' y2='179.47'/>    </g>    <g>      <g>        <path class='anx-icon-textdokument-fragezeichen-cls2' d='M168.32,139.53c3.47-2.84,10-5.83,13.82-.69a8.14,8.14,0,0,1-1.79,11.56c-3.3,2.5-5.51,4.84-5.34,10.08'/>        <circle class='anx-icon-textdokument-fragezeichen-cls3' cx='174.79' cy='168.08' r='4.56'/>      </g>      <circle class='anx-icon-textdokument-fragezeichen-cls2' cx='175.67' cy='152.33' r='34.95'/>    </g>  </g></svg>");
var AnxIconTextdokumentRufzeichen = make_icon_makeIcon("TextdokumentRufzeichen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-textdokument-rufzeichen-cls1, .anx-icon-textdokument-rufzeichen-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-textdokument-rufzeichen-cls1 {        stroke-width: 7.5px;      }      .anx-icon-textdokument-rufzeichen-cls2 {        stroke-width: 7.5px;      }      .anx-icon-textdokument-rufzeichen-cls3 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-textdokument-rufzeichen-cls1' cx='129' cy='129' r='125'/>    <g>      <g>        <polyline class='anx-icon-textdokument-rufzeichen-cls1' points='117.98 58.58 117.98 95.3 74.97 95.3'/>        <polyline class='anx-icon-textdokument-rufzeichen-cls2' points='183.03 186.5 183.03 199.42 74.97 199.42 74.97 95.3 117.98 58.58 183.03 58.58 183.03 118.16'/>      </g>      <line class='anx-icon-textdokument-rufzeichen-cls2' x1='89.73' y1='130.01' x2='147.54' y2='130.01'/>      <line class='anx-icon-textdokument-rufzeichen-cls2' x1='89.73' y1='113.53' x2='154.9' y2='113.53'/>      <line class='anx-icon-textdokument-rufzeichen-cls2' x1='89.73' y1='146.5' x2='140.72' y2='146.5'/>      <line class='anx-icon-textdokument-rufzeichen-cls2' x1='89.73' y1='162.98' x2='142.93' y2='162.98'/>      <line class='anx-icon-textdokument-rufzeichen-cls2' x1='89.73' y1='179.47' x2='136.49' y2='179.47'/>    </g>    <g>      <g>        <circle class='anx-icon-textdokument-rufzeichen-cls3' cx='175.67' cy='168.08' r='4.56'/>        <line class='anx-icon-textdokument-rufzeichen-cls2' x1='175.67' y1='160.48' x2='175.67' y2='132.56'/>      </g>      <circle class='anx-icon-textdokument-rufzeichen-cls2' cx='175.67' cy='152.33' r='34.95'/>    </g>  </g></svg>");
var AnxIconUpload = make_icon_makeIcon("Upload", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-upload-cls1, .anx-icon-upload-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-upload-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-upload-cls2 {        stroke-linejoin: round;      }    </style>  </defs>    <g>    <path class='anx-icon-upload-cls1' d='M156.83,163.46h17a28.42,28.42,0,0,0,8-55.69,36.84,36.84,0,0,0-67.67-16.55,26.89,26.89,0,0,0-34.82,18.51,27,27,0,0,0,3.39,53.73h17.71'/>    <polygon class='anx-icon-upload-cls2' points='118.15 147.36 118.15 182.26 139.85 182.26 139.85 147.36 155.06 147.36 129 108.01 102.94 147.36 118.15 147.36'/>    <circle class='anx-icon-upload-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconUserProfil = make_icon_makeIcon("UserProfil", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-user-profil-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-user-profil-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <circle class='anx-icon-user-profil-cls1' cx='129' cy='129' r='125'/>    <rect class='anx-icon-user-profil-cls1' x='68.77' y='73.16' width='118.32' height='130.05' rx='9.69' ry='9.69'/>    <path class='anx-icon-user-profil-cls1' d='M131.31,90.46c-11-.61-16-22.26-16.89-29.26s-1.14-29,14.58-28.74,13.74,13.3,14,19.32c.39,8.4-5.91,20-5.91,20'/>    <path class='anx-icon-user-profil-cls1' d='M129,176.11h27.57v-4.72a7.19,7.19,0,0,0-3.07-5.9,31.45,31.45,0,0,0-10.71-4.68c-9.25-2.18-6.73-6.18-5.48-8.34,3.12-5.39,5.77-4.18,6.57-15.42,1.08-15.26-9.4-19-14.88-19s-16,3.73-14.88,19c.8,11.24,2.54,10,6.57,15.42,1.5,2,3.77,6.16-5.48,8.34a31.38,31.38,0,0,0-10.6,4.61,7.37,7.37,0,0,0-3.18,6.1v4.59Z'/>    <circle class='anx-icon-user-profil-cls2' cx='129' cy='93.92' r='10.14'/>  </g></svg>");
var AnxIconVerbundeneServerBlade = make_icon_makeIcon("VerbundeneServerBlade", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-verbundene-server-blade-cls1, .anx-icon-verbundene-server-blade-cls2, .anx-icon-verbundene-server-blade-cls4 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-verbundene-server-blade-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-verbundene-server-blade-cls2, .anx-icon-verbundene-server-blade-cls4 {        stroke-linejoin: round;      }      .anx-icon-verbundene-server-blade-cls3 {        fill: var(--anx-icons-color);      }      .anx-icon-verbundene-server-blade-cls4 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-verbundene-server-blade-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <g>      <path class='anx-icon-verbundene-server-blade-cls2' d='M206.78,118.55H51.22L83.76,68.84h91Z'/>      <path class='anx-icon-verbundene-server-blade-cls2' d='M206.78,155.51H51.22v-37H206.78Z'/>      <path class='anx-icon-verbundene-server-blade-cls1' d='M76.11,189.16h26.34'/>      <path class='anx-icon-verbundene-server-blade-cls1' d='M155.55,189.16h26.34'/>      <path class='anx-icon-verbundene-server-blade-cls1' d='M112.52,189.16h33'/>      <path class='anx-icon-verbundene-server-blade-cls1' d='M128.93,169.44v19.72'/>      <path class='anx-icon-verbundene-server-blade-cls3' d='M188.51,130.41a6.62,6.62,0,1,1-6.62,6.62A6.62,6.62,0,0,1,188.51,130.41Z'/>      <path class='anx-icon-verbundene-server-blade-cls4' d='M62.94,144.34l14.62-14.62'/>      <path class='anx-icon-verbundene-server-blade-cls4' d='M80.73,144.34l14.62-14.62'/>      <path class='anx-icon-verbundene-server-blade-cls4' d='M98.73,144.34l14.62-14.62'/>      <path class='anx-icon-verbundene-server-blade-cls4' d='M116.53,144.34l14.61-14.62'/>    </g>  </g></svg>");
var AnxIconVerlautbarungWichtigeNewsPressemitteilung = make_icon_makeIcon("VerlautbarungWichtigeNewsPressemitteilung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-verlautbarung-wichtige-news-pressemitteilung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-verlautbarung-wichtige-news-pressemitteilung-cls1' d='M163.06,121.72a15.29,15.29,0,0,0-13-15.09V85.16a4.66,4.66,0,0,0-7.31-3.83l-29,20.11H75.78c-10.66,0-20.17,7.79-21.18,18.4a20.4,20.4,0,0,0,20.3,22.39h38.82l29.06,19.93a4.66,4.66,0,0,0,7.29-3.84V136.8A15.28,15.28,0,0,0,163.06,121.72Z'/>      <polyline class='anx-icon-verlautbarung-wichtige-news-pressemitteilung-cls1' points='106.19 157.56 122.29 188.28 97.68 188.28 81.58 157.56'/>      <path class='anx-icon-verlautbarung-wichtige-news-pressemitteilung-cls1' d='M170.92,102.83a20.94,20.94,0,0,1,2.12,36.6'/>      <path class='anx-icon-verlautbarung-wichtige-news-pressemitteilung-cls1' d='M179.9,159.29a41.7,41.7,0,0,0,0-75.14'/>    </g>    <circle class='anx-icon-verlautbarung-wichtige-news-pressemitteilung-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconVerpflegungMittagspauseEssen = make_icon_makeIcon("VerpflegungMittagspauseEssen", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-verpflegung-mittagspause-essen-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <ellipse class='anx-icon-verpflegung-mittagspause-essen-cls1' cx='82.13' cy='97.97' rx='24.12' ry='31.42' transform='translate(-45.22 86.77) rotate(-45)'/>      <line class='anx-icon-verpflegung-mittagspause-essen-cls1' x1='104.15' y1='119.06' x2='179.94' y2='194.85'/>      <line class='anx-icon-verpflegung-mittagspause-essen-cls1' x1='154.81' y1='119.06' x2='79.02' y2='194.85'/>      <polyline class='anx-icon-verpflegung-mittagspause-essen-cls1' points='203.88 95.55 166.48 132.95 140.89 107.36 178.29 69.96'/>      <line class='anx-icon-verpflegung-mittagspause-essen-cls1' x1='191.09' y1='82.76' x2='153.69' y2='120.16'/>    </g>    <circle class='anx-icon-verpflegung-mittagspause-essen-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconVerschluesselung = make_icon_makeIcon("Verschluesselung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-verschluesselung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-verschluesselung-cls1' d='M191.74,187.33H66.26V106.06H191.74Z'/>    <path class='anx-icon-verschluesselung-cls1' d='M156.75,106.06h-55.5V88.23a27.75,27.75,0,1,1,55.5,0Z'/>    <path class='anx-icon-verschluesselung-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-verschluesselung-cls1' d='M142.52,106.06h-27V88.2a13.52,13.52,0,0,1,27,0Z'/>    <path class='anx-icon-verschluesselung-cls1' d='M136.48,147.1l3.87,16.36h-22.7l3.87-16.36a11.72,11.72,0,1,1,15,0Z'/>  </g></svg>");
var AnxIconVideo = make_icon_makeIcon("Video", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-video-cls1, .anx-icon-video-cls2, .anx-icon-video-cls3 {        fill: none;        stroke: var(--anx-icons-color);      }      .anx-icon-video-cls1, .anx-icon-video-cls2 {        stroke-miterlimit: 10;      }      .anx-icon-video-cls1, .anx-icon-video-cls3 {        stroke-width: 7.5px;      }      .anx-icon-video-cls2 {        stroke-width: 7.5px;      }      .anx-icon-video-cls3 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <rect class='anx-icon-video-cls1' x='52.04' y='76.18' width='153.67' height='105.65' rx='7.84' ry='7.84'/>    <circle class='anx-icon-video-cls2' cx='129' cy='129' r='125'/>    <polygon class='anx-icon-video-cls3' points='113.16 106.59 113.16 151.41 150.51 129 113.16 106.59'/>  </g></svg>");
var AnxIconVierenBugs = make_icon_makeIcon("VierenBugs", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-vieren-bugs-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-vieren-bugs-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-vieren-bugs-cls1' d='M149.1,82.65v4H108.61v-4A20.25,20.25,0,0,1,128.85,62.4h0A20.25,20.25,0,0,1,149.1,82.65Z'/>    <path class='anx-icon-vieren-bugs-cls1' d='M168.3,102.66l23.79-23.79'/>    <path class='anx-icon-vieren-bugs-cls1' d='M191.55,198.46l-27.93-27.94'/>    <path class='anx-icon-vieren-bugs-cls1' d='M168.3,136.79h23.79'/>    <path class='anx-icon-vieren-bugs-cls1' d='M128.85,191.32V125.58'/>    <path class='anx-icon-vieren-bugs-cls1' d='M89.41,102.66l-23.5-23.5'/>    <path class='anx-icon-vieren-bugs-cls1' d='M94.09,170.52l-27.4,27.4'/>    <path class='anx-icon-vieren-bugs-cls1' d='M128.85,191.32h0a39.44,39.44,0,0,1-39.44-39.44V102.66H168.3v49.22A39.44,39.44,0,0,1,128.85,191.32Z'/>    <line class='anx-icon-vieren-bugs-cls1' x1='89.41' y1='136.79' x2='65.91' y2='136.79'/>    <path class='anx-icon-vieren-bugs-cls1' d='M143.18,68.35l10.3-10.3'/>    <path class='anx-icon-vieren-bugs-cls1' d='M114.52,68.35,104,57.8'/>  </g></svg>");
var AnxIconVirtualisierung = make_icon_makeIcon("Virtualisierung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-virtualisierung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <rect class='anx-icon-virtualisierung-cls1' x='87.09' y='69.25' width='82.29' height='79.91' rx='9.37' ry='9.37'/>      <rect class='anx-icon-virtualisierung-cls1' x='108.82' y='88.87' width='82.29' height='79.91' rx='9.37' ry='9.37'/>      <rect class='anx-icon-virtualisierung-cls1' x='66.88' y='108.84' width='82.29' height='79.91' rx='9.37' ry='9.37'/>    </g>    <circle class='anx-icon-virtualisierung-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconVollbildVerschieben = make_icon_makeIcon("VollbildVerschieben", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-vollbild-verschieben-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-vollbild-verschieben-cls1' cx='129' cy='129' r='125'/>    <line class='anx-icon-vollbild-verschieben-cls1' x1='129' y1='54.42' x2='129' y2='203.58'/>    <line class='anx-icon-vollbild-verschieben-cls1' x1='54.42' y1='129' x2='203.58' y2='129'/>    <polyline class='anx-icon-vollbild-verschieben-cls1' points='105.59 77.83 129 54.42 152.41 77.83'/>    <polyline class='anx-icon-vollbild-verschieben-cls1' points='152.41 180.17 129 203.58 105.59 180.17'/>    <polyline class='anx-icon-vollbild-verschieben-cls1' points='77.83 152.41 54.42 129 77.83 105.59'/>    <polyline class='anx-icon-vollbild-verschieben-cls1' points='180.17 105.59 203.58 129 180.17 152.41'/>  </g></svg>");
var AnxIconVr = make_icon_makeIcon("Vr", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-vr-cls1, .anx-icon-vr-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-vr-cls1 {        stroke-miterlimit: 10;      }      .anx-icon-vr-cls2 {        stroke-linecap: round;        stroke-linejoin: round;      }    </style>  </defs>    <g>    <path class='anx-icon-vr-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <g>      <path class='anx-icon-vr-cls2' d='M198.28,171.43H142l-13-13.9-11.81,13.9H59.72a9,9,0,0,1-8.95-9V101.65a9,9,0,0,1,8.95-9H198.28a9,9,0,0,1,8.95,9v60.82A9,9,0,0,1,198.28,171.43Z'/>      <path class='anx-icon-vr-cls2' d='M175.51,106.74h9c4.14,0,7.52,2.91,7.52,6.46v6.63'/>      <rect class='anx-icon-vr-cls2' x='37.45' y='109.36' width='13.32' height='50.37'/>      <rect class='anx-icon-vr-cls2' x='207.23' y='109.36' width='13.32' height='50.37'/>    </g>  </g></svg>");
var AnxIconWachstumUmsatz = make_icon_makeIcon("WachstumUmsatz", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-wachstum-umsatz-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-wachstum-umsatz-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <path class='anx-icon-wachstum-umsatz-cls1' d='M96.43,194.19h-32V162.75h32Z'/>    <path class='anx-icon-wachstum-umsatz-cls1' d='M145,194.19H113V147h32Z'/>    <path class='anx-icon-wachstum-umsatz-cls1' d='M193.55,194.19h-32V129.07h32Z'/>    <g>      <polyline class='anx-icon-wachstum-umsatz-cls1' points='168.46 82.83 126.43 124.86 111.83 110.26 75.14 146.96'/>      <polygon class='anx-icon-wachstum-umsatz-cls2' points='151.37 73.48 187.49 63.81 177.81 99.92 151.37 73.48'/>    </g>    <circle class='anx-icon-wachstum-umsatz-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconWarningSmall = make_icon_makeIcon("WarningSmall", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 16'>    <defs>        <style>        .anx-icon-warning-small-cls1, .anx-icon-warning-small-cls2 {            fill:none;            stroke:#969696;            stroke-miterlimit:10;            stroke-width:1.5px;        }        .anx-icon-warning-small-cls1 {            stroke-linecap:square;        }                .anx-icon-warning-small-cls2 {            stroke-linecap:round;        }        .anx-icon-warning-small-cls3 {            fill:#969696;        }        </style>    </defs>        <path class='anx-icon-warning-small-cls1' d='M8.42.84.81,15.06a.09.09,0,0,0,.08.13H16.11a.09.09,0,0,0,.08-.13L8.58.84A.09.09,0,0,0,8.42.84Z'/>    <line class='anx-icon-warning-small-cls2' x1='8.5' y1='6.25' x2='8.5' y2='10.3'/>    <circle class='anx-icon-warning-small-cls3' cx='8.5' cy='12.5' r='0.87'/></svg>");
var AnxIconWarning = make_icon_makeIcon("Warning", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-warning-cls1, .anx-icon-warning-cls2, .anx-icon-warning-cls3 {        fill: none;        stroke: var(--anx-icons-color);        stroke-width: 7.5px;      }      .anx-icon-warning-cls1, .anx-icon-warning-cls3 {        stroke-miterlimit: 10;      }      .anx-icon-warning-cls2, .anx-icon-warning-cls3 {        stroke-linecap: round;      }      .anx-icon-warning-cls2 {        stroke-linejoin: round;      }      .anx-icon-warning-cls4 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <circle class='anx-icon-warning-cls1' cx='129' cy='129' r='125'/>  <g>    <polygon class='anx-icon-warning-cls2' points='129 49.4 51.89 180.32 206.11 180.32 129 49.4'/>    <g>      <line class='anx-icon-warning-cls3' x1='129' y1='95.84' x2='129' y2='140.33'/>      <circle class='anx-icon-warning-cls4' cx='129' cy='157.48' r='6.24'/>    </g>  </g></svg>");
var AnxIconWebdesign = make_icon_makeIcon("Webdesign", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-webdesign-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-webdesign-cls1' d='M192.4,197.16H65.6A11.66,11.66,0,0,1,53.94,185.5v-6.67h54.55l5.53,3.49h29.67l5.82-3.49h54.55v6.67A11.66,11.66,0,0,1,192.4,197.16Z'/>    <path class='anx-icon-webdesign-cls1' d='M150.05,59.92l12.57-12.57,18.79,18.79L168.84,78.72Z'/>    <path class='anx-icon-webdesign-cls1' d='M160.8,86.76l-39.48,39.48-24.23,5.44,5.44-24.23L142,68Z'/>    <path class='anx-icon-webdesign-cls1' d='M144.15,84.06l-30.42,30.43'/>    <path class='anx-icon-webdesign-cls1' d='M170.9,89.52h17.31a6.53,6.53,0,0,1,6.54,6.53v62a6.54,6.54,0,0,1-6.54,6.54H68.62A6.53,6.53,0,0,1,62.09,158v-62a6.53,6.53,0,0,1,6.53-6.53H100.5'/>    <circle class='anx-icon-webdesign-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconWebentwicklung = make_icon_makeIcon("Webentwicklung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-webentwicklung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <rect class='anx-icon-webentwicklung-cls1' x='60.39' y='73.81' width='136.03' height='76.97' rx='6.75' ry='6.75'/>      <path class='anx-icon-webentwicklung-cls1' d='M194,184.19H64a12,12,0,0,1-12-12v-6.84H108l5.67,3.58h30.43l6-3.58H206v6.84A12,12,0,0,1,194,184.19Z'/>    </g>    <circle class='anx-icon-webentwicklung-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconWeiterbildung = make_icon_makeIcon("Weiterbildung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-weiterbildung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-weiterbildung-cls2 {        fill: var(--anx-icons-color);      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-weiterbildung-cls1' d='M49.11,98.65l68-25.31a36.32,36.32,0,0,1,25.63.09l66.22,25.2a2.94,2.94,0,0,1,0,5.49L142,129.84a36.33,36.33,0,0,1-26.09,0L49.08,104.15A2.94,2.94,0,0,1,49.11,98.65Z'/>      <polyline class='anx-icon-weiterbildung-cls1' points='62.95 109.48 62.95 152.6 54.35 174.44 73.65 182.74 70.64 170.29'/>    </g>    <path class='anx-icon-weiterbildung-cls1' d='M84.73,135.77s-7.18,73.76,43.2,73.76,45.12-73.76,45.12-73.76l-37.63,12A24.68,24.68,0,0,1,120,147.7Z'/>    <circle class='anx-icon-weiterbildung-cls2' cx='143.2' cy='163.32' r='7.47'/>    <path class='anx-icon-weiterbildung-cls1' d='M144.23,182.74c0,5.67-7.25,10.27-16.18,10.27s-16.18-4.6-16.18-10.27'/>    <circle class='anx-icon-weiterbildung-cls2' cx='112.94' cy='163.32' r='7.47'/>    <circle class='anx-icon-weiterbildung-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc = make_icon_makeIcon("WeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1, .anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;      }      .anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1 {        stroke-width: 7.5px;      }      .anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls2 {        stroke-width: 5.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1' cx='129.13' cy='129' r='47.87'/>    <ellipse class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls2' cx='129.13' cy='129' rx='11.51' ry='47.87'/>    <ellipse class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls2' cx='129.13' cy='129' rx='31.07' ry='47.87'/>    <g>      <path class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1' d='M182.16,106c13.88-20.53,19.65-37.32,13.4-43.57s-23-.48-43.57,13.4'/>      <path class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1' d='M75.84,152C62,172.52,56.19,189.31,62.44,195.56s23,.48,43.57-13.4'/>    </g>    <g>      <path class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1' d='M106,75.84C85.48,62,68.69,56.19,62.44,62.44S62,85.48,75.84,106'/>      <path class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1' d='M152,182.16c20.53,13.88,37.32,19.65,43.57,13.4s.48-23-13.4-43.57'/>    </g>    <ellipse class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls2' cx='129.13' cy='129' rx='47.87' ry='14.67'/>    <circle class='anx-icon-weltweite-infrastruktur-weltweite-vernetzung-global-wwc-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconWhiteLabel = make_icon_makeIcon("WhiteLabel", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-white-label-cls1, .anx-icon-white-label-cls2 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }      .anx-icon-white-label-cls2 {        stroke-linecap: round;      }    </style>  </defs>    <g>    <path class='anx-icon-white-label-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-white-label-cls1' d='M172.85,153l-81,41.67a7.39,7.39,0,0,1-10-3.2L57.14,143.34a7.39,7.39,0,0,1,3.2-10l81.07-41.69a16.42,16.42,0,0,1,12.43-1.07L184,100.08a10.29,10.29,0,0,1,6.71,13L181,143.37A16.39,16.39,0,0,1,172.85,153Z'/>    <path class='anx-icon-white-label-cls1' d='M150.25,112.24a11.94,11.94,0,1,1-5.16,16.07A11.94,11.94,0,0,1,150.25,112.24Z'/>    <path class='anx-icon-white-label-cls2' d='M159.6,118.16s10.94-64.93,34.81-49.31c13.69,9,3.79,22-8.09,31.2'/>  </g></svg>");
var AnxIconWidgets = make_icon_makeIcon("Widgets", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-widgets-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <circle class='anx-icon-widgets-cls1' cx='129' cy='129' r='125'/>    <g>      <rect class='anx-icon-widgets-cls1' x='77.78' y='80.27' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='117.63' y='80.27' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='156.5' y='80.27' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='77.78' y='117.28' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='117.63' y='117.28' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='156.5' y='117.28' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='77.78' y='154.29' width='23.44' height='23.44'/>      <rect class='anx-icon-widgets-cls1' x='117.63' y='154.29' width='23.44' height='23.44'/>      <line class='anx-icon-widgets-cls1' x1='168.5' y1='154.29' x2='168.5' y2='177.73'/>      <line class='anx-icon-widgets-cls1' x1='156.78' y1='166.01' x2='180.22' y2='166.01'/>    </g>  </g></svg>");
var AnxIconWindows = make_icon_makeIcon("Windows", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-windows-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-windows-cls1' d='M254,129A125,125,0,1,1,129,4,125,125,0,0,1,254,129Z'/>    <path class='anx-icon-windows-cls1' d='M120.68,184.48V136.26h67.64v57.8Zm-63.09-8.77V135.54h49.34v47.08Zm0-52.9V82.65l49.34-6.78v46.94Zm63.09-.46V73.82l67.64-9.88v58.41Z'/>  </g></svg>");
var AnxIconWlan = make_icon_makeIcon("Wlan", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-wlan-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <path class='anx-icon-wlan-cls1' d='M52.61,110.51c.88-.7,2-1.5,3-2.44a109.93,109.93,0,0,1,149.73.55'/>      <path class='anx-icon-wlan-cls1' d='M76.66,131.16c29.51-30.19,79.68-28.68,107.27.23'/>      <path class='anx-icon-wlan-cls1' d='M100.74,152.26c13.6-15.84,43.82-16.95,59.21.17'/>      <path class='anx-icon-wlan-cls1' d='M142,174.93a11.75,11.75,0,1,1-11.77-11.73A11.69,11.69,0,0,1,142,174.93Z'/>    </g>    <circle class='anx-icon-wlan-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconX = make_icon_makeIcon("X", "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><defs><style>.a{fill:none;stroke:var(--error-color);stroke-miterlimit:10;stroke-width:1.8px;}</style></defs><line class='a' x1='0.7' y1='0.7' x2='15.3' y2='15.3'/><line class='a' x1='15.3' y1='0.7' x2='0.7' y2='15.3'/></svg>");
var AnxIconZeitungMedienNews = make_icon_makeIcon("ZeitungMedienNews", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-zeitung-medien-news-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <path class='anx-icon-zeitung-medien-news-cls1' d='M183,193.76H84.71V75.38H203.09v98.3A20.08,20.08,0,0,1,183,193.76Z'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M54.91,177.28v-73a9.9,9.9,0,0,1,9.9-9.9h19.9v96H68.08A13.17,13.17,0,0,1,54.91,177.28Z'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M84.71,174H74.87A5.05,5.05,0,0,1,69.81,169V94.42h14.9Z'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M157.6,156.09H102.71V129H157.6Z'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M99.61,174h60.78'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M99.61,111.53h88.58'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M99.61,94.42h24.91'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M138.18,94.42h50'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M188.19,129H170.1'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M188.19,151.13H170.1'/>    <path class='anx-icon-zeitung-medien-news-cls1' d='M188.19,174H170.1'/>    <circle class='anx-icon-zeitung-medien-news-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconZertifikat = make_icon_makeIcon("Zertifikat", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-zertifikat-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <rect class='anx-icon-zertifikat-cls1' x='74.78' y='62.54' width='108.45' height='132.92'/>    <polygon class='anx-icon-zertifikat-cls1' points='129 136.67 135.07 148.97 148.65 150.95 138.83 160.53 141.15 174.05 129 167.66 116.86 174.05 119.17 160.53 109.35 150.95 122.93 148.97 129 136.67'/>    <line class='anx-icon-zertifikat-cls1' x1='97.55' y1='83.88' x2='160.45' y2='83.88'/>    <g>      <line class='anx-icon-zertifikat-cls1' x1='97.55' y1='99.38' x2='133.12' y2='99.38'/>      <line class='anx-icon-zertifikat-cls1' x1='140.83' y1='99.38' x2='160.45' y2='99.38'/>    </g>    <line class='anx-icon-zertifikat-cls1' x1='97.55' y1='114.12' x2='160.45' y2='114.12'/>    <circle class='anx-icon-zertifikat-cls1' cx='129' cy='129' r='125'/>  </g></svg>");
var AnxIconZielMarkierung = make_icon_makeIcon("ZielMarkierung", "<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 258 258'>  <defs>    <style>      .anx-icon-ziel-markierung-cls1 {        fill: none;        stroke: var(--anx-icons-color);        stroke-miterlimit: 10;        stroke-width: 7.5px;      }    </style>  </defs>    <g>    <g>      <line class='anx-icon-ziel-markierung-cls1' x1='82.3' y1='73.52' x2='82.3' y2='199.95'/>      <polygon class='anx-icon-ziel-markierung-cls1' points='184.53 139.56 98.51 139.56 98.51 76.34 184.53 76.34 162.76 107.95 184.53 139.56'/>    </g>    <circle class='anx-icon-ziel-markierung-cls1' cx='129' cy='129' r='125'/>  </g></svg>"); // --- END AUTO-GENERATED FILE ---

/***/ }),

/***/ "49ab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

__webpack_require__("159b");

__webpack_require__("b64b");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SerializationHelper = void 0; // @ts-nocheck

var StringUtils_1 = __webpack_require__("6cb7");

var SerializationHelper = /*#__PURE__*/function () {
  function SerializationHelper() {
    _classCallCheck(this, SerializationHelper);
  }

  _createClass(SerializationHelper, null, [{
    key: "toInstance",
    value: function toInstance(obj, json) {
      var jsonObj;

      if (typeof json === "string") {
        jsonObj = JSON.parse(json);
      } else {
        jsonObj = json;
      }

      Object.keys(jsonObj).forEach(function (k) {
        var camelized = StringUtils_1.StringUtils.snakeCaseToCamelCase(k);

        if (camelized !== k) {
          jsonObj[camelized] = jsonObj[k];
          delete jsonObj[k];
        }
      });

      if (typeof obj.constructor.fromJSON === "function") {
        obj.fromJSON(jsonObj);
      } else {
        for (var propName in jsonObj) {
          if (obj.constructor.prototype.hasOwnProperty.call(obj, propName)) {
            obj[propName] = jsonObj[propName];
          }
        }
      }

      return obj;
    }
  }, {
    key: "toInstanceArray",
    value: function toInstanceArray(Obj, json) {
      var _this = this;

      var instances = [];

      if (json.length >= 1) {
        json.forEach(function (jsonObject) {
          instances.push(_this.toInstance(new Obj(), jsonObject));
        });
      } else {
        instances.push(this.toInstance(new Obj(), json));
      }

      return instances;
    }
  }, {
    key: "toJson",
    value: function toJson(obj) {
      Object.keys(obj).forEach(function (key) {
        if (StringUtils_1.StringUtils.camelCaseToSnakeCase(key) !== key) {
          obj[StringUtils_1.StringUtils.camelCaseToSnakeCase(key)] = obj[key];
          delete obj[key];
        }
      });
      return obj;
    }
  }]);

  return SerializationHelper;
}();

exports.SerializationHelper = SerializationHelper;

/***/ }),

/***/ "4a4b":
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "4a5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxFooter/AnxFooter.vue?vue&type=template&id=3716aafa&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"anx-footer-container"},'div',_vm.attributes,false),[_c('div',{staticClass:"anx-footer",style:(_vm.cssProps)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('anx-hr-line',{attrs:{"color":"blue","margin-top":_vm.marginTop,"margin-bottom":"20px"}}),_c('div',{staticClass:"anx-footer-elements"},[_c('div',{staticClass:"anx-footer-desktop"},[_vm._t("icon",function(){return [(_vm.icon != null)?_c('anx-icon',{staticClass:"anx-footer-logo",attrs:{"alt":"anx-footer-logo","height":"40px","icon":_vm.icon}}):_vm._e()]})],2),_c('div',{staticClass:"anx-footer-right"},[_c('div',{staticClass:"anx-footer-text"},[_vm._t("default",function(){return [_c('div',{staticClass:"anx-footer-text copyright"},[(_vm.showCopyrightDate)?_c('span',[_vm._v(" "+_vm._s(_vm.copyrightDateFrom)+" - "+_vm._s(new Date().getFullYear())+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.companyName)+" ")]),_vm._l((_vm.links),function(link,i){return _c('div',{key:i,staticClass:"anx-footer-link"},[_c('anx-link',{attrs:{"href":link.link}},[_vm._v(_vm._s(link.text))])],1)})]})],2)])]),_c('div',{staticClass:"anx-footer-mobile"},[_vm._t("icon",function(){return [(_vm.icon != null)?_c('anx-icon',{staticClass:"anx-footer-logo",attrs:{"alt":"anx-footer-logo","height":"40px","icon":_vm.icon}}):_vm._e()]})],2)],1)])])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxFooter/AnxFooter.vue?vue&type=template&id=3716aafa&scoped=true&


/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var aFunction = __webpack_require__("1c0b");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var bind = __webpack_require__("0538");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4bbd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4bc1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = __webpack_require__("7037").default;

var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

__webpack_require__("b0c0");

__webpack_require__("d3b7");

__webpack_require__("25f0");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttributesHelper = void 0;
/**
 * Some components have attributes, that should only be set if they are not null.
 * This helper class generates an object, containing only those attributes, that are not null and should be passed to the component.
 * E.g: If the id is not set, no id should be used for the component.
 * You can bind the attributes object to the component using the v-bind directive.
 *
 * @export
 * @class AttributesHelper
 */

var AttributesHelper = /*#__PURE__*/function () {
  function AttributesHelper() {
    _classCallCheck(this, AttributesHelper);
  }

  _createClass(AttributesHelper, null, [{
    key: "attributes",
    value:
    /**
     * Attrbibutes for the component
     * This functions only searches for specific attributes (id, name)
     *
     * Options:
     *   - uniqueId: Generate a unique id if notihing is specified
     *   - uniqueIdPrefix: The prefix for the unique id
     */
    function attributes(instance, options) {
      var attributes = {};

      if (instance && "$options" in instance && "propsData" in instance.$options) {
        var properties = instance.$options.propsData;
        /** Check if id is set */

        if ("id" in properties && properties.id && properties.id !== "") {
          attributes.id = properties.id;
        } else if (options && options.uniqueId === true) {
          /** Assign a unique id based on the counter */
          attributes.id = AttributesHelper.getUniqueId({
            prefix: options.uniqueIdPrefix
          });
        }
        /** Check if the name is set */


        if ("name" in properties && properties.name && properties.name !== "") {
          attributes.name = properties.name;
        }
      }

      return attributes;
    }
    /**
     * This function generates a unique id
     *
     * @static
     * @param {{ prefix?: string }} options
     * @return {*}  {string}
     * @memberof AttributesHelper
     */

  }, {
    key: "getUniqueId",
    value: function getUniqueId(options) {
      var id = "";

      if (options.prefix && _typeof(options.prefix) !== undefined) {
        id += options.prefix;
      } else {
        id += "anx-component-";
      }

      id += AttributesHelper.counter.toString();
      AttributesHelper.counter++;
      return id;
    }
  }]);

  return AttributesHelper;
}();

exports.AttributesHelper = AttributesHelper;
/** The counter for unique ids */

AttributesHelper.counter = 1;

/***/ }),

/***/ "4c05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_style_index_0_id_5cbdd526_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b7b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_style_index_0_id_5cbdd526_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLogin_vue_vue_type_style_index_0_id_5cbdd526_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4c67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxList_vue_vue_type_template_id_67e37bb0_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1129");
/* harmony import */ var _AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c410");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxList_vue_vue_type_style_index_0_id_67e37bb0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("be31");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxList_vue_vue_type_template_id_67e37bb0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxList_vue_vue_type_template_id_67e37bb0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "67e37bb0",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4f79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_style_index_0_id_798c4a06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("140e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_style_index_0_id_798c4a06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLink_vue_vue_type_style_index_0_id_798c4a06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "500a":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("a15b");

__webpack_require__("ac1f");

__webpack_require__("1276");

__webpack_require__("fb6a");

__webpack_require__("5319");

module.exports = {
  camelize: function camelize(text) {
    text = text.split("_").join("-");
    var words = text.split("-");
    var result = "";

    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      result += module.exports.capitalize(word);
    }

    return result;
  },
  capitalize: function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  },
  kebab: function kebab(text) {
    return text.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/\s+/g, "-").toLowerCase();
  },
  removeNewLines: function removeNewLines(text) {
    return text.replace(/\r?\n|\r/g, "");
  },
  replaceQuotationMarks: function replaceQuotationMarks(text) {
    return text.replace(/"/g, "'");
  },
  replaceWidthAndHeightForSvg: function replaceWidthAndHeightForSvg(text) {
    /** We only want to replace the width and height
     * property of the first <svg> element, so we extract
     * it from the rest of the string */
    var svgElement = text.substring(text.indexOf("<svg "), text.indexOf(">") + 1);
    /** Replace the width and the height in the svg element */

    svgElement = svgElement.replace(/\bwidth='(\d+)'/g, "width='100%'").replace(/\bheight='(\d+)'/g, "height='100%'");
    /** Return the whole svg element and insert the modified svg element */

    return text.replace(/<svg [\s\S]*?>/, svgElement);
  }
};

/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("7b0b");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "518b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxHeader_vue_vue_type_template_id_0e758f08_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9736");
/* harmony import */ var _AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6715");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxHeader_vue_vue_type_style_index_0_id_0e758f08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f6df");
/* harmony import */ var _AnxHeader_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("f29e");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2877");







/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(
  _AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxHeader_vue_vue_type_template_id_0e758f08_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxHeader_vue_vue_type_template_id_0e758f08_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "0e758f08",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "51a9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

var AnxModal_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxButton_vue_1 = tslib_1.__importDefault(__webpack_require__("3097"));
/**
 * This component is used for generating dynamic modals.
 * Modals are dialogs that can be used to display information for users.
 */


var AnxModal = AnxModal_1 = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxModal, _vue_property_decorat);

  var _super = _createSuper(AnxModal);

  function AnxModal() {
    var _this;

    _classCallCheck(this, AnxModal);

    _this = _super.apply(this, arguments);
    /** This is the layer of our modal (necessary for displaying modals inside of modals) */

    _this.modalLayer = 0;
    return _this;
  }
  /** Add event listeners for click event on mount */


  _createClass(AnxModal, [{
    key: "mounted",
    value: function mounted() {
      /** Increase the number of opened modals and store the current layer of our modal*/
      this.modalLayer = ++AnxModal_1.numberModalsOpened;
      this.updateStyles();
    }
    /** Check if the id is set otherwise create a unique id */

  }, {
    key: "_id",
    get: function get() {
      if (this.id !== null) {
        return this.id;
      }

      return "anx-modal-" + AnxModal_1.numberModalsOpened;
    }
    /** Decrease the number of opened modals */

  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (AnxModal_1.numberModalsOpened > 0) AnxModal_1.numberModalsOpened--;
      this.updateStyles();
    }
    /** Check if the modal should be closed by the click */

  }, {
    key: "checkForClosing",
    value: function checkForClosing(e) {
      /** Check if the click was outside the modal */
      if (e.target == this.$refs["anxModalOutsideContainer"]) {
        /** Only close the modal if the current modal is in front */
        if (this.modalLayer == AnxModal_1.numberModalsOpened) {
          this.$emit("close");
        }
      }
    }
    /**
     * If a modal is opened, the styles of the body have to be updated
     * so that the background does not scroll
     */

  }, {
    key: "updateStyles",
    value: function updateStyles() {
      var body = document.body; // Check if there are any modals opened and add or remove the class for scrolling to the body

      if (AnxModal_1.numberModalsOpened > 0) {
        body.classList.add("anx-modal-is-open");
      } else {
        body.classList.remove("anx-modal-is-open");
      }

      return;
    }
  }]);

  return AnxModal;
}(vue_property_decorator_1.Vue);
/** This is the number of currently opened modals */


AnxModal.numberModalsOpened = 0;

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Enter a title for the modal"
})], AnxModal.prototype, "title", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxModal.prototype, "hasCloseButton", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Close"
})], AnxModal.prototype, "closeButtonText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "center"
})], AnxModal.prototype, "closeButtonAlign", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxModal.prototype, "confirm", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Confirm"
})], AnxModal.prototype, "confirmButtonText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxModal.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "m"
})], AnxModal.prototype, "size", void 0);

AnxModal = AnxModal_1 = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxButton: AnxButton_vue_1.default
  }
})], AnxModal);
exports.default = AnxModal;

/***/ }),

/***/ "5288":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "528e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var _variables_scss_1 = tslib_1.__importDefault(__webpack_require__("fb51"));
/**
 * The *anx-button* is based on a standard HTML button.
 * It can be used like a normal button, but has some convenient features.
 */


var AnxButton = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxButton, _vue_property_decorat);

  var _super = _createSuper(AnxButton);

  function AnxButton() {
    _classCallCheck(this, AnxButton);

    return _super.apply(this, arguments);
  }

  _createClass(AnxButton, [{
    key: "cssProps",
    get:
    /** @ignore */
    function get() {
      return {
        "--button-width": this.width !== null ? this.width : "auto",
        "--button-color": this.color !== null ? this.color : _variables_scss_1.default.defaultButtonColor,
        "--button-color-disabled": this.disabledColor !== null ? this.disabledColor : _variables_scss_1.default.defaultButtonColorDisabled
      };
    }
  }]);

  return AnxButton;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "submit"
})], AnxButton.prototype, "btnType", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxButton.prototype, "outline", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "button"
})], AnxButton.prototype, "text", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxButton.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxButton.prototype, "inline", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "click"
})], AnxButton.prototype, "eventName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxButton.prototype, "color", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxButton.prototype, "disabledColor", void 0);

AnxButton = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxButton);
exports.default = AnxButton;

/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});


/***/ }),

/***/ "5507":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("96cf");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var vee_validate_1 = __webpack_require__("7bb1");

var AttributesHelper_1 = __webpack_require__("4bc1");
/**
 * This component is an advanced input textarea
 */


var AnxTextarea = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxTextarea, _vue_property_decorat);

  var _super = _createSuper(AnxTextarea);

  function AnxTextarea() {
    var _this;

    _classCallCheck(this, AnxTextarea);

    _this = _super.apply(this, arguments);
    _this.active = false;
    _this.filled = false;
    /** The id that is actually used */

    _this.inputId = "";
    /** This variable is used as v-model for the input field (Using the value variable directly is not allowed because props should not be mutated directly) */

    _this.localValue = "";
    return _this;
  }

  _createClass(AnxTextarea, [{
    key: "cssProps",
    get: function get() {
      return {
        "--textarea-width": this.width
      };
    }
    /**
     * Watch the localValue variable used as v-model for the textarea
     * When it changes, the users is typing and changed some text, it has
     * to be checked if the textarea should be active or not.
     */

  }, {
    key: "localValueChanged",
    value: function localValueChanged(newVal) {
      if (newVal && newVal.length) {
        this.active = true;
      }
    }
    /**
     * Watch the attribute/prop value.
     * When this variable changes it means that the value for the textarea has been
     * updated from the parent component programmatically. The localValue variable has to
     * be assigned and it has to be checked, if the textarea is filled
     */

  }, {
    key: "valueChanged",
    value: function valueChanged() {
      this.localValue = this.value !== null ? this.value : "";
      this.isFilled();
    }
    /**
     * Set the id for the component when created
     */

  }, {
    key: "created",
    value: function created() {
      this.inputId = AttributesHelper_1.AttributesHelper.attributes(this, {
        uniqueId: true,
        uniqueIdPrefix: "anx-textarea-"
      }).id;
    }
    /**
     * After mount, the prop value has to be assigned to the localValue and it has to be checked,
     * if the input field should be filled
     */

  }, {
    key: "mounted",
    value: function mounted() {
      this.localValue = this.value !== null ? this.value : "";
      this.isFilled();
    }
    /** Do a validation if the component is updated */

  }, {
    key: "updated",
    value: function updated() {
      /** Only validate, if the value is set */
      if (this.value && this.value !== "") this.validate();
    }
    /**
     * This function is needed, because the validation property is obsolete, but is used in some applications.
     * Backward compatibility is implemented by this function.
     * In the old anx-textarea, if the validation property was set, the rules would be required by default, without setting it.
     */

  }, {
    key: "validationRules",
    get: function get() {
      if (this.validation !== null && this.rules === null) {
        return "required";
      }

      return this.rules;
    }
    /** Check if the input-field is filled, Set class filled. */

  }, {
    key: "isFilled",
    value: function isFilled() {
      if (this.localValue && this.localValue.length > 0) {
        this.filled = true;
      } else {
        this.filled = false;
      }
    }
    /**When the User click in and out of the field, the state active will be set and
     * the state filled will be checked.
     */

  }, {
    key: "inputBlur",
    value: function inputBlur() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /** Trigger a validation manually, when focus is lost */
                this.validate();
                this.active = !this.active;
                this.isFilled();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /** Validate the input with the defined rules */

  }, {
    key: "validate",
    value: function validate() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.validationRules !== null)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.$refs.observer.validate();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * This function is called, when the user clicks the input field
     * If the field is readonly, nothing should happen
     */

  }, {
    key: "clickInputField",
    value: function clickInputField() {
      this.active = true;
    }
  }]);

  return AnxTextarea;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTextarea.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "anx-textarea"
})], AnxTextarea.prototype, "name", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTextarea.prototype, "dataVvAs", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Additional Text"
})], AnxTextarea.prototype, "label", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "4"
})], AnxTextarea.prototype, "rows", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTextarea.prototype, "disabled", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "100%"
})], AnxTextarea.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTextarea.prototype, "validation", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTextarea.prototype, "rules", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTextarea.prototype, "value", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxTextarea.prototype, "autocomplete", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("localValue")], AnxTextarea.prototype, "localValueChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Watch("value")], AnxTextarea.prototype, "valueChanged", null);

AnxTextarea = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    ValidationProvider: vee_validate_1.ValidationProvider
  }
})], AnxTextarea);
exports.default = AnxTextarea;

/***/ }),

/***/ "5530":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _objectSpread2; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js








function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/***/ }),

/***/ "55fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0a19");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.13.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5bc3":
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5fc4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_style_index_0_id_0f850245_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5288");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_style_index_0_id_0f850245_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToast_vue_vue_type_style_index_0_id_0f850245_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6062":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dd04");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxGlobal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6069":
/***/ (function(module, exports) {

module.exports = typeof window == 'object';


/***/ }),

/***/ "60a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Component", function() { return /* reexport */ vue_class_component_esm; });
__webpack_require__.d(__webpack_exports__, "Vue", function() { return /* reexport */ external_commonjs_vue_commonjs2_vue_root_Vue_default.a; });
__webpack_require__.d(__webpack_exports__, "Mixins", function() { return /* reexport */ mixins; });
__webpack_require__.d(__webpack_exports__, "Inject", function() { return /* binding */ Inject; });
__webpack_require__.d(__webpack_exports__, "InjectReactive", function() { return /* binding */ InjectReactive; });
__webpack_require__.d(__webpack_exports__, "Provide", function() { return /* binding */ Provide; });
__webpack_require__.d(__webpack_exports__, "ProvideReactive", function() { return /* binding */ ProvideReactive; });
__webpack_require__.d(__webpack_exports__, "Model", function() { return /* binding */ Model; });
__webpack_require__.d(__webpack_exports__, "Prop", function() { return /* binding */ Prop; });
__webpack_require__.d(__webpack_exports__, "PropSync", function() { return /* binding */ PropSync; });
__webpack_require__.d(__webpack_exports__, "Watch", function() { return /* binding */ Watch; });
__webpack_require__.d(__webpack_exports__, "Emit", function() { return /* binding */ Emit; });
__webpack_require__.d(__webpack_exports__, "Ref", function() { return /* binding */ Ref; });

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof external_commonjs_vue_commonjs2_vue_root_Vue_default.a ? superProto.constructor : external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = [// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter'];
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function vue_class_component_esm_Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.5.1 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>




/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = this[reactiveInjectKey] || {};
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        // inject parent reactive services (if any)
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject = componentOptions.inject || {};
            componentOptions.inject[reactiveInjectKey] = {
                from: reactiveInjectKey,
                default: {},
            };
        }
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managedReactive[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    // @ts-ignore
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, [emitName].concat(args));
                    }
                }
                else {
                    if (args.length === 0) {
                        _this.$emit(emitName, returnValue);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, returnValue, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, [emitName, returnValue].concat(args));
                    }
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "628e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxContact_vue_vue_type_template_id_710bf1b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8ae5");
/* harmony import */ var _AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d428");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxContact_vue_vue_type_style_index_0_id_710bf1b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("757e");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxContact_vue_vue_type_template_id_710bf1b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxContact_vue_vue_type_template_id_710bf1b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "710bf1b0",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "6311":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxTableContainer/AnxTableContainer.vue?vue&type=template&id=35d78eab&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scrollable !== null)?_c('div',{staticClass:"anx-table-container"},[_c('div',{staticClass:"anx-table-container-scrollable",style:(_vm.height !== null ? ("height: " + _vm.height + ";") : '')},[_vm._t("default")],2),(_vm.scrollable !== null)?_c('div',{staticClass:"scroll-shadow"}):_vm._e()]):_c('div',{staticClass:"anx-table-container"},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxTableContainer/AnxTableContainer.vue?vue&type=template&id=35d78eab&scoped=true&


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "6584":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a36b");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "65cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_style_index_0_id_4d673718_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8637");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_style_index_0_id_4d673718_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_style_index_0_id_4d673718_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6715":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c1af");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6755":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxFormContainer/AnxFormContainer.vue?vue&type=template&id=76effed1&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-form-container"},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxFormContainer/AnxFormContainer.vue?vue&type=template&id=76effed1&

// EXTERNAL MODULE: ./src/components/AnxFormContainer/AnxFormContainer.vue?vue&type=style&index=0&lang=scss&
var AnxFormContainervue_type_style_index_0_lang_scss_ = __webpack_require__("08ed");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/AnxFormContainer/AnxFormContainer.vue

var script = {}



/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AnxFormContainer = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "681a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5507");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6911":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxInput_vue_vue_type_template_id_526a1d8a_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3a9c");
/* harmony import */ var _AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6584");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxInput_vue_vue_type_style_index_0_id_526a1d8a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("bd60");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxInput_vue_vue_type_template_id_526a1d8a_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxInput_vue_vue_type_template_id_526a1d8a_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "526a1d8a",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "6912":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f77");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _icons__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _icons__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9f89");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxToastPlugin", function() { return _toast__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e5f5");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxVariablesPlugin", function() { return _variables__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2fce");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxAlertPlugin", function() { return _alert__WEBPACK_IMPORTED_MODULE_3__["a"]; });






/***/ }),

/***/ "69c0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6b58":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("7037")["default"];

var assertThisInitialized = __webpack_require__("3c96");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "6b7b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6b8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * The *anx-icon* component is used in combination with the **AnxIconsPlugin** to render icons.
 */


var AnxIcon = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxIcon, _vue_property_decorat);

  var _super = _createSuper(AnxIcon);

  function AnxIcon() {
    _classCallCheck(this, AnxIcon);

    return _super.apply(this, arguments);
  }

  _createClass(AnxIcon, [{
    key: "iconName",
    get: function get() {
      if (this.icon.indexOf("anx-icon") === 0) return this.icon;else return "anx-icon-".concat(this.icon);
    }
  }]);

  return AnxIcon;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "anexia"
})], AnxIcon.prototype, "icon", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxIcon.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxIcon.prototype, "height", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxIcon.prototype, "margin", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxIcon.prototype, "title", void 0);

AnxIcon = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxIcon);
exports.default = AnxIcon;

/***/ }),

/***/ "6ba2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6bb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxSelect_vue_vue_type_template_id_a1c0af30_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fda7");
/* harmony import */ var _AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("06e9");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxSelect_vue_vue_type_style_index_0_id_a1c0af30_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8154");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxSelect_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxSelect_vue_vue_type_template_id_a1c0af30_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxSelect_vue_vue_type_template_id_a1c0af30_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "a1c0af30",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "6bda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxLink/AnxLink.vue?vue&type=template&id=798c4a06&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disabled === null)?_c('a',{class:{ 'anx-link': true, 'no-style': _vm.noStyle !== null },attrs:{"href":_vm.href,"target":_vm.newTab !== null ? '_blank' : '_self'},on:{"click":function($event){return _vm.click($event)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2):_c('span',{class:'anx-link disabled disabled-style-' +
      _vm.disabledStyle +
      (_vm.noStyle != null ? ' no-style' : '')},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxLink/AnxLink.vue?vue&type=template&id=798c4a06&scoped=true&


/***/ }),

/***/ "6cb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

__webpack_require__("ac1f");

__webpack_require__("5319");

__webpack_require__("466d");

__webpack_require__("d81d");

__webpack_require__("a15b");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringUtils = void 0;

var StringUtils = /*#__PURE__*/function () {
  function StringUtils() {
    _classCallCheck(this, StringUtils);
  }

  _createClass(StringUtils, null, [{
    key: "snakeCaseToCamelCase",
    value: function snakeCaseToCamelCase(str) {
      return str.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
      });
    }
  }, {
    key: "camelCaseToSnakeCase",
    value: function camelCaseToSnakeCase(str) {
      return str.replace(/[A-Z]/g, function (letter) {
        return "_".concat(letter.toLowerCase());
      });
    }
  }, {
    key: "toKebabCase",
    value: function toKebabCase(str) {
      var matches = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
      var kebabCaseString = "";

      if (matches) {
        matches.map(function (x) {
          return x.toLowerCase();
        });
        kebabCaseString = matches.join("-");
      } else {
        return str;
      }

      return kebabCaseString.toLowerCase();
    }
  }]);

  return StringUtils;
}();

exports.StringUtils = StringUtils;

/***/ }),

/***/ "6d22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxGlobal/AnxGlobal.vue?vue&type=template&id=66aabbc8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'anx-global': true,
    'disable-fullscreen': _vm.disableFullscreen !== null
  }},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxGlobal/AnxGlobal.vue?vue&type=template&id=66aabbc8&


/***/ }),

/***/ "6d65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8985");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6dc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxTableCol/AnxTableCol.vue?vue&type=template&id=28ec5454&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:("anx-table-col text-" + _vm.align)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxTableCol/AnxTableCol.vue?vue&type=template&id=28ec5454&scoped=true&


/***/ }),

/***/ "6e7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxForm/AnxForm.vue?vue&type=template&id=7db652f3&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"anxForm",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('form',_vm._b({staticClass:"anx-form",on:{"submit":function($event){$event.preventDefault();return _vm.checkValidation.apply(null, arguments)}}},'form',_vm.attributes,false),[_vm._t("default"),(_vm.submitButton !== null)?_c('div',{staticClass:"submit-button-wrapper"},[_c('anx-button',{attrs:{"type":"submit","width":_vm.submitButton.width ? _vm.submitButton.width : null,"text":_vm.submitButton.text,"disabled":_vm.submitButton.disabled && invalid,"inline":_vm.submitButton.inline}})],1):_vm._e()],2)]}}],null,true)})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxForm/AnxForm.vue?vue&type=template&id=7db652f3&scoped=true&


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f43":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "6f77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4978");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIcon24h", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIcon3d", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconLKWTransport", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["pb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAiKuenstlicheintelligenz", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAlexa", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAnderesWeiteresTeil", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAndroid", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAnexiaStamp", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAnexia", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconApp", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconApple", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconArbeitBuero", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconArrowGreenBottom", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconArrowRedBottom", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAtSign", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["n"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconAuszeichnung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["o"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconBarcode", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["p"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconBildFoto", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["q"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconBlockchain", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["r"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCardboardVrBrilleSmartphone", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["t"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCardboardVrBrille", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["s"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCheckGreen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["v"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCheckWhite", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["w"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCheck", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["u"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCloudStorage", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["y"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCloud", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["x"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCloudservicesHosting", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["z"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconConnections", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["A"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconController", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["B"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconCopy", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["C"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDashboardEchtzeitMonitor", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["D"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDatenbank", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["E"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDevices", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["F"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDns", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["G"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDokument", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["H"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDollar", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["I"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDownload", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["J"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconDsl", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["K"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconESim", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["L"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconEingabe", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["M"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconEins", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["N"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconEinstellungenVerwaltung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["O"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconError", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["P"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconEuro", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Q"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconExperimentierfreudig", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["R"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFabrik", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["S"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFirmenautoAuto", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["T"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFlexibilitaet", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["U"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFlexibleArbeitszeitenTiming", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["V"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFolder", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["W"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconForschungEntwicklung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["X"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFotoapparat", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Y"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconFramework", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Z"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconGabelstapler", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconGefahrenWarnung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["bb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconGenericautomation", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["cb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconHerz", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["db"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconHomeoffice", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["eb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconIdee", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["fb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconInformation", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["gb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconInstallation", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["hb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconInterdisziplinaer", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ib"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconIp", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["jb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconKalender", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["kb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconKontaktTelefonTelekommunikation", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["lb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconKonzept", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["mb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconKunde", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["nb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconKunden", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ob"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconLaden", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["qb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconLastverteilung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["rb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconLike", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["sb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconLoeschen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["tb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMailKontakt", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ub"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMassgeschneiderteIndividuelleLoesungen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["vb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMbaas", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["wb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMicrocontroller", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["xb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMitarbeiterevents", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["yb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMobileEntwicklung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["zb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMonitoring", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconMusik", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Bb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconNetzwerk", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Cb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconOeffentlicherNahverkehr", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Db"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconOffline", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Eb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconOnlineshopWarenkorb", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Fb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPaket", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Gb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconParkplatz", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Hb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPartyProjektabschluss", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ib"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPdf", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Jb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPfeilLinksKlein", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Lb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPfeilLinks", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Kb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPfeilOben", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Mb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPfeilRechtsKlein", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ob"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPfeilRechts", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Nb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPfeilRunter", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Pb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPflichtenheft", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Qb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPlatform", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Rb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconPraesentation", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Sb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconProjektablauf", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Tb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconProjektmanagementCheckliste", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ub"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconRedundant", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Vb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSatellit", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Wb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSchluessel", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Xb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconScrum", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Yb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSeoSemCrawler", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Zb"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconServerVeerbunden", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ac"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconServiceprovider", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["bc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSharing", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["cc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconShop", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["dc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSicherheitFirewall", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ec"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSignal", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["fc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSkalierbar", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["gc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSmartTv", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["hc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSmartWatch", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ic"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSmarthome", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["jc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSoftwareentwicklungCode", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["kc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSpieleUndSpass", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["lc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSprechblasen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["mc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconStandortUnternehmenssitz", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["nc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconStartUp", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["oc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconStatistikAnalysen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["pc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconStern", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["qc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconStorageBackup", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["rc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconStromEnergie", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["sc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSuchen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["tc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconSupportMitarbeiter", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["uc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconTasse", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["vc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconTeam", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["wc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconTechnischerSupport", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["xc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconTextdokument", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["yc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconTextdokumentFragezeichen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["zc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconTextdokumentRufzeichen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ac"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconUpload", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Bc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconUserProfil", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Cc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVerbundeneServerBlade", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Dc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVerlautbarungWichtigeNewsPressemitteilung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ec"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVerpflegungMittagspauseEssen", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Fc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVerschluesselung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Gc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVideo", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Hc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVierenBugs", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Ic"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVirtualisierung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Jc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVollbildVerschieben", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Kc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconVr", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Lc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWachstumUmsatz", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Mc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWarningSmall", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Oc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWarning", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Nc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWebdesign", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Pc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWebentwicklung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Qc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWeiterbildung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Rc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Sc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWhiteLabel", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Tc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWidgets", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Uc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWindows", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Vc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconWlan", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Wc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconX", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Xc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconZeitungMedienNews", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Yc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconZertifikat", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["Zc"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconZielMarkierung", function() { return _icons__WEBPACK_IMPORTED_MODULE_0__["ad"]; });

/* harmony import */ var _components_AnxIcon_AnxIcon_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2769");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _components_AnxIcon_AnxIcon_vue__WEBPACK_IMPORTED_MODULE_1__) if(["default","AnxIconsPlugin","AnxIconsNames","AnxIcon24h","AnxIcon3d","AnxIconLKWTransport","AnxIconAiKuenstlicheintelligenz","AnxIconAlexa","AnxIconAnderesWeiteresTeil","AnxIconAndroid","AnxIconAnexiaStamp","AnxIconAnexia","AnxIconApp","AnxIconApple","AnxIconArbeitBuero","AnxIconArrowGreenBottom","AnxIconArrowRedBottom","AnxIconAtSign","AnxIconAuszeichnung","AnxIconBarcode","AnxIconBildFoto","AnxIconBlockchain","AnxIconCardboardVrBrilleSmartphone","AnxIconCardboardVrBrille","AnxIconCheckGreen","AnxIconCheckWhite","AnxIconCheck","AnxIconCloudStorage","AnxIconCloud","AnxIconCloudservicesHosting","AnxIconConnections","AnxIconController","AnxIconCopy","AnxIconDashboardEchtzeitMonitor","AnxIconDatenbank","AnxIconDevices","AnxIconDns","AnxIconDokument","AnxIconDollar","AnxIconDownload","AnxIconDsl","AnxIconESim","AnxIconEingabe","AnxIconEins","AnxIconEinstellungenVerwaltung","AnxIconError","AnxIconEuro","AnxIconExperimentierfreudig","AnxIconFabrik","AnxIconFirmenautoAuto","AnxIconFlexibilitaet","AnxIconFlexibleArbeitszeitenTiming","AnxIconFolder","AnxIconForschungEntwicklung","AnxIconFotoapparat","AnxIconFramework","AnxIconGabelstapler","AnxIconGefahrenWarnung","AnxIconGenericautomation","AnxIconHerz","AnxIconHomeoffice","AnxIconIdee","AnxIconInformation","AnxIconInstallation","AnxIconInterdisziplinaer","AnxIconIp","AnxIconKalender","AnxIconKontaktTelefonTelekommunikation","AnxIconKonzept","AnxIconKunde","AnxIconKunden","AnxIconLaden","AnxIconLastverteilung","AnxIconLike","AnxIconLoeschen","AnxIconMailKontakt","AnxIconMassgeschneiderteIndividuelleLoesungen","AnxIconMbaas","AnxIconMicrocontroller","AnxIconMitarbeiterevents","AnxIconMobileEntwicklung","AnxIconMonitoring","AnxIconMusik","AnxIconNetzwerk","AnxIconOeffentlicherNahverkehr","AnxIconOffline","AnxIconOnlineshopWarenkorb","AnxIconPaket","AnxIconParkplatz","AnxIconPartyProjektabschluss","AnxIconPdf","AnxIconPfeilLinksKlein","AnxIconPfeilLinks","AnxIconPfeilOben","AnxIconPfeilRechtsKlein","AnxIconPfeilRechts","AnxIconPfeilRunter","AnxIconPflichtenheft","AnxIconPlatform","AnxIconPraesentation","AnxIconProjektablauf","AnxIconProjektmanagementCheckliste","AnxIconRedundant","AnxIconSatellit","AnxIconSchluessel","AnxIconScrum","AnxIconSeoSemCrawler","AnxIconServerVeerbunden","AnxIconServiceprovider","AnxIconSharing","AnxIconShop","AnxIconSicherheitFirewall","AnxIconSignal","AnxIconSkalierbar","AnxIconSmartTv","AnxIconSmartWatch","AnxIconSmarthome","AnxIconSoftwareentwicklungCode","AnxIconSpieleUndSpass","AnxIconSprechblasen","AnxIconStandortUnternehmenssitz","AnxIconStartUp","AnxIconStatistikAnalysen","AnxIconStern","AnxIconStorageBackup","AnxIconStromEnergie","AnxIconSuchen","AnxIconSupportMitarbeiter","AnxIconTasse","AnxIconTeam","AnxIconTechnischerSupport","AnxIconTextdokument","AnxIconTextdokumentFragezeichen","AnxIconTextdokumentRufzeichen","AnxIconUpload","AnxIconUserProfil","AnxIconVerbundeneServerBlade","AnxIconVerlautbarungWichtigeNewsPressemitteilung","AnxIconVerpflegungMittagspauseEssen","AnxIconVerschluesselung","AnxIconVideo","AnxIconVierenBugs","AnxIconVirtualisierung","AnxIconVollbildVerschieben","AnxIconVr","AnxIconWachstumUmsatz","AnxIconWarningSmall","AnxIconWarning","AnxIconWebdesign","AnxIconWebentwicklung","AnxIconWeiterbildung","AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc","AnxIconWhiteLabel","AnxIconWidgets","AnxIconWindows","AnxIconWlan","AnxIconX","AnxIconZeitungMedienNews","AnxIconZertifikat","AnxIconZielMarkierung"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _components_AnxIcon_AnxIcon_vue__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0c29");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconsPlugin", function() { return _plugin__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnxIconsNames", function() { return _plugin__WEBPACK_IMPORTED_MODULE_2__["a"]; });

// Export all icons
 // Export the AnxIcon component itself

 // Export the plugin to enable global registering of icons



/***/ }),

/***/ "6f8f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ae1");

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "7037":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("a4d3");

__webpack_require__("e01a");

__webpack_require__("d3b7");

__webpack_require__("d28b");

__webpack_require__("3ca3");

__webpack_require__("ddb0");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "70d7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};

/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "757e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_style_index_0_id_710bf1b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0a11");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_style_index_0_id_710bf1b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_style_index_0_id_710bf1b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "781d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("51a9");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "78a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxParagraph_vue_vue_type_template_id_7dcab4fe_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cb62");
/* harmony import */ var _AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6d65");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxParagraph_vue_vue_type_style_index_0_id_7dcab4fe_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a589");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxParagraph_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxParagraph_vue_vue_type_template_id_7dcab4fe_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxParagraph_vue_vue_type_template_id_7dcab4fe_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "7dcab4fe",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "7a3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b8a");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7bb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBag", function() { return ErrorBag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rules", function() { return Rules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationObserver", function() { return ValidationObserver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationProvider", function() { return ValidationProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validator", function() { return Validator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "directive", function() { return directive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapFields", function() { return mapFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withValidation", function() { return withValidation; });
/**
  * vee-validate v2.2.15
  * (c) 2019 Abdelrahman Awad
  * @license MIT
  */
// 

var isTextInput = function (el) {
  return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'textarea', 'number'], el.type);
};

var isCheckboxOrRadioInput = function (el) {
  return includes(['radio', 'checkbox'], el.type);
};

var isDateInput = function (el) {
  return includes(['date', 'week', 'month', 'datetime-local', 'time'], el.type);
};

/**
 * Gets the data attribute. the name must be kebab-case.
 */
var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };

var isNaN$1 = function (value) {
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }

  // eslint-disable-next-line
  return typeof(value) === 'number' && value !== value;
};

/**
 * Checks if the values are either null or undefined.
 */
var isNullOrUndefined = function () {
  var values = [], len = arguments.length;
  while ( len-- ) values[ len ] = arguments[ len ];

  return values.every(function (value) {
    return value === null || value === undefined;
  });
};

/**
 * Creates the default flags object.
 */
var createFlags = function () { return ({
  untouched: true,
  touched: false,
  dirty: false,
  pristine: true,
  valid: null,
  invalid: null,
  validated: false,
  pending: false,
  required: false,
  changed: false
}); };

/**
 * Shallow object comparison.
 */
var isEqual = function (lhs, rhs) {
  if (lhs instanceof RegExp && rhs instanceof RegExp) {
    return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
  }

  if (Array.isArray(lhs) && Array.isArray(rhs)) {
    if (lhs.length !== rhs.length) { return false; }

    for (var i = 0; i < lhs.length; i++) {
      if (!isEqual(lhs[i], rhs[i])) {
        return false;
      }
    }

    return true;
  }

  // if both are objects, compare each key recursively.
  if (isObject(lhs) && isObject(rhs)) {
    return Object.keys(lhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    }) && Object.keys(rhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    });
  }

  if (isNaN$1(lhs) && isNaN$1(rhs)) {
    return true;
  }

  return lhs === rhs;
};

/**
 * Determines the input field scope.
 */
var getScope = function (el) {
  var scope = getDataAttribute(el, 'scope');
  if (isNullOrUndefined(scope)) {
    var form = getForm(el);

    if (form) {
      scope = getDataAttribute(form, 'scope');
    }
  }

  return !isNullOrUndefined(scope) ? scope : null;
};

/**
 * Get the closest form element.
 */
var getForm = function (el) {
  if (isNullOrUndefined(el)) { return null; }

  if (el.tagName === 'FORM') { return el; }

  if (!isNullOrUndefined(el.form)) { return el.form; }

  return !isNullOrUndefined(el.parentNode) ? getForm(el.parentNode) : null;
};

/**
 * Gets the value in an object safely.
 */
var getPath = function (path, target, def) {
  if ( def === void 0 ) def = undefined;

  if (!path || !target) { return def; }

  var value = target;
  path.split('.').every(function (prop) {
    if (prop in value) {
      value = value[prop];

      return true;
    }

    value = def;

    return false;
  });

  return value;
};

/**
 * Checks if path exists within an object.
 */
var hasPath = function (path, target) {
  var obj = target;
  var previousPath = null;
  var isNullOrNonObject = false;
  var isValidPath = path.split('.').reduce(function (reducer, prop) {
    if (obj == null || typeof obj !== 'object') {
      isNullOrNonObject = true;
      return reducer && false;
    }

    if (prop in obj) {
      obj = obj[prop];
      previousPath = previousPath === null ? prop : previousPath + '.' + prop;

      return reducer && true;
    }

    return reducer && false;
  }, true);

  if (false) {}

  return isValidPath;
};

/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
  var params = [];
  var name = rule.split(':')[0];

  if (includes(rule, ':')) {
    params = rule.split(':').slice(1).join(':').split(',');
  }

  return { name: name, params: params };
};

/**
 * Debounces a function.
 */
var debounce = function (fn, wait, token) {
  if ( wait === void 0 ) wait = 0;
  if ( token === void 0 ) token = { cancelled: false };

  if (wait === 0) {
    return fn;
  }

  var timeout;

  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var later = function () {
      timeout = null;

      // check if the fn call was cancelled.
      if (!token.cancelled) { fn.apply(void 0, args); }
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (!timeout) { fn.apply(void 0, args); }
  };
};

/**
 * Appends a rule definition to a list of rules.
 */
var appendRule = function (rule, rules) {
  if (!rules) {
    return normalizeRules(rule);
  }

  if (!rule) {
    return normalizeRules(rules);
  }

  if (typeof rules === 'string') {
    rules = normalizeRules(rules);
  }

  return assign({}, rules, normalizeRules(rule));
};

/**
 * Normalizes the given rules expression.
 */
var normalizeRules = function (rules) {
  // if falsy value return an empty object.
  if (!rules) {
    return {};
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce(function (prev, curr) {
      var params = [];
      // $FlowFixMe
      if (rules[curr] === true) {
        params = [];
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr];
      } else if (isObject(rules[curr])) {
        params = rules[curr];
      } else {
        params = [rules[curr]];
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params;
      }

      return prev;
    }, {});
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.');
    return {};
  }

  return rules.split('|').reduce(function (prev, rule) {
    var parsedRule = parseRule(rule);
    if (!parsedRule.name) {
      return prev;
    }

    prev[parsedRule.name] = parsedRule.params;
    return prev;
  }, {});
};

/**
 * Emits a warning to the console.
 */
var warn = function (message) {
  console.warn(("[vee-validate] " + message)); // eslint-disable-line
};

/**
 * Creates a branded error object.
 */
var createError = function (message) { return new Error(("[vee-validate] " + message)); };

/**
 * Checks if the value is an object.
 */
var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && ! Array.isArray(obj); };

/**
 * Checks if a function is callable.
 */
var isCallable = function (func) { return typeof func === 'function'; };

/**
 * Check if element has the css class on it.
 */
var hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
};

/**
 * Adds the provided css className to the element.
 */
var addClass = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
    return;
  }

  if (!hasClass(el, className)) {
    el.className += " " + className;
  }
};

/**
 * Remove the provided css className from the element.
 */
var removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
    return;
  }

  if (hasClass(el, className)) {
    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * Adds or removes a class name on the input depending on the status flag.
 */
var toggleClass = function (el, className, status) {
  if (!el || !className) { return; }

  if (Array.isArray(className)) {
    className.forEach(function (item) { return toggleClass(el, item, status); });
    return;
  }

  if (status) {
    return addClass(el, className);
  }

  removeClass(el, className);
};

/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
var toArray = function (arrayLike) {
  if (isCallable(Array.from)) {
    return Array.from(arrayLike);
  }

  var array = [];
  var length = arrayLike.length;
  /* istanbul ignore next */
  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  /* istanbul ignore next */
  return array;
};

/**
 * Converts an array-like object to array and place other elements in an array
 */
var ensureArray = function (arrayLike) {
  if (Array.isArray(arrayLike)) {
    return [].concat( arrayLike );
  }
  var array = toArray(arrayLike);
  return isEmptyArray(array) ? [arrayLike] : array;
};

/**
 * Assign polyfill from the mdn.
 */
var assign = function (target) {
  var others = [], len = arguments.length - 1;
  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];

  /* istanbul ignore else */
  if (isCallable(Object.assign)) {
    return Object.assign.apply(Object, [ target ].concat( others ));
  }

  /* istanbul ignore next */
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  /* istanbul ignore next */
  var to = Object(target);
  /* istanbul ignore next */
  others.forEach(function (arg) {
    // Skip over if undefined or null
    if (arg != null) {
      Object.keys(arg).forEach(function (key) {
        to[key] = arg[key];
      });
    }
  });
  /* istanbul ignore next */
  return to;
};

var id = 0;
var idTemplate = '{id}';

/**
 * Generates a unique id.
 */
var uniqId = function () {
  // handle too many uses of uniqId, although unlikely.
  if (id >= 9999) {
    id = 0;
    // shift the template.
    idTemplate = idTemplate.replace('{id}', '_{id}');
  }

  id++;
  var newId = idTemplate.replace('{id}', String(id));

  return newId;
};

var findIndex = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return i;
    }
  }

  return -1;
};

/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
var find = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  var idx = findIndex(array, predicate);

  return idx === -1 ? undefined : array[idx];
};

var isBuiltInComponent = function (vnode) {
  if (!vnode) {
    return false;
  }

  var tag = vnode.componentOptions.tag;

  return /^(keep-alive|transition|transition-group)$/.test(tag);
};

var makeDelayObject = function (events, delay, delayConfig) {
  if (typeof delay === 'number') {
    return events.reduce(function (prev, e) {
      prev[e] = delay;
      return prev;
    }, {});
  }

  return events.reduce(function (prev, e) {
    if (typeof delay === 'object' && e in delay) {
      prev[e] = delay[e];
      return prev;
    }

    if (typeof delayConfig === 'number') {
      prev[e] = delayConfig;
      return prev;
    }

    prev[e] = (delayConfig && delayConfig[e]) || 0;

    return prev;
  }, {});
};

var deepParseInt = function (input) {
  if (typeof input === 'number') { return input; }

  if (typeof input === 'string') { return parseInt(input); }

  var map = {};
  for (var element in input) {
    map[element] = parseInt(input[element]);
  }

  return map;
};

var merge = function (target, source) {
  if (! (isObject(target) && isObject(source))) {
    return target;
  }

  Object.keys(source).forEach(function (key) {
    var obj, obj$1;

    if (isObject(source[key])) {
      if (! target[key]) {
        assign(target, ( obj = {}, obj[key] = {}, obj ));
      }

      merge(target[key], source[key]);
      return;
    }

    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
  });

  return target;
};

var fillRulesFromElement = function (el, rules) {
  if (el.required) {
    rules = appendRule('required', rules);
  }

  if (isTextInput(el)) {
    if (el.type === 'email') {
      rules = appendRule(("email" + (el.multiple ? ':multiple' : '')), rules);
    }

    if (el.pattern) {
      rules = appendRule({ regex: el.pattern }, rules);
    }

    // 524288 is the max on some browsers and test environments.
    if (el.maxLength >= 0 && el.maxLength < 524288) {
      rules = appendRule(("max:" + (el.maxLength)), rules);
    }

    if (el.minLength > 0) {
      rules = appendRule(("min:" + (el.minLength)), rules);
    }

    if (el.type === 'number') {
      rules = appendRule('decimal', rules);
      if (el.min !== '') {
        rules = appendRule(("min_value:" + (el.min)), rules);
      }

      if (el.max !== '') {
        rules = appendRule(("max_value:" + (el.max)), rules);
      }
    }

    return rules;
  }

  if (isDateInput(el)) {
    var timeFormat = el.step && Number(el.step) < 60 ? 'HH:mm:ss' : 'HH:mm';

    if (el.type === 'date') {
      return appendRule('date_format:yyyy-MM-dd', rules);
    }

    if (el.type === 'datetime-local') {
      return appendRule(("date_format:yyyy-MM-ddT" + timeFormat), rules);
    }

    if (el.type === 'month') {
      return appendRule('date_format:yyyy-MM', rules);
    }

    if (el.type === 'week') {
      return appendRule('date_format:yyyy-[W]WW', rules);
    }

    if (el.type === 'time') {
      return appendRule(("date_format:" + timeFormat), rules);
    }
  }

  return rules;
};

var values = function (obj) {
  if (isCallable(Object.values)) {
    return Object.values(obj);
  }

  // fallback to keys()
  /* istanbul ignore next */
  return Object.keys(obj).map(function (k) { return obj[k]; });
};

var parseSelector = function (selector) {
  var rule = null;
  if (includes(selector, ':')) {
    rule = selector.split(':').pop();
    selector = selector.replace((":" + rule), '');
  }

  if (selector[0] === '#') {
    return {
      id: selector.slice(1),
      rule: rule,
      name: null,
      scope: null
    };
  }

  var scope = null;
  var name = selector;
  if (includes(selector, '.')) {
    var parts = selector.split('.');
    scope = parts[0];
    name = parts.slice(1).join('.');
  }

  return {
    id: null,
    scope: scope,
    name: name,
    rule: rule
  };
};

var includes = function (collection, item) {
  return collection.indexOf(item) !== -1;
};

var isEmptyArray = function (arr) {
  return Array.isArray(arr) && arr.length === 0;
};

var defineNonReactive = function (obj, prop, value) {
  Object.defineProperty(obj, prop, {
    configurable: false,
    writable: true,
    value: value
  });
};

// 

var LOCALE = 'en';

var Dictionary = function Dictionary (dictionary) {
  if ( dictionary === void 0 ) dictionary = {};

  this.container = {};
  this.merge(dictionary);
};

var prototypeAccessors = { locale: { configurable: true } };

prototypeAccessors.locale.get = function () {
  return LOCALE;
};

prototypeAccessors.locale.set = function (value) {
  LOCALE = value || 'en';
};

Dictionary.prototype.hasLocale = function hasLocale (locale) {
  return !!this.container[locale];
};

Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
  if (!this.container[locale]) {
    this.container[locale] = {};
  }

  this.container[locale].dateFormat = format;
};

Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
  if (!this.container[locale] || !this.container[locale].dateFormat) {
    return null;
  }

  return this.container[locale].dateFormat;
};

Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var message = null;
  if (!this.hasMessage(locale, key)) {
    message = this._getDefaultMessage(locale);
  } else {
    message = this.container[locale].messages[key];
  }

  return isCallable(message) ? message.apply(void 0, data) : message;
};

/**
 * Gets a specific message for field. falls back to the rule message.
 */
Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  if (!this.hasLocale(locale)) {
    return this.getMessage(locale, key, data);
  }

  var dict = this.container[locale].custom && this.container[locale].custom[field];
  if (!dict || !dict[key]) {
    return this.getMessage(locale, key, data);
  }

  var message = dict[key];
  return isCallable(message) ? message.apply(void 0, data) : message;
};

Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
  if (this.hasMessage(locale, '_default')) {
    return this.container[locale].messages._default;
  }

  return this.container.en.messages._default;
};

Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  if (!this.hasAttribute(locale, key)) {
    return fallback;
  }

  return this.container[locale].attributes[key];
};

Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].messages &&
          this.container[locale].messages[key]
  );
};

Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].attributes &&
          this.container[locale].attributes[key]
  );
};

Dictionary.prototype.merge = function merge$1 (dictionary) {
  merge(this.container, dictionary);
};

Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }
    
  if (!this.container[locale].messages) {
    this.container[locale].messages = {};
  }

  this.container[locale].messages[key] = message;
};

Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].attributes[key] = attribute;
};

Object.defineProperties( Dictionary.prototype, prototypeAccessors );

var drivers = {
  default: new Dictionary({
    en: {
      messages: {},
      attributes: {},
      custom: {}
    }
  })
};

var currentDriver = 'default';

var DictionaryResolver = function DictionaryResolver () {};

DictionaryResolver._checkDriverName = function _checkDriverName (driver) {
  if (!driver) {
    throw createError('you must provide a name to the dictionary driver');
  }
};

DictionaryResolver.setDriver = function setDriver (driver, implementation) {
    if ( implementation === void 0 ) implementation = null;

  this._checkDriverName(driver);
  if (implementation) {
    drivers[driver] = implementation;
  }

  currentDriver = driver;
};

DictionaryResolver.getDriver = function getDriver () {
  return drivers[currentDriver];
};

// 

var ErrorBag = function ErrorBag (errorBag, id) {
  if ( errorBag === void 0 ) errorBag = null;
  if ( id === void 0 ) id = null;

  this.vmId = id || null;
  // make this bag a mirror of the provided one, sharing the same items reference.
  if (errorBag && errorBag instanceof ErrorBag) {
    this.items = errorBag.items;
  } else {
    this.items = [];
  }
};

ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Adds an error to the internal array.
 */
ErrorBag.prototype.add = function add (error) {
    var ref;

  (ref = this.items).push.apply(
    ref, this._normalizeError(error)
  );
};

/**
 * Normalizes passed errors to an error array.
 */
ErrorBag.prototype._normalizeError = function _normalizeError (error) {
    var this$1 = this;

  if (Array.isArray(error)) {
    return error.map(function (e) {
      e.scope = !isNullOrUndefined(e.scope) ? e.scope : null;
      e.vmId = !isNullOrUndefined(e.vmId) ? e.vmId : (this$1.vmId || null);

      return e;
    });
  }

  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
  error.vmId = !isNullOrUndefined(error.vmId) ? error.vmId : (this.vmId || null);

  return [error];
};

/**
 * Regenrates error messages if they have a generator function.
 */
ErrorBag.prototype.regenerate = function regenerate () {
  this.items.forEach(function (i) {
    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
  });
};

/**
 * Updates a field error with the new field scope.
 */
ErrorBag.prototype.update = function update (id, error) {
  var item = find(this.items, function (i) { return i.id === id; });
  if (!item) {
    return;
  }

  var idx = this.items.indexOf(item);
  this.items.splice(idx, 1);
  item.scope = error.scope;
  this.items.push(item);
};

/**
 * Gets all error messages from the internal array.
 */
ErrorBag.prototype.all = function all (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return this.items.filter(filterFn).map(function (e) { return e.msg; });
};

/**
 * Checks if there are any errors in the internal array.
 */
ErrorBag.prototype.any = function any (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return !!this.items.filter(filterFn).length;
};

/**
 * Removes all items from the internal array.
 */
ErrorBag.prototype.clear = function clear (scope) {
    var this$1 = this;

  var matchesVM = isNullOrUndefined(this.vmId) ? function () { return true; } : function (i) { return i.vmId === this$1.vmId; };
  var matchesScope = function (i) { return i.scope === scope; };
  if (arguments.length === 0) {
    matchesScope = function () { return true; };
  } else if (isNullOrUndefined(scope)) {
    scope = null;
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (matchesVM(this.items[i]) && matchesScope(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Collects errors into groups or for a specific field.
 */
ErrorBag.prototype.collect = function collect (field, scope, map) {
    var this$1 = this;
    if ( map === void 0 ) map = true;

  var isSingleField = !isNullOrUndefined(field) && !field.includes('*');
  var groupErrors = function (items) {
    var errors = items.reduce(function (collection, error) {
      if (!isNullOrUndefined(this$1.vmId) && error.vmId !== this$1.vmId) {
        return collection;
      }

      if (!collection[error.field]) {
        collection[error.field] = [];
      }

      collection[error.field].push(map ? error.msg : error);

      return collection;
    }, {});

    // reduce the collection to be a single array.
    if (isSingleField) {
      return values(errors)[0] || [];
    }

    return errors;
  };

  if (isNullOrUndefined(field)) {
    return groupErrors(this.items);
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  var collected = this.items.reduce(function (prev, curr) {
    if (isPrimary(curr)) {
      prev.primary.push(curr);
    }

    if (isAlt(curr)) {
      prev.alt.push(curr);
    }

    return prev;
  }, { primary: [], alt: [] });

  collected = collected.primary.length ? collected.primary : collected.alt;

  return groupErrors(collected);
};

/**
 * Gets the internal array length.
 */
ErrorBag.prototype.count = function count () {
    var this$1 = this;

  if (this.vmId) {
    return this.items.filter(function (e) { return e.vmId === this$1.vmId; }).length;
  }

  return this.items.length;
};

/**
 * Finds and fetches the first error message for the specified field id.
 */
ErrorBag.prototype.firstById = function firstById (id) {
  var error = find(this.items, function (i) { return i.id === id; });

  return error ? error.msg : undefined;
};

/**
 * Gets the first error message for a specific field.
 */
ErrorBag.prototype.first = function first (field, scope) {
    if ( scope === void 0 ) scope = null;

  var selector = isNullOrUndefined(scope) ? field : (scope + "." + field);
  var match = this._match(selector);

  return match && match.msg;
};

/**
 * Returns the first error rule for the specified field
 */
ErrorBag.prototype.firstRule = function firstRule (field, scope) {
  var errors = this.collect(field, scope, false);

  return (errors.length && errors[0].rule) || undefined;
};

/**
 * Checks if the internal array has at least one error for the specified field.
 */
ErrorBag.prototype.has = function has (field, scope) {
    if ( scope === void 0 ) scope = null;

  return !!this.first(field, scope);
};

/**
 * Gets the first error message for a specific field and a rule.
 */
ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Gets the first error message for a specific field that not match the rule.
 */
ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
    if ( rule === void 0 ) rule = 'required';
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Removes errors by matching against the id or ids.
 */
ErrorBag.prototype.removeById = function removeById (id) {
  var condition = function (item) { return item.id === id; };
  if (Array.isArray(id)) {
    condition = function (item) { return id.indexOf(item.id) !== -1; };
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (condition(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Removes all error messages associated with a specific field.
 */
ErrorBag.prototype.remove = function remove (field, scope, vmId) {
  if (isNullOrUndefined(field)) {
    return;
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;
  var matches = function (item) { return isPrimary(item) || isAlt(item); };
  var shouldRemove = function (item) {
    if (isNullOrUndefined(vmId)) { return matches(item); }

    return matches(item) && item.vmId === vmId;
  };

  for (var i = 0; i < this.items.length; ++i) {
    if (shouldRemove(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

ErrorBag.prototype._makeCandidateFilters = function _makeCandidateFilters (selector) {
    var this$1 = this;

  var matchesRule = function () { return true; };
  var matchesScope = function () { return true; };
  var matchesName = function () { return true; };
  var matchesVM = function () { return true; };

  var ref = parseSelector(selector);
    var id = ref.id;
    var rule = ref.rule;
    var scope = ref.scope;
    var name = ref.name;

  if (rule) {
    matchesRule = function (item) { return item.rule === rule; };
  }

  // match by id, can be combined with rule selection.
  if (id) {
    return {
      isPrimary: function (item) { return matchesRule(item) && (function (item) { return id === item.id; }); },
      isAlt: function () { return false; }
    };
  }

  if (isNullOrUndefined(scope)) {
    // if no scope specified, make sure the found error has no scope.
    matchesScope = function (item) { return isNullOrUndefined(item.scope); };
  } else {
    matchesScope = function (item) { return item.scope === scope; };
  }

  if (!isNullOrUndefined(name) && name !== '*') {
    matchesName = function (item) { return item.field === name; };
  }

  if (!isNullOrUndefined(this.vmId)) {
    matchesVM = function (item) { return item.vmId === this$1.vmId; };
  }

  // matches the first candidate.
  var isPrimary = function (item) {
    return matchesVM(item) && matchesName(item) && matchesRule(item) && matchesScope(item);
  };

  // matches a second candidate, which is a field with a name containing the '.' character.
  var isAlt = function (item) {
    return matchesVM(item) && matchesRule(item) && item.field === (scope + "." + name);
  };

  return {
    isPrimary: isPrimary,
    isAlt: isAlt
  };
};

ErrorBag.prototype._match = function _match (selector) {
  if (isNullOrUndefined(selector)) {
    return undefined;
  }

  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  return this.items.reduce(function (prev, item, idx, arr) {
    var isLast = idx === arr.length - 1;
    if (prev.primary) {
      return isLast ? prev.primary : prev;
    }

    if (isPrimary(item)) {
      prev.primary = item;
    }

    if (isAlt(item)) {
      prev.alt = item;
    }

    // keep going.
    if (!isLast) {
      return prev;
    }

    return prev.primary || prev.alt;
  }, {});
};

var DEFAULT_CONFIG = {
  locale: 'en',
  delay: 0,
  errorBagName: 'errors',
  dictionary: null,
  fieldsBagName: 'fields',
  classes: false,
  classNames: null,
  events: 'input',
  inject: true,
  fastExit: true,
  aria: true,
  validity: false,
  mode: 'aggressive',
  useConstraintAttrs: true,
  i18n: null,
  i18nRootKey: 'validation'
};

var currentConfig = assign({}, DEFAULT_CONFIG);

var resolveConfig = function (ctx) {
  var selfConfig = getPath('$options.$_veeValidate', ctx, {});

  return assign({}, currentConfig, selfConfig);
};

var getConfig = function () { return currentConfig; };

var setConfig = function (newConf) {
  currentConfig = assign({}, currentConfig, newConf);
};

// VNode Utils

// Gets the model object on the vnode.
function findModel (vnode) {
  if (!vnode.data) {
    return null;
  }

  // Component Model
  if (vnode.data.model) {
    return vnode.data.model;
  }

  return !!(vnode.data.directives) && find(vnode.data.directives, function (d) { return d.name === 'model'; });
}

function extractChildren (vnode) {
  if (Array.isArray(vnode)) {
    return vnode;
  }

  if (Array.isArray(vnode.children)) {
    return vnode.children;
  }

  if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
    return vnode.componentOptions.children;
  }

  return [];
}

function extractVNodes (vnode) {
  if (findModel(vnode)) {
    return [vnode];
  }

  var children = extractChildren(vnode);

  return children.reduce(function (nodes, node) {
    var candidates = extractVNodes(node);
    if (candidates.length) {
      nodes.push.apply(nodes, candidates);
    }

    return nodes;
  }, []);
}

// Resolves v-model config if exists.
function findModelConfig (vnode) {
  if (!vnode.componentOptions) { return null; }

  return vnode.componentOptions.Ctor.options.model;
}
// Adds a listener to vnode listener object.
function mergeVNodeListeners (obj, eventName, handler) {
  // Has a single listener, convert to array.
  if (isCallable(obj[eventName])) {
    var prevHandler = obj[eventName];
    obj[eventName] = [prevHandler];
  }

  // no listeners, create the array.
  if (isNullOrUndefined(obj[eventName])) {
    obj[eventName] = [];
  }

  obj[eventName].push(handler);
}

// Adds a listener to a native HTML vnode.
function addNativeNodeListener (node, eventName, handler) {
  if (isNullOrUndefined(node.data.on)) {
    node.data.on = {};
  }

  mergeVNodeListeners(node.data.on, eventName, handler);
}

// Adds a listener to a Vue component vnode.
function addComponentNodeListener (node, eventName, handler) {
  /* istanbul ignore next */
  if (!node.componentOptions.listeners) {
    node.componentOptions.listeners = {};
  }

  mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
}
function addVNodeListener (vnode, eventName, handler) {
  if (vnode.componentOptions) {
    addComponentNodeListener(vnode, eventName, handler);
    return;
  }

  addNativeNodeListener(vnode, eventName, handler);
}
// Determines if `change` should be used over `input` for listeners.
function getInputEventName (vnode, model) {
  // Is a component.
  if (vnode.componentOptions) {
    var ref = findModelConfig(vnode) || { event: 'input' };
    var event = ref.event;

    return event;
  }

  // Lazy Models and select tag typically use change event
  if ((model && model.modifiers && model.modifiers.lazy) || vnode.tag === 'select') {
    return 'change';
  }

  // is a textual-type input.
  if (vnode.data.attrs && isTextInput({ type: vnode.data.attrs.type || 'text' })) {
    return 'input';
  }

  return 'change';
}

function normalizeSlots (slots, ctx) {
  return Object.keys(slots).reduce(function (arr, key) {
    slots[key].forEach(function (vnode) {
      if (!vnode.context) {
        slots[key].context = ctx;
        if (!vnode.data) {
          vnode.data = {};
        }
        vnode.data.slot = key;
      }
    });

    return arr.concat(slots[key]);
  }, []);
}
function createRenderless (h, children) {
  // Only render the first item of the node.
  if (Array.isArray(children) && children[0]) {
    return children[0];
  }

  // a single node.
  if (children) {
    return children;
  }

  // No slots, render nothing.
  return h();
}

/**
 * Generates the options required to construct a field.
 */
var Resolver = function Resolver () {};

Resolver.generate = function generate (el, binding, vnode) {
  var model = Resolver.resolveModel(binding, vnode);
  var options = resolveConfig(vnode.context);

  return {
    name: Resolver.resolveName(el, vnode),
    el: el,
    listen: !binding.modifiers.disable,
    bails: binding.modifiers.bails ? true : (binding.modifiers.continues === true ? false : undefined),
    scope: Resolver.resolveScope(el, binding, vnode),
    vm: vnode.context,
    expression: binding.value,
    component: vnode.componentInstance,
    classes: options.classes,
    classNames: options.classNames,
    getter: Resolver.resolveGetter(el, vnode, model),
    events: Resolver.resolveEvents(el, vnode) || options.events,
    model: model,
    delay: Resolver.resolveDelay(el, vnode, options),
    rules: Resolver.resolveRules(el, binding, vnode),
    immediate: !!binding.modifiers.initial || !!binding.modifiers.immediate,
    persist: !!binding.modifiers.persist,
    validity: options.validity && !vnode.componentInstance,
    aria: options.aria && !vnode.componentInstance,
    initialValue: Resolver.resolveInitialValue(vnode)
  };
};

Resolver.getCtorConfig = function getCtorConfig (vnode) {
  if (!vnode.componentInstance) { return null; }

  var config = getPath('componentInstance.$options.$_veeValidate', vnode);

  return config;
};

/**
 * Resolves the rules defined on an element.
 */
Resolver.resolveRules = function resolveRules (el, binding, vnode) {
  var rules = '';
  if (!binding.value && (!binding || !binding.expression)) {
    rules = getDataAttribute(el, 'rules');
  }

  if (binding.value && includes(['string', 'object'], typeof binding.value.rules)) {
    rules = binding.value.rules;
  } else if (binding.value) {
    rules = binding.value;
  }

  if (vnode.componentInstance) {
    return rules;
  }

  // If validity is disabled, ignore field rules.
  var normalized = normalizeRules(rules);
  if (!getConfig().useConstraintAttrs) {
    return normalized;
  }

  return assign({}, fillRulesFromElement(el, {}), normalized);
};

/**
 * @param {*} vnode
 */
Resolver.resolveInitialValue = function resolveInitialValue (vnode) {
  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });

  return model && model.value;
};

/**
 * Resolves the delay value.
 * @param {*} el
 * @param {*} vnode
 * @param {Object} options
 */
Resolver.resolveDelay = function resolveDelay (el, vnode, options) {
  var delay = getDataAttribute(el, 'delay');
  var globalDelay = (options && 'delay' in options) ? options.delay : 0;

  if (!delay && vnode.componentInstance && vnode.componentInstance.$attrs) {
    delay = vnode.componentInstance.$attrs['data-vv-delay'];
  }

  if (!isObject(globalDelay)) {
    return deepParseInt(delay || globalDelay);
  }

  if (!isNullOrUndefined(delay)) {
    globalDelay.input = delay;
  }

  return deepParseInt(globalDelay);
};

/**
 * Resolves the events to validate in response to.
 * @param {*} el
 * @param {*} vnode
 */
Resolver.resolveEvents = function resolveEvents (el, vnode) {
  // resolve it from the root element.
  var events = getDataAttribute(el, 'validate-on');

  // resolve from data-vv-validate-on if its a vue component.
  if (!events && vnode.componentInstance && vnode.componentInstance.$attrs) {
    events = vnode.componentInstance.$attrs['data-vv-validate-on'];
  }

  // resolve it from $_veeValidate options.
  if (!events && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    events = config && config.events;
  }

  if (!events && getConfig().events) {
    events = getConfig().events;
  }

  // resolve the model event if its configured for custom components.
  if (events && vnode.componentInstance && includes(events, 'input')) {
    var ref = vnode.componentInstance.$options.model || { event: 'input' };
      var event = ref.event;
    // if the prop was configured but not the model.
    if (!event) {
      return events;
    }

    events = events.replace('input', event);
  }

  return events;
};

/**
 * Resolves the scope for the field.
 * @param {*} el
 * @param {*} binding
 */
Resolver.resolveScope = function resolveScope (el, binding, vnode) {
    if ( vnode === void 0 ) vnode = {};

  var scope = null;
  if (vnode.componentInstance && isNullOrUndefined(scope)) {
    scope = vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-scope'];
  }

  return !isNullOrUndefined(scope) ? scope : getScope(el);
};

/**
 * Checks if the node directives contains a v-model or a specified arg.
 * Args take priority over models.
 *
 * @return {Object}
 */
Resolver.resolveModel = function resolveModel (binding, vnode) {
  if (binding.arg) {
    return { expression: binding.arg };
  }

  var model = findModel(vnode);
  if (!model) {
    return null;
  }

  // https://github.com/vuejs/vue/blob/dev/src/core/util/lang.js#L26
  var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
  var lazy = !!(model.modifiers && model.modifiers.lazy);

  if (!watchable) {
    return { expression: null, lazy: lazy };
  }

  return { expression: model.expression, lazy: lazy };
};

/**
 * Resolves the field name to trigger validations.
 * @return {String} The field name.
 */
Resolver.resolveName = function resolveName (el, vnode) {
  var name = getDataAttribute(el, 'name');

  if (!name && !vnode.componentInstance) {
    return el.name;
  }

  if (!name && vnode.componentInstance && vnode.componentInstance.$attrs) {
    name = vnode.componentInstance.$attrs['data-vv-name'] || vnode.componentInstance.$attrs['name'];
  }

  if (!name && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.name)) {
      var boundGetter = config.name.bind(vnode.componentInstance);

      return boundGetter();
    }

    return vnode.componentInstance.name;
  }

  return name;
};

/**
 * Returns a value getter input type.
 */
Resolver.resolveGetter = function resolveGetter (el, vnode, model) {
  if (model && model.expression) {
    return function () {
      return getPath(model.expression, vnode.context);
    };
  }

  if (vnode.componentInstance) {
    var path = getDataAttribute(el, 'value-path') || (vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-value-path']);
    if (path) {
      return function () {
        return getPath(path, vnode.componentInstance);
      };
    }

    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.value)) {
      var boundGetter = config.value.bind(vnode.componentInstance);

      return function () {
        return boundGetter();
      };
    }

    var ref = vnode.componentInstance.$options.model || { prop: 'value' };
      var prop = ref.prop;

    return function () {
      return vnode.componentInstance[prop];
    };
  }

  switch (el.type) {
  case 'checkbox': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));

    els = toArray(els).filter(function (el) { return el.checked; });
    if (!els.length) { return undefined; }

    return els.map(function (checkbox) { return checkbox.value; });
  };
  case 'radio': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
    var elm = find(els, function (el) { return el.checked; });

    return elm && elm.value;
  };
  case 'file': return function (context) {
    return toArray(el.files);
  };
  case 'select-multiple': return function () {
    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
  };
  default: return function () {
    return el && el.value;
  };
  }
};

var RULES = {};

var RuleContainer = function RuleContainer () {};

var staticAccessors = { rules: { configurable: true } };

RuleContainer.add = function add (name, ref) {
    var validate = ref.validate;
    var options = ref.options;
    var paramNames = ref.paramNames;

  RULES[name] = {
    validate: validate,
    options: options,
    paramNames: paramNames
  };
};

staticAccessors.rules.get = function () {
  return RULES;
};

RuleContainer.has = function has (name) {
  return !!RULES[name];
};

RuleContainer.isImmediate = function isImmediate (name) {
  return !!(RULES[name] && RULES[name].options.immediate);
};

RuleContainer.isRequireRule = function isRequireRule (name) {
  return !!(RULES[name] && RULES[name].options.computesRequired);
};

RuleContainer.isTargetRule = function isTargetRule (name) {
  return !!(RULES[name] && RULES[name].options.hasTarget);
};

RuleContainer.remove = function remove (ruleName) {
  delete RULES[ruleName];
};

RuleContainer.getParamNames = function getParamNames (ruleName) {
  return RULES[ruleName] && RULES[ruleName].paramNames;
};

RuleContainer.getOptions = function getOptions (ruleName) {
  return RULES[ruleName] && RULES[ruleName].options;
};

RuleContainer.getValidatorMethod = function getValidatorMethod (ruleName) {
  return RULES[ruleName] ? RULES[ruleName].validate : null;
};

Object.defineProperties( RuleContainer, staticAccessors );

// 

var isEvent = function (evt) {
  return (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) || (evt && evt.srcElement);
};

var normalizeEvents = function (evts) {
  if (!evts) { return []; }

  return (typeof evts === 'string' ? evts.split('|') : evts);
};

var supportsPassive = true;

var detectPassiveSupport = function () {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get () {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    supportsPassive = false;
  }
  return supportsPassive;
};

var addEventListener = function (el, eventName, cb) {
  el.addEventListener(eventName, cb, supportsPassive ? { passive: true } : false);
};

// 

var DEFAULT_OPTIONS = {
  targetOf: null,
  immediate: false,
  persist: false,
  scope: null,
  listen: true,
  name: null,
  rules: {},
  vm: null,
  classes: false,
  validity: true,
  aria: true,
  events: 'input|blur',
  delay: 0,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
};

var Field = function Field (options) {
  if ( options === void 0 ) options = {};

  this.id = uniqId();
  this.el = options.el;
  this.updated = false;
  this.vmId = options.vmId;
  defineNonReactive(this, 'dependencies', []);
  defineNonReactive(this, 'watchers', []);
  defineNonReactive(this, 'events', []);
  this.delay = 0;
  this.rules = {};
  this.forceRequired = false;
  this._cacheId(options);
  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
  options = assign({}, DEFAULT_OPTIONS, options);
  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
  this.validity = options.validity;
  this.aria = options.aria;
  this.flags = options.flags || createFlags();
  defineNonReactive(this, 'vm', options.vm);
  defineNonReactive(this, 'componentInstance', options.component);
  this.ctorConfig = this.componentInstance ? getPath('$options.$_veeValidate', this.componentInstance) : undefined;
  this.update(options);
  // set initial value.
  this.initialValue = this.value;
  this.updated = false;
};

var prototypeAccessors$1 = { validator: { configurable: true },isRequired: { configurable: true },isDisabled: { configurable: true },alias: { configurable: true },value: { configurable: true },bails: { configurable: true },rejectsFalse: { configurable: true } };

prototypeAccessors$1.validator.get = function () {
  if (!this.vm || !this.vm.$validator) {
    return { validate: function () { return Promise.resolve(true); } };
  }

  return this.vm.$validator;
};

prototypeAccessors$1.isRequired.get = function () {
  return !!this.rules.required || this.forceRequired;
};

prototypeAccessors$1.isDisabled.get = function () {
  return !!(this.el && this.el.disabled);
};

/**
 * Gets the display name (user-friendly name).
 */
prototypeAccessors$1.alias.get = function () {
  if (this._alias) {
    return this._alias;
  }

  var alias = null;
  if (this.ctorConfig && this.ctorConfig.alias) {
    alias = isCallable(this.ctorConfig.alias) ? this.ctorConfig.alias.call(this.componentInstance) : this.ctorConfig.alias;
  }

  if (!alias && this.el) {
    alias = getDataAttribute(this.el, 'as');
  }

  if (!alias && this.componentInstance) {
    return this.componentInstance.$attrs && this.componentInstance.$attrs['data-vv-as'];
  }

  return alias;
};

/**
 * Gets the input value.
 */

prototypeAccessors$1.value.get = function () {
  if (!isCallable(this.getter)) {
    return undefined;
  }

  return this.getter();
};

prototypeAccessors$1.bails.get = function () {
  return this._bails;
};

/**
 * If the field rejects false as a valid value for the required rule.
 */

prototypeAccessors$1.rejectsFalse.get = function () {
  if (this.componentInstance && this.ctorConfig) {
    return !!this.ctorConfig.rejectsFalse;
  }

  if (!this.el) {
    return false;
  }

  return this.el.type === 'checkbox';
};

/**
 * Determines if the instance matches the options provided.
 */
Field.prototype.matches = function matches (options) {
    var this$1 = this;

  if (!options) {
    return true;
  }

  if (options.id) {
    return this.id === options.id;
  }

  var matchesComponentId = isNullOrUndefined(options.vmId) ? function () { return true; } : function (id) { return id === this$1.vmId; };
  if (!matchesComponentId(options.vmId)) {
    return false;
  }

  if (options.name === undefined && options.scope === undefined) {
    return true;
  }

  if (options.scope === undefined) {
    return this.name === options.name;
  }

  if (options.name === undefined) {
    return this.scope === options.scope;
  }

  return options.name === this.name && options.scope === this.scope;
};

/**
 * Caches the field id.
 */
Field.prototype._cacheId = function _cacheId (options) {
  if (this.el && !options.targetOf) {
    this.el._veeValidateId = this.id;
  }
};

/**
 * Keeps a reference of the most current validation run.
 */
Field.prototype.waitFor = function waitFor (pendingPromise) {
  this._waitingFor = pendingPromise;
};

Field.prototype.isWaitingFor = function isWaitingFor (promise) {
  return this._waitingFor === promise;
};

/**
 * Updates the field with changed data.
 */
Field.prototype.update = function update (options) {
    var this$1 = this;

  this.targetOf = options.targetOf || null;
  this.immediate = options.immediate || this.immediate || false;
  this.persist = options.persist || this.persist || false;

  // update errors scope if the field scope was changed.
  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
    this.validator.update(this.id, { scope: options.scope });
  }
  this.scope = !isNullOrUndefined(options.scope) ? options.scope
    : !isNullOrUndefined(this.scope) ? this.scope : null;
  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
  this._bails = options.bails !== undefined ? options.bails : this._bails;
  this.model = options.model || this.model;
  this.listen = options.listen !== undefined ? options.listen : this.listen;
  this.classes = (options.classes || this.classes || false) && !this.componentInstance;
  this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
  this.getter = isCallable(options.getter) ? options.getter : this.getter;
  this._alias = options.alias || this._alias;
  this.events = (options.events) ? normalizeEvents(options.events) : this.events;
  this.delay = makeDelayObject(this.events, options.delay || this.delay, this._delay);
  this.updateDependencies();
  this.addActionListeners();

  if (false) {}

  // update required flag flags
  if (options.rules !== undefined) {
    this.flags.required = this.isRequired;
  }

  if (Object.keys(options.rules || {}).length === 0 && this.updated) {
    var resetFlag = this.flags.validated;
    this.validator.validate(("#" + (this.id))).then(function () {
      this$1.flags.validated = resetFlag;
    });
  }

  // validate if it was validated before and field was updated and there was a rules mutation.
  if (this.flags.validated && options.rules !== undefined && this.updated) {
    this.validator.validate(("#" + (this.id)));
  }

  this.updated = true;
  this.addValueListeners();

  // no need to continue.
  if (!this.el) {
    return;
  }
  this.updateClasses();
  this.updateAriaAttrs();
};

/**
 * Resets field flags and errors.
 */
Field.prototype.reset = function reset () {
    var this$1 = this;

  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
    delete this._cancellationToken;
  }

  var defaults = createFlags();
  Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
    this$1.flags[flag] = defaults[flag];
  });

  // update initial value
  this.initialValue = this.value;
  this.flags.changed = false;

  this.addValueListeners();
  this.addActionListeners();
  this.updateClasses(true);
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
 */
Field.prototype.setFlags = function setFlags (flags) {
    var this$1 = this;

  var negated = {
    pristine: 'dirty',
    dirty: 'pristine',
    valid: 'invalid',
    invalid: 'valid',
    touched: 'untouched',
    untouched: 'touched'
  };

  Object.keys(flags).forEach(function (flag) {
    this$1.flags[flag] = flags[flag];
    // if it has a negation and was not specified, set it as well.
    if (negated[flag] && flags[negated[flag]] === undefined) {
      this$1.flags[negated[flag]] = !flags[flag];
    }
  });

  if (
    flags.untouched !== undefined ||
    flags.touched !== undefined ||
    flags.dirty !== undefined ||
    flags.pristine !== undefined
  ) {
    this.addActionListeners();
  }
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Determines if the field requires references to target fields.
*/
Field.prototype.updateDependencies = function updateDependencies () {
    var this$1 = this;

  // reset dependencies.
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];

  // we get the selectors for each field.
  var fields = Object.keys(this.rules).reduce(function (prev, r) {
    if (RuleContainer.isTargetRule(r)) {
      prev.push({ selector: this$1.rules[r][0], name: r });
    }

    return prev;
  }, []);

  if (!fields.length || !this.vm || !this.vm.$el) { return; }

  // must be contained within the same component, so we use the vm root element constrain our dom search.
  fields.forEach(function (ref$1) {
      var selector = ref$1.selector;
      var name = ref$1.name;

    var ref = this$1.vm.$refs[selector];
    var el = Array.isArray(ref) ? ref[0] : ref;
    if (!el) {
      return;
    }

    var options = {
      vm: this$1.vm,
      classes: this$1.classes,
      classNames: this$1.classNames,
      delay: this$1.delay,
      scope: this$1.scope,
      events: this$1.events.join('|'),
      immediate: this$1.immediate,
      targetOf: this$1.id
    };

    // probably a component.
    if (isCallable(el.$watch)) {
      options.component = el;
      options.el = el.$el;
      options.getter = Resolver.resolveGetter(el.$el, el.$vnode);
    } else {
      options.el = el;
      options.getter = Resolver.resolveGetter(el, {});
    }

    this$1.dependencies.push({ name: name, field: new Field(options) });
  });
};

/**
 * Removes listeners.
 */
Field.prototype.unwatch = function unwatch (tag) {
    if ( tag === void 0 ) tag = null;

  if (!tag) {
    this.watchers.forEach(function (w) { return w.unwatch(); });
    this.watchers = [];
    return;
  }

  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
};

/**
 * Updates the element classes depending on each field flag status.
 */
Field.prototype.updateClasses = function updateClasses (isReset) {
    var this$1 = this;
    if ( isReset === void 0 ) isReset = false;

  if (!this.classes || this.isDisabled) { return; }
  var applyClasses = function (el) {
    toggleClass(el, this$1.classNames.dirty, this$1.flags.dirty);
    toggleClass(el, this$1.classNames.pristine, this$1.flags.pristine);
    toggleClass(el, this$1.classNames.touched, this$1.flags.touched);
    toggleClass(el, this$1.classNames.untouched, this$1.flags.untouched);

    // remove valid/invalid classes on reset.
    if (isReset) {
      toggleClass(el, this$1.classNames.valid, false);
      toggleClass(el, this$1.classNames.invalid, false);
    }

    // make sure we don't set any classes if the state is undetermined.
    if (!isNullOrUndefined(this$1.flags.valid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.valid, this$1.flags.valid);
    }

    if (!isNullOrUndefined(this$1.flags.invalid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.invalid, this$1.flags.invalid);
    }
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyClasses(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyClasses);
};

/**
 * Adds the listeners required for automatic classes and some flags.
 */
Field.prototype.addActionListeners = function addActionListeners () {
    var this$1 = this;

  // remove previous listeners.
  this.unwatch(/class/);

  if (!this.el) { return; }

  var onBlur = function () {
    this$1.flags.touched = true;
    this$1.flags.untouched = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.touched, true);
      toggleClass(this$1.el, this$1.classNames.untouched, false);
    }

    // only needed once.
    this$1.unwatch(/^class_blur$/);
  };

  var inputEvent = isTextInput(this.el) ? 'input' : 'change';
  var onInput = function () {
    this$1.flags.dirty = true;
    this$1.flags.pristine = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.pristine, false);
      toggleClass(this$1.el, this$1.classNames.dirty, true);
    }

    // only needed once.
    this$1.unwatch(/^class_input$/);
  };

  if (this.componentInstance && isCallable(this.componentInstance.$once)) {
    this.componentInstance.$once('input', onInput);
    this.componentInstance.$once('blur', onBlur);
    this.watchers.push({
      tag: 'class_input',
      unwatch: function () {
        this$1.componentInstance.$off('input', onInput);
      }
    });
    this.watchers.push({
      tag: 'class_blur',
      unwatch: function () {
        this$1.componentInstance.$off('blur', onBlur);
      }
    });
    return;
  }

  if (!this.el) { return; }

  addEventListener(this.el, inputEvent, onInput);
  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
  var blurEvent = isCheckboxOrRadioInput(this.el) ? 'change' : 'blur';
  addEventListener(this.el, blurEvent, onBlur);
  this.watchers.push({
    tag: 'class_input',
    unwatch: function () {
      this$1.el.removeEventListener(inputEvent, onInput);
    }
  });

  this.watchers.push({
    tag: 'class_blur',
    unwatch: function () {
      this$1.el.removeEventListener(blurEvent, onBlur);
    }
  });
};

Field.prototype.checkValueChanged = function checkValueChanged () {
  // handle some people initialize the value to null, since text inputs have empty string value.
  if (this.initialValue === null && this.value === '' && isTextInput(this.el)) {
    return false;
  }

  return this.value !== this.initialValue;
};

/**
 * Determines the suitable primary event to listen for.
 */
Field.prototype._determineInputEvent = function _determineInputEvent () {
  // if its a custom component, use the customized model event or the input event.
  if (this.componentInstance) {
    return (this.componentInstance.$options.model && this.componentInstance.$options.model.event) || 'input';
  }

  if (this.model && this.model.lazy) {
    return 'change';
  }

  if (isTextInput(this.el)) {
    return 'input';
  }

  return 'change';
};

/**
 * Determines the list of events to listen to.
 */
Field.prototype._determineEventList = function _determineEventList (defaultInputEvent) {
    var this$1 = this;

  // if no event is configured, or it is a component or a text input then respect the user choice.
  if (!this.events.length || this.componentInstance || isTextInput(this.el)) {
    return [].concat( this.events ).map(function (evt) {
      if (evt === 'input' && this$1.model && this$1.model.lazy) {
        return 'change';
      }

      return evt;
    });
  }

  // force suitable event for non-text type fields.
  return this.events.map(function (e) {
    if (e === 'input') {
      return defaultInputEvent;
    }

    return e;
  });
};

/**
 * Adds the listeners required for validation.
 */
Field.prototype.addValueListeners = function addValueListeners () {
    var this$1 = this;

  this.unwatch(/^input_.+/);
  if (!this.listen || !this.el) { return; }

  var token = { cancelled: false };
  var fn = this.targetOf ? function () {
    var target = this$1.validator._resolveField(("#" + (this$1.targetOf)));
    if (target && target.flags.validated) {
      this$1.validator.validate(("#" + (this$1.targetOf)));
    }
  } : function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
    if (args.length === 0 || isEvent(args[0])) {
      args[0] = this$1.value;
    }

    this$1.flags.pending = true;
    this$1._cancellationToken = token;
    this$1.validator.validate(("#" + (this$1.id)), args[0]);
  };

  var inputEvent = this._determineInputEvent();
  var events = this._determineEventList(inputEvent);

  // if on input validation is requested.
  if (includes(events, inputEvent)) {
    var ctx = null;
    var expression = null;
    var watchCtxVm = false;
    // if its watchable from the context vm.
    if (this.model && this.model.expression) {
      ctx = this.vm;
      expression = this.model.expression;
      watchCtxVm = true;
    }

    // watch it from the custom component vm instead.
    if (!expression && this.componentInstance && this.componentInstance.$options.model) {
      ctx = this.componentInstance;
      expression = this.componentInstance.$options.model.prop || 'value';
    }

    if (ctx && expression) {
      var debouncedFn = debounce(fn, this.delay[inputEvent], token);
      var unwatch = ctx.$watch(expression, debouncedFn);
      this.watchers.push({
        tag: 'input_model',
        unwatch: function () {
          this$1.vm.$nextTick(function () {
            unwatch();
          });
        }
      });

      // filter out input event when we are watching from the context vm.
      if (watchCtxVm) {
        events = events.filter(function (e) { return e !== inputEvent; });
      }
    }
  }

  // Add events.
  events.forEach(function (e) {
    var debouncedFn = debounce(fn, this$1.delay[e], token);

    this$1._addComponentEventListener(e, debouncedFn);
    this$1._addHTMLEventListener(e, debouncedFn);
  });
};

Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
    var this$1 = this;

  if (!this.componentInstance) { return; }

  this.componentInstance.$on(evt, validate);
  this.watchers.push({
    tag: 'input_vue',
    unwatch: function () {
      this$1.componentInstance.$off(evt, validate);
    }
  });
};

Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
    var this$1 = this;

  if (!this.el || this.componentInstance) { return; }

  // listen for the current element.
  var addListener = function (el) {
    addEventListener(el, evt, validate);
    this$1.watchers.push({
      tag: 'input_native',
      unwatch: function () {
        el.removeEventListener(evt, validate);
      }
    });
  };

  addListener(this.el);
  if (!isCheckboxOrRadioInput(this.el)) {
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(function (el) {
    // skip if it is added by v-validate and is not the current element.
    if (el._veeValidateId && el !== this$1.el) {
      return;
    }

    addListener(el);
  });
};

/**
 * Updates aria attributes on the element.
 */
Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
    var this$1 = this;

  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) { return; }

  var applyAriaAttrs = function (el) {
    el.setAttribute('aria-required', this$1.isRequired ? 'true' : 'false');
    el.setAttribute('aria-invalid', this$1.flags.invalid ? 'true' : 'false');
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyAriaAttrs(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyAriaAttrs);
};

/**
 * Updates the custom validity for the field.
 */
Field.prototype.updateCustomValidity = function updateCustomValidity () {
  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity) || !this.validator.errors) { return; }

  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
};

/**
 * Removes all listeners.
 */
Field.prototype.destroy = function destroy () {
  // ignore the result of any ongoing validation.
  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
  }

  this.unwatch();
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];
};

Object.defineProperties( Field.prototype, prototypeAccessors$1 );

// 

var FieldBag = function FieldBag (items) {
  if ( items === void 0 ) items = [];

  this.items = items || [];
  this.itemsById = this.items.reduce(function (itemsById, item) {
    itemsById[item.id] = item;
    return itemsById;
  }, {});
};

var prototypeAccessors$2 = { length: { configurable: true } };

FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Gets the current items length.
 */

prototypeAccessors$2.length.get = function () {
  return this.items.length;
};

/**
 * Finds the first field that matches the provided matcher object.
 */
FieldBag.prototype.find = function find$1 (matcher) {
  return find(this.items, function (item) { return item.matches(matcher); });
};

/**
 * Finds the field with the given id, using a plain object as a map to link
 * ids to items faster than by looping over the array and matching.
 */
FieldBag.prototype.findById = function findById (id) {
  return this.itemsById[id] || null;
};

/**
 * Filters the items down to the matched fields.
 */
FieldBag.prototype.filter = function filter (matcher) {
  // multiple matchers to be tried.
  if (Array.isArray(matcher)) {
    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
  }

  return this.items.filter(function (item) { return item.matches(matcher); });
};

/**
 * Maps the field items using the mapping function.
 */
FieldBag.prototype.map = function map (mapper) {
  return this.items.map(mapper);
};

/**
 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
 */
FieldBag.prototype.remove = function remove (matcher) {
  var item = null;
  if (matcher instanceof Field) {
    item = matcher;
  } else {
    item = this.find(matcher);
  }

  if (!item) { return null; }

  var index = this.items.indexOf(item);
  this.items.splice(index, 1);
  delete this.itemsById[item.id];

  return item;
};

/**
 * Adds a field item to the list.
 */
FieldBag.prototype.push = function push (item) {
  if (! (item instanceof Field)) {
    throw createError('FieldBag only accepts instances of Field that has an id defined.');
  }

  if (!item.id) {
    throw createError('Field id must be defined.');
  }

  if (this.findById(item.id)) {
    throw createError(("Field with id " + (item.id) + " is already added."));
  }

  this.items.push(item);
  this.itemsById[item.id] = item;
};

Object.defineProperties( FieldBag.prototype, prototypeAccessors$2 );

var ScopedValidator = function ScopedValidator (base, vm) {
  this.id = vm._uid;
  this._base = base;
  this._paused = false;

  // create a mirror bag with limited component scope.
  this.errors = new ErrorBag(base.errors, this.id);
};

var prototypeAccessors$3 = { flags: { configurable: true },rules: { configurable: true },fields: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

prototypeAccessors$3.flags.get = function () {
    var this$1 = this;

  return this._base.fields.items.filter(function (f) { return f.vmId === this$1.id; }).reduce(function (acc, field) {
    if (field.scope) {
      if (!acc[("$" + (field.scope))]) {
        acc[("$" + (field.scope))] = {};
      }

      acc[("$" + (field.scope))][field.name] = field.flags;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

prototypeAccessors$3.rules.get = function () {
  return this._base.rules;
};

prototypeAccessors$3.fields.get = function () {
  return new FieldBag(this._base.fields.filter({ vmId: this.id }));
};

prototypeAccessors$3.dictionary.get = function () {
  return this._base.dictionary;
};

prototypeAccessors$3.locale.get = function () {
  return this._base.locale;
};

prototypeAccessors$3.locale.set = function (val) {
  this._base.locale = val;
};

ScopedValidator.prototype.localize = function localize () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).localize.apply(ref, args);
};

ScopedValidator.prototype.update = function update () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).update.apply(ref, args);
};

ScopedValidator.prototype.attach = function attach (opts) {
  var attachOpts = assign({}, opts, { vmId: this.id });

  return this._base.attach(attachOpts);
};

ScopedValidator.prototype.pause = function pause () {
  this._paused = true;
};

ScopedValidator.prototype.resume = function resume () {
  this._paused = false;
};

ScopedValidator.prototype.remove = function remove (ruleName) {
  return this._base.remove(ruleName);
};

ScopedValidator.prototype.detach = function detach (name, scope) {
  return this._base.detach(name, scope, this.id);
};

ScopedValidator.prototype.extend = function extend () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).extend.apply(ref, args);
};

ScopedValidator.prototype.validate = function validate (descriptor, value, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validate(descriptor, value, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.verify = function verify () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).verify.apply(ref, args);
};

ScopedValidator.prototype.validateAll = function validateAll (values, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateAll(values, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.validateScopes = function validateScopes (opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateScopes(assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.destroy = function destroy () {
  delete this.id;
  delete this._base;
};

ScopedValidator.prototype.reset = function reset (matcher) {
  return this._base.reset(Object.assign({}, matcher || {}, { vmId: this.id }));
};

ScopedValidator.prototype.flag = function flag () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).flag.apply(ref, args.concat( [this.id] ));
};

ScopedValidator.prototype._resolveField = function _resolveField () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base)._resolveField.apply(ref, args);
};

Object.defineProperties( ScopedValidator.prototype, prototypeAccessors$3 );

var VALIDATOR = null;

var getValidator = function () {
  return VALIDATOR;
};

var setValidator = function (value) {
  VALIDATOR = value;

  return value;
};

// 

/**
 * Checks if a parent validator instance was requested.
 */
var requestsValidator = function (injections) {
  if (isObject(injections) && injections.$validator) {
    return true;
  }

  return false;
};

var mixin = {
  provide: function provide () {
    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
      return {
        $validator: this.$validator
      };
    }

    return {};
  },
  beforeCreate: function beforeCreate () {
    // if built in do nothing.
    if (isBuiltInComponent(this.$vnode) || this.$options.$__veeInject === false) {
      return;
    }

    // if its a root instance set the config if it exists.
    if (!this.$parent) {
      setConfig(this.$options.$_veeValidate || {});
    }

    var options = resolveConfig(this);

    // if its a root instance, inject anyways, or if it requested a new instance.
    if (!this.$parent || (this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator))) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    var requested = requestsValidator(this.$options.inject);

    // if automatic injection is enabled and no instance was requested.
    if (! this.$validator && options.inject && !requested) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    // don't inject errors or fieldBag as no validator was resolved.
    if (!requested && !this.$validator) {
      return;
    }

    // There is a validator but it isn't injected, mark as reactive.
    if (!requested && this.$validator) {
      var Vue = this.$options._base; // the vue constructor.
      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
    }

    if (!this.$options.computed) {
      this.$options.computed = {};
    }

    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
      return this.$validator.errors;
    };
    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
      return this.$validator.fields.items.reduce(function (acc, field) {
        if (field.scope) {
          if (!acc[("$" + (field.scope))]) {
            acc[("$" + (field.scope))] = {};
          }

          acc[("$" + (field.scope))][field.name] = field.flags;

          return acc;
        }

        acc[field.name] = field.flags;

        return acc;
      }, {});
    };
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$validator && this._uid === this.$validator.id) {
      this.$validator.errors.clear(); // remove errors generated by this component.
    }
  }
};

// 

/**
 * Finds the requested field by id from the context object.
 */
function findField (el, context) {
  if (!context || !context.$validator) {
    return null;
  }

  return context.$validator.fields.findById(el._veeValidateId);
}
var directive = {
  bind: function bind (el, binding, vnode) {
    var validator = vnode.context.$validator;
    if (!validator) {
      if (false) {}

      return;
    }

    var fieldOptions = Resolver.generate(el, binding, vnode);
    validator.attach(fieldOptions);
  },
  inserted: function inserted (el, binding, vnode) {
    var field = findField(el, vnode.context);
    var scope = Resolver.resolveScope(el, binding, vnode);

    // skip if scope hasn't changed.
    if (!field || scope === field.scope) { return; }

    // only update scope.
    field.update({ scope: scope });

    // allows the field to re-evaluated once more in the update hook.
    field.updated = false;
  },
  update: function update (el, binding, vnode) {
    var field = findField(el, vnode.context);

    // make sure we don't do unneccasary work if no important change was done.
    if (!field || (field.updated && isEqual(binding.value, binding.oldValue))) { return; }
    var scope = Resolver.resolveScope(el, binding, vnode);
    var rules = Resolver.resolveRules(el, binding, vnode);

    field.update({
      scope: scope,
      rules: rules
    });
  },
  unbind: function unbind (el, binding, ref) {
    var context = ref.context;

    var field = findField(el, context);
    if (!field) { return; }

    context.$validator.detach(field);
  }
};

// 

var Validator = function Validator (validations, options, pluginContainer) {
  if ( options === void 0 ) options = { fastExit: true };
  if ( pluginContainer === void 0 ) pluginContainer = null;

  this.errors = new ErrorBag();
  this.fields = new FieldBag();
  this._createFields(validations);
  this.paused = false;
  this.fastExit = !isNullOrUndefined(options && options.fastExit) ? options.fastExit : true;
  this.$vee = pluginContainer || {
    _vm: {
      $nextTick: function (cb) { return isCallable(cb) ? cb() : Promise.resolve(); },
      $emit: function () {},
      $off: function () {}
    }
  };
};

var prototypeAccessors$4 = { rules: { configurable: true },dictionary: { configurable: true },flags: { configurable: true },locale: { configurable: true } };
var staticAccessors$1 = { rules: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

/**
 * @deprecated
 */
staticAccessors$1.rules.get = function () {
  if (false) {}

  return RuleContainer.rules;
};

/**
 * @deprecated
 */
prototypeAccessors$4.rules.get = function () {
  if (false) {}

  return RuleContainer.rules;
};

prototypeAccessors$4.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$1.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$4.flags.get = function () {
  return this.fields.items.reduce(function (acc, field) {
      var obj;

    if (field.scope) {
      acc[("$" + (field.scope))] = ( obj = {}, obj[field.name] = field.flags, obj );

      return acc;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

/**
 * Getter for the current locale.
 */
prototypeAccessors$4.locale.get = function () {
  return Validator.locale;
};

/**
 * Setter for the validator locale.
 */
prototypeAccessors$4.locale.set = function (value) {
  Validator.locale = value;
};

staticAccessors$1.locale.get = function () {
  return DictionaryResolver.getDriver().locale;
};

/**
 * Setter for the validator locale.
 */
staticAccessors$1.locale.set = function (value) {
  var hasChanged = value !== DictionaryResolver.getDriver().locale;
  DictionaryResolver.getDriver().locale = value;
  if (hasChanged && Validator.$vee && Validator.$vee._vm) {
    Validator.$vee._vm.$emit('localeChanged');
  }
};

/**
 * Static constructor.
 * @deprecated
 */
Validator.create = function create (validations, options) {
  if (false) {}

  return new Validator(validations, options);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator._guardExtend(name, validator);
  // rules imported from the minimal bundle
  // will have the options embedded in them
  var mergedOpts = validator.options || {};
  Validator._merge(name, {
    validator: validator,
    paramNames: (options && options.paramNames) || validator.paramNames,
    options: assign({ hasTarget: false, immediate: true }, mergedOpts, options || {})
  });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.remove = function remove (name) {
  if (false) {}

  RuleContainer.remove(name);
};

/**
 * Adds and sets the current locale for the validator.
*/
Validator.prototype.localize = function localize (lang, dictionary) {
  Validator.localize(lang, dictionary);
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.localize = function localize (lang, dictionary) {
    var obj;

  if (isObject(lang)) {
    DictionaryResolver.getDriver().merge(lang);
    return;
  }

  // merge the dictionary.
  if (dictionary) {
    var locale = lang || dictionary.name;
    dictionary = assign({}, dictionary);
    DictionaryResolver.getDriver().merge(( obj = {}, obj[locale] = dictionary, obj ));
  }

  if (lang) {
    // set the locale.
    Validator.locale = lang;
  }
};

/**
 * Registers a field to be validated.
 */
Validator.prototype.attach = function attach (fieldOpts) {
    var this$1 = this;

  // We search for a field with the same name & scope, having persist enabled
  var oldFieldMatcher = { name: fieldOpts.name, scope: fieldOpts.scope, persist: true };
  var oldField = fieldOpts.persist ? this.fields.find(oldFieldMatcher) : null;

  if (oldField) {
    // We keep the flags of the old field, then we remove its instance
    fieldOpts.flags = oldField.flags;
    oldField.destroy();
    this.fields.remove(oldField);
  }

  // fixes initial value detection with v-model and select elements.
  var value = fieldOpts.initialValue;
  var field = new Field(fieldOpts);
  this.fields.push(field);

  // validate the field initially
  if (field.immediate) {
    this.$vee._vm.$nextTick(function () { return this$1.validate(("#" + (field.id)), value || field.value, { vmId: fieldOpts.vmId }); });
  } else {
    this._validate(field, value || field.value, { initial: true }).then(function (result) {
      field.flags.valid = result.valid;
      field.flags.invalid = !result.valid;
    });
  }

  return field;
};

/**
 * Sets the flags on a field.
 */
Validator.prototype.flag = function flag (name, flags, uid) {
    if ( uid === void 0 ) uid = null;

  var field = this._resolveField(name, undefined, uid);
  if (!field || !flags) {
    return;
  }

  field.setFlags(flags);
};

/**
 * Removes a field from the validator.
 */
Validator.prototype.detach = function detach (name, scope, uid) {
  var field = isCallable(name.destroy) ? name : this._resolveField(name, scope, uid);
  if (!field) { return; }

  // We destroy/remove the field & error instances if it's not a `persist` one
  if (!field.persist) {
    field.destroy();
    this.errors.remove(field.name, field.scope, field.vmId);
    this.fields.remove(field);
  }
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.prototype.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator.extend(name, validator, options);
};

Validator.prototype.reset = function reset (matcher) {
    var this$1 = this;

  // two ticks
  return this.$vee._vm.$nextTick().then(function () {
    return this$1.$vee._vm.$nextTick();
  }).then(function () {
    this$1.fields.filter(matcher).forEach(function (field) {
      field.waitFor(null);
      field.reset(); // reset field flags.
      this$1.errors.remove(field.name, field.scope, matcher && matcher.vmId);
    });
  });
};

/**
 * Updates a field, updating both errors and flags.
 */
Validator.prototype.update = function update (id, ref) {
    var scope = ref.scope;

  var field = this._resolveField(("#" + id));
  if (!field) { return; }

  // remove old scope.
  this.errors.update(id, { scope: scope });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.prototype.remove = function remove (name) {
  Validator.remove(name);
};

/**
 * Validates a value against a registered field validations.
 */
Validator.prototype.validate = function validate (fieldDescriptor, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  // overload to validate all.
  if (isNullOrUndefined(fieldDescriptor)) {
    return this.validateScopes({ silent: silent, vmId: vmId });
  }

  // overload to validate scope-less fields.
  if (fieldDescriptor === '*') {
    return this.validateAll(undefined, { silent: silent, vmId: vmId });
  }

  // if scope validation was requested.
  if (/^(.+)\.\*$/.test(fieldDescriptor)) {
    var matched = fieldDescriptor.match(/^(.+)\.\*$/)[1];
    return this.validateAll(matched);
  }

  var field = this._resolveField(fieldDescriptor);
  if (!field) {
    return this._handleFieldNotFound(fieldDescriptor);
  }

  if (!silent) { field.flags.pending = true; }
  if (value === undefined) {
    value = field.value;
  }

  var validationPromise = this._validate(field, value);
  field.waitFor(validationPromise);

  return validationPromise.then(function (result) {
    if (!silent && field.isWaitingFor(validationPromise)) {
      // allow next validation to mutate the state.
      field.waitFor(null);
      this$1._handleValidationResults([result], vmId);
    }

    return result.valid;
  });
};

/**
 * Pauses the validator.
 */
Validator.prototype.pause = function pause () {
  this.paused = true;

  return this;
};

/**
 * Resumes the validator.
 */
Validator.prototype.resume = function resume () {
  this.paused = false;

  return this;
};

/**
 * Validates each value against the corresponding field validations.
 */
Validator.prototype.validateAll = function validateAll (values, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  var matcher = null;
  var providedValues = false;

  if (typeof values === 'string') {
    matcher = { scope: values, vmId: vmId };
  } else if (isObject(values)) {
    matcher = Object.keys(values).map(function (key) {
      return { name: key, vmId: vmId, scope: null };
    });
    providedValues = true;
  } else if (Array.isArray(values)) {
    matcher = values.map(function (key) {
      return typeof key === 'object' ? Object.assign({ vmId: vmId }, key) : { name: key, vmId: vmId };
    });
  } else {
    matcher = { scope: null, vmId: vmId };
  }

  return Promise.all(
    this.fields.filter(matcher).map(function (field) { return this$1._validate(field, providedValues ? values[field.name] : field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates all scopes.
 */
Validator.prototype.validateScopes = function validateScopes (ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  return Promise.all(
    this.fields.filter({ vmId: vmId }).map(function (field) { return this$1._validate(field, field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates a value against the rules.
 */
Validator.prototype.verify = function verify (value, rules, options) {
    if ( options === void 0 ) options = {};

  var field = {
    name: (options && options.name) || '{field}',
    rules: normalizeRules(rules),
    bails: getPath('bails', options, true),
    forceRequired: false,
    get isRequired () {
      return !!this.rules.required || this.forceRequired;
    }
  };

  var targetRules = Object.keys(field.rules).filter(RuleContainer.isTargetRule);
  if (targetRules.length && options && isObject(options.values)) {
    field.dependencies = targetRules.map(function (rule) {
      var ref = field.rules[rule];
        var targetKey = ref[0];

      return {
        name: rule,
        field: { value: options.values[targetKey] }
      };
    });
  }

  return this._validate(field, value).then(function (result) {
    var errors = [];
    var ruleMap = {};
    result.errors.forEach(function (e) {
      errors.push(e.msg);
      ruleMap[e.rule] = e.msg;
    });

    return {
      valid: result.valid,
      errors: errors,
      failedRules: ruleMap
    };
  });
};

/**
 * Perform cleanup.
 */
Validator.prototype.destroy = function destroy () {
  this.$vee._vm.$off('localeChanged');
};

/**
 * Creates the fields to be validated.
 */
Validator.prototype._createFields = function _createFields (validations) {
    var this$1 = this;

  if (!validations) { return; }

  Object.keys(validations).forEach(function (field) {
    var options = assign({}, { name: field, rules: validations[field] });
    this$1.attach(options);
  });
};

/**
 * Date rules need the existence of a format, so date_format must be supplied.
 */
Validator.prototype._getDateFormat = function _getDateFormat (validations) {
  var format = null;
  if (validations.date_format && Array.isArray(validations.date_format)) {
    format = validations.date_format[0];
  }

  return format || DictionaryResolver.getDriver().getDateFormat(this.locale);
};

/**
 * Formats an error message for field and a rule.
 */
Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
    if ( data === void 0 ) data = {};
    if ( targetName === void 0 ) targetName = null;

  var name = this._getFieldDisplayName(field);
  var params = this._getLocalizedParams(rule, targetName);

  return DictionaryResolver.getDriver().getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
};

/**
 * We need to convert any object param to an array format since the locales do not handle params as objects yet.
 */
Validator.prototype._convertParamObjectToArray = function _convertParamObjectToArray (obj, ruleName) {
  if (Array.isArray(obj)) {
    return obj;
  }

  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames || !isObject(obj)) {
    return obj;
  }

  return paramNames.reduce(function (prev, paramName) {
    if (paramName in obj) {
      prev.push(obj[paramName]);
    }

    return prev;
  }, []);
};

/**
 * Translates the parameters passed to the rule (mainly for target fields).
 */
Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
    if ( targetName === void 0 ) targetName = null;

  var params = this._convertParamObjectToArray(rule.params, rule.name);
  if (rule.options.hasTarget && params && params[0]) {
    var localizedName = targetName || DictionaryResolver.getDriver().getAttribute(this.locale, params[0], params[0]);
    return [localizedName].concat(params.slice(1));
  }

  return params;
};

/**
 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
 */
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
  return field.alias || DictionaryResolver.getDriver().getAttribute(this.locale, field.name, field.name);
};

/**
 * Converts an array of params to an object with named properties.
 * Only works if the rule is configured with a paramNames array.
 * Returns the same params if it cannot convert it.
 */
Validator.prototype._convertParamArrayToObj = function _convertParamArrayToObj (params, ruleName) {
  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames) {
    return params;
  }

  if (isObject(params)) {
    // check if the object is either a config object or a single parameter that is an object.
    var hasKeys = paramNames.some(function (name) { return Object.keys(params).indexOf(name) !== -1; });
    // if it has some of the keys, return it as is.
    if (hasKeys) {
      return params;
    }
    // otherwise wrap the object in an array.
    params = [params];
  }

  // Reduce the paramsNames to a param object.
  return params.reduce(function (prev, value, idx) {
    prev[paramNames[idx]] = value;

    return prev;
  }, {});
};

/**
 * Tests a single input value against a rule.
 */
Validator.prototype._test = function _test (field, value, rule) {
    var this$1 = this;

  var validator = RuleContainer.getValidatorMethod(rule.name);
  var params = Array.isArray(rule.params) ? toArray(rule.params) : rule.params;
  if (!params) {
    params = [];
  }

  var targetName = null;
  if (!validator || typeof validator !== 'function') {
    return Promise.reject(createError(("No such validator '" + (rule.name) + "' exists.")));
  }

  // has field dependencies.
  if (rule.options.hasTarget && field.dependencies) {
    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
    if (target) {
      targetName = target.field.alias;
      params = [target.field.value].concat(params.slice(1));
    }
  } else if (rule.name === 'required' && field.rejectsFalse) {
    // invalidate false if no args were specified and the field rejects false by default.
    params = params.length ? params : [true];
  }

  if (rule.options.isDate) {
    var dateFormat = this._getDateFormat(field.rules);
    if (rule.name !== 'date_format') {
      params.push(dateFormat);
    }
  }

  var result = validator(value, this._convertParamArrayToObj(params, rule.name));

  // If it is a promise.
  if (isCallable(result.then)) {
    return result.then(function (values) {
      var allValid = true;
      var data = {};
      if (Array.isArray(values)) {
        allValid = values.every(function (t) { return (isObject(t) ? t.valid : t); });
      } else { // Is a single object/boolean.
        allValid = isObject(values) ? values.valid : values;
        data = values.data;
      }

      return {
        valid: allValid,
        data: result.data,
        errors: allValid ? [] : [this$1._createFieldError(field, rule, data, targetName)]
      };
    });
  }

  if (!isObject(result)) {
    result = { valid: result, data: {} };
  }

  return {
    valid: result.valid,
    data: result.data,
    errors: result.valid ? [] : [this._createFieldError(field, rule, result.data, targetName)]
  };
};

/**
 * Merges a validator object into the RULES and Messages.
 */
Validator._merge = function _merge (name, ref) {
    var validator = ref.validator;
    var options = ref.options;
    var paramNames = ref.paramNames;

  var validate = isCallable(validator) ? validator : validator.validate;
  if (validator.getMessage) {
    DictionaryResolver.getDriver().setMessage(Validator.locale, name, validator.getMessage);
  }

  RuleContainer.add(name, {
    validate: validate,
    options: options,
    paramNames: paramNames
  });
};

/**
 * Guards from extension violations.
 */
Validator._guardExtend = function _guardExtend (name, validator) {
  if (isCallable(validator)) {
    return;
  }

  if (!isCallable(validator.validate)) {
    throw createError(
      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
    );
  }
};

/**
 * Creates a Field Error Object.
 */
Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
    var this$1 = this;

  return {
    id: field.id,
    vmId: field.vmId,
    field: field.name,
    msg: this._formatErrorMessage(field, rule, data, targetName),
    rule: rule.name,
    scope: field.scope,
    regenerate: function () {
      return this$1._formatErrorMessage(field, rule, data, targetName);
    }
  };
};

/**
 * Tries different strategies to find a field.
 */
Validator.prototype._resolveField = function _resolveField (name, scope, uid) {
  if (name[0] === '#') {
    return this.fields.findById(name.slice(1));
  }

  if (!isNullOrUndefined(scope)) {
    return this.fields.find({ name: name, scope: scope, vmId: uid });
  }

  if (includes(name, '.')) {
    var ref = name.split('.');
      var fieldScope = ref[0];
      var fieldName = ref.slice(1);
    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope, vmId: uid });
    if (field) {
      return field;
    }
  }

  return this.fields.find({ name: name, scope: null, vmId: uid });
};

/**
 * Handles when a field is not found.
 */
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);

  return Promise.reject(createError(
    ("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first.")
  ));
};

/**
 * Handles validation results.
 */
Validator.prototype._handleValidationResults = function _handleValidationResults (results, vmId) {
    var this$1 = this;

  var matchers = results.map(function (result) { return ({ id: result.id }); });
  this.errors.removeById(matchers.map(function (m) { return m.id; }));
  // remove by name and scope to remove any custom errors added.
  results.forEach(function (result) {
    this$1.errors.remove(result.field, result.scope, vmId);
  });
  var allErrors = results.reduce(function (prev, curr) {
    prev.push.apply(prev, curr.errors);

    return prev;
  }, []);

  this.errors.add(allErrors);

  // handle flags.
  this.fields.filter(matchers).forEach(function (field) {
    var result = find(results, function (r) { return r.id === field.id; });
    field.setFlags({
      pending: false,
      valid: result.valid,
      validated: true
    });
  });
};

Validator.prototype._shouldSkip = function _shouldSkip (field, value) {
  // field is configured to run through the pipeline regardless
  if (field.bails === false) {
    return false;
  }

  // disabled fields are skipped if useConstraintAttrs is enabled in config
  if (field.isDisabled && getConfig().useConstraintAttrs) {
    return true;
  }

  // skip if the field is not required and has an empty value.
  return !field.isRequired && (isNullOrUndefined(value) || value === '' || isEmptyArray(value));
};

Validator.prototype._shouldBail = function _shouldBail (field) {
  // if the field was configured explicitly.
  if (field.bails !== undefined) {
    return field.bails;
  }

  return this.fastExit;
};

/**
 * Starts the validation process.
 */
Validator.prototype._validate = function _validate (field, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var initial = ref.initial;

  var requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);

  field.forceRequired = false;
  requireRules.forEach(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });

    if (isCallable(result.then)) { throw createError('Require rules cannot be async'); }
    if (!isObject(result)) { throw createError('Require rules has to return an object (see docs)'); }

    if (result.data.required === true) {
      field.forceRequired = true;
    }
  });

  if (this._shouldSkip(field, value)) {
    return Promise.resolve({ valid: true, id: field.id, field: field.name, scope: field.scope, errors: [] });
  }

  var promises = [];
  var errors = [];
  var isExitEarly = false;
  if (isCallable(field.checkValueChanged)) {
    field.flags.changed = field.checkValueChanged();
  }

  // use of '.some()' is to break iteration in middle by returning true
  Object.keys(field.rules).filter(function (rule) {
    if (!initial || !RuleContainer.has(rule)) { return true; }

    return RuleContainer.isImmediate(rule);
  }).some(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });
    if (isCallable(result.then)) {
      promises.push(result);
    } else if (!result.valid && this$1._shouldBail(field)) {
      errors.push.apply(errors, result.errors);
      isExitEarly = true;
    } else {
      // promisify the result.
      promises.push(new Promise(function (resolve) { return resolve(result); }));
    }

    return isExitEarly;
  });

  if (isExitEarly) {
    return Promise.resolve({ valid: false, errors: errors, id: field.id, field: field.name, scope: field.scope });
  }

  return Promise.all(promises).then(function (results) {
    return results.reduce(function (prev, v) {
        var ref;

      if (!v.valid) {
        (ref = prev.errors).push.apply(ref, v.errors);
      }

      prev.valid = prev.valid && v.valid;

      return prev;
    }, { valid: true, errors: errors, id: field.id, field: field.name, scope: field.scope });
  });
};

Object.defineProperties( Validator.prototype, prototypeAccessors$4 );
Object.defineProperties( Validator, staticAccessors$1 );

// 

var normalizeValue = function (value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (prev, key) {
      prev[key] = normalizeValue(value[key]);

      return prev;
    }, {});
  }

  if (isCallable(value)) {
    return value('{0}', ['{1}', '{2}', '{3}']);
  }

  return value;
};

var normalizeFormat = function (locale) {
  // normalize messages
  var dictionary = {};
  if (locale.messages) {
    dictionary.messages = normalizeValue(locale.messages);
  }

  if (locale.custom) {
    dictionary.custom = normalizeValue(locale.custom);
  }

  if (locale.attributes) {
    dictionary.attributes = locale.attributes;
  }

  if (!isNullOrUndefined(locale.dateFormat)) {
    dictionary.dateFormat = locale.dateFormat;
  }

  return dictionary;
};

var I18nDictionary = function I18nDictionary (i18n, rootKey) {
  this.i18n = i18n;
  this.rootKey = rootKey;
};

var prototypeAccessors$5 = { locale: { configurable: true } };

prototypeAccessors$5.locale.get = function () {
  return this.i18n.locale;
};

prototypeAccessors$5.locale.set = function (value) {
  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};

I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
  return this.i18n.getDateTimeFormat(locale || this.locale);
};

I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
  this.i18n.setDateTimeFormat(locale || this.locale, value);
};

I18nDictionary.prototype.getMessage = function getMessage (_, key, data) {
  var path = (this.rootKey) + ".messages." + key;
  var dataOptions = data;

  if (Array.isArray(data)) {
    dataOptions = [].concat.apply([], data);
  }

  if (this.i18n.te(path)) {
    return this.i18n.t(path, dataOptions);
  }

  // fallback to the fallback message
  if (this.i18n.te(path, this.i18n.fallbackLocale)) {
    return this.i18n.t(path, this.i18n.fallbackLocale, dataOptions);
  }

  // fallback to the root message
  return this.i18n.t(((this.rootKey) + ".messages._default"), dataOptions);
};

I18nDictionary.prototype.getAttribute = function getAttribute (_, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  var path = (this.rootKey) + ".attributes." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path);
  }

  return fallback;
};

I18nDictionary.prototype.getFieldMessage = function getFieldMessage (_, field, key, data) {
  var path = (this.rootKey) + ".custom." + field + "." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path, data);
  }

  return this.getMessage(_, key, data);
};

I18nDictionary.prototype.merge = function merge$1 (dictionary) {
    var this$1 = this;

  Object.keys(dictionary).forEach(function (localeKey) {
      var obj;

    // i18n doesn't deep merge
    // first clone the existing locale (avoid mutations to locale)
    var clone = merge({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
    // Merge cloned locale with new one
    var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
    this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
    if (locale.dateFormat) {
      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
    }
  });
};

I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      messages: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      attributes: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$5 );

var aggressive = function () { return ({
  on: ['input']
}); };

var lazy = function () { return ({
  on: ['change']
}); };

var eager = function (ref) {
  var errors = ref.errors;

  if (errors.length) {
    return {
      on: ['input']
    };
  }

  return {
    on: ['change', 'blur']
  };
};

var passive = function () { return ({
  on: []
}); };

var modes = {
  aggressive: aggressive,
  eager: eager,
  passive: passive,
  lazy: lazy
};

// 

var Vue;
var pendingPlugins;
var pluginInstance;

var VeeValidate$1 = function VeeValidate (config, _Vue) {
  this.configure(config);
  pluginInstance = this;
  if (_Vue) {
    Vue = _Vue;
  }
  this._validator = setValidator(
    new Validator(null, { fastExit: config && config.fastExit }, this)
  );
  this._initVM(this.config);
  this._initI18n(this.config);
};

var prototypeAccessors$6 = { i18nDriver: { configurable: true },config: { configurable: true } };
var staticAccessors$2 = { i18nDriver: { configurable: true },config: { configurable: true } };

VeeValidate$1.setI18nDriver = function setI18nDriver (driver, instance) {
  DictionaryResolver.setDriver(driver, instance);
};

VeeValidate$1.configure = function configure (cfg) {
  setConfig(cfg);
};

VeeValidate$1.setMode = function setMode (mode, implementation) {
  setConfig({ mode: mode });
  if (!implementation) {
    return;
  }

  if (!isCallable(implementation)) {
    throw new Error('A mode implementation must be a function');
  }

  modes[mode] = implementation;
};

VeeValidate$1.use = function use (plugin, options) {
    if ( options === void 0 ) options = {};

  if (!isCallable(plugin)) {
    return warn('The plugin must be a callable function');
  }

  // Don't install plugins until vee-validate is installed.
  if (!pluginInstance) {
    if (!pendingPlugins) {
      pendingPlugins = [];
    }
    pendingPlugins.push({ plugin: plugin, options: options });
    return;
  }

  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
};
VeeValidate$1.install = function install (_Vue, opts) {
  if (Vue && _Vue === Vue) {
    if (false) {}
    return;
  }

  Vue = _Vue;
  pluginInstance = new VeeValidate$1(opts);
  // inject the plugin container statically into the validator class
  Validator.$vee = pluginInstance;

  detectPassiveSupport();

  Vue.mixin(mixin);
  Vue.directive('validate', directive);
  if (pendingPlugins) {
    pendingPlugins.forEach(function (ref) {
        var plugin = ref.plugin;
        var options = ref.options;

      VeeValidate$1.use(plugin, options);
    });
    pendingPlugins = null;
  }
};

prototypeAccessors$6.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$2.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$6.config.get = function () {
  return getConfig();
};

staticAccessors$2.config.get = function () {
  return getConfig();
};

VeeValidate$1.prototype._initVM = function _initVM (config) {
    var this$1 = this;

  this._vm = new Vue({
    data: function () { return ({
      errors: this$1._validator.errors,
      fields: this$1._validator.fields
    }); }
  });
};

VeeValidate$1.prototype._initI18n = function _initI18n (config) {
    var this$1 = this;

  var dictionary = config.dictionary;
    var i18n = config.i18n;
    var i18nRootKey = config.i18nRootKey;
    var locale = config.locale;
  var onLocaleChanged = function () {
    if (dictionary) {
      this$1.i18nDriver.merge(dictionary);
    }

    this$1._validator.errors.regenerate();
  };

  // i18 is being used for localization.
  if (i18n) {
    VeeValidate$1.setI18nDriver('i18n', new I18nDictionary(i18n, i18nRootKey));
    i18n._vm.$watch('locale', onLocaleChanged);
  } else if (typeof window !== 'undefined') {
    this._vm.$on('localeChanged', onLocaleChanged);
  }

  if (dictionary) {
    this.i18nDriver.merge(dictionary);
  }

  if (locale && !i18n) {
    this._validator.localize(locale);
  }
};

VeeValidate$1.prototype.configure = function configure (cfg) {
  setConfig(cfg);
};

Object.defineProperties( VeeValidate$1.prototype, prototypeAccessors$6 );
Object.defineProperties( VeeValidate$1, staticAccessors$2 );

VeeValidate$1.mixin = mixin;
VeeValidate$1.directive = directive;
VeeValidate$1.Validator = Validator;
VeeValidate$1.ErrorBag = ErrorBag;

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
var formatFileSize = function (size) {
  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var threshold = 1024;
  size = Number(size) * threshold;
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
};

/**
 * Checks if vee-validate is defined globally.
 */
var isDefinedGlobally = function () {
  return typeof VeeValidate !== 'undefined';
};

var obj;

var messages = {
  _default: function (field) { return ("The " + field + " value is not valid"); },
  after: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target);
},
  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters"); },
  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores"); },
  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters"); },
  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces"); },
  before: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target);
},
  between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " field must be between " + min + " and " + max);
},
  confirmed: function (field) { return ("The " + field + " confirmation does not match"); },
  credit_card: function (field) { return ("The " + field + " field is invalid"); },
  date_between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " must be between " + min + " and " + max);
},
  date_format: function (field, ref) {
    var format = ref[0];

    return ("The " + field + " must be in the format " + format);
},
  decimal: function (field, ref) {
    if ( ref === void 0 ) ref = [];
    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';

    return ("The " + field + " field must be numeric and may contain" + (!decimals || decimals === '*' ? '' : ' ' + decimals) + " decimal points");
},
  digits: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be numeric and contains exactly " + length + " digits");
},
  dimensions: function (field, ref) {
    var width = ref[0];
    var height = ref[1];

    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels");
},
  email: function (field) { return ("The " + field + " field must be a valid email"); },
  excluded: function (field) { return ("The " + field + " field must be a valid value"); },
  ext: function (field) { return ("The " + field + " field must be a valid file"); },
  image: function (field) { return ("The " + field + " field must be an image"); },
  included: function (field) { return ("The " + field + " field must be a valid value"); },
  integer: function (field) { return ("The " + field + " field must be an integer"); },
  ip: function (field) { return ("The " + field + " field must be a valid ip address"); },
  ip_or_fqdn: function (field) { return ("The " + field + " field must be a valid ip address or FQDN"); },
  length: function (field, ref) {
    var length = ref[0];
    var max = ref[1];

    if (max) {
      return ("The " + field + " length must be between " + length + " and " + max);
    }

    return ("The " + field + " length must be " + length);
  },
  max: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field may not be greater than " + length + " characters");
},
  max_value: function (field, ref) {
    var max = ref[0];

    return ("The " + field + " field must be " + max + " or less");
},
  mimes: function (field) { return ("The " + field + " field must have a valid file type"); },
  min: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be at least " + length + " characters");
},
  min_value: function (field, ref) {
    var min = ref[0];

    return ("The " + field + " field must be " + min + " or more");
},
  numeric: function (field) { return ("The " + field + " field may only contain numeric characters"); },
  regex: function (field) { return ("The " + field + " field format is invalid"); },
  required: function (field) { return ("The " + field + " field is required"); },
  required_if: function (field, ref) {
    var target = ref[0];

    return ("The " + field + " field is required when the " + target + " field has this value");
},
  size: function (field, ref) {
    var size = ref[0];

    return ("The " + field + " size must be less than " + (formatFileSize(size)));
},
  url: function (field) { return ("The " + field + " field is not a valid URL"); }
};

var locale = {
  name: 'en',
  messages: messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize(( obj = {}, obj[locale.name] = locale, obj ));
}

function toInteger (dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number)
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate (argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument)
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimeter);
  var timeString;

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimeter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimeter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1 +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = patterns.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  var hours;

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);

    if (!validateTimezone()) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOWeekYear (isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex (year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate (year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate (year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate (year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime (hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

function validateTimezone (hours, minutes) {
  if (minutes != null && (minutes < 0 || minutes > 59)) {
    return false
  }

  return true
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount)
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  return !isNaN(date)
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance (token, count, options) {
  options = options || {};

  var result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}

function buildFormatLongFn (args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format
  }
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};

var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};

var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};

var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}

function buildLocalizeFn (args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var context = options.context ? String(options.context) : 'standalone';

    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      valuesArray = args.formattingValues[width] || args.formattingValues[args.defaultFormattingWidth];
    } else {
      valuesArray = args.values[width] || args.values[args.defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index]
  }
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};

var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaulFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn (args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};

    var matchResult = string.match(args.matchPattern);
    if (!matchResult) {
      return null
    }
    var matchedString = matchResult[0];

    var parseResult = string.match(args.parsePattern);
    if (!parseResult) {
      return null
    }
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    }
  }
}

function buildMatchFn (args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;

    var matchPattern = (width && args.matchPatterns[width]) || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null
    }
    var matchedString = matchResult[0];

    var parsePatterns = (width && args.parsePatterns[width]) || args.parsePatterns[args.defaultParseWidth];

    var value;
    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string)
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string)
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    }
  }
}

function findKey (object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;

var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};

var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};

var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};

var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};

var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};

var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10)
    }
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1
    }
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

var MILLISECONDS_IN_DAY = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var weekStartsOn = 1;

  var date = toDate(dirtyDate, dirtyOptions);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, options);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale &&
    locale.options &&
    locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);

  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale &&
    locale.options &&
    locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK$1 = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCWeek(date, dirtyOptions).getTime() - startOfUTCWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {width: 'abbreviated'})
      // A, B
      case 'GGGGG':
        return localize.era(era, {width: 'narrow'})
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {width: 'wide'})
    }
  },

  // Year
  y: function (date, token, localize, options) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();

    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;

    // Two digit year
    if (token === 'yy') {
      var twoDigitYear = year % 100;
      return addLeadingZeros(twoDigitYear, 2)
    }

    // Ordinal number
    if (token === 'yo') {
      return localize.ordinalNumber(year, {unit: 'year'})
    }

    // Padding
    return addLeadingZeros(year, token.length)
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2)
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {unit: 'year'})
    }

    // Padding
    return addLeadingZeros(weekYear, token.length)
  },

  // ISO week-numbering year
  R: function (date, token, localize, options) {
    var isoWeekYear = getUTCISOWeekYear(date, options);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length)
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token, localize, options) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length)
  },

  // Quarter
  Q: function (date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter)
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2)
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {unit: 'quarter'})
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {width: 'abbreviated', context: 'formatting'})
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {width: 'narrow', context: 'formatting'})
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter)
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2)
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {unit: 'quarter'})
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {width: 'abbreviated', context: 'standalone'})
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {width: 'narrow', context: 'standalone'})
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {width: 'wide', context: 'standalone'})
    }
  },

  // Month
  M: function (date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'M':
        return String(month + 1)
      // 01, 02, ..., 12
      case 'MM':
        return addLeadingZeros(month + 1, 2)
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {unit: 'month'})
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {width: 'abbreviated', context: 'formatting'})
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {width: 'narrow', context: 'formatting'})
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone month
  L: function (date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1)
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2)
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {unit: 'month'})
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {width: 'abbreviated', context: 'standalone'})
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {width: 'narrow', context: 'standalone'})
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {width: 'wide', context: 'standalone'})
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {unit: 'week'})
    }

    return addLeadingZeros(week, token.length)
  },

  // ISO week of year
  I: function (date, token, localize, options) {
    var isoWeek = getUTCISOWeek(date, options);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {unit: 'week'})
    }

    return addLeadingZeros(isoWeek, token.length)
  },

  // Day of the month
  d: function (date, token, localize, options) {
    var dayOfMonth = date.getUTCDate();

    if (token === 'do') {
      return localize.ordinalNumber(dayOfMonth, {unit: 'date'})
    }

    return addLeadingZeros(dayOfMonth, token.length)
  },

  // Day of year
  D: function (date, token, localize, options) {
    var dayOfYear = getUTCDayOfYear(date, options);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {unit: 'dayOfYear'})
    }

    return addLeadingZeros(dayOfYear, token.length)
  },

  // Day of week
  E: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = ((dayOfWeek - options.weekStartsOn + 8) % 7) || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek)
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2)
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {unit: 'day'})
      case 'eee':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = ((dayOfWeek - options.weekStartsOn + 8) % 7) || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek)
      // Padded numberical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length)
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {unit: 'day'})
      case 'ccc':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'standalone'})
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'standalone'})
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {width: 'short', context: 'standalone'})
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'standalone'})
    }
  },

  // ISO day of week
  i: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek)
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length)
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {unit: 'day'})
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = (hours / 12) >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = (hours / 12) >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // Hour [1-12]
  h: function (date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (hours === 0) {
      hours = 12;
    }

    if (token === 'ho') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [0-23]
  H: function (date, token, localize, options) {
    var hours = date.getUTCHours();

    if (token === 'Ho') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [0-11]
  K: function (date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [1-24]
  k: function (date, token, localize, options) {
    var hours = date.getUTCHours();

    if (hours === 0) {
      hours = 24;
    }

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Minute
  m: function (date, token, localize, options) {
    var minutes = date.getUTCMinutes();

    if (token === 'mo') {
      return localize.ordinalNumber(minutes, {unit: 'minute'})
    }

    return addLeadingZeros(minutes, token.length)
  },

  // Second
  s: function (date, token, localize, options) {
    var seconds = date.getUTCSeconds();

    if (token === 'so') {
      return localize.ordinalNumber(seconds, {unit: 'second'})
    }

    return addLeadingZeros(seconds, token.length)
  },

  // Fraction of second
  S: function (date, token, localize, options) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, numberOfDigits)
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z'
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Seconds timestamp
  t: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length)
  },

  // Milliseconds timestamp
  T: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length)
  }
};

function addLeadingZeros (number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output
}

function formatTimezone (offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimeter + minutes
}

function formatTimezoneWithOptionalMinutes (offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
  }
  return formatTimezone(offset, dirtyDelimeter)
}

function formatTimezoneShort (offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours)
  }
  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2)
}

function dateLongFormatter (pattern, formatLong, options) {
  switch (pattern) {
    case 'P':
      return formatLong.date({width: 'short'})
    case 'PP':
      return formatLong.date({width: 'medium'})
    case 'PPP':
      return formatLong.date({width: 'long'})
    case 'PPPP':
    default:
      return formatLong.date({width: 'full'})
  }
}

function timeLongFormatter (pattern, formatLong, options) {
  switch (pattern) {
    case 'p':
      return formatLong.time({width: 'short'})
    case 'pp':
      return formatLong.time({width: 'medium'})
    case 'ppp':
      return formatLong.time({width: 'long'})
    case 'pppp':
    default:
      return formatLong.time({width: 'full'})
  }
}

function dateTimeLongFormatter (pattern, formatLong, options) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong)
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({width: 'short'});
      break
    case 'PP':
      dateTimeFormat = formatLong.dateTime({width: 'medium'});
      break
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({width: 'long'});
      break
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({width: 'full'});
      break
  }

  return dateTimeFormat
    .replace('{{date}}', dateLongFormatter(datePattern, formatLong))
    .replace('{{time}}', timeLongFormatter(timePattern, formatLong))
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount, dirtyOptions)
}

var protectedTokens = ['D', 'DD', 'YY', 'YYYY'];

function isProtectedToken(token) {
  return protectedTokens.indexOf(token) !== -1
}

function throwProtectedError(token) {
  throw new RangeError(
    '`options.awareOfUnicodeTokens` must be set to `true` to use `' +
      token +
      '` token; see: https://git.io/fxCyr'
  )
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp = /^'(.*?)'?$/;
var doubleQuoteRegExp = /''/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/dd/yyyy'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   "do 'de' MMMM yyyy",
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(
 *   new Date(2014, 6, 2, 15),
 *   "h 'o''clock'"
 * )
 * //=> "3 o'clock"
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError(
      '2 arguments required, but only ' + arguments.length + ' present'
    )
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  var localeFirstWeekContainsDate =
    locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError(
      'firstWeekContainsDate must be between 1 and 7 inclusively'
    )
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn =
    localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn =
    options.weekStartsOn == null
      ? defaultWeekStartsOn
      : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var originalDate = toDate(dirtyDate, options);

  if (!isValid(originalDate, options)) {
    return 'Invalid Date'
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset, options);

  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };

  var result = formatStr
    .match(longFormattingTokensRegExp)
    .map(function(substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong, formatterOptions)
      }
      return substring
    })
    .join('')
    .match(formattingTokensRegExp)
    .map(function(substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'"
      }

      var firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString(substring)
      }

      var formatter = formatters[firstCharacter];
      if (formatter) {
        if (!options.awareOfUnicodeTokens && isProtectedToken(substring)) {
          throwProtectedError(substring);
        }
        return formatter(utcDate, substring, locale.localize, formatterOptions)
      }

      return substring
    })
    .join('');

  return result
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'")
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() > dateToCompare.getTime()
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() < dateToCompare.getTime()
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1 (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
  var dateRight = toDate(dirtyRightDate, dirtyOptions);
  return dateLeft.getTime() === dateRight.getTime()
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var day = toInteger(dirtyDay);

  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCWeek (dirtyDate, dirtyWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, dirtyOptions) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate, dirtyOptions);
  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_SECOND = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern (pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null
  }

  var value = parseInt(matchResult[0], 10);

  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  }
}

function parseTimezonePattern (pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    }
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value: sign * (
      hours * MILLISECONDS_IN_HOUR$1 +
        minutes * MILLISECONDS_IN_MINUTE$2 +
        seconds * MILLISECONDS_IN_SECOND
    ),
    rest: string.slice(matchResult[0].length)
  }
}

function parseAnyDigitsSigned (string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback)
}

function parseNDigits (n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback)
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback)
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback)
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback)
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback)
  }
}

function parseNDigitsSigned (n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback)
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback)
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback)
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback)
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback)
  }
}

function dayPeriodEnumToHours (enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4
    case 'evening':
      return 17
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0
  }
}

function normalizeTwoDigitYear (twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result
}

var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// User for validation
function isLeapYearIndex$1 (year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {width: 'abbreviated'}) ||
            match.era(string, {width: 'narrow'})
        // A, B
        case 'GGGGG':
          return match.era(string, {width: 'narrow'})
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(string, {width: 'wide'}) ||
            match.era(string, {width: 'abbreviated'}) ||
            match.era(string, {width: 'narrow'})
      }
    },
    set: function (date, value, options) {
      // Sets year 10 BC if BC, or 10 AC if AC
      date.setUTCFullYear(value === 1 ? 10 : -9, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    priority: 130,
    parse: function (string, token, match, options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        }
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback)
        case 'yo':
          return match.ordinalNumber(string, {unit: 'year', valueCallback: valueCallback})
        default:
          return parseNDigits(token.length, string, valueCallback)
      }
    },
    validate: function (date, value, options) {
      return value.isTwoDigitYear || value.year > 0
    },
    set: function (date, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        }
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback)
        case 'Yo':
          return match.ordinalNumber(string, {unit: 'year', valueCallback: valueCallback})
        default:
          return parseNDigits(token.length, string, valueCallback)
      }
    },
    validate: function (date, value, options) {
      return value.isTwoDigitYear || value.year > 0
    },
    set: function (date, value, options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options)
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options)
    }
  },

  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, match, options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string)
      }

      return parseNDigitsSigned(token.length, string)
    },
    set: function (date, value, options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear)
    }
  },

  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, match, options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string)
      }

      return parseNDigitsSigned(token.length, string)
    },
    set: function (date, value, options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ': // 01, 02, 03, 04
          return parseNDigits(token.length, string)
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(string, {unit: 'quarter'})
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.quarter(string, {width: 'narrow', context: 'formatting'})
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(string, {width: 'narrow', context: 'formatting'})
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(string, {width: 'wide', context: 'formatting'}) ||
            match.quarter(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.quarter(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 4
    },
    set: function (date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq': // 01, 02, 03, 04
          return parseNDigits(token.length, string)
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(string, {unit: 'quarter'})
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.quarter(string, {width: 'narrow', context: 'standalone'})
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(string, {width: 'narrow', context: 'standalone'})
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(string, {width: 'wide', context: 'standalone'}) ||
            match.quarter(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.quarter(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 4
    },
    set: function (date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return value - 1
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback)
        // 01, 02, ..., 12
        case 'MM':
          return parseNDigits(2, string, valueCallback)
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return match.ordinalNumber(string, {unit: 'month', valueCallback: valueCallback})
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.month(string, {width: 'narrow', context: 'formatting'})
        // J, F, ..., D
        case 'MMMMM':
          return match.month(string, {width: 'narrow', context: 'formatting'})
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(string, {width: 'wide', context: 'formatting'}) ||
            match.month(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.month(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return value - 1
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback)
        // 01, 02, ..., 12
        case 'LL':
          return parseNDigits(2, string, valueCallback)
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return match.ordinalNumber(string, {unit: 'month', valueCallback: valueCallback})
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.month(string, {width: 'narrow', context: 'standalone'})
        // J, F, ..., D
        case 'LLLLL':
          return match.month(string, {width: 'narrow', context: 'standalone'})
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(string, {width: 'wide', context: 'standalone'}) ||
            match.month(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.month(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string)
        case 'wo':
          return match.ordinalNumber(string, {unit: 'week'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 53
    },
    set: function (date, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options)
    }
  },

  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string)
        case 'Io':
          return match.ordinalNumber(string, {unit: 'week'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 53
    },
    set: function (date, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options)
    }
  },

  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string)
        case 'do':
          return match.ordinalNumber(string, {unit: 'date'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR$1[month]
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH$1[month]
      }
    },
    set: function (date, value, options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string)
        case 'Do':
          return match.ordinalNumber(string, {unit: 'date'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366
      } else {
        return value >= 1 && value <= 365
      }
    },
    set: function (date, value, options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
        // T
        case 'EEEEE':
          return match.day(string, {width: 'narrow', context: 'formatting'})
        // Tu
        case 'EEEEEE':
          return match.day(string, {width: 'short', context: 'formatting'}) ||
          match.day(string, {width: 'narrow', context: 'formatting'})
        // Tuesday
        case 'EEEE':
        default:
          return match.day(string, {width: 'wide', context: 'formatting'}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee': // 03
          return parseNDigits(token.length, string, valueCallback)
        // 3rd
        case 'eo':
          return match.ordinalNumber(string, {unit: 'day', valueCallback: valueCallback})
        // Tue
        case 'eee':
          return match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
        // T
        case 'eeeee':
          return match.day(string, {width: 'narrow', context: 'formatting'})
        // Tu
        case 'eeeeee':
          return match.day(string, {width: 'short', context: 'formatting'}) ||
          match.day(string, {width: 'narrow', context: 'formatting'})
        // Tuesday
        case 'eeee':
        default:
          return match.day(string, {width: 'wide', context: 'formatting'}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc': // 03
          return parseNDigits(token.length, string, valueCallback)
        // 3rd
        case 'co':
          return match.ordinalNumber(string, {unit: 'day', valueCallback: valueCallback})
        // Tue
        case 'ccc':
          return match.day(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.day(string, {width: 'short', context: 'standalone'}) ||
            match.day(string, {width: 'narrow', context: 'standalone'})
        // T
        case 'ccccc':
          return match.day(string, {width: 'narrow', context: 'standalone'})
        // Tu
        case 'cccccc':
          return match.day(string, {width: 'short', context: 'standalone'}) ||
          match.day(string, {width: 'narrow', context: 'standalone'})
        // Tuesday
        case 'cccc':
        default:
          return match.day(string, {width: 'wide', context: 'standalone'}) ||
            match.day(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.day(string, {width: 'short', context: 'standalone'}) ||
            match.day(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7
        }
        return value
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii': // 02
          return parseNDigits(token.length, string)
        // 2nd
        case 'io':
          return match.ordinalNumber(string, {unit: 'day'})
        // Tue
        case 'iii':
          return match.day(string, {width: 'abbreviated', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // T
        case 'iiiii':
          return match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // Tu
        case 'iiiiii':
          return match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
          match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // Tuesday
        case 'iiii':
        default:
          return match.day(string, {width: 'wide', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 7
    },
    set: function (date, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'aaaaa':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'aaaa':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'bbbbb':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'bbbb':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'BBBBB':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'BBBB':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string)
        case 'ho':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 12
    },
    set: function (date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date
    }
  },

  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string)
        case 'Ho':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 23
    },
    set: function (date, value, options) {
      date.setUTCHours(value, 0, 0, 0);
      return date
    }
  },

  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string)
        case 'Ko':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date
    }
  },

  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string)
        case 'ko':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 24
    },
    set: function (date, value, options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date
    }
  },

  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string)
        case 'mo':
          return match.ordinalNumber(string, {unit: 'minute'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 59
    },
    set: function (date, value, options) {
      date.setUTCMinutes(value, 0, 0);
      return date
    }
  },

  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string)
        case 'so':
          return match.ordinalNumber(string, {unit: 'second'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 59
    },
    set: function (date, value, options) {
      date.setUTCSeconds(value, 0);
      return date
    }
  },

  // Fraction of second
  S: {
    priority: 40,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3))
      };
      return parseNDigits(token.length, string, valueCallback)
    },
    set: function (date, value, options) {
      date.setUTCMilliseconds(value);
      return date
    }
  },

  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 20,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string)
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string)
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string)
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string)
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string)
      }
    },
    set: function (date, value, options) {
      return new Date(date.getTime() - value)
    }
  },

  // Timezone (ISO-8601)
  x: {
    priority: 20,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string)
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string)
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string)
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string)
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string)
      }
    },
    set: function (date, value, options) {
      return new Date(date.getTime() - value)
    }
  },

  // Seconds timestamp
  t: {
    priority: 10,
    parse: function (string, token, match, options) {
      return parseAnyDigitsSigned(string)
    },
    set: function (date, value, options) {
      return new Date(value * 1000)
    }
  },

  // Milliseconds timestamp
  T: {
    priority: 10,
    parse: function (string, token, match, options) {
      return parseAnyDigitsSigned(string)
    },
    set: function (date, value, options) {
      return new Date(value)
    }
  }
};

var TIMEZONE_UNIT_PRIORITY = 20;

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp$1 = /^'(.*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;

var notWhitespaceRegExp = /\S/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 6     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 6     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              |  40 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  20 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  20 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Seconds timestamp               |  10 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Milliseconds timestamp          |  10 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `baseDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *
 * 6. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - defines values missing from the parsed dateString
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/dd/yyyy',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   "do 'de' MMMM",
 *   new Date(2010, 0, 1),
 *   {locale: eo}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(
  dirtyDateString,
  dirtyFormatString,
  dirtyBaseDate,
  dirtyOptions
) {
  if (arguments.length < 3) {
    throw new TypeError(
      '3 arguments required, but only ' + arguments.length + ' present'
    )
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  if (!locale.match) {
    throw new RangeError('locale must contain match property')
  }

  var localeFirstWeekContainsDate =
    locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError(
      'firstWeekContainsDate must be between 1 and 7 inclusively'
    )
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn =
    localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn =
    options.weekStartsOn == null
      ? defaultWeekStartsOn
      : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBaseDate, options)
    } else {
      return new Date(NaN)
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [
    {
      priority: TIMEZONE_UNIT_PRIORITY,
      set: dateToSystemTimezone,
      index: 0
    }
  ];

  var i;

  var tokens = formatString.match(formattingTokensRegExp$1);

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.awareOfUnicodeTokens && isProtectedToken(token)) {
      throwProtectedError(token);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];
    if (parser) {
      var parseResult = parser.parse(
        dateString,
        token,
        locale.match,
        subFnOptions
      );

      if (!parseResult) {
        return new Date(NaN)
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });

      dateString = parseResult.rest;
    } else {
      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN)
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN)
  }

  var uniquePrioritySetters = setters
    .map(function(setter) {
      return setter.priority
    })
    .sort(function(a, b) {
      return b - a
    })
    .filter(function(priority, index, array) {
      return array.indexOf(priority) === index
    })
    .map(function(priority) {
      return setters
        .filter(function(setter) {
          return setter.priority === priority
        })
        .reverse()
    })
    .map(function(setterArray) {
      return setterArray[0]
    });

  var date = toDate(dirtyBaseDate, options);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (
      setter.validate &&
      !setter.validate(utcDate, setter.value, subFnOptions)
    ) {
      return new Date(NaN)
    }

    utcDate = setter.set(utcDate, setter.value, subFnOptions);
  }

  return utcDate
}

function dateToSystemTimezone(date) {
  var convertedDate = new Date(0);
  convertedDate.setFullYear(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate()
  );
  convertedDate.setHours(
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
  return convertedDate
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'")
}

// 

/**
 * Custom parse behavior on top of date-fns parse function.
 */
function parseDate$1 (date, format$1) {
  if (typeof date !== 'string') {
    return isValid(date) ? date : null;
  }

  var parsed = parse(date, format$1, new Date());

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!isValid(parsed) || format(parsed, format$1) !== date) {
    return null;
  }

  return parsed;
}

var afterValidator = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion; if ( inclusion === void 0 ) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isAfter(value, targetValue) || (inclusion && isEqual$1(value, targetValue));
};

var options = {
  hasTarget: true,
  isDate: true
};

// required to convert from a list of array values to an object.
var paramNames = ['targetValue', 'inclusion', 'format'];

var after = {
  validate: afterValidator,
  options: options,
  paramNames: paramNames
};

/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */

var alpha = {
  en: /^[A-Z]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[A-ZÆØÅ]*$/i,
  de: /^[A-ZÄÖÜß]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[A-Z\xC0-\xFF]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[А-ЯЁ]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[A-ZČĆŽŠĐ]*$/i,
  sv: /^[A-ZÅÄÖ]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaSpaces = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی\s]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  it: /^[A-Z\xC0-\xFF\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  sv: /^[A-ZÅÄÖ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i
};

var alphanumeric = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[0-9A-Z\xC0-\xFF]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  sv: /^[0-9A-ZÅÄÖ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaDash = {
  en: /^[0-9A-Z_-]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
  da: /^[0-9A-ZÆØÅ_-]*$/i,
  de: /^[0-9A-ZÄÖÜß_-]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی_-]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
  it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
  ru: /^[0-9А-ЯЁ_-]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
  sv: /^[0-9A-ZÅÄÖ_-]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i
};

var validate = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
  }

  return (alpha[locale] || alpha.en).test(value);
};

var paramNames$1 = ['locale'];

var alpha$1 = {
  validate: validate,
  paramNames: paramNames$1
};

var validate$1 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$1(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
  }

  return (alphaDash[locale] || alphaDash.en).test(value);
};

var paramNames$2 = ['locale'];

var alpha_dash = {
  validate: validate$1,
  paramNames: paramNames$2
};

var validate$2 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$2(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
  }

  return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var paramNames$3 = ['locale'];

var alpha_num = {
  validate: validate$2,
  paramNames: paramNames$3
};

var validate$3 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$3(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
  }

  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

var paramNames$4 = ['locale'];

var alpha_spaces = {
  validate: validate$3,
  paramNames: paramNames$4
};

var validate$4 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion; if ( inclusion === void 0 ) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isBefore(value, targetValue) || (inclusion && isEqual$1(value, targetValue));
};

var options$1 = {
  hasTarget: true,
  isDate: true
};

var paramNames$5 = ['targetValue', 'inclusion', 'format'];

var before = {
  validate: validate$4,
  options: options$1,
  paramNames: paramNames$5
};

var validate$5 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var min = ref.min;
  var max = ref.max;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$5(val, { min: min, max: max }); });
  }

  return Number(min) <= value && Number(max) >= value;
};

var paramNames$6 = ['min', 'max'];

var between = {
  validate: validate$5,
  paramNames: paramNames$6
};

var validate$6 = function (value, ref) {
  var targetValue = ref.targetValue;

  return String(value) === String(targetValue);
};
var options$2 = {
  hasTarget: true
};

var paramNames$7 = ['targetValue'];

var confirmed = {
  validate: validate$6,
  options: options$2,
  paramNames: paramNames$7
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType;

    if (input === null) {
      invalidType = 'null';
    } else {
      invalidType = _typeof(input);

      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
        invalidType = input.constructor.name;
      } else {
        invalidType = "a ".concat(invalidType);
      }
    }

    throw new TypeError("Expected string but received ".concat(invalidType, "."));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(assertString_1);

var isCreditCard_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isCreditCard = unwrapExports(isCreditCard_1);

var validate$7 = function (value) { return isCreditCard(String(value)); };

var credit_card = {
  validate: validate$7
};

var validate$8 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var min = ref.min;
  var max = ref.max;
  var inclusivity = ref.inclusivity; if ( inclusivity === void 0 ) inclusivity = '()';
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusivity;
    inclusivity = '()';
  }

  var minDate = parseDate$1(String(min), format);
  var maxDate = parseDate$1(String(max), format);
  var dateVal = parseDate$1(String(value), format);

  if (!minDate || !maxDate || !dateVal) {
    return false;
  }

  if (inclusivity === '()') {
    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
  }

  if (inclusivity === '(]') {
    return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
  }

  if (inclusivity === '[)') {
    return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
  }

  return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) ||
    (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
};

var options$3 = {
  isDate: true
};

var paramNames$8 = ['min', 'max', 'inclusivity', 'format'];

var date_between = {
  validate: validate$8,
  options: options$3,
  paramNames: paramNames$8
};

var validate$9 = function (value, ref) {
  var format = ref.format;

  return !!parseDate$1(value, format);
};

var options$4 = {
  isDate: true
};

var paramNames$9 = ['format'];

var date_format = {
  validate: validate$9,
  options: options$4,
  paramNames: paramNames$9
};

var validate$a = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var decimals = ref.decimals; if ( decimals === void 0 ) decimals = '*';
  var separator = ref.separator; if ( separator === void 0 ) separator = '.';

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$a(val, { decimals: decimals, separator: separator }); });
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }

  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
  var regex = new RegExp(("^[-+]?\\d*(\\" + separator + "\\d" + regexPart + ")?([eE]{1}[-]?\\d+)?$"));

  if (! regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  // eslint-disable-next-line
  return parsedValue === parsedValue;
};

var paramNames$a = ['decimals', 'separator'];

var decimal = {
  validate: validate$a,
  paramNames: paramNames$a
};

var validate$b = function (value, ref) {
  var length = ref[0];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$b(val, [length]); });
  }
  var strVal = String(value);

  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
};

var digits = {
  validate: validate$b
};

var imageRegex = /\.(jpg|svg|jpeg|png|bmp|gif)$/i;

var validateImage = function (file, width, height) {
  var URL = window.URL || window.webkitURL;
  return new Promise(function (resolve) {
    var image = new Image();
    image.onerror = function () { return resolve({ valid: false }); };
    image.onload = function () { return resolve({
      valid: image.width === Number(width) && image.height === Number(height)
    }); };

    image.src = URL.createObjectURL(file);
  });
};

var validate$c = function (files, ref) {
  var width = ref[0];
  var height = ref[1];

  var images = ensureArray(files).filter(function (file) { return imageRegex.test(file.name); });
  if (images.length === 0) {
    return false;
  }
  return Promise.all(images.map(function (image) { return validateImage(image, width, height); }));
};

var dimensions = {
  validate: validate$c
};

var merge_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(merge_1);

var isByteLength_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(isByteLength_1);

var isFQDN_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(assertString_1);

var _merge = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  var parts = str.split('.');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }

  if (options.require_tld) {
    var tld = parts.pop();

    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }

  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];

    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }

    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isFQDN = unwrapExports(isFQDN_1);

var isIP_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::
    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.

    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    } // initial or final ::


    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }

        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ; else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }

    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }

    return blocks.length === expectedNumberOfBlocks;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isIP = unwrapExports(isIP_1);

var isEmail_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(assertString_1);

var _merge = _interopRequireDefault(merge_1);

var _isByteLength = _interopRequireDefault(isByteLength_1);

var _isFQDN = _interopRequireDefault(isFQDN_1);

var _isIP = _interopRequireDefault(isIP_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);

    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');
  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace('.', ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  })) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isEmail = unwrapExports(isEmail_1);

function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var validate$d = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var multiple = ref.multiple; if ( multiple === void 0 ) multiple = false;
  var rest = objectWithoutProperties( ref, ["multiple"] );
  var options = rest;

  if (multiple && !Array.isArray(value)) {
    value = String(value).split(',').map(function (emailStr) { return emailStr.trim(); });
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) { return isEmail(String(val), validatorOptions); });
  }

  return isEmail(String(value), validatorOptions);
};

var email = {
  validate: validate$d
};

var validate$e = function (value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$e(val, options); });
  }

  return toArray(options).some(function (item) {
    // eslint-disable-next-line
    return item == value;
  });
};

var included = {
  validate: validate$e
};

var validate$f = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return !validate$e.apply(void 0, args);
};

var excluded = {
  validate: validate$f
};

var validate$g = function (files, extensions) {
  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');
  return ensureArray(files).every(function (file) { return regex.test(file.name); });
};

var ext = {
  validate: validate$g
};

var validate$h = function (files) { return (Array.isArray(files) ? files : [files]).every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }); };

var image = {
  validate: validate$h
};

var validate$i = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
  }

  return /^-?[0-9]+$/.test(String(value));
};

var integer = {
  validate: validate$i
};

var validate$j = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var version = ref.version; if ( version === void 0 ) version = 4;

  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isIP(val, version); });
  }

  return isIP(value, version);
};

var paramNames$b = ['version'];

var ip = {
  validate: validate$j,
  paramNames: paramNames$b
};

var validate$k = function (value) {
  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return (isIP(val, '') || isFQDN(val)); });
  }

  return isIP(value, '') || isFQDN(value);
};

var ip_or_fqdn = {
  validate: validate$k
};

var validate$l = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value === other;
};

var is = {
  validate: validate$l
};

var validate$m = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value !== other;
};

var is_not = {
  validate: validate$m
};

/**
 * @param {Array|String} value
 * @param {Number} length
 * @param {Number} max
 */
var compare = function (value, length, max) {
  if (max === undefined) {
    return value.length === length;
  }

  // cast to number.
  max = Number(max);

  return value.length >= length && value.length <= max;
};

var validate$n = function (value, ref) {
  var length = ref[0];
  var max = ref[1]; if ( max === void 0 ) max = undefined;

  if (isNullOrUndefined(value)) {
    return false;
  }

  length = Number(length);
  if (typeof value === 'number') {
    value = String(value);
  }

  if (!value.length) {
    value = toArray(value);
  }

  return compare(value, length, max);
};

var length = {
  validate: validate$n
};

var validate$o = function (value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return length >= 0;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$o(val, [length]); });
  }

  return String(value).length <= length;
};

var max = {
  validate: validate$o
};

var validate$p = function (value, ref) {
  var max = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) { return validate$p(val, [max]); });
  }

  return Number(value) <= max;
};

var max_value = {
  validate: validate$p
};

var validate$q = function (files, mimes) {
  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');
  return ensureArray(files).every(function (file) { return regex.test(file.type); });
};

var mimes = {
  validate: validate$q
};

var validate$r = function (value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$r(val, [length]); });
  }

  return String(value).length >= length;
};

var min = {
  validate: validate$r
};

var validate$s = function (value, ref) {
  var min = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) { return validate$s(val, [min]); });
  }

  return Number(value) >= min;
};

var min_value = {
  validate: validate$s
};

var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
var en = /^[0-9]+$/;

var validate$t = function (value) {
  var testValue = function (val) {
    var strValue = String(val);

    return en.test(strValue) || ar.test(strValue);
  };

  if (Array.isArray(value)) {
    return value.every(testValue);
  }

  return testValue(value);
};

var numeric = {
  validate: validate$t
};

var validate$u = function (value, ref) {
  var expression = ref.expression;

  if (typeof expression === 'string') {
    expression = new RegExp(expression);
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$u(val, { expression: expression }); });
  }

  return expression.test(String(value));
};

var paramNames$c = ['expression'];

var regex = {
  validate: validate$u,
  paramNames: paramNames$c
};

var validate$v = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;

  if (isNullOrUndefined(value) || isEmptyArray(value)) {
    return false;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && invalidateFalse) {
    return false;
  }

  return !!String(value).trim().length;
};

var required = {
  validate: validate$v
};

var validate$w = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var otherFieldVal = ref[0];
  var possibleVals = ref.slice(1);

  var required = possibleVals.includes(String(otherFieldVal).trim());

  if (!required) {
    return {
      valid: true,
      data: {
        required: required
      }
    };
  }

  var invalid = (isEmptyArray(value) || [false, null, undefined].includes(value));

  invalid = invalid || !String(value).trim().length;

  return {
    valid: !invalid,
    data: {
      required: required
    }
  };
};

var options$5 = {
  hasTarget: true,
  computesRequired: true
};

var required_if = {
  validate: validate$w,
  options: options$5
};

var validate$x = function (files, ref) {
  var size = ref[0];

  if (isNaN(size)) {
    return false;
  }
  var nSize = Number(size) * 1024;
  return ensureArray(files).every(function (file) { return file.size <= nSize; });
};

var size = {
  validate: validate$x
};

var isURL_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = _interopRequireDefault(assertString_1);

var _isFQDN = _interopRequireDefault(isFQDN_1);

var _isIP = _interopRequireDefault(isIP_1);

var _merge = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);
  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isURL = unwrapExports(isURL_1);

var validate$y = function (value, options) {
  if ( options === void 0 ) options = {};

  if (isNullOrUndefined(value)) {
    value = '';
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) { return isURL(val, validatorOptions); });
  }

  return isURL(value, validatorOptions);
};

var url = {
  validate: validate$y
};

/* eslint-disable camelcase */

var Rules = /*#__PURE__*/Object.freeze({
  after: after,
  alpha_dash: alpha_dash,
  alpha_num: alpha_num,
  alpha_spaces: alpha_spaces,
  alpha: alpha$1,
  before: before,
  between: between,
  confirmed: confirmed,
  credit_card: credit_card,
  date_between: date_between,
  date_format: date_format,
  decimal: decimal,
  digits: digits,
  dimensions: dimensions,
  email: email,
  ext: ext,
  image: image,
  included: included,
  integer: integer,
  length: length,
  ip: ip,
  ip_or_fqdn: ip_or_fqdn,
  is_not: is_not,
  is: is,
  max: max,
  max_value: max_value,
  mimes: mimes,
  min: min,
  min_value: min_value,
  excluded: excluded,
  numeric: numeric,
  regex: regex,
  required: required,
  required_if: required_if,
  size: size,
  url: url
});

// 

var normalize = function (fields) {
  if (Array.isArray(fields)) {
    return fields.reduce(function (prev, curr) {
      if (includes(curr, '.')) {
        prev[curr.split('.')[1]] = curr;
      } else {
        prev[curr] = curr;
      }

      return prev;
    }, {});
  }

  return fields;
};

// Combines two flags using either AND or OR depending on the flag type.
var combine = function (lhs, rhs) {
  var mapper = {
    pristine: function (lhs, rhs) { return lhs && rhs; },
    dirty: function (lhs, rhs) { return lhs || rhs; },
    touched: function (lhs, rhs) { return lhs || rhs; },
    untouched: function (lhs, rhs) { return lhs && rhs; },
    valid: function (lhs, rhs) { return lhs && rhs; },
    invalid: function (lhs, rhs) { return lhs || rhs; },
    pending: function (lhs, rhs) { return lhs || rhs; },
    required: function (lhs, rhs) { return lhs || rhs; },
    validated: function (lhs, rhs) { return lhs && rhs; }
  };

  return Object.keys(mapper).reduce(function (flags, flag) {
    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);

    return flags;
  }, {});
};

var mapScope = function (scope, deep) {
  if ( deep === void 0 ) deep = true;

  return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
      flags = assign({}, scope[field]);
      return flags;
    }

    // scope.
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
      return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
      return flags;
    }

    flags = combine(flags, scope[field]);

    return flags;
  }, null);
};

/**
 * Maps fields to computed functions.
 */
var mapFields = function (fields) {
  if (!fields) {
    return function () {
      return mapScope(this.$validator.flags);
    };
  }

  var normalized = normalize(fields);
  return Object.keys(normalized).reduce(function (prev, curr) {
    var field = normalized[curr];
    prev[curr] = function mappedField () {
      // if field exists
      if (this.$validator.flags[field]) {
        return this.$validator.flags[field];
      }

      // scopeless fields were selected.
      if (normalized[curr] === '*') {
        return mapScope(this.$validator.flags, false);
      }

      // if it has a scope defined
      var index = field.indexOf('.');
      if (index <= 0) {
        return {};
      }

      var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

      scope = this.$validator.flags[("$" + scope)];
      name = name.join('.');

      // an entire scope was selected: scope.*
      if (name === '*' && scope) {
        return mapScope(scope);
      }

      if (scope && scope[name]) {
        return scope[name];
      }

      return {};
    };

    return prev;
  }, {});
};

var $validator = null;

var PROVIDER_COUNTER = 0;

var ValidationProvider = {
  $__veeInject: false,
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1 () {
        if (!this.$vnode.context.$_veeObserver) {
          this.$vnode.context.$_veeObserver = createObserver();
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    vid: {
      type: [String, Number],
      default: function () {
        PROVIDER_COUNTER++;

        return ("_vee_" + PROVIDER_COUNTER);
      }
    },
    name: {
      type: String,
      default: null
    },
    mode: {
      type: [String, Function],
      default: function () {
        return getConfig().mode;
      }
    },
    events: {
      type: Array,
      validate: function () {
        /* istanbul ignore next */
        if (false) {}

        return true;
      },
      default: function () {
        var events = getConfig().events;
        if (typeof events === 'string') {
          return events.split('|');
        }

        return events;
      }
    },
    rules: {
      type: [Object, String],
      default: null
    },
    immediate: {
      type: Boolean,
      default: false
    },
    persist: {
      type: Boolean,
      default: false
    },
    bails: {
      type: Boolean,
      default: function () { return getConfig().fastExit; }
    },
    debounce: {
      type: Number,
      default: function () { return getConfig().delay || 0; }
    },
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: {
      deep: true,
      handler: function handler (val, oldVal) {
        this._needsValidation = !isEqual(val, oldVal);
      }
    }
  },
  data: function () { return ({
    messages: [],
    value: undefined,
    initialized: false,
    initialValue: undefined,
    flags: createFlags(),
    failedRules: {},
    forceRequired: false,
    isDeactivated: false,
    id: null
  }); },
  computed: {
    isValid: function isValid () {
      return this.flags.valid;
    },
    fieldDeps: function fieldDeps () {
      var this$1 = this;

      var rules = normalizeRules(this.rules);

      return Object.keys(rules).filter(RuleContainer.isTargetRule).map(function (rule) {
        var depName = rules[rule][0];
        watchCrossFieldDep(this$1, depName);

        return depName;
      });
    },
    normalizedEvents: function normalizedEvents () {
      var this$1 = this;

      var ref = computeModeSetting(this);
      var on = ref.on;

      return normalizeEvents(on || this.events || []).map(function (e) {
        if (e === 'input') {
          return this$1._inputEventName;
        }

        return e;
      });
    },
    isRequired: function isRequired () {
      var rules = normalizeRules(this.rules);
      var forceRequired = this.forceRequired;

      var isRequired = rules.required || forceRequired;
      this.flags.required = isRequired;

      return isRequired;
    },
    classes: function classes () {
      var this$1 = this;

      var names = getConfig().classNames;
      return Object.keys(this.flags).reduce(function (classes, flag) {
        var className = (names && names[flag]) || flag;
        if (isNullOrUndefined(this$1.flags[flag])) {
          return classes;
        }

        if (className) {
          classes[className] = this$1.flags[flag];
        }

        return classes;
      }, {});
    }
  },
  render: function render (h) {
    var this$1 = this;

    this.registerField();
    var ctx = createValidationCtx(this);

    // Gracefully handle non-existent scoped slots.
    var slot = this.$scopedSlots.default;
    /* istanbul ignore next */
    if (!isCallable(slot)) {
      if (false) {}

      return h(this.tag, this.$slots.default);
    }

    var nodes = slot(ctx);
    // Handle single-root slot.
    extractVNodes(nodes).forEach(function (input) {
      addListeners.call(this$1, input);
    });

    return this.slim ? createRenderless(h, nodes) : h(this.tag, nodes);
  },
  beforeDestroy: function beforeDestroy () {
    // cleanup reference.
    this.$_veeObserver.unsubscribe(this);
  },
  activated: function activated () {
    this.$_veeObserver.subscribe(this);
    this.isDeactivated = false;
  },
  deactivated: function deactivated () {
    this.$_veeObserver.unsubscribe(this);
    this.isDeactivated = true;
  },
  methods: {
    setFlags: function setFlags (flags) {
      var this$1 = this;

      Object.keys(flags).forEach(function (flag) {
        this$1.flags[flag] = flags[flag];
      });
    },
    syncValue: function syncValue (e) {
      var value = normalizeValue$1(e);
      this.value = value;
      this.flags.changed = this.initialValue !== value;
    },
    reset: function reset () {
      this.messages = [];
      this._pendingValidation = null;
      this.initialValue = this.value;
      var flags = createFlags();
      this.setFlags(flags);
    },
    validate: function validate () {
      var this$1 = this;
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      if (args.length > 0) {
        this.syncValue(args[0]);
      }

      return this.validateSilent().then(function (result) {
        this$1.applyResult(result);

        return result;
      });
    },
    validateSilent: function validateSilent () {
      var this$1 = this;

      this.setFlags({ pending: true });

      return $validator.verify(this.value, this.rules, {
        name: this.name,
        values: createValuesLookup(this),
        bails: this.bails
      }).then(function (result) {
        this$1.setFlags({ pending: false });
        if (!this$1.isRequired) {
          this$1.setFlags({ valid: result.valid, invalid: !result.valid });
        }

        return result;
      });
    },
    applyResult: function applyResult (ref) {
      var errors = ref.errors;
      var failedRules = ref.failedRules;

      this.messages = errors;
      this.failedRules = assign({}, failedRules);
      this.setFlags({
        valid: !errors.length,
        changed: this.value !== this.initialValue,
        invalid: !!errors.length,
        validated: true
      });
    },
    registerField: function registerField () {
      if (!$validator) {
        $validator = getValidator() || new Validator(null, { fastExit: getConfig().fastExit });
      }

      updateRenderingContextRefs(this);
    }
  }
};

function createValidationCtx (ctx) {
  return {
    errors: ctx.messages,
    flags: ctx.flags,
    classes: ctx.classes,
    valid: ctx.isValid,
    failedRules: ctx.failedRules,
    reset: function () { return ctx.reset(); },
    validate: function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      return ctx.validate.apply(ctx, args);
  },
    aria: {
      'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
      'aria-required': ctx.isRequired ? 'true' : 'false'
    }
  };
}

function normalizeValue$1 (value) {
  if (isEvent(value)) {
    return value.target.type === 'file' ? toArray(value.target.files) : value.target.value;
  }

  return value;
}

/**
 * Determines if a provider needs to run validation.
 */
function shouldValidate (ctx, model) {
  // when an immediate/initial validation is needed and wasn't done before.
  if (!ctx._ignoreImmediate && ctx.immediate) {
    return true;
  }

  // when the value changes for whatever reason.
  if (ctx.value !== model.value) {
    return true;
  }

  // when it needs validation due to props/cross-fields changes.
  if (ctx._needsValidation) {
    return true;
  }

  // when the initial value is undefined and the field wasn't rendered yet.
  if (!ctx.initialized && model.value === undefined) {
    return true;
  }

  return false;
}

function computeModeSetting (ctx) {
  var compute = isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode];

  return compute({
    errors: ctx.messages,
    value: ctx.value,
    flags: ctx.flags
  });
}

function onRenderUpdate (model) {
  if (!this.initialized) {
    this.initialValue = model.value;
  }

  var validateNow = shouldValidate(this, model);
  this._needsValidation = false;
  this.value = model.value;
  this._ignoreImmediate = true;

  if (!validateNow) {
    return;
  }

  this.validateSilent().then(this.immediate || this.flags.validated ? this.applyResult : function (x) { return x; });
}

// Creates the common handlers for a validatable context.
function createCommonHandlers (ctx) {
  var onInput = function (e) {
    ctx.syncValue(e); // track and keep the value updated.
    ctx.setFlags({ dirty: true, pristine: false });
  };

  // Blur event listener.
  var onBlur = function () {
    ctx.setFlags({ touched: true, untouched: false });
  };

  var onValidate = ctx.$veeHandler;
  var mode = computeModeSetting(ctx);

  // Handle debounce changes.
  if (!onValidate || ctx.$veeDebounce !== ctx.debounce) {
    onValidate = debounce(
      function () {
        ctx.$nextTick(function () {
          var pendingPromise = ctx.validateSilent();
          // avoids race conditions between successive validations.
          ctx._pendingValidation = pendingPromise;
          pendingPromise.then(function (result) {
            if (pendingPromise === ctx._pendingValidation) {
              ctx.applyResult(result);
              ctx._pendingValidation = null;
            }
          });
        });
      },
      mode.debounce || ctx.debounce
    );

    // Cache the handler so we don't create it each time.
    ctx.$veeHandler = onValidate;
    // cache the debounce value so we detect if it was changed.
    ctx.$veeDebounce = ctx.debounce;
  }

  return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
}

// Adds all plugin listeners to the vnode.
function addListeners (node) {
  var model = findModel(node);
  // cache the input eventName.
  this._inputEventName = this._inputEventName || getInputEventName(node, model);

  onRenderUpdate.call(this, model);

  var ref = createCommonHandlers(this);
  var onInput = ref.onInput;
  var onBlur = ref.onBlur;
  var onValidate = ref.onValidate;
  addVNodeListener(node, this._inputEventName, onInput);
  addVNodeListener(node, 'blur', onBlur);

  // add the validation listeners.
  this.normalizedEvents.forEach(function (evt) {
    addVNodeListener(node, evt, onValidate);
  });

  this.initialized = true;
}

function createValuesLookup (ctx) {
  var providers = ctx.$_veeObserver.refs;

  return ctx.fieldDeps.reduce(function (acc, depName) {
    if (!providers[depName]) {
      return acc;
    }

    acc[depName] = providers[depName].value;

    return acc;
  }, {});
}

function updateRenderingContextRefs (ctx) {
  // IDs should not be nullable.
  if (isNullOrUndefined(ctx.id) && ctx.id === ctx.vid) {
    ctx.id = PROVIDER_COUNTER;
    PROVIDER_COUNTER++;
  }

  var id = ctx.id;
  var vid = ctx.vid;
  // Nothing has changed.
  if (ctx.isDeactivated || (id === vid && ctx.$_veeObserver.refs[id])) {
    return;
  }

  // vid was changed.
  if (id !== vid && ctx.$_veeObserver.refs[id] === ctx) {
    ctx.$_veeObserver.unsubscribe({ vid: id });
  }

  ctx.$_veeObserver.subscribe(ctx);
  ctx.id = vid;
}

function createObserver () {
  return {
    refs: {},
    subscribe: function subscribe (ctx) {
      this.refs[ctx.vid] = ctx;
    },
    unsubscribe: function unsubscribe (ctx) {
      delete this.refs[ctx.vid];
    }
  };
}

function watchCrossFieldDep (ctx, depName, withHooks) {
  if ( withHooks === void 0 ) withHooks = true;

  var providers = ctx.$_veeObserver.refs;
  if (!ctx._veeWatchers) {
    ctx._veeWatchers = {};
  }

  if (!providers[depName] && withHooks) {
    return ctx.$once('hook:mounted', function () {
      watchCrossFieldDep(ctx, depName, false);
    });
  }

  if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
    ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
      if (ctx.flags.validated) {
        ctx._needsValidation = true;
        ctx.validate();
      }
    });
  }
}

var flagMergingStrategy = {
  pristine: 'every',
  dirty: 'some',
  touched: 'some',
  untouched: 'every',
  valid: 'every',
  invalid: 'some',
  pending: 'some',
  validated: 'every'
};

function mergeFlags (lhs, rhs, strategy) {
  var stratName = flagMergingStrategy[strategy];

  return [lhs, rhs][stratName](function (f) { return f; });
}

var OBSERVER_COUNTER = 0;

var ValidationObserver = {
  name: 'ValidationObserver',
  provide: function provide () {
    return {
      $_veeObserver: this
    };
  },
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1 () {
        if (!this.$vnode.context.$_veeObserver) {
          return null;
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  data: function () { return ({
    vid: ("obs_" + (OBSERVER_COUNTER++)),
    refs: {},
    observers: [],
    persistedStore: {}
  }); },
  computed: {
    ctx: function ctx () {
      var this$1 = this;

      var ctx = {
        errors: {},
        validate: function (arg) {
          var promise = this$1.validate(arg);

          return {
            then: function then (thenable) {
              return promise.then(function (success) {
                if (success && isCallable(thenable)) {
                  return Promise.resolve(thenable());
                }

                return Promise.resolve(success);
              });
            }
          };
        },
        reset: function () { return this$1.reset(); }
      };

      return values(this.refs).concat( Object.keys(this.persistedStore).map(function (key) {
          return {
            vid: key,
            flags: this$1.persistedStore[key].flags,
            messages: this$1.persistedStore[key].errors
          };
        }),
        this.observers ).reduce(function (acc, provider) {
        Object.keys(flagMergingStrategy).forEach(function (flag) {
          var flags = provider.flags || provider.ctx;
          if (!(flag in acc)) {
            acc[flag] = flags[flag];
            return;
          }

          acc[flag] = mergeFlags(acc[flag], flags[flag], flag);
        });

        acc.errors[provider.vid] = provider.messages || values(provider.ctx.errors).reduce(function (errs, obsErrors) {
          return errs.concat(obsErrors);
        }, []);

        return acc;
      }, ctx);
    }
  },
  created: function created () {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  activated: function activated () {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  deactivated: function deactivated () {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  render: function render (h) {
    var slots = this.$slots.default || this.$scopedSlots.default || [];
    if (isCallable(slots)) {
      slots = slots(this.ctx);
    }

    return this.slim ? createRenderless(h, slots) : h(this.tag, { on: this.$listeners, attrs: this.$attrs }, slots);
  },
  methods: {
    subscribe: function subscribe (subscriber, kind) {
      var obj;

      if ( kind === void 0 ) kind = 'provider';
      if (kind === 'observer') {
        this.observers.push(subscriber);
        return;
      }

      this.refs = Object.assign({}, this.refs, ( obj = {}, obj[subscriber.vid] = subscriber, obj ));
      if (subscriber.persist && this.persistedStore[subscriber.vid]) {
        this.restoreProviderState(subscriber);
      }
    },
    unsubscribe: function unsubscribe (ref, kind) {
      var vid = ref.vid;
      if ( kind === void 0 ) kind = 'provider';

      if (kind === 'provider') {
        this.removeProvider(vid);
      }

      var idx = findIndex(this.observers, function (o) { return o.vid === vid; });
      if (idx !== -1) {
        this.observers.splice(idx, 1);
      }
    },
    validate: function validate (ref) {
      if ( ref === void 0 ) ref = { silent: false };
      var silent = ref.silent;

      return Promise.all(values(this.refs).map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }).concat( this.observers.map(function (obs) { return obs.validate({ silent: silent }); })
      )).then(function (results) { return results.every(function (r) { return r; }); });
    },
    reset: function reset () {
      var this$1 = this;

      Object.keys(this.persistedStore).forEach(function (key) {
        this$1.$delete(this$1.persistedStore, key);
      });
      return values(this.refs).concat( this.observers).forEach(function (ref) { return ref.reset(); });
    },
    restoreProviderState: function restoreProviderState (provider) {
      var state = this.persistedStore[provider.vid];
      provider.setFlags(state.flags);
      provider.applyResult(state);
      this.$delete(this.persistedStore, provider.vid);
    },
    removeProvider: function removeProvider (vid) {
      var obj;

      var provider = this.refs[vid];
      // save it for the next time.
      if (provider && provider.persist) {
        /* istanbul ignore else */
        if (false) {}

        this.persistedStore = assign({}, this.persistedStore, ( obj = {}, obj[vid] = {
            flags: provider.flags,
            errors: provider.messages,
            failedRules: provider.failedRules
          }, obj ));
      }

      this.$delete(this.refs, vid);
    },
  }
};

function withValidation (component, ctxToProps) {
  if ( ctxToProps === void 0 ) ctxToProps = null;

  var options = isCallable(component) ? component.options : component;
  options.$__veeInject = false;
  var hoc = {
    name: ((options.name || 'AnonymousHoc') + "WithValidation"),
    props: assign({}, ValidationProvider.props),
    data: ValidationProvider.data,
    computed: assign({}, ValidationProvider.computed),
    methods: assign({}, ValidationProvider.methods),
    $__veeInject: false,
    beforeDestroy: ValidationProvider.beforeDestroy,
    inject: ValidationProvider.inject
  };

  // Default ctx converts ctx props to component props.
  if (!ctxToProps) {
    ctxToProps = function (ctx) { return ctx; };
  }

  var eventName = (options.model && options.model.event) || 'input';

  hoc.render = function (h) {
    var obj;

    this.registerField();
    var vctx = createValidationCtx(this);
    var listeners = assign({}, this.$listeners);

    var model = findModel(this.$vnode);
    this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
    onRenderUpdate.call(this, model);

    var ref = createCommonHandlers(this);
    var onInput = ref.onInput;
    var onBlur = ref.onBlur;
    var onValidate = ref.onValidate;

    mergeVNodeListeners(listeners, eventName, onInput);
    mergeVNodeListeners(listeners, 'blur', onBlur);
    this.normalizedEvents.forEach(function (evt, idx) {
      mergeVNodeListeners(listeners, evt, onValidate);
    });

    // Props are any attrs not associated with ValidationProvider Plus the model prop.
    // WARNING: Accidental prop overwrite will probably happen.
    var ref$1 = findModelConfig(this.$vnode) || { prop: 'value' };
    var prop = ref$1.prop;
    var props = assign({}, this.$attrs, ( obj = {}, obj[prop] = model.value, obj ), ctxToProps(vctx));

    return h(options, {
      attrs: this.$attrs,
      props: props,
      on: listeners
    }, normalizeSlots(this.$slots, this.$vnode.context));
  };

  return hoc;
}

var version = '2.2.15';

Object.keys(Rules).forEach(function (rule) {
  Validator.extend(rule, Rules[rule].validate, assign({}, Rules[rule].options, { paramNames: Rules[rule].paramNames }));
});

// Merge the english messages.
Validator.localize({ en: locale });

var install = VeeValidate$1.install;

VeeValidate$1.version = version;
VeeValidate$1.mapFields = mapFields;
VeeValidate$1.ValidationProvider = ValidationProvider;
VeeValidate$1.ValidationObserver = ValidationObserver;
VeeValidate$1.withValidation = withValidation;

/* harmony default export */ __webpack_exports__["default"] = (VeeValidate$1);



/***/ }),

/***/ "7c24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_style_index_0_id_3d074454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("69c0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_style_index_0_id_3d074454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_style_index_0_id_3d074454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7c97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8ca3");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7d25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_style_index_0_id_23cb9858_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4bbd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_style_index_0_id_23cb9858_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_style_index_0_id_23cb9858_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxCheckbox_vue_vue_type_template_id_2fdb377b_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9d0e");
/* harmony import */ var _AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("eb94");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxCheckbox_vue_vue_type_style_index_0_id_2fdb377b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f0b5");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxCheckbox_vue_vue_type_template_id_2fdb377b_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxCheckbox_vue_vue_type_template_id_2fdb377b_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "2fdb377b",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "8004":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * This component can be used to display some text in read-only format.
 * It has special styles and differs from a input field with readonly attribute.
 */


var AnxReadonly = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxReadonly, _vue_property_decorat);

  var _super = _createSuper(AnxReadonly);

  function AnxReadonly() {
    _classCallCheck(this, AnxReadonly);

    return _super.apply(this, arguments);
  }

  _createClass(AnxReadonly, [{
    key: "click",
    value:
    /** Handle a click on the readonly */
    function click() {
      if (this.copyOnClick !== null) {
        this.copy(this.$el.childNodes[0]);
      }
    }
    /** Select and copy the text of the area */

  }, {
    key: "copy",
    value: function copy() {
      var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!elem) {
        elem = this.$el.childNodes[0];
      }

      try {
        // Select the text
        var range = document.createRange();
        range.selectNode(elem);
        var selection = window.getSelection();

        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
        } // Try to copy the selected text


        document.execCommand("copy");
      } catch (e) {
        // Browser is unable to execute copy command
        return false;
      }
      /**
       * This event will be emitted after the content has successfully been copied to the clipboard
       *
       * @event copied
       */


      this.$emit("copied");
      return true;
    }
  }]);

  return AnxReadonly;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxReadonly.prototype, "copyOnClick", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxReadonly.prototype, "bold", void 0);

AnxReadonly = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxReadonly);
exports.default = AnxReadonly;

/***/ }),

/***/ "8154":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_style_index_0_id_a1c0af30_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8746");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_style_index_0_id_a1c0af30_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxSelect_vue_vue_type_style_index_0_id_a1c0af30_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "825a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxHrLine_vue_vue_type_template_id_736bfe57_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("345b");
/* harmony import */ var _AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("34d4");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxHrLine_vue_vue_type_style_index_0_id_736bfe57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aa44");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxHrLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxHrLine_vue_vue_type_template_id_736bfe57_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxHrLine_vue_vue_type_template_id_736bfe57_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "736bfe57",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "84c8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxToast_vue_vue_type_template_id_0f850245_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0429");
/* harmony import */ var _AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("55fd");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxToast_vue_vue_type_style_index_0_id_0f850245_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5fc4");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxToast_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxToast_vue_vue_type_template_id_0f850245_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxToast_vue_vue_type_template_id_0f850245_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "0f850245",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8637":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8659":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_style_index_0_id_7657fe93_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9891");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_style_index_0_id_7657fe93_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxLanguageSwitcher_vue_vue_type_style_index_0_id_7657fe93_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "86ec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("ac1f");

__webpack_require__("5319");

__webpack_require__("b64b");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxTableContainer_vue_1 = tslib_1.__importDefault(__webpack_require__("e7fc"));

var AnxTableRow_vue_1 = tslib_1.__importDefault(__webpack_require__("d25a"));

var AnxTableCol_vue_1 = tslib_1.__importDefault(__webpack_require__("2de1"));
/**
 * A powerfull table with many design features
 */


var AnxTable = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxTable, _vue_property_decorat);

  var _super = _createSuper(AnxTable);

  function AnxTable() {
    _classCallCheck(this, AnxTable);

    return _super.apply(this, arguments);
  }

  _createClass(AnxTable, [{
    key: "camelCaseToText",
    value:
    /** Converts camelCase to Text */
    function camelCaseToText(camelCase) {
      return camelCase.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
        return str.toUpperCase();
      });
    }
    /** Returns the colums that should be displayed */

  }, {
    key: "displayColumns",
    get: function get() {
      var columns = [];

      if (this.columns === null) {
        /** If no specific columns are defined, we use the first entry of the items to get the names of the columns */
        if (this.items && this.items.length > 0) {
          for (var _i = 0, _Object$keys = Object.keys(this.items[0]); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            columns.push({
              name: this.camelCaseToText(key),
              index: key,
              width: "auto",
              align: "left"
            });
          }
        }
      } else {
        /** If the columns property is defined, we use it for the names */
        columns = this.columns;
      }

      return columns;
    }
  }]);

  return AnxTable;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "scrollable", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "stripped", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "bordered", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "borderless", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "hover", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "height", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "uppercaseTitle", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "items", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "columns", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTable.prototype, "noHeader", void 0);

AnxTable = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxTableContainer: AnxTableContainer_vue_1.default,
    AnxTableRow: AnxTableRow_vue_1.default,
    AnxTableCol: AnxTableCol_vue_1.default
  }
})], AnxTable);
exports.default = AnxTable;

/***/ }),

/***/ "8746":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "884c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8910":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8985":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxTitle_vue_1 = tslib_1.__importDefault(__webpack_require__("d602"));
/**
 * The *anx-paragraph* is a computed version of the default HTML \<p\> tag that matches our styleguideline.
 */


var AnxParagraph = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxParagraph, _vue_property_decorat);

  var _super = _createSuper(AnxParagraph);

  function AnxParagraph() {
    _classCallCheck(this, AnxParagraph);

    return _super.apply(this, arguments);
  }

  return AnxParagraph;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxParagraph.prototype, "title", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "h1"
})], AnxParagraph.prototype, "size", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxParagraph.prototype, "hint", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxParagraph.prototype, "noline", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxParagraph.prototype, "inverse", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxParagraph.prototype, "noMarginTitle", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "p"
})], AnxParagraph.prototype, "element", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxParagraph.prototype, "marginBottom", void 0);

AnxParagraph = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxTitle: AnxTitle_vue_1.default
  }
})], AnxParagraph);
exports.default = AnxParagraph;

/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8ae5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxContact/AnxContact.vue?vue&type=template&id=710bf1b0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-contact"},[_c('anx-content',{attrs:{"title":_vm.title}},[(this.$slots.default)?_c('anx-paragraph',[_vm._t("default")],2):_vm._e(),_c('anx-form',{ref:"contactForm",on:{"submit":_vm.submit}},[_c('div',{staticClass:"input-inline"},[_c('anx-input',{attrs:{"id":"first_name","name":_vm.firstName.name,"rules":"required","label":_vm.firstName.label ? _vm.firstName.label : _vm.firstName.name,"width":"45%"},model:{value:(_vm.request.firstName),callback:function ($$v) {_vm.$set(_vm.request, "firstName", $$v)},expression:"request.firstName"}}),_c('anx-input',{staticClass:"right",attrs:{"id":"last_name","name":_vm.lastName.name,"rules":"required","label":_vm.lastName.label ? _vm.lastName.label : _vm.lastName.name,"width":"45%"},model:{value:(_vm.request.lastName),callback:function ($$v) {_vm.$set(_vm.request, "lastName", $$v)},expression:"request.lastName"}})],1),(_vm.showEmail)?_c('anx-input',{attrs:{"id":"email","name":_vm.email.name,"rules":"required|email","label":_vm.email.label ? _vm.email.label : _vm.email.name},model:{value:(_vm.request.email),callback:function ($$v) {_vm.$set(_vm.request, "email", $$v)},expression:"request.email"}}):_vm._e(),(_vm.showPhone)?_c('anx-input',{attrs:{"id":"phone","name":_vm.phone.name,"rules":"required","label":_vm.phone.label ? _vm.phone.label : _vm.phone.name},model:{value:(_vm.request.phone),callback:function ($$v) {_vm.$set(_vm.request, "phone", $$v)},expression:"request.phone"}}):_vm._e(),_c('anx-textarea',{attrs:{"id":"message","name":_vm.message.name,"label":_vm.message.label ? _vm.message.label : _vm.message.name},model:{value:(_vm.request.message),callback:function ($$v) {_vm.$set(_vm.request, "message", $$v)},expression:"request.message"}}),_c('div',{staticClass:"recaptcha-wrapper"},[(_vm.useRecaptcha && !_vm.invisibleCaptcha)?_c('vue-recaptcha',{attrs:{"sitekey":_vm.recaptchaSitekey,"loadRecaptchaScript":true,"size":"100%"},on:{"verify":_vm.verifyCaptcha,"error":_vm.errorCaptcha,"expired":_vm.expiredCaptcha}}):_vm._e()],1),_c('anx-alert',{model:{value:(_vm.showError_),callback:function ($$v) {_vm.showError_=$$v},expression:"showError_"}},[_vm._v(_vm._s(_vm.error))]),_c('anx-alert',{attrs:{"type":"success","text":_vm.success},model:{value:(_vm.showSuccess_),callback:function ($$v) {_vm.showSuccess_=$$v},expression:"showSuccess_"}}),_c('anx-alert',{model:{value:(_vm.internalRecaptchaError),callback:function ($$v) {_vm.internalRecaptchaError=$$v},expression:"internalRecaptchaError"}},[_vm._v("Recaptcha error")]),(_vm.useRecaptcha && _vm.invisibleCaptcha)?_c('vue-recaptcha',{ref:"invisibleCaptcha",attrs:{"sitekey":_vm.recaptchaSitekey,"loadRecaptchaScript":true},on:{"verify":_vm.verifyCaptcha,"error":_vm.errorCaptcha,"expired":_vm.expiredCaptcha}},[_c('anx-button',{attrs:{"width":"100%","text":_vm.sendButton.text}})],1):_vm._e(),(!_vm.useRecaptcha || !_vm.invisibleCaptcha)?_c('anx-button',{attrs:{"id":"anx-contact-form-send-button","width":"100%","disabled":!_vm.isButtonEnabled,"text":_vm.sendButton.text}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxContact/AnxContact.vue?vue&type=template&id=710bf1b0&scoped=true&


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("96cf");

__webpack_require__("4de4");

__webpack_require__("159b");

__webpack_require__("d81d");

__webpack_require__("fb6a");

__webpack_require__("b0c0");

__webpack_require__("b64b");

__webpack_require__("caad");

__webpack_require__("2532");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxTable_vue_1 = tslib_1.__importDefault(__webpack_require__("ac31"));

var AnxTableRow_vue_1 = tslib_1.__importDefault(__webpack_require__("d25a"));

var AnxTableCol_vue_1 = tslib_1.__importDefault(__webpack_require__("2de1"));

var AnxTitle_vue_1 = tslib_1.__importDefault(__webpack_require__("d602"));

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));

var AnxModal_vue_1 = tslib_1.__importDefault(__webpack_require__("b4c7"));

var AnxButton_vue_1 = tslib_1.__importDefault(__webpack_require__("3097"));

var AnxInput_vue_1 = tslib_1.__importDefault(__webpack_require__("6911"));
/**
 * This component is based on the *anx-table* and fully automatically renders a CRUD table with your data.
 */


var AnxCrudTable = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxCrudTable, _vue_property_decorat);

  var _super = _createSuper(AnxCrudTable);

  function AnxCrudTable() {
    var _this;

    _classCallCheck(this, AnxCrudTable);

    _this = _super.apply(this, arguments);
    _this.instances = [];
    _this.selectedItem = null;
    _this.createInstance = null;
    _this.showDeleteModal = false;
    _this.showEditModal = false;
    _this.showCreateModal = false;
    _this.internalSort = {
      name: 0,
      order: "ASC"
    };
    _this.searchValue = "";
    /** _page cannot be used as name for internal page */

    _this.page_ = 0;
    return _this;
  }
  /** Number of pages should be at least 1 (even if there are no entries: "Page 1 of 1") */


  _createClass(AnxCrudTable, [{
    key: "numberPages",
    get: function get() {
      var num = Math.ceil(this.sortedInstances.length / this.maxItems);

      if (num <= 0) {
        return 1;
      } else {
        return num;
      }
    }
  }, {
    key: "page",
    get: function get() {
      if (this.page_ < this.numberPages) {
        return this.page_;
      } else {
        this.page = this.numberPages - 1;
        return this.page_;
      }
    },
    set: function set(page) {
      if (page < 0 || this.numberPages <= 0) {
        this.page_ = 0;
      } else if (page >= this.numberPages && this.numberPages > 0) {
        this.page_ = this.numberPages - 1;
      } else {
        this.page_ = page;
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.fetch();

      if (this.sort) {
        this.internalSort = this.sort;
      }
    }
  }, {
    key: "onSortChanged",
    value: function onSortChanged() {
      if (this.sort) {
        this.internalSort = this.sort;
      }
    }
  }, {
    key: "onModelClassChange",
    value: function onModelClassChange() {
      this.fetch();
    }
  }, {
    key: "paginatedSortedFilteredInstancesNonSoftDeleted",
    get: function get() {
      return this.paginatedSortedFilteredInstances.filter(function (instance) {
        if (Object.prototype.hasOwnProperty.call(instance, "deleted") && instance.deleted // eslint-disable-line
        ) {
            return false;
          }

        return true;
      });
    }
  }, {
    key: "paginatedSortedFilteredInstances",
    get: function get() {
      var instances = this.paginatedSortedInstances;
      this.hideColumns.forEach(function (column) {
        instances.map(function (instance) {
          if (Object.prototype.hasOwnProperty.call(instance, column)) {
            // eslint-disable-next-line
            delete instance[column];
          }
        });
      });
      return instances;
    }
  }, {
    key: "paginatedSortedInstances",
    get: function get() {
      if (!this.isPaginated) {
        return this.sortedInstances;
      }

      return this.sortedInstances.slice(this.page * this.maxItems, (this.page + 1) * this.maxItems);
    }
  }, {
    key: "isPaginated",
    get: function get() {
      return this.maxItems > 0;
    }
  }, {
    key: "useSearch",
    get: function get() {
      // Check if search columns are defined
      if (!this.searchColumns || this.searchColumns.length === 0) {
        return false;
      } // If there are no instances we can't use search


      if (!this.instances || this.instances.length === 0) {
        return false;
      } // Check if all search columns are right, otherwise don't use the search


      for (var i = 0; i < this.searchColumns.length; i++) {
        if (!(this.searchColumns[i] in this.instances[0])) {
          // eslint-disable-next-line
          console.error("Unknown search column ".concat(this.searchColumns[i], "! Check if you are using the property properly."));
          return false;
        }
      }

      return true;
    }
  }, {
    key: "searchFilteredInstances",
    get: function get() {
      var _this2 = this;

      // Check if the search should be used
      if (!this.useSearch || !this.searchValue || this.searchValue == "") {
        return this.instances;
      }

      var instances = [];
      this.instances.forEach(function (instance) {
        if (_this2.searchColumns) {
          for (var i = 0; i < _this2.searchColumns.length; i++) {
            if (_this2.searchColumns[i] in instance) {
              if ( // eslint-disable-next-line
              instance[_this2.searchColumns[i]].toLowerCase().indexOf(_this2.searchValue.toLowerCase()) >= 0) {
                instances.push(instance);
                break;
              }
            }
          }
        }
      });
      return instances;
    }
  }, {
    key: "sortedInstances",
    get: function get() {
      var _this3 = this;

      if (!this.internalSort || !this.internalSort.name || !this.internalSort.order) {
        return this.searchFilteredInstances;
      }

      var sort = this.searchFilteredInstances.sort(function (a, b) {
        /*eslint-disable */

        /**
         * We need to access the object dynamically here but
         * we don't know the properties of it since the modelClass is injected on runtime
         */
        if (_this3.internalSort.order === "ASC") {
          return a[_this3.internalSort.name] - b[_this3.internalSort.name];
        } else {
          return b[_this3.internalSort.name] - a[_this3.internalSort.name];
        }
        /*eslint-enable */

      });
      return sort;
    }
    /**
     * Only show actions tab when there are any actions, you need to add upcoming actions here too
     */

  }, {
    key: "hasActions",
    get: function get() {
      return this.editable || this.deletable;
    }
  }, {
    key: "tableColumns",
    get: function get() {
      var _this4 = this;

      if (this.instances.length) {
        var instanceProps = Object.keys(this.instances[0]).map(function (v) {
          return {
            name: v
          };
        });
        instanceProps = instanceProps.filter(function (instanceProp) {
          if (_this4.hideColumns.includes(instanceProp.name)) {
            return false;
          }

          return true;
        });

        if (instanceProps[0].name === "id") {
          instanceProps[0].width = "60px";
          instanceProps[0].align = "center";
        }

        if (this.hasActions) {
          instanceProps.push({
            name: "Actions"
          });
        }

        return instanceProps;
      }

      return [];
    }
  }, {
    key: "fetch",
    value: function fetch() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.modelClass) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.modelClass.getAll({
                  authorization: this.authorization
                });

              case 5:
                this.instances = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                this.instances = [];

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));
    }
  }, {
    key: "deleteSelectedItem",
    value: function deleteSelectedItem() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.selectedItem) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return this.selectedItem.delete({
                  authorization: this.authorization
                });

              case 3:
                _context2.next = 5;
                return this.fetch();

              case 5:
                this.showDeleteModal = false;
                _context2.next = 9;
                break;

              case 8:
                throw new Error("No selected item to delete set!");

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "editSelectedItem",
    value: function editSelectedItem() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.selectedItem) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 3;
                return this.selectedItem.update({
                  authorization: this.authorization
                });

              case 3:
                _context3.next = 5;
                return this.fetch();

              case 5:
                this.showEditModal = false;
                _context3.next = 9;
                break;

              case 8:
                throw new Error("No selected item to update!");

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "createItem",
    value: function createItem() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.createInstance) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.next = 4;
                return this.createInstance.save({
                  authorization: this.authorization
                });

              case 4:
                _context4.next = 6;
                return this.fetch();

              case 6:
                this.showCreateModal = false;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return AnxCrudTable;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxCrudTable.prototype, "modelClass", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxCrudTable.prototype, "showHeader", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxCrudTable.prototype, "searchColumns", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Search"
})], AnxCrudTable.prototype, "searchFieldLabel", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxCrudTable.prototype, "deletable", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Create new"
})], AnxCrudTable.prototype, "createButtonText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxCrudTable.prototype, "editable", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxCrudTable.prototype, "authorization", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      name: 0,
      order: "ASC"
    };
  }
})], AnxCrudTable.prototype, "sort", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return [];
  }
})], AnxCrudTable.prototype, "hideColumns", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: -1
})], AnxCrudTable.prototype, "maxItems", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("sort")], AnxCrudTable.prototype, "onSortChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Watch("modelClass")], AnxCrudTable.prototype, "onModelClassChange", null);

AnxCrudTable = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxTable: AnxTable_vue_1.default,
    AnxTableRow: AnxTableRow_vue_1.default,
    AnxTableCol: AnxTableCol_vue_1.default,
    AnxTitle: AnxTitle_vue_1.default,
    AnxIcon: AnxIcon_vue_1.default,
    AnxModal: AnxModal_vue_1.default,
    AnxButton: AnxButton_vue_1.default,
    AnxInput: AnxInput_vue_1.default
  }
})], AnxCrudTable);
exports.default = AnxCrudTable;

/***/ }),

/***/ "90d7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("96cf");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var vee_validate_1 = __webpack_require__("7bb1");

var AnxButton_vue_1 = tslib_1.__importDefault(__webpack_require__("3097"));

var AttributesHelper_1 = __webpack_require__("4bc1");
/**
 * A simple form used for collecting user input
 */


var AnxForm = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxForm, _vue_property_decorat);

  var _super = _createSuper(AnxForm);

  function AnxForm() {
    _classCallCheck(this, AnxForm);

    return _super.apply(this, arguments);
  }

  _createClass(AnxForm, [{
    key: "submit",
    value:
    /** Emit the submit event */
    function submit() {
      return true;
    }
    /**
     * This validates the form manually
     * This is needed, cause the input fields are only validated after first input.
     * If a field is required but has never had any input, the { valid } prop of the observer would be true.
     */

  }, {
    key: "checkValidation",
    value: function checkValidation() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var validator;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validator = this.$refs.anxForm;
                _context.next = 3;
                return validator.validate();

              case 3:
                if (!_context.sent) {
                  _context.next = 5;
                  break;
                }

                this.submit();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /** Checks if the form is valid and does validation */

  }, {
    key: "isValid",
    value: function isValid() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var validator;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                validator = this.$refs.anxForm;
                _context2.next = 3;
                return validator.validate();

              case 3:
                if (!_context2.sent) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", true);

              case 5:
                return _context2.abrupt("return", false);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Attrbibutes for the component
     * Passing this attributes with v-bind allows to not pass unused items
     */

  }, {
    key: "attributes",
    get: function get() {
      return AttributesHelper_1.AttributesHelper.attributes(this);
    }
  }]);

  return AnxForm;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxForm.prototype, "submitButton", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxForm.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Emit("submit")], AnxForm.prototype, "submit", null);

AnxForm = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxButton: AnxButton_vue_1.default,
    ValidationObserver: vee_validate_1.ValidationObserver
  }
})], AnxForm);
exports.default = AnxForm;

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9213":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxLogin_vue_vue_type_template_id_5cbdd526_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aa30");
/* harmony import */ var _AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1e24");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxLogin_vue_vue_type_style_index_0_id_5cbdd526_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4c05");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxLogin_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxLogin_vue_vue_type_template_id_5cbdd526_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxLogin_vue_vue_type_template_id_5cbdd526_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "5cbdd526",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "92d7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return he;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module), __webpack_require__("c8ba")))

/***/ }),

/***/ "92fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ccbd");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "949a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("96cf");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxAlert_vue_1 = tslib_1.__importDefault(__webpack_require__("3321"));

var AnxButton_vue_1 = tslib_1.__importDefault(__webpack_require__("3097"));

var AnxContent_vue_1 = tslib_1.__importDefault(__webpack_require__("09f6"));

var AnxForm_vue_1 = tslib_1.__importDefault(__webpack_require__("3473"));

var AnxInput_vue_1 = tslib_1.__importDefault(__webpack_require__("6911"));

var AnxParagraph_vue_1 = tslib_1.__importDefault(__webpack_require__("78a2"));

var AnxTextarea_vue_1 = tslib_1.__importDefault(__webpack_require__("f682"));

var vue_recaptcha_1 = tslib_1.__importDefault(__webpack_require__("e096"));

var AnxContact = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxContact, _vue_property_decorat);

  var _super = _createSuper(AnxContact);

  function AnxContact() {
    var _this;

    _classCallCheck(this, AnxContact);

    _this = _super.apply(this, arguments);
    /** This is returned on submit via @sumbit event */

    _this.request = {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      message: null,
      captchaToken: null
    };
    /** Show the error alert */

    _this.showError_ = false;
    /** Show the success alert */

    _this.showSuccess_ = false;
    /** Is true if the recaptcha has an error (alert will be shown) */

    _this.internalRecaptchaError = false;
    return _this;
  }
  /** Display the alert if the error message has changed */


  _createClass(AnxContact, [{
    key: "onErrorChanged",
    value: function onErrorChanged() {
      this.showError();
    }
    /** Display the alert if the success message has changed */

  }, {
    key: "onSuccessChanged",
    value: function onSuccessChanged() {
      this.showSuccess();
    }
    /** Show the error */

  }, {
    key: "showError",
    value: function showError() {
      this.showError_ = true;
    }
    /** Show the success */

  }, {
    key: "showSuccess",
    value: function showSuccess() {
      this.showSuccess_ = true;
    }
    /** Checks if the recaptcha should be used */

  }, {
    key: "useRecaptcha",
    get: function get() {
      return this.recaptchaSitekey === null ? false : true;
    }
    /** Returns if the button should be enabled or not */

  }, {
    key: "isButtonEnabled",
    get: function get() {
      if (this.useRecaptcha) {
        // When using recaptcha, it has to be checked
        return this.request.captchaToken && this.enabled ? true : false;
      } else {
        // Otherwise only check if the form is enabled
        return this.enabled ? true : false;
      }
    }
    /** Is called if the captcha has been verified. The captcha token is passed */

  }, {
    key: "verifyCaptcha",
    value: function verifyCaptcha(res) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var valid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (res) {
                  this.request.captchaToken = res;
                } // If the capctha is invisible, the form should also be submitted


                if (!this.invisibleCaptcha) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return this.$refs.contactForm.isValid();

              case 4:
                valid = _context.sent;

                if (valid) {
                  // Submit if valid
                  this.submit();
                } else {
                  // Reset the captcha if invalid
                  this.$refs.invisibleCaptcha.reset();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /** Is called if the captcha has an error */

  }, {
    key: "errorCaptcha",
    value: function errorCaptcha() {
      this.request.captchaToken = null;
      this.internalRecaptchaError = true;
    }
    /** Is called if the token has expired */

  }, {
    key: "expiredCaptcha",
    value: function expiredCaptcha() {
      this.request.captchaToken = null;
    }
    /** Emit the submit event and add the request data */

  }, {
    key: "submit",
    value: function submit() {
      /**
       * triggered on contact form submit
       * @event submit
       * @property {object} request - The request containing the data the user entered
       */
      this.$emit("submit", this.request);
    }
  }]);

  return AnxContact;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContact.prototype, "recaptchaSitekey", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxContact.prototype, "invisibleCaptcha", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Contact"
})], AnxContact.prototype, "title", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      name: "first name",
      label: "First name"
    };
  }
})], AnxContact.prototype, "firstName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      name: "last name",
      label: "Last name"
    };
  }
})], AnxContact.prototype, "lastName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      name: "email",
      label: "Email"
    };
  }
})], AnxContact.prototype, "email", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      name: "phone",
      label: "Phone"
    };
  }
})], AnxContact.prototype, "phone", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      name: "message",
      label: "Message"
    };
  }
})], AnxContact.prototype, "message", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: function _default() {
    return {
      text: "Send"
    };
  }
})], AnxContact.prototype, "sendButton", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxContact.prototype, "enabled", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: false
})], AnxContact.prototype, "showPhone", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxContact.prototype, "showEmail", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContact.prototype, "error", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContact.prototype, "success", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("error")], AnxContact.prototype, "onErrorChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Watch("success")], AnxContact.prototype, "onSuccessChanged", null);

AnxContact = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxAlert: AnxAlert_vue_1.default,
    AnxButton: AnxButton_vue_1.default,
    AnxContent: AnxContent_vue_1.default,
    AnxForm: AnxForm_vue_1.default,
    AnxInput: AnxInput_vue_1.default,
    AnxParagraph: AnxParagraph_vue_1.default,
    AnxTextarea: AnxTextarea_vue_1.default,
    VueRecaptcha: vue_recaptcha_1.default
  }
})], AnxContact);
exports.default = AnxContact;

/***/ }),

/***/ "94b7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2be7");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "970b":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "9736":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxHeader/AnxHeader.vue?vue&type=template&id=0e758f08&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header anx-header",style:(_vm.cssProps)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"header-container d-flex"},[_c('div',{staticClass:"header-image anx-header-image"},[_c('anx-link',{attrs:{"href":_vm.iconUrl,"route-name":_vm.iconUrlRouteName,"no-style":"","disabled":_vm.iconUrl == null ? true : null}},[_vm._t("icon",function(){return [_c('anx-icon',{attrs:{"alt":"anx-header-logo","icon":_vm.icon,"height":_vm.iconSize,"width":_vm.iconSize}})]})],2)],1),(_vm.i18n)?_c('div',{staticClass:"header-language-nav"},[_vm._t("header-top-right",function(){return [_c('div',{class:{
                  'header-lang-switcher-top-nav': true,
                  show: !_vm.menus
                }},[(_vm.i18nOptions !== null)?_c('AnxLanguageSwitcher',{attrs:{"i18n":_vm.i18n,"languages":_vm.i18nOptions},on:{"localeChange":function($event){return _vm.localeChange($event)}}}):_c('AnxLanguageSwitcher',{attrs:{"i18n":_vm.i18n},on:{"localeChange":function($event){return _vm.localeChange($event)}}})],1)]})],2):_vm._e()]),_c('anx-hr-line',{attrs:{"margin-top":"20px","margin-bottom":"20px","color":"blue"}}),(_vm.menus)?_c('div',{staticClass:"header-nav-menu"},[_c('div',{staticClass:"menu-text left"},_vm._l((_vm.menus),function(menu){return _c('anx-link',{key:menu.id,staticClass:"anx-link-header",attrs:{"href":("" + (menu.link)),"disabled":_vm.isLinkActive(menu) ? null : true,"external":menu.external ? true : null,"text":menu.menu}})}),1),(_vm.i18n)?_c('div',{staticClass:"menu-text right header-lang-switcher-bottom-nav"},[(_vm.menus)?_c('div',[(_vm.i18nOptions !== null)?_c('AnxLanguageSwitcher',{attrs:{"i18n":_vm.i18n,"languages":_vm.i18nOptions},on:{"localeChange":function($event){return _vm.localeChange($event)}}}):_c('AnxLanguageSwitcher',{attrs:{"i18n":_vm.i18n},on:{"localeChange":function($event){return _vm.localeChange($event)}}})],1):_vm._e()]):_vm._e()]):_vm._e()],1)])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxHeader/AnxHeader.vue?vue&type=template&id=0e758f08&scoped=true&


/***/ }),

/***/ "97e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxCrudTable_vue_vue_type_template_id_1d4bd6ac_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b5fd");
/* harmony import */ var _AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7c97");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxCrudTable_vue_vue_type_style_index_0_id_1d4bd6ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c374");
/* harmony import */ var _AnxCrudTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("f371");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2877");







/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(
  _AnxCrudTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxCrudTable_vue_vue_type_template_id_1d4bd6ac_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxCrudTable_vue_vue_type_template_id_1d4bd6ac_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "1d4bd6ac",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "9891":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "9981":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var AttributesHelper_1 = __webpack_require__("4bc1");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * The *anx-alert* is used to delivery important messages to the user.
 * Currently the two types **error** and **success** are supported.
 */


var AnxAlert = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxAlert, _vue_property_decorat);

  var _super = _createSuper(AnxAlert);

  function AnxAlert() {
    var _this;

    _classCallCheck(this, AnxAlert);

    _this = _super.apply(this, arguments);
    /** Variables for anx-alert */

    _this.visibility = false;
    _this.fadeOut = false;
    _this.fadeIn = false;
    return _this;
  }
  /** Watcher for show changes */


  _createClass(AnxAlert, [{
    key: "onShowChanged",
    value: function onShowChanged(val) {
      if (val) {
        this.showAction();
      } else {
        this.hideAction();
      }
    }
    /** Emit the dismiss event */

  }, {
    key: "input",
    value: function input(val) {
      if (!val) {
        this.hideAction();
      }

      return val;
    }
    /**
     * Attrbibutes for the component
     * Passing this attributes with v-bind allows to not pass unused items
     */

  }, {
    key: "attributes",
    get: function get() {
      return AttributesHelper_1.AttributesHelper.attributes(this);
    }
    /** Set visibility when mounting */

  }, {
    key: "created",
    value: function created() {
      this.visibility = this.value;
      /** If the Alert is visible by default, the show action has to be called at the beginning */

      if (this.value) {
        this.showAction();
      }
    }
    /** Show the alert */

  }, {
    key: "showAction",
    value: function showAction() {
      var _this2 = this;

      if (this.animations) {
        this.fadeIn = true;

        if (typeof window !== "undefined") {
          window.setTimeout(function () {
            _this2.fadeIn = false;
            _this2.visibility = true;
          }, 1000);
        }
      } else {
        this.visibility = true;
      }
      /** Check if the alert should be auto closed and set a timeout */


      if (this.autoClose !== null) {
        if (typeof window !== "undefined") {
          window.setTimeout(function () {
            _this2.input(false);
          }, this.autoCloseTimeout);
        }
      }
    }
    /** Hide the alert */

  }, {
    key: "hideAction",
    value: function hideAction() {
      var _this3 = this;

      if (this.animations) {
        this.fadeOut = true;
        window.setTimeout(function () {
          _this3.fadeOut = false;
          _this3.visibility = false;
        }, 1000);
      } else {
        this.visibility = false;
      }
    }
  }]);

  return AnxAlert;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxAlert.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: false
})], AnxAlert.prototype, "value", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxAlert.prototype, "animations", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "error"
})], AnxAlert.prototype, "type", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxAlert.prototype, "autoClose", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: 5000
})], AnxAlert.prototype, "autoCloseTimeout", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxAlert.prototype, "text", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("value")], AnxAlert.prototype, "onShowChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Emit("input")], AnxAlert.prototype, "input", null);

AnxAlert = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxAlert);
exports.default = AnxAlert;

/***/ }),

/***/ "9982":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * This component contains global styles for the ANX application
 * Every content has to be inside this component
 */


var AnxGlobal = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxGlobal, _vue_property_decorat);

  var _super = _createSuper(AnxGlobal);

  function AnxGlobal() {
    _classCallCheck(this, AnxGlobal);

    return _super.apply(this, arguments);
  }

  return AnxGlobal;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxGlobal.prototype, "disableFullscreen", void 0);

AnxGlobal = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxGlobal);
exports.default = AnxGlobal;

/***/ }),

/***/ "9ab4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__createBinding", function() { return __createBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldGet", function() { return __classPrivateFieldGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldSet", function() { return __classPrivateFieldSet; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxToaster_vue_vue_type_template_id_0ecc43b6_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e250");
/* harmony import */ var _AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("92fc");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxToaster_vue_vue_type_style_index_0_id_0ecc43b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a457");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxToaster_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxToaster_vue_vue_type_template_id_0ecc43b6_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxToaster_vue_vue_type_template_id_0ecc43b6_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "0ecc43b6",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "9c38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_style_index_0_id_f4c65b2e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df25");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_style_index_0_id_f4c65b2e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_style_index_0_id_f4c65b2e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9c59":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */
function encode(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?#&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //
    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encode(key);
      value = encode(value);

      //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //
      if (key === null || value === null) continue;
      pairs.push(key +'='+ value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ "9d0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxCheckbox/AnxCheckbox.vue?vue&type=template&id=2fdb377b&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validation !== null)?_c('ValidationProvider',{attrs:{"name":_vm.name,"rules":"required:true"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('div',{staticClass:"anx-checkbox"},[_c('label',{attrs:{"for":_vm.inputId}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueModel),expression:"valueModel"}],class:errors && errors.length > 0 ? 'is-invalid' : '',attrs:{"id":_vm.inputId,"name":_vm.name,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.valueModel)?_vm._i(_vm.valueModel,null)>-1:(_vm.valueModel)},on:{"change":[function($event){var $$a=_vm.valueModel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.valueModel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.valueModel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.valueModel=$$c}},function($event){return _vm.$emit('input', _vm.valueModel)}]}}),_c('div',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.name))]})],2)]),_c('span',{staticClass:"error"},[_vm._v(_vm._s(errors[0]))])])]}}],null,true)}):_c('div',{staticClass:"anx-checkbox"},[_c('label',{attrs:{"for":_vm.inputId}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueModel),expression:"valueModel"}],attrs:{"id":_vm.inputId,"name":_vm.name,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.valueModel)?_vm._i(_vm.valueModel,null)>-1:(_vm.valueModel)},on:{"change":[function($event){var $$a=_vm.valueModel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.valueModel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.valueModel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.valueModel=$$c}},function($event){return _vm.$emit('input', _vm.valueModel)}]}}),_c('div',{staticClass:"text"},[_c('span',[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.name)+" ")]})],2)])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxCheckbox/AnxCheckbox.vue?vue&type=template&id=2fdb377b&scoped=true&


/***/ }),

/***/ "9e85":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "9f89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ AnxToastPlugin; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./src/components/AnxToaster/AnxToaster.vue
var AnxToaster = __webpack_require__("9c0c");

// CONCATENATED MODULE: ./src/plugins/toast/api.js



var api_Api = function Api(Vue) {
  var globalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // This are all the toasters
  var toasters = {
    top: {
      left: null,
      center: null,
      right: null
    },
    bottom: {
      left: null,
      center: null,
      right: null
    }
  };

  function getToaster(propsData) {
    var componentClass = Vue.extend(AnxToaster["default"]);
    var instance = new componentClass({
      propsData: propsData
    });
    instance.$mount(); // Check if the instance has already been created or has to be created

    if (toasters[instance._verticalAlign][instance._horizontalAlign]) {
      return toasters[instance._verticalAlign][instance._horizontalAlign];
    } else {
      document.body.appendChild(instance.$el); // Remove the element if it has to be destroyed

      instance.$on("destroy", function () {
        toasters[instance._verticalAlign][instance._horizontalAlign] = null;

        try {
          document.body.removeChild(instance.$el);
        } catch (ex) {// Dont't handle this exception
        }
      });
      toasters[instance._verticalAlign][instance._horizontalAlign] = instance;
      return instance;
    }
  }

  return {
    /**
     * Show a default toast
     */
    show: function show(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var localOptions = Object(objectSpread2["a" /* default */])({
        message: message
      }, options);

      var propsData = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, globalOptions), localOptions);

      var toaster = getToaster(propsData);
      var toast = toaster.addToast(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, propsData), {}, {
        value: true
      }));
      return toast;
    },

    /**
     * Show a success toast
     * This is just a wrapper around the show function
     *
     * @param {string} message The message to show
     * @param {Object} options The options for the toast
     */
    success: function success(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.show(message, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, options), {}, {
        type: "success"
      }));
    },

    /**
     * Show a error toast
     * This is just a wrapper around the show function
     *
     * @param {string} message The message to show
     * @param {Object} options The options for the toast
     */
    error: function error(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.show(message, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, options), {}, {
        type: "error"
      }));
    },

    /**
     * Show a warning toast
     * This is just a wrapper around the show function
     *
     * @param {string} message The message to show
     * @param {Object} options The options for the toast
     */
    warning: function warning(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.show(message, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, options), {}, {
        type: "warning"
      }));
    }
  };
};

/* harmony default export */ var api = (api_Api);
// CONCATENATED MODULE: ./src/plugins/toast/plugin.js

var AnxToastPlugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var methods = api(Vue, options);
    Vue.prototype.$anxToast = methods;
    Vue.$anxToast = methods;
  }
};
// CONCATENATED MODULE: ./src/plugins/toast/index.js


/***/ }),

/***/ "a059":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxLink_vue_vue_type_template_id_798c4a06_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6bda");
/* harmony import */ var _AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2b0b");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxLink_vue_vue_type_style_index_0_id_798c4a06_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4f79");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxLink_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxLink_vue_vue_type_template_id_798c4a06_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxLink_vue_vue_type_template_id_798c4a06_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "798c4a06",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "a144":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a26f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_style_index_0_id_28ec5454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eadb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_style_index_0_id_28ec5454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTableCol_vue_vue_type_style_index_0_id_28ec5454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a322":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxTableRow = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxTableRow, _vue_property_decorat);

  var _super = _createSuper(AnxTableRow);

  function AnxTableRow() {
    _classCallCheck(this, AnxTableRow);

    return _super.apply(this, arguments);
  }

  return AnxTableRow;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTableRow.prototype, "item", void 0);

AnxTableRow = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxTableRow);
exports.default = AnxTableRow;

/***/ }),

/***/ "a36b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("96cf");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var vee_validate_1 = __webpack_require__("7bb1");

var AttributesHelper_1 = __webpack_require__("4bc1");
/**
 * This component is a advanced version of the simple HTML input tag. This component is used for user input via a textbox.
 */


var AnxInput = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxInput, _vue_property_decorat);

  var _super = _createSuper(AnxInput);

  function AnxInput() {
    var _this;

    _classCallCheck(this, AnxInput);

    _this = _super.apply(this, arguments);
    _this.active = false;
    _this.filled = false;
    /** The id that is actually used */

    _this.inputId = "";
    /** This variable is used as v-model for the input field (Using the value variable directly is not allowed because props should not be mutated directly) */

    _this.localValue = "";
    return _this;
  }
  /**
   * Watch the localValue variable used as v-model for the input field
   * When it changes, the users is typing and changed some text, it has
   * to be checked if the input field should be active or not.
   */


  _createClass(AnxInput, [{
    key: "localValueChanged",
    value: function localValueChanged(newVal) {
      if (newVal && newVal.length) {
        this.active = true;
      }
    }
    /**
     * Watch the attribute/prop value.
     * When this variable changes it means that the value for the input field has been
     * updated from the parent component programmatically. The localValue variable has to
     * be assigned and it has to be checked, if the input field is filled
     */

  }, {
    key: "valueChanged",
    value: function valueChanged() {
      this.localValue = this.value !== null ? this.stringValue : "";
      this.isFilled();
    }
    /**
     * Set the id for the component when created
     */

  }, {
    key: "created",
    value: function created() {
      this.inputId = AttributesHelper_1.AttributesHelper.attributes(this, {
        uniqueId: true,
        uniqueIdPrefix: "anx-input-"
      }).id;
    }
    /**
     * After mount, the prop value has to be assigned to the localValue and it has to be checked,
     * if the input field should be filled
     */

  }, {
    key: "mounted",
    value: function mounted() {
      this.localValue = this.value !== null ? this.stringValue : "";
      this.isFilled();
    }
    /** Do a validation if the component is updated */

  }, {
    key: "updated",
    value: function updated() {
      /** Only validate, if the value is set */
      if (this.value && this.value !== "") this.validate();
    }
    /** This returns the string value of the value from the v-model */

  }, {
    key: "stringValue",
    get: function get() {
      if (typeof this.value === "string") {
        return this.value;
      }

      return String(this.value);
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--input-width": this.width
      };
    }
    /** Check if the input-field is filled, Set class filled. */

  }, {
    key: "isFilled",
    value: function isFilled() {
      if (this.localValue && this.localValue.length > 0) {
        this.filled = true;
      } else {
        this.filled = false;
      }
    }
    /**When the User click in and out of the field, the state active will be set and
     * the state filled will be checked.
     */

  }, {
    key: "inputBlur",
    value: function inputBlur() {
      /** Do validation on focus lost */
      this.validate();

      if (this.readonly === null) {
        this.active = !this.active;
        this.isFilled();
      }
    }
    /** Validate the input with the defined rules */

  }, {
    key: "validate",
    value: function validate() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.rules !== null)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.$refs.observer.validate();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * This function is called, when the user clicks the input field
     * If the field is readonly, nothing should happen
     */

  }, {
    key: "clickInputField",
    value: function clickInputField() {
      if (this.readonly === null) {
        this.active = true;
      }
    }
  }]);

  return AnxInput;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "anx-input"
})], AnxInput.prototype, "name", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "dataVvAs", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Input"
})], AnxInput.prototype, "label", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "text"
})], AnxInput.prototype, "type", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "rules", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "100%"
})], AnxInput.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "assistiveText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "readonly", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxInput.prototype, "value", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "inline", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxInput.prototype, "autocomplete", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxInput.prototype, "disabled", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("localValue")], AnxInput.prototype, "localValueChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Watch("value")], AnxInput.prototype, "valueChanged", null);

AnxInput = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    ValidationProvider: vee_validate_1.ValidationProvider
  }
})], AnxInput);
exports.default = AnxInput;

/***/ }),

/***/ "a430":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxReadonly_vue_vue_type_template_id_f4c65b2e_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e73a");
/* harmony import */ var _AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e7f8");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxReadonly_vue_vue_type_style_index_0_id_f4c65b2e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9c38");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxReadonly_vue_vue_type_template_id_f4c65b2e_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxReadonly_vue_vue_type_template_id_f4c65b2e_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "f4c65b2e",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "a43c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("af90");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a457":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_style_index_0_id_0ecc43b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ba2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_style_index_0_id_0ecc43b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxToaster_vue_vue_type_style_index_0_id_0ecc43b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a589":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_style_index_0_id_7dcab4fe_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("25ec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_style_index_0_id_7dcab4fe_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxParagraph_vue_vue_type_style_index_0_id_7dcab4fe_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a8f3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxAlert/AnxAlert.vue?vue&type=template&id=33abed87&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:'anx-alert ' +
      "anx-alert-" + _vm.type + " " +
      (_vm.visibility ? 'visible ' : 'hidden ') +
      (_vm.fadeIn ? 'fade-in ' : '') +
      (_vm.fadeOut ? 'fade-out ' : '')},'div',_vm.attributes,false),[_c('div',{staticClass:"message"},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)]),_c('div',{staticClass:"dismiss",on:{"click":function($event){return _vm.input(!_vm.visibility)}}},[_vm._v("×")])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxAlert/AnxAlert.vue?vue&type=template&id=33abed87&scoped=true&


/***/ }),

/***/ "a925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

__webpack_require__("96cf");

__webpack_require__("d3b7");

__webpack_require__("e6cf");

__webpack_require__("b0c0");

__webpack_require__("159b");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractModel = void 0;

var tslib_1 = __webpack_require__("9ab4");

var SerializationHelper_1 = __webpack_require__("49ab");

var StringUtils_1 = __webpack_require__("6cb7");

var AbstractModel = /*#__PURE__*/function () {
  function AbstractModel() {
    _classCallCheck(this, AbstractModel);

    this.id = null;
  }
  /**
   * Get All API endpoint
   * This function is used to fetch all entries via the API
   * Params can additionally be defined
   * When calling the get method, there is likely no instance of the model, so the function is static
   */


  _createClass(AbstractModel, [{
    key: "save",
    value:
    /**
     * Save API endpoint
     * This is used for saving the data in the model
     * This function is called directly on the model instance and is therefore non static
     */
    function save() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          authorization = _ref.authorization;

      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(AbstractModel.HOST + AbstractModel.API_BASE + StringUtils_1.StringUtils.toKebabCase(this.constructor.name), {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization ? authorization : ""
                  },
                  body: JSON.stringify(this)
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Delete API endpoint
     * This is used to delete an entry
     */

  }, {
    key: "delete",
    value: function _delete() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          authorization = _ref2.authorization;

      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(AbstractModel.HOST + AbstractModel.API_BASE + StringUtils_1.StringUtils.toKebabCase(this.constructor.name) + "/" + this.id, {
                  method: "DELETE",
                  headers: {
                    Authorization: authorization ? authorization : ""
                  }
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Update API endpoint
     * This is used to update an existing entry
     */

  }, {
    key: "update",
    value: function update() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          authorization = _ref3.authorization;

      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetch(AbstractModel.HOST + AbstractModel.API_BASE + StringUtils_1.StringUtils.toKebabCase(this.constructor.name) + "/" + this.id, {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization ? authorization : ""
                  },
                  body: JSON.stringify(this)
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }], [{
    key: "getAll",
    value: function getAll() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          params = _ref4.params,
          authorization = _ref4.authorization;

      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var apiUrl, res, jsonData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                apiUrl = this.HOST + this.API_BASE + StringUtils_1.StringUtils.toKebabCase(this.name);

                if (params && params.length) {
                  params.forEach(function (param) {
                    apiUrl += "/" + param;
                  });
                }

                _context4.next = 4;
                return fetch(apiUrl, {
                  headers: {
                    Authorization: authorization ? authorization : ""
                  }
                });

              case 4:
                res = _context4.sent;
                _context4.next = 7;
                return res.json();

              case 7:
                jsonData = _context4.sent;
                return _context4.abrupt("return", SerializationHelper_1.SerializationHelper.toInstanceArray(this, jsonData));

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Get API endpoint
     * This function is used to get an entry via the API
     * It is just a wrapper arround the getAll function, if no param is provided, all entries are fetched
     * When calling the get method, there is likely no instance of the model, so the function is static
     */

  }, {
    key: "get",
    value: function get(_ref5) {
      var param = _ref5.param,
          authorization = _ref5.authorization;
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getAll({
                  params: param ? [param] : [],
                  authorization: authorization
                });

              case 2:
                data = _context5.sent;

                if (!(!data || data.length === 0)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", null);

              case 7:
                return _context5.abrupt("return", data[0]);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return AbstractModel;
}();

exports.AbstractModel = AbstractModel;
AbstractModel.API_BASE = "/api/"; // By default, the HOST should be empty string. This can be used if you have an external host for your API

AbstractModel.HOST = "";

/***/ }),

/***/ "a961":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "aa30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxLogin/AnxLogin.vue?vue&type=template&id=5cbdd526&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('anx-container',{staticClass:"anx-login",attrs:{"width":_vm.width}},[_c('anx-content',{staticClass:"anx-login-header",attrs:{"inverse":""}},[_vm._t("header",function(){return [(_vm.logo)?_c('img',{attrs:{"src":_vm.logo}}):_vm._e()]})],2),_c('anx-content',{class:'anx-login-body ' + (_vm.noFooter === null ? 'with-footer' : '')},[(_vm.customerLogo)?_c('div',{staticClass:"customer-logo"},[_vm._t("customer-logo",function(){return [_c('img',{staticClass:"customer-logo",attrs:{"src":_vm.customerLogo}})]})],2):_vm._e(),_c('anx-form',{staticClass:"anx-login-form",on:{"submit":_vm.login}},[_vm._t("username-input",function(){return [_c('anx-input',{attrs:{"name":_vm.usernameName,"id":_vm.usernameId,"label":_vm.usernameLabel,"rules":_vm.usernameRules,"assistive-text":_vm.usernameAssistiveText,"type":"text","autocomplete":"username"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})]}),_vm._t("password-input",function(){return [_c('anx-input',{attrs:{"name":_vm.passwordName,"id":_vm.passwordId,"label":_vm.passwordLabel,"rules":_vm.passwordRules,"assistive-text":_vm.passwordAssistiveText,"type":"password","autocomplete":"current-password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})]}),_vm._t("remember-me-input",function(){return [(_vm.rememberMe !== null)?_c('anx-checkbox',{attrs:{"name":"remember-me-checkbox","id":"remember-me-checkbox"},model:{value:(_vm.rememberMeCheckbox),callback:function ($$v) {_vm.rememberMeCheckbox=$$v},expression:"rememberMeCheckbox"}},[_vm._v(" "+_vm._s(_vm.rememberMeText)+" ")]):_vm._e()]}),(_vm.hasLoginError)?_c('span',{staticClass:"error"},[_vm._t("error",function(){return [_c('anx-alert',{attrs:{"type":"error"},model:{value:(_vm.hasLoginError),callback:function ($$v) {_vm.hasLoginError=$$v},expression:"hasLoginError"}},[_vm._v(" "+_vm._s(_vm.loginError)+" ")])]})],2):_vm._e(),_vm._t("submit-button",function(){return [_c('div',{class:("button-container button-" + _vm.submitButtonAlign)},[_c('anx-button',{staticClass:"login-button",attrs:{"type":"submit","width":_vm.submitButtonWidth,"text":_vm.submitButtonText,"inline":""}})],1)]})],2),(_vm.noFooter === null)?_c('div',{staticClass:"anx-login-footer"},[_vm._t("footer",function(){return [_c('anx-hr-line',{attrs:{"color":"green","margin":"20px"}}),_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"text",style:(("min-height:" + _vm.footerIconSize))},_vm._l((_vm.footerText),function(text,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(text)),_c('br')])}),0),_c('div',{staticClass:"stamp"},[_vm._t("footer-icon",function(){return [_c('anx-icon',{attrs:{"icon":_vm.footerIcon,"width":_vm.footerIconSize,"height":_vm.footerIconSize}})]})],2)])]})],2):_vm._e()],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxLogin/AnxLogin.vue?vue&type=template&id=5cbdd526&scoped=true&


/***/ }),

/***/ "aa44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_style_index_0_id_736bfe57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e87a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_style_index_0_id_736bfe57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHrLine_vue_vue_type_style_index_0_id_736bfe57_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ac31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxTable_vue_vue_type_template_id_58967b24_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b62f");
/* harmony import */ var _AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("47fb");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxTable_vue_vue_type_style_index_0_id_58967b24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ff1a");
/* harmony import */ var _AnxTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("34f5");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2877");







/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(
  _AnxTable_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxTable_vue_vue_type_template_id_58967b24_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxTable_vue_vue_type_template_id_58967b24_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "58967b24",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aead":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxTextarea/AnxTextarea.vue?vue&type=template&id=38a20043&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"observer",staticClass:"anx-textarea",style:(_vm.cssProps),attrs:{"name":_vm.dataVvAs === null ? _vm.name : _vm.dataVvAs,"rules":_vm.validationRules,"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],class:{ filled: _vm.filled, active: _vm.active, 'is-invalid': errors && errors.length > 0 },attrs:{"id":_vm.inputId,"name":_vm.name,"rows":_vm.rows,"disabled":_vm.disabled !== null,"autocomplete":_vm.autocomplete},domProps:{"value":(_vm.localValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.localValue=$event.target.value},function($event){return _vm.$emit('input', _vm.localValue)}],"blur":_vm.inputBlur,"click":function($event){return _vm.clickInputField()}}}),_vm._v(" "),_c('label',{attrs:{"id":"textarea-label","for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]),(_vm.validationRules !== null && errors && errors.length > 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(errors[0]))]):_vm._e()]}}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxTextarea/AnxTextarea.vue?vue&type=template&id=38a20043&scoped=true&


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "af3e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "af90":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");
/**
 * The *anx-container* is part of the **grid system** used in the ui tool.
 */


var AnxContainer = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxContainer, _vue_property_decorat);

  var _super = _createSuper(AnxContainer);

  function AnxContainer() {
    _classCallCheck(this, AnxContainer);

    return _super.apply(this, arguments);
  }

  _createClass(AnxContainer, [{
    key: "cssProps",
    get: function get() {
      return {
        "--width": this.width
      };
    }
  }]);

  return AnxContainer;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "530px"
})], AnxContainer.prototype, "width", void 0);

AnxContainer = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxContainer);
exports.default = AnxContainer;

/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b332":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_style_index_0_id_7db652f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("af3e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_style_index_0_id_7db652f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxForm_vue_vue_type_style_index_0_id_7db652f3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b4c7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxModal_vue_vue_type_template_id_3d074454_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("28c1");
/* harmony import */ var _AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("781d");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxModal_vue_vue_type_style_index_0_id_3d074454_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7c24");
/* harmony import */ var _AnxModal_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("bf53");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2877");







/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(
  _AnxModal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxModal_vue_vue_type_template_id_3d074454_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxModal_vue_vue_type_template_id_3d074454_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "3d074454",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b5fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxCrudTable/AnxCrudTable.vue?vue&type=template&id=1d4bd6ac&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-crud-table"},[_c('div',{staticClass:"anx-crud-header"},[_c('div',{class:{ 'anx-crud-header-row': true, 'with-input': _vm.useSearch }},[_vm._t("title",function(){return [(_vm.modelClass && _vm.showHeader)?_c('anx-title',{attrs:{"size":"h1","noline":"","no-margin":"","text":_vm.modelClass.name}}):_vm._e()]}),_c('div',{staticClass:"flex-end"},[(_vm.useSearch)?_c('anx-input',{staticClass:"crud-search",attrs:{"label":_vm.searchFieldLabel,"width":"200px"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}):_vm._e(),_c('div',[_c('anx-button',{attrs:{"id":"crud-create","text":_vm.createButtonText},on:{"click":function($event){_vm.createInstance = new _vm.modelClass();
              _vm.showCreateModal = true;
              _vm.$emit('createActionClicked');}}})],1)],1)],2)]),_c('anx-table',{attrs:{"stripped":"","bordered":"","hover":"","columns":_vm.tableColumns},scopedSlots:_vm._u([{key:"tbody",fn:function(){return _vm._l((_vm.paginatedSortedFilteredInstancesNonSoftDeleted),function(instance,i){return _c('anx-table-row',{key:i},[_vm._l((instance),function(instanceProp,j){return _c('anx-table-col',{key:j,attrs:{"align":"center","content":instanceProp}})}),_c('anx-table-col',{staticClass:"actions",attrs:{"align":"center"}},[(_vm.editable)?_c('anx-icon',{staticClass:"action",attrs:{"id":("crud-update-icon-" + i),"icon":"einstellungen-verwaltung","width":"40px"},nativeOn:{"click":function($event){_vm.showEditModal = true;
              _vm.selectedItem = instance;
              _vm.$emit('editActionClicked');}}}):_vm._e(),(_vm.deletable)?_c('anx-icon',{staticClass:"action",attrs:{"id":("crud-delete-icon-" + i),"icon":"loeschen","width":"40px"},nativeOn:{"click":function($event){_vm.showDeleteModal = true;
              _vm.selectedItem = instance;}}}):_vm._e()],1)],2)})},proxy:true}])}),(_vm.isPaginated)?_c('div',{staticClass:"pagination"},[_c('div',{staticClass:"page-switch"},[_c('span',{staticClass:"page-switch-link fast-forward",on:{"click":function($event){_vm.page = 0}}},[_vm._v("«")]),_c('span',{staticClass:"page-switch-link backward",on:{"click":function($event){_vm.page--}}},[_vm._v("<")]),_vm._v(" Page "+_vm._s(_vm.page + 1)+" of "+_vm._s(_vm.numberPages)+" "),_c('span',{staticClass:"page-switch-link forward",on:{"click":function($event){_vm.page++}}},[_vm._v(">")]),_c('span',{staticClass:"page-switch-link fast-forward",on:{"click":function($event){_vm.page = _vm.numberPages - 1}}},[_vm._v("»")])])]):_vm._e(),_vm._t("createModal",function(){return [(_vm.showCreateModal)?_c('anx-modal',{attrs:{"title":"Create","has-close-button":"","close-button-align":"right"},on:{"close":function($event){_vm.showCreateModal = false}}},[_vm._l((_vm.createInstance),function(instanceProp,i){return _c('span',{key:i},[(i !== 'id')?_c('div',[_c('anx-input',{attrs:{"label":i},model:{value:(_vm.createInstance[i]),callback:function ($$v) {_vm.$set(_vm.createInstance, i, $$v)},expression:"createInstance[i]"}})],1):_vm._e()])}),_c('template',{slot:"modal-footer"},[_c('span',{staticClass:"button-space"}),_c('anx-button',{on:{"click":_vm.createItem}},[_vm._v("Save")])],1)],2):_vm._e()]}),_vm._t("deleteModal",function(){return [(_vm.showDeleteModal)?_c('anx-modal',{attrs:{"title":"Confirm delete","confirm":"","has-close-button":"","close-button-align":"right"},on:{"close":function($event){_vm.showDeleteModal = false},"confirm":_vm.deleteSelectedItem}},[_vm._v(" Do you really want to delete? ")]):_vm._e()]}),_vm._t("editModal",function(){return [(_vm.showEditModal)?_c('anx-modal',{attrs:{"title":"Edit","has-close-button":"","close-button-align":"right"},on:{"close":function($event){_vm.showEditModal = false}}},[_vm._l((_vm.selectedItem),function(instanceProp,i){return _c('span',{key:i},[(i !== 'id')?_c('div',[_c('anx-input',{attrs:{"label":i},model:{value:(_vm.selectedItem[i]),callback:function ($$v) {_vm.$set(_vm.selectedItem, i, $$v)},expression:"selectedItem[i]"}})],1):_vm._e()])}),_c('template',{slot:"modal-footer"},[_c('span',{staticClass:"button-space"}),_c('anx-button',{on:{"click":_vm.editSelectedItem}},[_vm._v("Save")])],1)],2):_vm._e()]})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxCrudTable/AnxCrudTable.vue?vue&type=template&id=1d4bd6ac&scoped=true&


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b62f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxTable/AnxTable.vue?vue&type=template&id=58967b24&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('anx-table-container',{attrs:{"scrollable":_vm.scrollable,"height":_vm.height !== null ? _vm.height : 'auto'}},[_c('table',{class:'anx-table ' +
        (_vm.stripped !== null ? 'anx-table-striped ' : '') +
        (_vm.bordered !== null ? 'anx-table-bordered ' : '') +
        (_vm.borderless !== null ? 'anx-table-borderless ' : '') +
        (_vm.scrollable !== null ? 'anx-table-scrollable ' : '') +
        (_vm.hover !== null ? 'anx-table-hover ' : '')},[(_vm.noHeader === null && _vm.displayColumns.length > 0)?_c('thead',{class:_vm.uppercaseTitle !== null ? 'text-uppercase' : ''},[_c('tr',_vm._l((_vm.displayColumns),function(column){return _c('th',{key:column.index,class:column.align ? ("text-" + (column.align)) : '',attrs:{"scope":"col","width":column.width},domProps:{"textContent":_vm._s(column.name)}})}),0)]):_vm._e(),_c('tbody',[_vm._t("tbody",function(){return _vm._l((_vm.items),function(item,i){return _c('anx-table-row',{key:i,attrs:{"item":item}},_vm._l((_vm.displayColumns),function(column){return _c('anx-table-col',{key:("col-" + i + "-" + (column.index)),attrs:{"width":column.width,"align":column.align ? column.align : 'left',"content":item[column.index]}},[_vm._t(("" + (column.index) + i),null,{"content":item[column.index]})],2)}),1)})})],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxTable/AnxTable.vue?vue&type=template&id=58967b24&scoped=true&


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "b8db":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b9b5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b9ef":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxTitle_vue_1 = tslib_1.__importDefault(__webpack_require__("d602"));

var AnxContent = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxContent, _vue_property_decorat);

  var _super = _createSuper(AnxContent);

  function AnxContent() {
    _classCallCheck(this, AnxContent);

    return _super.apply(this, arguments);
  }

  return AnxContent;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "title", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "h1"
})], AnxContent.prototype, "size", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "inverse", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "first", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "noline", void 0);

AnxContent = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxTitle: AnxTitle_vue_1.default
  }
})], AnxContent);
exports.default = AnxContent;

/***/ }),

/***/ "bac9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9981");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxAlert_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "bc7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_style_index_0_id_3716aafa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b8db");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_style_index_0_id_3716aafa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_style_index_0_id_3716aafa_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bd60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_style_index_0_id_526a1d8a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("28ab");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_style_index_0_id_526a1d8a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxInput_vue_vue_type_style_index_0_id_526a1d8a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "be06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxTitle/AnxTitle.vue?vue&type=template&id=45a04698&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.size,{tag:"component",class:"anx-title size-" + _vm.size + " " +
      (_vm.noMargin !== null ? 'no-margin ' : '') +
      (_vm.noline !== null ? 'no-line ' : ''),style:(_vm.cssProps)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxTitle/AnxTitle.vue?vue&type=template&id=45a04698&scoped=true&


/***/ }),

/***/ "be31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_style_index_0_id_67e37bb0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3288");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_style_index_0_id_67e37bb0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_style_index_0_id_67e37bb0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bf53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3bd6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxModal_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c0a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxContainer/AnxContainer.vue?vue&type=template&id=23cb9858&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-container container",style:(_vm.cssProps),attrs:{"width":_vm.width}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxContainer/AnxContainer.vue?vue&type=template&id=23cb9858&scoped=true&


/***/ }),

/***/ "c1af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("9911");

__webpack_require__("ac1f");

__webpack_require__("466d");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxHrLine_vue_1 = tslib_1.__importDefault(__webpack_require__("825a1"));

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));

var AnxLink_vue_1 = tslib_1.__importDefault(__webpack_require__("a059"));

var AnxLanguageSwitcher_vue_1 = tslib_1.__importDefault(__webpack_require__("1dc4"));
/**
 * The *anx-header* is a simple header that is displayed on the top of the page
 */


var AnxHeader = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxHeader, _vue_property_decorat);

  var _super = _createSuper(AnxHeader);

  function AnxHeader() {
    var _this;

    _classCallCheck(this, AnxHeader);

    _this = _super.apply(this, arguments);
    /** Require the url module (import can't be used because it does not have @types) */

    _this.Url = __webpack_require__("1816");
    return _this;
  }
  /** this event is emitted when the locale is changed via the language switcher */


  _createClass(AnxHeader, [{
    key: "localeChange",
    value: function localeChange(locale) {
      return locale;
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--width": this.width
      };
    }
    /** Checks if the specified link should be active in the header (active means clickable) */

  }, {
    key: "isLinkActive",
    value: function isLinkActive(menu) {
      var link = menu.link;
      /** Try to get the current window url via window or $route ($route is more appropriate) */

      var currentUrl = null;
      if (typeof window !== "undefined") currentUrl = window.location.href;
      if (this.$route) currentUrl = this.$route.path;
      /** If the current window url could not be retrieved, we can't compare the urls */

      if (!currentUrl) return false;
      var url = new this.Url(link);
      var windowUrl = new this.Url(currentUrl);
      /** URL must not always be an exact match to be highlighted, you can also provide a regex */

      var matches = false;
      matches = url.href === windowUrl.href;

      if (!matches && menu.activeRegex) {
        matches = windowUrl.href.match(menu.activeRegex) !== null ? true : false;
      }
      /** Link is only active, if it doesn't match. Otherwise it is deactivated (not clickable) */


      return !matches;
    }
  }]);

  return AnxHeader;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxHeader.prototype, "i18n", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxHeader.prototype, "i18nOptions", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "anexia"
})], AnxHeader.prototype, "icon", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "45px"
})], AnxHeader.prototype, "iconSize", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxHeader.prototype, "menus", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "530px"
})], AnxHeader.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "/"
})], AnxHeader.prototype, "iconUrl", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxHeader.prototype, "iconUrlRouteName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Emit("localeChange")], AnxHeader.prototype, "localeChange", null);

AnxHeader = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxHrLine: AnxHrLine_vue_1.default,
    AnxLanguageSwitcher: AnxLanguageSwitcher_vue_1.default,
    AnxIcon: AnxIcon_vue_1.default,
    AnxLink: AnxLink_vue_1.default
  }
})], AnxHeader);
exports.default = AnxHeader;

/***/ }),

/***/ "c2b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxIcon/AnxIcon.vue?vue&type=template&id=a1b355ac&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconName,{tag:"component",staticClass:"anx-icon",attrs:{"width":_vm.width,"height":_vm.height,"margin":_vm.margin,"title":_vm.title}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxIcon/AnxIcon.vue?vue&type=template&id=a1b355ac&scoped=true&


/***/ }),

/***/ "c374":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_style_index_0_id_1d4bd6ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("44cd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_style_index_0_id_1d4bd6ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_style_index_0_id_1d4bd6ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c410":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cea3");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e494");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxParagraph/AnxParagraph.vue?vue&type=template&id=7dcab4fe&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title === null)?_c(_vm.element,{tag:"component",class:"anx-paragraph anx-paragraph-" + _vm.size + " " +
      (_vm.hint !== null ? 'hint ' : '') +
      (_vm.inverse !== null ? 'inversed-colors' : ''),style:(_vm.marginBottom !== null ? 'margin-bottom: ' + _vm.marginBottom : '')},[_vm._t("default")],2):_c('div',{class:{ 'inversed-colors': _vm.inverse !== null }},[_c('anx-title',{staticClass:"anx-paragraph-title",attrs:{"size":_vm.size,"no-margin":_vm.noMarginTitle,"noline":_vm.noline}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(_vm.element,{tag:"component",class:"anx-paragraph anx-paragraph-" + _vm.size + " " + (_vm.hint !== null ? 'hint ' : ''),style:(_vm.marginBottom !== null ? 'margin-bottom: ' + _vm.marginBottom : '')},[_vm._t("default")],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxParagraph/AnxParagraph.vue?vue&type=template&id=7dcab4fe&scoped=true&


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ccbd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("cca6");

__webpack_require__("caad");

__webpack_require__("2532");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_1 = tslib_1.__importDefault(__webpack_require__("8bbf"));

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxToast_vue_1 = tslib_1.__importDefault(__webpack_require__("84c8"));
/**
 * The *anx-toaster* is the container used for displaying the *anx-toast*
 */


var AnxToaster = /*#__PURE__*/function (_vue_1$default) {
  _inherits(AnxToaster, _vue_1$default);

  var _super = _createSuper(AnxToaster);

  function AnxToaster() {
    var _this;

    _classCallCheck(this, AnxToaster);

    _this = _super.apply(this, arguments);
    _this.VERTICAL_POSITIONS = ["top", "bottom"];
    _this.HORIZONTAL_POSITIONS = ["left", "center", "right"];
    _this.numberToasts = 0;
    return _this;
  }
  /**
   * Emit the destroy event.
   * This indicates that the toast can be removed from the DOM
   *
   * @event destroy
   */


  _createClass(AnxToaster, [{
    key: "destroy",
    value: function destroy() {
      return true;
    }
    /** Add a toast to the toaster */

  }, {
    key: "addToast",
    value: function addToast() {
      var _this2 = this;

      var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Set the value to true, because it should always be true when adding a toast
      propsData = Object.assign(Object.assign({}, propsData), {
        value: true
      });
      var componentClass = vue_1.default.extend(AnxToast_vue_1.default);
      var instance = new componentClass({
        propsData: propsData
      }); // Mount the toast in the toaster

      var toaster = this.$refs.anxToaster;
      instance.$mount(); // Check if the toast has to be inserted on the begin or the end

      if (this.verticalAlign === "top") {
        toaster.insertBefore(instance.$el, toaster.firstChild);
      } else {
        toaster.appendChild(instance.$el);
      } // When the toast is closed, it should be hidden


      instance.$on("input", function (value) {
        if (!value) {
          instance.hideAction();
        }
      }); // After the toast has been hidden, it should be destroyed

      instance.$on("destroy", function () {
        try {
          toaster.removeChild(instance.$el);
        } catch (ex) {// This means that the toast has already been removed
        } // If the toaster does not have any child nodes, it can be destroyed


        if (!toaster.hasChildNodes()) {
          _this2.destroy();
        }
      });
      return instance;
    }
    /** Getter for validated vertical align */

  }, {
    key: "_verticalAlign",
    get: function get() {
      return this.validateVerticalAlign(this.verticalAlign.toLowerCase());
    }
    /** Validates the vertical align property */

  }, {
    key: "validateVerticalAlign",
    value: function validateVerticalAlign(align) {
      if (this.VERTICAL_POSITIONS.includes(align)) {
        return align;
      } // Default value


      return this.VERTICAL_POSITIONS[0];
    }
    /** Getter for validated horizontal align */

  }, {
    key: "_horizontalAlign",
    get: function get() {
      return this.validateHorizontalAlign(this.horizontalAlign.toLowerCase());
    }
    /** Validates the horizontal align property */

  }, {
    key: "validateHorizontalAlign",
    value: function validateHorizontalAlign(align) {
      if (this.HORIZONTAL_POSITIONS.includes(align)) {
        return align;
      } // Default value


      return this.HORIZONTAL_POSITIONS[2];
    }
  }]);

  return AnxToaster;
}(vue_1.default);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "top"
})], AnxToaster.prototype, "verticalAlign", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "right"
})], AnxToaster.prototype, "horizontalAlign", void 0);

tslib_1.__decorate([vue_property_decorator_1.Emit("destroy")], AnxToaster.prototype, "destroy", null);

AnxToaster = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxToast: AnxToast_vue_1.default
  }
})], AnxToaster);
exports.default = AnxToaster;

/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "cea3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));
/**
 * This component renders a list based on the items provided
 */


var AnxList = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxList, _vue_property_decorat);

  var _super = _createSuper(AnxList);

  function AnxList() {
    _classCallCheck(this, AnxList);

    return _super.apply(this, arguments);
  }

  return AnxList;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxList.prototype, "icon", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxList.prototype, "items", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "initial"
})], AnxList.prototype, "listStyleType", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxList.prototype, "noPadding", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxList.prototype, "noSpacing", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "0px"
})], AnxList.prototype, "marginTop", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "0px"
})], AnxList.prototype, "marginBottom", void 0);

AnxList = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxIcon: AnxIcon_vue_1.default
  }
})], AnxList);
exports.default = AnxList;

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d25a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxTableRow_vue_vue_type_template_id_3ccffd92_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea2e");
/* harmony import */ var _AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0df1");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxTableRow_vue_vue_type_style_index_0_id_3ccffd92_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3535");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxTableRow_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxTableRow_vue_vue_type_template_id_3ccffd92_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxTableRow_vue_vue_type_template_id_3ccffd92_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "3ccffd92",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "d27c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d38a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f222");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxFooter_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d428":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("949a");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContact_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d602":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxTitle_vue_vue_type_template_id_45a04698_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("be06");
/* harmony import */ var _AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2739");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxTitle_vue_vue_type_style_index_0_id_45a04698_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("eb7c");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxTitle_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxTitle_vue_vue_type_template_id_45a04698_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxTitle_vue_vue_type_template_id_45a04698_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "45a04698",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "d746":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxGlobal_vue_vue_type_template_id_66aabbc8___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6d22");
/* harmony import */ var _AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3637");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxGlobal_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6062");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxGlobal_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxGlobal_vue_vue_type_template_id_66aabbc8___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxGlobal_vue_vue_type_template_id_66aabbc8___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExpPrototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d919":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxContainer_vue_vue_type_template_id_23cb9858_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c0a8");
/* harmony import */ var _AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a43c");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxContainer_vue_vue_type_style_index_0_id_23cb9858_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7d25");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxContainer_vue_vue_type_template_id_23cb9858_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxContainer_vue_vue_type_template_id_23cb9858_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "23cb9858",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dd04":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "ded4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};

/***/ }),

/***/ "df25":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e096":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (VueRecaptcha);


/***/ }),

/***/ "e0bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxTableContainer = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxTableContainer, _vue_property_decorat);

  var _super = _createSuper(AnxTableContainer);

  function AnxTableContainer() {
    _classCallCheck(this, AnxTableContainer);

    return _super.apply(this, arguments);
  }

  return AnxTableContainer;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTableContainer.prototype, "scrollable", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxTableContainer.prototype, "height", void 0);

AnxTableContainer = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxTableContainer);
exports.default = AnxTableContainer;

/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e24a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxButton/AnxButton.vue?vue&type=template&id=4d673718&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'anx-button': true,
    inline: _vm.inline !== null,
    'btn-outline': _vm.outline !== null
  },style:(_vm.cssProps),attrs:{"type":_vm.btnType},on:{"click":function($event){return _vm.$emit(_vm.eventName)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxButton/AnxButton.vue?vue&type=template&id=4d673718&scoped=true&


/***/ }),

/***/ "e250":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxToaster/AnxToaster.vue?vue&type=template&id=0ecc43b6&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"anxToaster",class:("anx-toaster anx-toaster-" + _vm._verticalAlign + " anx-toaster-" + _vm._horizontalAlign)},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxToaster/AnxToaster.vue?vue&type=template&id=0ecc43b6&scoped=true&


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e494":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxLink_vue_1 = tslib_1.__importDefault(__webpack_require__("a059"));

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));

var AnxParagraph_vue_1 = tslib_1.__importDefault(__webpack_require__("78a2"));
/**
 * The *anx-card* is a special layout used on websites of Anexia.
 * It contains an icon, a header, a link and some text.
 */


var Card = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(Card, _vue_property_decorat);

  var _super = _createSuper(Card);

  function Card() {
    _classCallCheck(this, Card);

    return _super.apply(this, arguments);
  }

  return Card;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop()], Card.prototype, "title", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], Card.prototype, "linkText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "#"
})], Card.prototype, "link", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], Card.prototype, "icon", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], Card.prototype, "image", void 0);

Card = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxLink: AnxLink_vue_1.default,
    AnxIcon: AnxIcon_vue_1.default,
    AnxParagraph: AnxParagraph_vue_1.default
  }
})], Card);
exports.default = Card;

/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5cc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxAlert_vue_1 = tslib_1.__importDefault(__webpack_require__("3321"));

var AnxButton_vue_1 = tslib_1.__importDefault(__webpack_require__("3097"));

var AnxCheckbox_vue_1 = tslib_1.__importDefault(__webpack_require__("7f56"));

var AnxContainer_vue_1 = tslib_1.__importDefault(__webpack_require__("d919"));

var AnxContent_vue_1 = tslib_1.__importDefault(__webpack_require__("09f6"));

var AnxForm_vue_1 = tslib_1.__importDefault(__webpack_require__("3473"));

var AnxHrLine_vue_1 = tslib_1.__importDefault(__webpack_require__("825a1"));

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));

var AnxInput_vue_1 = tslib_1.__importDefault(__webpack_require__("6911"));
/**
 * This component renders a highly adjustable login form that matches the style guidelines
 */


var AnxLogin = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxLogin, _vue_property_decorat);

  var _super = _createSuper(AnxLogin);

  function AnxLogin() {
    var _this;

    _classCallCheck(this, AnxLogin);

    _this = _super.apply(this, arguments);
    /** The variables for username and password */

    _this.username = "";
    _this.password = "";
    _this.rememberMeCheckbox = _this.rememberMeDefault;
    /** Shows the error message if this is true */

    _this.hasLoginError = false;
    return _this;
  }
  /** Watches the error message and sets the variable to show the error if needed */


  _createClass(AnxLogin, [{
    key: "onLoginErrorChanged",
    value: function onLoginErrorChanged(newVal) {
      if (newVal === null || !newVal) {
        this.hasLoginError = false;
      } else {
        this.hasLoginError = true;
      }
    }
    /** When the user hits the login button and the entered data passes validation, the login event is emitted */

  }, {
    key: "login",
    value: function login() {
      return {
        username: this.username,
        password: this.password,
        rememberMe: this.rememberMeCheckbox
      };
    }
    /** Check if the remember me text is set, otherwise return default text */

  }, {
    key: "rememberMeText",
    get: function get() {
      if (this.rememberMe && this.rememberMe.length > 0) {
        return this.rememberMe;
      }

      return "Remember me";
    }
  }]);

  return AnxLogin;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "400px"
})], AnxLogin.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "logo", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "customerLogo", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "loginError", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "username"
})], AnxLogin.prototype, "usernameName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "username-input"
})], AnxLogin.prototype, "usernameId", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Username"
})], AnxLogin.prototype, "usernameLabel", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "required"
})], AnxLogin.prototype, "usernameRules", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxLogin.prototype, "usernameAssistiveText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "password"
})], AnxLogin.prototype, "passwordName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "password-input"
})], AnxLogin.prototype, "passwordId", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Password"
})], AnxLogin.prototype, "passwordLabel", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "required"
})], AnxLogin.prototype, "passwordRules", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxLogin.prototype, "passwordAssistiveText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "submitButtonWidth", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Log in"
})], AnxLogin.prototype, "submitButtonText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "right"
})], AnxLogin.prototype, "submitButtonAlign", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "noFooter", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "footerText", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "anexia-stamp"
})], AnxLogin.prototype, "footerIcon", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "60px"
})], AnxLogin.prototype, "footerIconSize", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxLogin.prototype, "rememberMe", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: false
})], AnxLogin.prototype, "rememberMeDefault", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("loginError")], AnxLogin.prototype, "onLoginErrorChanged", null);

tslib_1.__decorate([vue_property_decorator_1.Emit()], AnxLogin.prototype, "login", null);

AnxLogin = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxAlert: AnxAlert_vue_1.default,
    AnxButton: AnxButton_vue_1.default,
    AnxCheckbox: AnxCheckbox_vue_1.default,
    AnxContainer: AnxContainer_vue_1.default,
    AnxContent: AnxContent_vue_1.default,
    AnxForm: AnxForm_vue_1.default,
    AnxHrLine: AnxHrLine_vue_1.default,
    AnxIcon: AnxIcon_vue_1.default,
    AnxInput: AnxInput_vue_1.default
  }
})], AnxLogin);
exports.default = AnxLogin;

/***/ }),

/***/ "e5f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ AnxVariablesPlugin; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js






function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js






function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// CONCATENATED MODULE: ./src/plugins/variables/api.js



var api_Api = function Api(Vue) {
  var globalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    /**
     * Sets all variables to the default variables
     */
    init: function init(options) {
      // Check if there are any variables set in globalOptions
      if ("variables" in globalOptions) {
        for (var _i = 0, _Object$entries = Object.entries(globalOptions.variables); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          this.setVariable(key, value);
        }
      } // Check if there are any variables set in options


      if ("variables" in options) {
        for (var _i2 = 0, _Object$entries2 = Object.entries(options.variables); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              _key = _Object$entries2$_i[0],
              _value = _Object$entries2$_i[1];

          this.setVariable(_key, _value);
        }
      }
    },

    /**
     * Sets a variable
     *
     * @param {*} key       The key of the variable
     * @param {*} value     The value of the variable
     * @returns true        On success
     * @returns false       On error
     */
    setVariable: function setVariable(key, value) {
      try {
        if (document) {
          document.documentElement.style.setProperty(key, value);
          return true;
        } else {
          throw true;
        }
      } catch (ex) {
        return false;
      }
    },

    /**
     * Resets a variable to the default value
     */
    resetVariable: function resetVariable(key) {
      try {
        document.documentElement.style.removeProperty(key);
      } catch (ex) {
        return false;
      }
    }
  };
};

/* harmony default export */ var api = (api_Api);
// CONCATENATED MODULE: ./src/plugins/variables/plugin.js

var AnxVariablesPlugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var methods = api(Vue, options);
    Vue.prototype.$anxVariables = methods;
    Vue.$anxVariables = methods;
    methods.init(options);
  }
};
// CONCATENATED MODULE: ./src/plugins/variables/index.js


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var isObject = __webpack_require__("861d");
var aFunction = __webpack_require__("1c0b");
var anInstance = __webpack_require__("19aa");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructorPrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e73a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxReadonly/AnxReadonly.vue?vue&type=template&id=f4c65b2e&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-readonly",on:{"click":_vm.click}},[_c('div',{class:'inner-text ' + (_vm.bold !== null ? 'bold ' : '')},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxReadonly/AnxReadonly.vue?vue&type=template&id=f4c65b2e&scoped=true&


/***/ }),

/***/ "e7f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8004");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxReadonly_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e7fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxTableContainer_vue_vue_type_template_id_35d78eab_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6311");
/* harmony import */ var _AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("102a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxTableContainer_vue_vue_type_style_index_0_id_35d78eab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2bc5");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxTableContainer_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxTableContainer_vue_vue_type_template_id_35d78eab_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxTableContainer_vue_vue_type_template_id_35d78eab_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "35d78eab",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "e807":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_style_index_0_id_38a20043_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b9b5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_style_index_0_id_38a20043_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTextarea_vue_vue_type_style_index_0_id_38a20043_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e87a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "ea2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxTableRow/AnxTableRow.vue?vue&type=template&id=3ccffd92&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"anx-table-row"},[_vm._t("default",function(){return _vm._l((_vm.item),function(content,name){return _c('td',{key:name},[_vm._v(_vm._s(content))])})})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxTableRow/AnxTableRow.vue?vue&type=template&id=3ccffd92&scoped=true&


/***/ }),

/***/ "eadb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eb7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_style_index_0_id_45a04698_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a961");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_style_index_0_id_45a04698_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTitle_vue_vue_type_style_index_0_id_45a04698_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "eb94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3812");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ed6d":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("4a4b");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "f03a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("528e");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxButton_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f0b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_style_index_0_id_2fdb377b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a144");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_style_index_0_id_2fdb377b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCheckbox_vue_vue_type_style_index_0_id_2fdb377b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f222":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var AttributesHelper_1 = __webpack_require__("4bc1");

var vue_property_decorator_1 = __webpack_require__("60a3");

var AnxIcon_vue_1 = tslib_1.__importDefault(__webpack_require__("2769"));

var AnxHrLine_vue_1 = tslib_1.__importDefault(__webpack_require__("825a1"));

var AnxLink_vue_1 = tslib_1.__importDefault(__webpack_require__("a059"));
/**
 * The *anx-footer* is a simple footer that is displayed on the bottom of the page
 */


var AnxFooter = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxFooter, _vue_property_decorat);

  var _super = _createSuper(AnxFooter);

  function AnxFooter() {
    var _this;

    _classCallCheck(this, AnxFooter);

    _this = _super.apply(this, arguments);
    _this.footerLinks = [];
    /** The current state of the footer, if it is fixed to bottom or not */

    _this.bottom = false;
    return _this;
  }

  _createClass(AnxFooter, [{
    key: "cssProps",
    get: function get() {
      return {
        "--width": this.width
      };
    }
    /** If the document height is to less, the footer should be fixed to the bottom of the page */

  }, {
    key: "setFooter",
    value: function setFooter() {
      var footer = document.getElementById("anx-footer");
      /** Check if the footer has been found and is on the page */

      if (footer) {
        /** If the footer is fixed to bottom, the height has to be added to document.body.scrollHeight */
        var documentHeight = document.body.scrollHeight;
        if (this.bottom) documentHeight += footer.scrollHeight;
        /** Compare the height of the document with the actual window height */

        if (documentHeight < window.innerHeight) {
          footer.classList.add("bottom");
          this.bottom = true;
        } else {
          footer.classList.remove("bottom");
          this.bottom = false;
        }
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.setFooter();
      /** Set footer on window resize */

      window.addEventListener("resize", this.setFooter);
      /** Additionally add a listener for height change of document.body */

      this.onElementHeightChange(document.body, this.setFooter);
    }
    /**
     * Attrbibutes for the component
     * Passing this attributes with v-bind allows to not pass unused items
     */

  }, {
    key: "attributes",
    get: function get() {
      return AttributesHelper_1.AttributesHelper.attributes(this);
    }
    /** Custom function to listen on height change of elements */

  }, {
    key: "onElementHeightChange",
    value: function onElementHeightChange(elm, callback) {
      var lastHeight = elm.clientHeight,
          newHeight;

      (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight != newHeight) callback();
        lastHeight = newHeight;
        window.setTimeout(run, 100);
      })();
    }
  }]);

  return AnxFooter;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxFooter.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxFooter.prototype, "links", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "anexia"
})], AnxFooter.prototype, "icon", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "530px"
})], AnxFooter.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "0px"
})], AnxFooter.prototype, "marginTop", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "Anexia Internetdienstleistungs GmbH"
})], AnxFooter.prototype, "companyName", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: true
})], AnxFooter.prototype, "showCopyrightDate", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: 2006
})], AnxFooter.prototype, "copyrightDateFrom", void 0);

AnxFooter = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    AnxIcon: AnxIcon_vue_1.default,
    AnxHrLine: AnxHrLine_vue_1.default,
    AnxLink: AnxLink_vue_1.default
  }
})], AnxFooter);
exports.default = AnxFooter;

/***/ }),

/***/ "f29e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("01ec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f33f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxLanguageSwitcher/AnxLanguageSwitcher.vue?vue&type=template&id=7657fe93&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.i18n)?_c('div',[_c('div',{staticClass:"anx-language-switcher"},_vm._l((_vm.languages),function(lang,key){return _c('label',{key:lang.code},[(_vm.locale !== lang.code && lang.link !== null)?_c('anx-link',{attrs:{"href":lang.link},on:{"click":function($event){return _vm.setLocale(lang.code)}}},[_vm._v(" "+_vm._s(lang.text)+" ")]):(_vm.locale !== lang.code && lang.link === null)?_c('anx-link',{on:{"click":function($event){return _vm.setLocale(lang.code)}}},[_vm._v(" "+_vm._s(lang.text)+" ")]):_c('span',[_vm._v(_vm._s(lang.text))]),(key != _vm.languages.length - 1)?_c('span',[_vm._v(" / ")]):_vm._e()],1)}),0)]):_c('div',[_vm._v(" No i18n instance provided! ")])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxLanguageSwitcher/AnxLanguageSwitcher.vue?vue&type=template&id=7657fe93&scoped=true&


/***/ }),

/***/ "f371":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9e85");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxCrudTable_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f535":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b9ef");
/* harmony import */ var _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_cache_loader_dist_cjs_js_ref_14_0_node_modules_thread_loader_dist_cjs_js_node_modules_babel_loader_lib_index_js_node_modules_ts_loader_index_js_ref_14_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxContent_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f598":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var _variables_scss_1 = tslib_1.__importDefault(__webpack_require__("fb51"));
/**
 * This component is used for rendering titles that match the UI design guidelines
 */


var AnxContent = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxContent, _vue_property_decorat);

  var _super = _createSuper(AnxContent);

  function AnxContent() {
    _classCallCheck(this, AnxContent);

    return _super.apply(this, arguments);
  }

  _createClass(AnxContent, [{
    key: "cssProps",
    get: function get() {
      return {
        "--margin-bottom": this.margin !== null ? this.margin : _variables_scss_1.default.titleSpacing
      };
    }
  }]);

  return AnxContent;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "h1"
})], AnxContent.prototype, "size", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "noMargin", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxContent.prototype, "text", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "noline", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxContent.prototype, "margin", void 0);

AnxContent = tslib_1.__decorate([vue_property_decorator_1.Component({})], AnxContent);
exports.default = AnxContent;

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f682":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnxTextarea_vue_vue_type_template_id_38a20043_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aead");
/* harmony import */ var _AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("681a");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _AnxTextarea_vue_vue_type_style_index_0_id_38a20043_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e807");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2877");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _AnxTextarea_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _AnxTextarea_vue_vue_type_template_id_38a20043_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _AnxTextarea_vue_vue_type_template_id_38a20043_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "38a20043",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "f6df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_style_index_0_id_0e758f08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f43");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_style_index_0_id_0e758f08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxHeader_vue_vue_type_style_index_0_id_0e758f08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f7f3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxContent/AnxContent.vue?vue&type=template&id=2eb4993f&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'anx-content ' +
      (_vm.inverse !== null ? 'inversed-colors ' : '') +
      (_vm.first !== null ? 'first-no-nav ' : '')},[(_vm.title !== null)?_c('anx-title',{attrs:{"size":_vm.size,"noline":_vm.noline,"text":_vm.title}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxContent/AnxContent.vue?vue&type=template&id=2eb4993f&scoped=true&


/***/ }),

/***/ "f8d7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fa08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_style_index_0_id_a1b355ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8910");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_style_index_0_id_a1b355ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxIcon_vue_vue_type_style_index_0_id_a1b355ac_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "faa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("970b").default;

var _createClass = __webpack_require__("5bc3").default;

var _inherits = __webpack_require__("ed6d").default;

var _createSuper = __webpack_require__("2d0d").default;

__webpack_require__("96cf");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = __webpack_require__("9ab4");

var vue_property_decorator_1 = __webpack_require__("60a3");

var vee_validate_1 = __webpack_require__("7bb1");

var AttributesHelper_1 = __webpack_require__("4bc1");
/**
 * This component is an advanced version of the HTML select tag that matches our style guidelines
 */


var AnxSelect = /*#__PURE__*/function (_vue_property_decorat) {
  _inherits(AnxSelect, _vue_property_decorat);

  var _super = _createSuper(AnxSelect);

  function AnxSelect() {
    var _this;

    _classCallCheck(this, AnxSelect);

    _this = _super.apply(this, arguments);
    _this.selected = _this.getOptionFromValue(_this.value).value;
    _this.selectedText = _this.getOptionFromValue(_this.value).text;
    _this.show = false;
    _this.error = [];
    _this.dynamicHeight = false;
    _this.inputId = "";
    return _this;
  }
  /**
   * Check if a validation rule is provided and return this validation rule
   * If validation parameter is provided, return the default validation rule
   * Otherwise return an empty string
   */


  _createClass(AnxSelect, [{
    key: "cValidationRules",
    get: function get() {
      if (this.validationRules !== null) return this.validationRules;
      if (this.validation !== null) return "excluded:null";
      return "";
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--select-width": this.width
      };
    }
    /**
     * Watch the selected variable. When selected is changed, the new value will be verify.
     * option "immediate:true" means, it will be execute before mounted
     * (this is important, for the validation observer)
     */

  }, {
    key: "onSelectedChanged",
    value: function onSelectedChanged(val) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(val && this.validation !== null)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.verify(val);

              case 3:
                window.setTimeout(this.handleResize, 100);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Verfiy the selected value and generate the error-message for the custom select.
     */

  }, {
    key: "verify",
    value: function verify(value) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$this$$validato, errors;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$validator.verify(value, this.cValidationRules, {
                  name: this.label
                });

              case 2:
                _yield$this$$validato = _context2.sent;
                errors = _yield$this$$validato.errors;
                this.error = errors;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Set the id for the component when created
     */

  }, {
    key: "created",
    value: function created() {
      this.inputId = AttributesHelper_1.AttributesHelper.attributes(this, {
        uniqueId: true,
        uniqueIdPrefix: "anx-select-"
      }).id;
    }
    /**
     * Reset the error, because after mount it shouldn't show the error message
     */

  }, {
    key: "mounted",
    value: function mounted() {
      this.error = [];
      this.closeOnClickOutsideElement();
      window.setTimeout(this.handleResize, 100);
    }
    /** Adapt the multiline select to the design */

  }, {
    key: "handleResize",
    value: function handleResize() {
      this.dynamicHeight = this.$refs.anxSelect.clientHeight >= 38;
    }
    /** Close the select dialoag when the users clicks outside of the anx-select */

  }, {
    key: "closeOnClickOutsideElement",
    value: function closeOnClickOutsideElement() {
      var _this2 = this;

      /** Add click event listener to the whole document */
      document.body.addEventListener("click", function (event) {
        /** This is the element, the user clicked */
        var clickedElement = event.target;
        /** Check if the user clicked outside of the anx-select and close it */

        if (clickedElement) {
          if (!_this2.isElementOrChild(_this2.$el, clickedElement)) {
            _this2.closeDialog();
          }
        }
      });
    }
    /** Handle a click outside the modal */

  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.show = false;
    }
    /** Check if child matches elem or child is a child of elem */

  }, {
    key: "isElementOrChild",
    value: function isElementOrChild(elem, child) {
      return child === elem || elem.contains(child);
    }
    /**
     * Set the variable with the selcted option and emit the input-event
     */

  }, {
    key: "select",
    value: function select(option) {
      this.selected = option.value;
      this.selectedText = option.text;
      this.show = false;
      /** This emits the input event with the selected user input */

      this.$emit("input", this.selected);
    }
    /**
     * Returns the options object by providing a value
     * If no options is found, the first options in the array is returned
     */

  }, {
    key: "getOptionFromValue",
    value: function getOptionFromValue(value) {
      for (var i = this.options.length - 1; i > 0; i--) {
        if (this.options[i].value === value) {
          return this.options[i];
        }
      }

      return this.options[0];
    }
  }]);

  return AnxSelect;
}(vue_property_decorator_1.Vue);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxSelect.prototype, "id", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxSelect.prototype, "name", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: ""
})], AnxSelect.prototype, "label", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  required: true
})], AnxSelect.prototype, "options", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: "100%"
})], AnxSelect.prototype, "width", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxSelect.prototype, "value", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxSelect.prototype, "validation", void 0);

tslib_1.__decorate([vue_property_decorator_1.Prop({
  default: null
})], AnxSelect.prototype, "validationRules", void 0);

tslib_1.__decorate([vue_property_decorator_1.Watch("selected", {
  immediate: false
})], AnxSelect.prototype, "onSelectedChanged", null);

AnxSelect = tslib_1.__decorate([vue_property_decorator_1.Component({
  components: {
    ValidationProvider: vee_validate_1.ValidationProvider
  }
})], AnxSelect);
exports.default = AnxSelect;

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setPublicPath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1eb2");
/* harmony import */ var _entry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ffb4");
/* harmony import */ var _entry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_entry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _entry__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _entry__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));


/* harmony default export */ __webpack_exports__["default"] = (_entry__WEBPACK_IMPORTED_MODULE_1___default.a);



/***/ }),

/***/ "fb51":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};

/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fda7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0339b1d2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AnxSelect/AnxSelect.vue?vue&type=template&id=a1c0af30&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.label,"rules":_vm.cValidationRules,"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('div',{ref:"anxSelect",class:{
      'anx-select': true,
      'dynamic-height': _vm.dynamicHeight,
      is_invalid: _vm.error.length > 0 || errors.length > 0
    },style:(_vm.cssProps),on:{"click":function($event){_vm.show = !_vm.show}}},[_c('label',{attrs:{"for":_vm.inputId},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(" "+_vm._s(_vm.label))]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"id":_vm.inputId,"name":_vm.name || _vm.inputId},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.text))])}),0),_c('div',{staticClass:"anx-select-div"},[_vm._v(" "+_vm._s(_vm.selectedText)+" ")]),_c('ul',{staticClass:"anx-select-options",class:{ show: _vm.show }},_vm._l((_vm.options),function(option){return _c('li',{key:option.value,class:{ active: _vm.selected === option.value },attrs:{"rel":option.value},on:{"click":function($event){$event.stopPropagation();return _vm.select(option)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)]),(_vm.error.length > 0 || errors.length > 0)?_c('div',{staticClass:"anx-select-error"},[(_vm.error.length > 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.error[0]))]):_c('span',{staticClass:"error"},[_vm._v(_vm._s(errors[0]))])]):_vm._e()]}}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AnxSelect/AnxSelect.vue?vue&type=template&id=a1c0af30&scoped=true&


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ff1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_style_index_0_id_58967b24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f8d7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_style_index_0_id_58967b24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AnxTable_vue_vue_type_style_index_0_id_58967b24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ffb4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnxVariablesPlugin = exports.AnxToastPlugin = exports.AnxIconsPlugin = exports.AnxIconsNames = exports.AbstractModel = exports.AnxAlertPlugin = exports.Components = void 0;

var tslib_1 = __webpack_require__("9ab4");

var components_1 = tslib_1.__importDefault(__webpack_require__("3617"));

exports.Components = components_1.default;

var AbstractModel_1 = __webpack_require__("a925");

Object.defineProperty(exports, "AbstractModel", {
  enumerable: true,
  get: function get() {
    return AbstractModel_1.AbstractModel;
  }
});

var plugins_1 = __webpack_require__("6912");

Object.defineProperty(exports, "AnxAlertPlugin", {
  enumerable: true,
  get: function get() {
    return plugins_1.AnxAlertPlugin;
  }
});
Object.defineProperty(exports, "AnxIconsPlugin", {
  enumerable: true,
  get: function get() {
    return plugins_1.AnxIconsPlugin;
  }
});
Object.defineProperty(exports, "AnxIconsNames", {
  enumerable: true,
  get: function get() {
    return plugins_1.AnxIconsNames;
  }
});
Object.defineProperty(exports, "AnxToastPlugin", {
  enumerable: true,
  get: function get() {
    return plugins_1.AnxToastPlugin;
  }
});
Object.defineProperty(exports, "AnxVariablesPlugin", {
  enumerable: true,
  get: function get() {
    return plugins_1.AnxVariablesPlugin;
  }
}); // Default export is the UI Plugin

var UIPlugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /** Register all components, that have been loaded*/
    for (var name in components_1.default) {
      Vue.component(name, components_1.default[name]);
    }
    /** Register AnxAlertPlugin */


    Vue.use(plugins_1.AnxAlertPlugin, options);
    /** Register the AnxIconsPlugin (this registers all icons as components) */

    Vue.use(plugins_1.AnxIconsPlugin, options);
    /** Register the AnxToastPlugin */

    Vue.use(plugins_1.AnxToastPlugin, options);
    /** Register the AnxVariablesPlugin */

    Vue.use(plugins_1.AnxVariablesPlugin, options);
  }
};
exports.default = UIPlugin; // Export all components as named exports

tslib_1.__exportStar(__webpack_require__("3617"), exports);

/***/ })

/******/ });
});
//# sourceMappingURL=anx.umd.js.map